// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

label {
  font-family: "Open Sans", sans-serif;
}

::ng-deep#page-wrapper {
  padding-bottom: 60px;
}

::ng-deep#wrapper {
  overflow-x: initial;
}

::ng-deep.wrapper-content {
  position: relative;
}

::ng-deep.clarify-is .mainnav {
  display: flex;
  flex-wrap: wrap;
  margin: 30px 0 40px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .mainnav {
    margin: 10px 0 30px;
  }
}
::ng-deep.clarify-is .mainnav.mainnav--bottom {
  margin: 30px 0 40px;
}
::ng-deep.clarify-is .mainnav.mainnav--bottom ul li a {
  padding: 12px 30px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .mainnav.mainnav--bottom ul li a {
    padding: 10px 20px;
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .mainnav.mainnav--bottom ul li a {
    padding: 9px;
    font-size: 11px;
  }
}
::ng-deep.clarify-is .mainnav.mainnav--bottom ul li.active a {
  background-color: #bbb !important;
  border-top: 1px solid #bbb !important;
  border-bottom: 1px solid #bbb !important;
  border-left: 1px solid #bbb !important;
}
::ng-deep.clarify-is .mainnav--editmode {
  margin: 0 0 15px;
}
::ng-deep.clarify-is .mainnav--editmode .mainnav__list {
  flex: 1;
  border-radius: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .mainnav--editmode .mainnav__list {
    flex: none;
    width: 100%;
  }
}
::ng-deep.clarify-is .mainnav--editmode .mainnav__list li {
  width: 100%;
  flex: 1;
}
::ng-deep.clarify-is .mainnav--editmode .mainnav__list li a {
  width: 100%;
  padding: 5px 2px;
  text-align: center;
}
::ng-deep.clarify-is .info {
  color: #fff;
  border: 1px solid rgb(0, 173, 208);
  margin-bottom: 18px;
  padding: 20px 40px;
  border-radius: 6px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .info {
    padding: 12px 20px;
  }
}
::ng-deep.clarify-is .info.infotitle {
  background-color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .info h1 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .info h1 {
    font-size: 28px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info h1 {
    font-size: 24px;
  }
}
::ng-deep.clarify-is .info h1 .info__maintitle {
  margin-right: auto;
}
::ng-deep.clarify-is .info h1 small {
  color: #fff;
  font-size: 80%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info h1 small {
    width: 100%;
    margin-top: 5px;
  }
}
::ng-deep.clarify-is .info .card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
::ng-deep.clarify-is .info .card__toprow--tne .card__topcol:first-child {
  width: 72% !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info .card__toprow--tne .card__topcol:first-child {
    flex: 1;
    width: auto !important;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol {
  padding: 0 15px;
  width: 33.3333333333%;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--full {
  width: 100% !important;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol:nth-child(1) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol:nth-child(1) {
    flex: 1;
    margin-right: auto;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--tab {
  width: 44%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol--tab {
    width: 120px;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--tt {
  width: 28%;
  margin-left: auto;
  text-align: right;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol--tt {
    width: auto;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
  line-height: 1;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:not(:first-child) {
  margin-left: -1px;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button {
  color: rgb(0, 173, 208);
  border: 1px solid rgb(0, 173, 208);
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount {
  color: rgb(0, 173, 208);
  background-color: #efefef;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid rgb(0, 173, 208);
  color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount {
  color: rgb(0, 173, 208);
  background-color: #efefef;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg .st0 {
  fill: rgb(0, 173, 208);
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: rgb(0, 173, 208);
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover {
  color: rgb(0, 173, 208);
  opacity: 1;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover > span.card__topcount {
  color: rgb(0, 173, 208);
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--ctt {
  position: relative;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--ctt ul li .card-body__tooltip {
  display: none;
  position: absolute;
  background: #fff;
  color: #676a6c;
  padding: 5px;
  top: -27px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--ctt ul li button:hover {
  opacity: 0.2 !important;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--ctt ul li:hover .card-body__tooltip, ::ng-deep.clarify-is .info .card__toprow .card__topcol--ctt ul li:active .card-body__tooltip {
  display: block;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol span.flagicon {
  position: relative;
  right: -6px;
  top: -11px;
  color: #ff0000;
  margin-left: 0;
}
::ng-deep.clarify-is .info .card__toprow .card__h3button {
  border: 1px solid rgb(0, 173, 208);
  background-color: transparent;
  padding: 2px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(0, 173, 208);
  font-size: 22px;
  line-height: 1.2;
  transition: all ease 0.3s;
  cursor: pointer;
}
::ng-deep.clarify-is .info .card__toprow .card__h3button:hover {
  background-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep.clarify-is .info .card__toprow .card__h3button:focus {
  outline: none;
}
::ng-deep.clarify-is .info .card__toprow .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
  text-align: right;
}
::ng-deep.clarify-is .info .card__toprow .tooltipicon i {
  color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .info .card__toprow .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.clarify-is .info .card__toprow .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(0, 173, 208);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.clarify-is .info h3 {
  font-size: 20px;
  margin: 0;
  cursor: pointer;
  color: rgb(0, 173, 208);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .info h3 {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info h3 {
    font-size: 15px;
    word-break: break-word;
  }
}
::ng-deep.clarify-is .info h3 > *:not(:last-child) {
  margin-right: 5px;
}
::ng-deep.clarify-is .info h3 .card__bwnh3pencil a {
  color: rgb(0, 173, 208);
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info h3 .card__bwnh3button {
    width: 100%;
    margin-top: 10px;
  }
}
::ng-deep.clarify-is .info h3 .card__bwnh3button button {
  font-size: 18px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info h3 .card__bwnh3button button {
    font-size: 16px !important;
  }
}
::ng-deep.clarify-is .info h3 i {
  cursor: pointer;
  font-size: 0.9em;
}
::ng-deep.clarify-is .info h3 i + div {
  padding-left: 7px;
}
::ng-deep.clarify-is .info h3 i + div span {
  display: block;
  font-size: 0.7em;
}
::ng-deep.clarify-is .info h3 i + span {
  padding-left: 7px;
}
::ng-deep.clarify-is app-clarify-data,
::ng-deep.clarify-is app-clarify-sub-challenge {
  display: block;
  margin-top: 30px;
}
::ng-deep.clarify-is .card-default {
  border-radius: 6px;
  border-top-width: 3px;
  border: 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
::ng-deep.clarify-is .card-default.card-default--summary {
  box-shadow: none;
}
::ng-deep.clarify-is .card-default.card-default--summary .info {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.clarify-is .card-default.card-default--summary .card-body {
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
  border-radius: 0;
}
::ng-deep.clarify-is .card-default.card-default--summary .card-body__inner {
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.clarify-is .card-default.card-default--summary + div {
  margin-top: 20px;
}
::ng-deep.clarify-is .card-default + div {
  margin-top: 30px;
}
::ng-deep.clarify-is .card-default .info {
  margin: 0;
  border: 1px solid rgb(0, 173, 208);
  border-radius: 6px;
}
::ng-deep.clarify-is .card-default .info.card__headactive {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc {
  background-color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc .card__topcol h3 {
  color: #fff;
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc .card__topcol ul li button {
  border-color: #fff;
  background-color: #fff;
  cursor: pointer;
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc .card__topcol ul li button span {
  color: rgb(0, 173, 208);
  background-color: #fff;
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc .card__topcol ul li button .st0 {
  fill: #fff;
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc i {
  color: #fff;
}
::ng-deep.clarify-is .card-default .card-body__inner {
  padding: 15px 40px;
  overflow-y: auto;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .card-default .card-body__inner {
    padding: 12px 20px;
  }
}
::ng-deep.clarify-is .card-default .card-body {
  display: none;
  border: 1px solid #CFDBE2;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
::ng-deep.clarify-is .card-default .card-body.card-show {
  display: block;
}
::ng-deep.clarify-is .card-default .card-body.card-show__wbg {
  background-color: #fff;
}
::ng-deep.clarify-is .card-default .card-body__finalstate p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body__finalstate p {
    font-size: 13px;
  }
}
::ng-deep.clarify-is .card-default .card-body__finalstate p:last-child {
  margin-bottom: 0;
}
::ng-deep.clarify-is .card-default .card-body__finalstate--2 {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
::ng-deep.clarify-is .card-default .card-body__finalstate--2 > div {
  width: 50%;
  padding: 0 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body__finalstate--2 > div {
    width: 100%;
  }
}
::ng-deep.clarify-is .card-default .card-body__finalstate--list p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.clarify-is .card-default .card-body__finalstate--list p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.clarify-is .card-default .card-body__subtitle {
  padding-left: 35px;
  margin-bottom: 16px;
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__subtitle--pl0 {
  padding-left: 0;
}
::ng-deep.clarify-is .card-default .card-body__subtitle *:last-child {
  margin-bottom: 0;
}
::ng-deep.clarify-is .card-default .card-body__subtitle > span {
  position: absolute;
  top: 0;
  right: 2px;
  opacity: 0.7;
  cursor: pointer;
}
::ng-deep.clarify-is .card-default .card-body__subtitle > span.eyebtn {
  right: 0;
}
::ng-deep.clarify-is .card-default .card-body__subtitle p {
  color: #969798;
  font-size: 15px;
}
::ng-deep.clarify-is .card-default .card-body__subtitle p i {
  padding-left: 5px;
}
::ng-deep.clarify-is .card-default .c-radio label {
  padding-left: 0;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.clarify-is .card-default .c-radio label > i {
  position: relative;
  top: 2px;
  margin-right: 6px;
  opacity: 0.6;
}
::ng-deep.clarify-is .card-default .c-radio label > span {
  vertical-align: middle;
}
::ng-deep.clarify-is .card-default .c-radio input {
  opacity: 0;
  margin: 0;
  display: none;
}
::ng-deep.clarify-is .card-default .c-radio input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.clarify-is .card-default .c-radio input + span::before {
  position: absolute;
  color: rgb(0, 173, 208);
  opacity: 0;
  font-size: 11px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.clarify-is .card-default .c-radio input:checked + span {
  border-color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .c-radio input:checked + span::before {
  opacity: 1;
}
::ng-deep.clarify-is .card-default .checkbox label {
  min-height: 20px;
  padding-left: 0;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.clarify-is .card-default .checkbox label > i {
  position: relative;
  top: 1px;
  margin-right: 6px;
}
::ng-deep.clarify-is .card-default .checkbox label > span {
  vertical-align: middle;
}
::ng-deep.clarify-is .card-default .checkbox input {
  opacity: 0;
  position: absolute;
  display: none;
}
::ng-deep.clarify-is .card-default .checkbox input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.clarify-is .card-default .checkbox input + span::before {
  font-size: 12px;
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.clarify-is .card-default .checkbox input:checked + span {
  border-color: #5D9CEC;
  background-color: #5D9CEC;
}
::ng-deep.clarify-is .card-default .checkbox input:checked + span::before {
  opacity: 1;
}
::ng-deep.clarify-is .card-default .card-body__button {
  background-color: #f5f5f5;
  border-top: 1px solid #e3e3e3;
  padding: 12px 40px;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn + .btn {
  margin-left: 15px;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .float-right {
  margin-left: auto;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-clarify {
  background-color: rgb(0, 173, 208);
  border-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-clarify:hover {
  background-color: rgb(0, 173, 208);
  border-color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-cancel {
  padding: 0;
  margin-left: 25px;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-danger {
  background-color: #fff;
  border-color: #fff;
  color: #ef6272;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-danger:hover {
  background-color: #ED2D2D;
  border-color: #EC2121;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-warning em {
  margin: 0;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall:hover {
  background-color: #fff;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall:hover i {
  margin-right: 6px;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall i {
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body--ebtn {
  margin-top: 15px;
  padding: 15px 40px;
  border-top: 1px solid #CFDBE2;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn {
    padding: 12px 20px;
  }
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow {
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
  padding: 0 8px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
    width: 100%;
    text-align: center;
  }
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow > div + div {
    margin-top: 10px;
  }
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow > div.card-body--col--last {
  margin-left: auto;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  padding: 7px 16px;
  text-align: center;
  transition: all ease 0.3s;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
    font-size: 12px;
  }
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn-bottom--disable {
  opacity: 0.5;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn i,
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--save {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--clarify {
  background-color: rgb(0, 173, 208);
  color: #fff;
  border-color: rgb(0, 173, 208);
  font-weight: 900;
  font-family: "Open Sans";
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel {
  padding: 0;
  background-color: transparent;
  margin-left: 0;
  color: #676a6c;
  border: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel:hover {
  transition: all ease 0.3s;
  color: #000;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--converge {
  padding: 0 8px;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  cursor: pointer;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
  font-size: 14px;
  color: #676a6c;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
  background-color: #f5f5f5;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
    padding-right: 7px;
    padding-left: 7px;
  }
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover i {
  margin-right: 6px;
  color: #ed5562;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    background-color: #f5f5f5;
    color: #ed5562;
    padding-right: 16px;
    padding-left: 16px;
  }
}
@media only screen and (max-width: 767px) and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    padding-right: 7px;
    padding-left: 7px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall > span {
    position: relative;
    left: 0;
  }
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
    margin-right: 6px !important;
  }
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .note-3 {
  margin-bottom: 15px;
}
::ng-deep.clarify-is .card-default .note-3 label {
  color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .footer-line {
  color: rgb(0, 173, 208);
  font-size: 15px;
}
::ng-deep.clarify-is .card-default .card-body__edit {
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs {
  width: 100%;
  margin-right: 0;
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs input,
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs select,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs input,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__minus--hide,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__minus--hide {
  display: none;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce {
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce .converge-icon,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce .converge-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 7px;
  font-size: 26px;
  color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip, ::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce .converge-icon:active > .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce .converge-icon:active > .card-body__tooltip {
  display: block;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce .converge-icon .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce .converge-icon .card-body__tooltip {
  display: none;
  font-size: 16px;
  color: #676a6c;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: max-content;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce input,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce input {
  padding-left: 26px;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow > div {
  padding: 0 15px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow > div:first-child {
  display: none;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol.hideblk {
  display: none;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol--2 {
  width: 50%;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow > div > div {
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow select {
  appearance: none;
  background-image: url("https://assets.foursightonline.com/app/images/select.png");
  background-size: 10px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  font-family: "Open Sans";
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow select:hover, ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow select:focus, ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow select:active {
  outline: none;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editlabel,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel {
  width: 35px;
  padding-right: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-weight: 700;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editnumber,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber {
  width: 40px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-right: 0;
  border-radius: 4px 0 0 4px;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editnumber + .card-body__editinput,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput {
  width: calc(100% - 41px);
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editnumber label,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label {
  margin-bottom: 0;
  font-weight: 900;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editselect,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
  width: 315px;
  padding-right: 15px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editselect,
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
    width: 100%;
    padding-right: 0;
    margin-bottom: 10px;
  }
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
  width: calc(100% - 351px);
  padding-right: 60px;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput input,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input {
  padding-right: 70px;
  font-family: "Open Sans";
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput input:hover, ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput input:focus, ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput input:active,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:hover,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:active {
  outline: none;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput,
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput .input-group-text,
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput .input-group-text {
    top: auto;
    transform: translate(0);
    bottom: 9px;
  }
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce {
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce .converge-icon,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 7px;
  font-size: 26px;
  color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip, ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce .converge-icon:active > .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:active > .card-body__tooltip {
  display: block;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce .converge-icon .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon .card-body__tooltip {
  display: none;
  font-size: 16px;
  color: #676a6c;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: max-content;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce input,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input {
  padding-left: 26px;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput:only-child,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child {
  width: 100%;
}
::ng-deep.clarify-is .card-default .card-body__edit + .card-body__addnew button {
  margin: 0 36px;
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  color: #676a6c;
  transition: all ease 0.3s;
  font-weight: 900;
}
::ng-deep.clarify-is .card-default .card-body__edit + .card-body__addnew button:hover {
  background-color: rgb(0, 173, 208);
  border: 1px solid rgb(0, 173, 208);
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}
::ng-deep.clarify-is .card-default .input-tabs {
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 0 0 0 0;
  margin: 0;
}
::ng-deep.clarify-is .card-default .input-tabs + i {
  position: relative;
  top: -1px;
}
::ng-deep.clarify-is .card-default .input-tabs.card__body--cs {
  position: relative;
  border-bottom: 1px solid #e4e4e4;
}
::ng-deep.clarify-is .card-default .input-tabs.card__body--cs::before, ::ng-deep.clarify-is .card-default .input-tabs.card__body--cs::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: 100%;
  width: 40px;
  height: 1px;
  background-color: #e4e4e4;
}
::ng-deep.clarify-is .card-default .input-tabs.card__body--cs::after {
  right: auto;
  left: 100%;
}
::ng-deep.clarify-is .card-default .input-tabs .select_faded {
  opacity: 0.2;
  padding-left: 32px;
}
::ng-deep.clarify-is .card-default .input-tabs input,
::ng-deep.clarify-is .card-default .input-tabs select {
  height: 45px;
  padding: 9px 15px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  margin: 7px 0px;
}
::ng-deep.clarify-is .card-default .input-tabs label {
  width: 20px;
  margin: 0;
}
::ng-deep.clarify-is .card-default .input-tabs select {
  width: 9%;
}
::ng-deep.clarify-is .card-default .input-tabs input {
  width: 90%;
  margin-left: 15px;
}
::ng-deep.clarify-is .card-default .input-group-text {
  cursor: pointer;
  padding: 3px 16px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.528571429;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #E9ECEF;
  border: 1px solid #DDE6E9;
  border-radius: 0.25rem;
  position: absolute;
  top: calc(50% + 1px);
  right: 0;
  transform: translateY(-50%);
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .input-group-text:hover {
  background-color: rgb(0, 173, 208);
  border-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep.clarify-is .card-bottom-button .button {
  font-size: 13px;
  color: #fff;
  padding: 8px 10px;
  border-radius: 3px;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-bottom-button .button:hover {
  opacity: 0.8;
}
::ng-deep.clarify-is .card-bottom-button .button i {
  font-size: 0.8em;
}
::ng-deep.clarify-is .card-bottom-button .button.btn-clarify {
  background-color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-bottom-button .button.btn-ideate {
  background-color: rgb(255, 121, 0);
}
::ng-deep.clarify-is .card-bottom-button .button.btn-implement {
  background-color: rgb(245, 67, 89);
}
::ng-deep.clarify-is .datadump-content-tabs {
  display: flex;
  flex-wrap: wrap;
  counter-reset: section;
}
::ng-deep.clarify-is .dump-tabs:first-child {
  display: none;
}
::ng-deep.clarify-is .dump-tabs {
  width: calc(50% - 50px) !important;
}
::ng-deep.clarify-is .datadump__col {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 17px;
}
::ng-deep.clarify-is .datadump__col .datadump-main {
  width: calc(100% - 68px);
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.clarify-is .datadump__col .datadump-main .datadump-group {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.clarify-is .datadump__col .datadump-main .datadump-group input {
  margin-bottom: 0px;
  width: 100%;
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 0 0.25rem 0.25rem 0;
}

.prevnext {
  padding: 20px 0;
}
.prevnext__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  margin: 0;
}
.prevnext li {
  list-style: none;
}
.prevnext li.prevnext__next {
  margin-left: auto;
}
.prevnext li.prevnext__prev a:hover > i {
  left: -5px;
}
.prevnext li.prevnext__next a {
  background-color: rgb(0, 173, 208);
  color: #fff;
  opacity: 1;
  padding: 6px 12px;
  border-radius: 3px;
}
.prevnext li.prevnext__next a:hover > i {
  left: 3px;
}
.prevnext li a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 14px;
  color: #676a6c;
  opacity: 0.47;
  padding: 6px 0;
  display: inline-block;
  transition: all ease 0.3s;
}
.prevnext li a i {
  position: relative;
  font-size: 1.1em;
  left: 0;
  transition: all ease 0.3s;
}

.playbtn {
  position: absolute;
  right: 10px;
  bottom: 7px;
  color: #06a6ce;
}

.Del-data-btn {
  padding: 40px 0;
}
.Del-data-btn .btn {
  margin-left: 15px;
  background-color: #fff;
  border-color: #f5f5f5;
  color: #ff485c;
}
.Del-data-btn .cancelbtn {
  color: #676a6c;
  text-align: center;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
}

.editmode__listrow {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow {
    grid-template-columns: 1fr;
  }
}
.editmode__listrow--equalblocks {
  display: flex;
  flex-wrap: wrap;
}
.editmode__listrow--equalblocks > .editmode__listcol {
  flex: 1;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow--equalblocks > .editmode__listcol {
    flex: none;
    width: 100%;
  }
}
.editmode__listrow--fullblocks {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid1 {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid3 > div:nth-child(1) {
  grid-row: 1/3;
}
.editmode__listrow--grid4 > div:nth-child(1) {
  grid-row: 1/4;
}
.editmode__listrow--grid5 > div:nth-child(1) {
  grid-row: 1/5;
}
.editmode__listrow--grid6 > div:nth-child(1) {
  grid-row: 1/6;
}
.editmode__listrow--grid7 > div:nth-child(1) {
  grid-row: 1/7;
}
.editmode__listcell {
  padding: 10px 15px;
  background-color: #EBEBEB;
  border: 1px solid #CFDBE2;
  border-radius: 6px;
  height: 100%;
}
.editmode__listcell--startbtn {
  border: 1px solid rgb(0, 173, 208);
  color: rgb(0, 173, 208);
  font-weight: 600;
  font-family: "Open Sans";
  font-size: 16px;
  cursor: pointer;
  line-height: 1;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell {
    font-size: 13px;
  }
}
.editmode__listcell h3 {
  color: rgb(0, 173, 208);
  margin-bottom: 5px;
}
.editmode__listcell h3 a,
.editmode__listcell h3 i {
  color: inherit;
}
.editmode__listcell p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell p {
    font-size: 13px;
  }
}
.editmode__listcell p:last-child {
  margin-bottom: 0;
}

.container-fluid {
  position: relative;
}
.container-fluid .trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
.container-fluid .trackInfo--clr {
  color: transparent !important;
}
.container-fluid .trackInfo--inputclr {
  color: rgb(0, 173, 208);
  font-size: 18px;
  background: transparent;
  margin-left: 0;
  padding-left: 0;
  position: absolute;
  left: 40px;
  top: 18px;
  font-size: 11px;
  background: transparent;
  margin-left: 8px;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.stick-challenge {
  position: relative;
}
.stick-challenge .card-body__inner {
  min-height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9;
  position: relative;
  padding-top: 0;
}
.stick-challenge .card-body__inner .card-body__subtitle {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
  padding: 15px 0 15px 35px;
  margin: 0;
}

.row--editmodebg {
  background-color: #fff;
  padding: 40px 35px;
}
.row--wbg {
  background-color: #fff;
}

.swal2-show button.swal2-cancel.swal2-styled.wbg {
  background-color: red !important;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.cn-dmodal {
  display: none;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

label {
  font-family: "Open Sans", sans-serif;
}

::ng-deep#page-wrapper {
  padding-bottom: 60px;
}

::ng-deep#wrapper {
  overflow-x: initial;
}

::ng-deep.develop-is.editmode {
  padding: 5px 60px;
  background: #ebebeb;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is.editmode {
    padding: 40px 0 0;
  }
}
::ng-deep.develop-is.editmode .mainnav {
  margin: 0 0 15px;
}
::ng-deep.develop-is.editmode .editmode_icons .formattingIcon li {
  border-radius: 5px;
  height: 31px;
  margin-left: 5px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is.editmode .editmode_icons .formattingIcon li {
    display: none;
  }
  ::ng-deep.develop-is.editmode .editmode_icons .formattingIcon li:first-child {
    display: block;
  }
}
::ng-deep.develop-is.editmode .editmode_icons .formattingIcon li svg {
  cursor: pointer;
}
::ng-deep.develop-is .highlight {
  background-color: #B4D5FF;
}
::ng-deep.develop-is .mainnav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-wrap: nowrap;
  margin: 30px 0 40px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .mainnav {
    margin: 10px 0 30px;
  }
}
::ng-deep.develop-is .mainnav.mainnav--bottom {
  margin: 30px 0 40px;
}
::ng-deep.develop-is .mainnav.mainnav--bottom ul li a {
  padding: 12px 30px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .mainnav.mainnav--bottom ul li a {
    padding: 10px 20px;
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .mainnav.mainnav--bottom ul li a {
    padding: 11px 5px;
    font-size: 11px;
  }
}
::ng-deep.develop-is .mainnav.mainnav--bottom ul li.active a {
  background-color: #bbb !important;
  border-top: 1px solid #bbb !important;
  border-bottom: 1px solid #bbb !important;
}
::ng-deep.develop-is .mainnav__editmodeicon {
  margin-left: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .mainnav__editmodeicon {
    margin: 10px 0 0 auto;
  }
}
::ng-deep.develop-is .mainnav__editmodeicon ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  height: 100%;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li {
  list-style: none;
  transition: none;
  width: 37px;
  height: 100%;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #CFDBE2;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.active {
  background-color: #676a6c;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li:not(:last-child) {
  margin-right: 5px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .mainnav__editmodeicon ul li:not(:last-child) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .mainnav__editmodeicon ul li {
    width: 35px;
    height: 31px;
    display: none;
  }
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.mainnav__editmodepin {
  display: flex;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st0 {
  fill: #FFFFFF;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st1 {
  fill: #cfdbe2;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st0 {
  fill: #6d6e71;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st1 {
  fill: #FFFFFF;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.listView svg .st0, ::ng-deep.develop-is .mainnav__editmodeicon ul li.individualView svg .st0, ::ng-deep.develop-is .mainnav__editmodeicon ul li.gridView svg .st0 {
  fill: #6d6e71;
}
::ng-deep.develop-is .mainnav__editmodeicon ul li.listView svg .st1, ::ng-deep.develop-is .mainnav__editmodeicon ul li.individualView svg .st1, ::ng-deep.develop-is .mainnav__editmodeicon ul li.gridView svg .st1 {
  fill: #FFFFFF;
}
::ng-deep.develop-is .mainnav.editnav {
  justify-content: space-between;
  align-items: center;
  background: #EBEBEB;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .mainnav.editnav {
    flex-direction: column;
  }
}
::ng-deep.develop-is .mainnav.editnav ul {
  background-color: #ebebeb;
  border-radius: 5px;
  width: 100%;
  flex: 1;
}
::ng-deep.develop-is .mainnav.editnav ul .develop.active {
  background-color: rgb(105, 190, 40);
}
::ng-deep.develop-is .mainnav.editnav ul li {
  background-color: #fff;
  width: 100%;
}
::ng-deep.develop-is .mainnav.editnav ul li a {
  padding: 5px 2px;
  width: 100%;
  text-align: center;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .mainnav.editnav .editmode_icons {
    margin: 10px 0 0 auto;
  }
}
::ng-deep.develop-is .info {
  color: #fff;
  border: 1px solid rgb(105, 190, 40);
  margin-bottom: 18px;
  padding: 20px 40px;
  border-radius: 6px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .info {
    padding: 12px 20px;
  }
}
::ng-deep.develop-is .info.infotitle {
  background-color: rgb(105, 190, 40);
}
::ng-deep.develop-is .info.infotitle h3 {
  color: #fff;
}
::ng-deep.develop-is .info h1 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .info h1 {
    font-size: 28px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info h1 {
    font-size: 24px;
  }
}
::ng-deep.develop-is .info h1 .info__maintitle {
  margin-right: auto;
}
::ng-deep.develop-is .info h1 small {
  color: #fff;
  font-size: 80%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info h1 small {
    width: 100%;
    margin-top: 5px;
  }
}
::ng-deep.develop-is .info .card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
::ng-deep.develop-is .info .card__toprow--tne .card__topcol:first-child {
  width: 72% !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info .card__toprow--tne .card__topcol:first-child {
    flex: 1;
    width: auto !important;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol {
  padding: 0 15px;
  width: 33.3333333333%;
}
::ng-deep.develop-is .info .card__toprow .card__topcol--full {
  width: 100% !important;
}
::ng-deep.develop-is .info .card__toprow .card__topcol:nth-child(1) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol:nth-child(1) {
    flex: 1;
    margin-right: auto;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol--tab {
  width: 44%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol--tab {
    width: 120px;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol--tt {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol--tt {
    width: auto;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol:nth-child(3) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol:nth-child(3) {
    width: auto;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tt {
  margin-left: auto;
  text-align: right;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--title > div:first-child {
  margin-right: 15px;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--startexist {
  width: 65%;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--startexist + div {
  width: 35%;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
  line-height: 1;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:not(:first-child) {
  margin-left: -1px;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button {
  color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid rgb(105, 190, 40);
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg .st0 {
  fill: rgb(105, 190, 40);
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: rgb(105, 190, 40);
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover {
  color: rgb(105, 190, 40);
  opacity: 1;
}
::ng-deep.develop-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover > span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.develop-is .info .card__toprow .card__h3button {
  border: 1px solid rgb(105, 190, 40);
  background-color: transparent;
  padding: 2px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(105, 190, 40);
  font-size: 22px;
  line-height: 1.2;
  transition: all ease 0.3s;
  cursor: pointer;
}
::ng-deep.develop-is .info .card__toprow .card__h3button.disabled {
  cursor: not-allowed;
}
::ng-deep.develop-is .info .card__toprow .card__h3button:hover {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.develop-is .info .card__toprow .card__h3button:focus {
  outline: none;
}
::ng-deep.develop-is .info .card__toprow .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.develop-is .info .card__toprow .tooltipicon i {
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .info .card__toprow .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.develop-is .info .card__toprow .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(105, 190, 40);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.develop-is .info h3 {
  font-size: 20px;
  margin: 0;
  cursor: pointer;
  color: rgb(105, 190, 40);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .info h3 {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info h3 {
    font-size: 15px;
    word-break: break-word;
  }
}
::ng-deep.develop-is .info h3 .card__bwnh3title {
  margin-right: 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info h3 .card__bwnh3button {
    width: 100%;
    margin-top: 10px;
  }
}
::ng-deep.develop-is .info h3 .card__bwnh3button button {
  font-size: 18px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .info h3 .card__bwnh3button button {
    font-size: 16px !important;
  }
}
::ng-deep.develop-is .info h3 i {
  cursor: pointer;
  font-size: 0.9em;
}
::ng-deep.develop-is .info h3 i + div {
  padding-left: 7px;
}
::ng-deep.develop-is .info h3 i + div span {
  display: block;
  font-size: 0.7em;
}
::ng-deep.develop-is .info h3 i + span {
  padding-left: 7px;
}
::ng-deep.develop-is .info h3 a {
  margin-left: 10px;
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .info h3 > a {
  margin-left: 0px;
}
::ng-deep.develop-is .info h3.d-flex {
  display: flex;
}
::ng-deep.develop-is .info h3.d-flex div:first-child {
  padding-right: 10px;
}
::ng-deep.develop-is .info h3.d-flex div:nth-child(2) span {
  display: block;
}
::ng-deep.develop-is .info .tooltipicon {
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.develop-is .info .tooltipicon i {
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .info .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.develop-is .info .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(105, 190, 40);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.develop-is .cn-section-heading {
  display: flex;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 10px;
  padding: 14px 24px;
  background-color: #ecf9e2;
  border-left: 4px solid rgb(105, 190, 40);
  border-radius: 0 6px 6px 0;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .cn-section-heading {
    padding: 12px 16px;
    margin-top: 30px;
  }
}
::ng-deep.develop-is .cn-section-heading__title {
  font-size: 22px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(105, 190, 40);
  margin: 0;
  line-height: 1.3;
  letter-spacing: 0.5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .cn-section-heading__title {
    font-size: 18px;
  }
}
::ng-deep.develop-is .cn-section-heading__btn {
  margin-left: 16px;
  padding: 6px 20px;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  color: #fff;
  background-color: rgb(105, 190, 40);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
::ng-deep.develop-is .cn-section-heading__btn:hover {
  opacity: 0.85;
}
::ng-deep.develop-is app-develop-challenge-top-ideas,
::ng-deep.develop-is app-develop-challenge-solution-prototype,
::ng-deep.develop-is app-develop-challenge-pluses,
::ng-deep.develop-is app-develop-challenge-opportunities,
::ng-deep.develop-is app-develop-challenge-issues,
::ng-deep.develop-is app-develop-challenge-new-thinking,
::ng-deep.develop-is app-develop-challenge-solution {
  display: block;
  margin-top: 30px;
}
::ng-deep.develop-is app-develop-challenge-pluses {
  margin-top: 10px;
}
::ng-deep.develop-is app-develop-challenge-solution {
  margin-top: 40px;
}
::ng-deep.develop-is .card-default {
  border-radius: 6px;
  border-top-width: 3px;
  border: 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
::ng-deep.develop-is .card-default.card-default--summary {
  box-shadow: none;
}
::ng-deep.develop-is .card-default.card-default--summary .info {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.develop-is .card-default.card-default--summary .card-body {
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
  border-radius: 0;
}
::ng-deep.develop-is .card-default.card-default--summary .card-body__inner {
  padding: 15px 20px;
}
::ng-deep.develop-is .card-default.card-default--summary + div {
  margin-top: 20px;
}
::ng-deep.develop-is .card-default + div {
  margin-top: 30px;
}
::ng-deep.develop-is .card-default .info {
  margin: 0;
  border: 1px solid rgb(105, 190, 40);
  border-radius: 6px;
}
::ng-deep.develop-is .card-default .info.card__headactive {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.develop-is .card-default .card-body__inner {
  padding: 15px 40px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default .card-body__inner {
    padding: 12px 20px;
  }
}
::ng-deep.develop-is .card-default .card-body {
  display: none;
  border: 1px solid #CFDBE2;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
::ng-deep.develop-is .card-default .card-body.stCard__body {
  border: none;
}
::ng-deep.develop-is .card-default .card-body.stCard__body .card-body__inner {
  padding: 0 !important;
}
::ng-deep.develop-is .card-default .card-body.stCard__body .card-body__subtitle {
  padding: 0 40px 5px !important;
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body.card-show {
  display: block;
}
::ng-deep.develop-is .card-default .card-body__finalstate p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__finalstate p {
    font-size: 13px;
  }
}
::ng-deep.develop-is .card-default .card-body__finalstate p:last-child {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body__finalstate--2, ::ng-deep.develop-is .card-default .card-body__finalstate--row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
::ng-deep.develop-is .card-default .card-body__finalstate--2 > div, ::ng-deep.develop-is .card-default .card-body__finalstate--row > div {
  width: 50%;
  padding: 0 10px;
  margin-bottom: 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__finalstate--2 > div, ::ng-deep.develop-is .card-default .card-body__finalstate--row > div {
    width: 100%;
  }
}
::ng-deep.develop-is .card-default .card-body__finalstate--2 > div p, ::ng-deep.develop-is .card-default .card-body__finalstate--row > div p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.develop-is .card-default .card-body__finalstate--2 > div p::before, ::ng-deep.develop-is .card-default .card-body__finalstate--row > div p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.develop-is .card-default .card-body__finalstate--cc {
  display: block;
  column-count: 2;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__finalstate--cc {
    column-count: 1;
  }
}
::ng-deep.develop-is .card-default .card-body__finalstate--cc > div {
  page-break-inside: avoid;
  break-inside: avoid;
}
::ng-deep.develop-is .card-default .card-body__finalstate--3 {
  margin: 0 -10px;
}
::ng-deep.develop-is .card-default .card-body__finalstate--3 > div {
  width: 50%;
  padding: 0 10px;
  margin-bottom: 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__finalstate--3 > div {
    width: 100%;
  }
}
::ng-deep.develop-is .card-default .card-body__finalstate--3 > div p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.develop-is .card-default .card-body__finalstate--3 > div p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.develop-is .card-default .card-body__listwidthdot ul {
  padding-left: 30px;
}
::ng-deep.develop-is .card-default .card-body__subtitle {
  padding-left: 35px;
  margin-bottom: 16px;
  position: relative;
}
::ng-deep.develop-is .card-default .card-body__subtitle--convtxt {
  padding-left: 31px;
}
::ng-deep.develop-is .card-default .card-body__subtitle > span {
  position: absolute;
  top: 0;
  right: 2px;
  opacity: 0.7;
  cursor: pointer;
}
::ng-deep.develop-is .card-default .card-body__subtitle > span.thinkeyebtn {
  right: 40px;
}
::ng-deep.develop-is .card-default .card-body__subtitle--pl0 {
  padding-left: 0;
}
::ng-deep.develop-is .card-default .card-body__subtitle *:last-child {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body__subtitle p {
  color: #969798;
  font-size: 15px;
}
::ng-deep.develop-is .card-default .card-body__subtitle p i {
  padding-left: 5px;
}
::ng-deep.develop-is .card-default .card-body__strength p.pl20 {
  padding-left: 20px;
}
::ng-deep.develop-is .card-default .card-body__strength > * {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body__strength > * + * {
  margin-top: 4px;
}
::ng-deep.develop-is .card-default .card-body__strength + div {
  margin-top: 20px;
}
::ng-deep.develop-is .card-default .card-body__solutionstable {
  margin-bottom: 20px;
}
::ng-deep.develop-is .card-default .card-body__solutionstable table {
  width: 100%;
}
::ng-deep.develop-is .card-default .card-body__solutionstable th,
::ng-deep.develop-is .card-default .card-body__solutionstable td {
  padding: 15px 15px 15px 0;
  vertical-align: top;
  width: 50%;
}
::ng-deep.develop-is .card-default .c-radio label {
  padding-left: 0;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.develop-is .card-default .c-radio label > i {
  position: relative;
  top: 2px;
  margin-right: 6px;
  opacity: 0.6;
}
::ng-deep.develop-is .card-default .c-radio label > span {
  vertical-align: middle;
}
::ng-deep.develop-is .card-default .c-radio input {
  opacity: 0;
  margin: 0;
  display: none;
}
::ng-deep.develop-is .card-default .c-radio input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.develop-is .card-default .c-radio input + span::before {
  position: absolute;
  color: rgb(0, 173, 208);
  opacity: 0;
  font-size: 11px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.develop-is .card-default .c-radio input:checked + span {
  border-color: rgb(0, 173, 208);
}
::ng-deep.develop-is .card-default .c-radio input:checked + span::before {
  opacity: 1;
}
::ng-deep.develop-is .card-default .checkbox {
  margin-top: 0;
}
::ng-deep.develop-is .card-default .checkbox a i {
  color: #676a6c;
}
::ng-deep.develop-is .card-default .checkbox .fa.fa-check.disabled {
  opacity: 0.7;
}
::ng-deep.develop-is .card-default .checkbox label {
  min-height: 20px;
  padding-left: 0;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
  width: auto !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .checkbox label {
    font-size: 14px;
  }
}
::ng-deep.develop-is .card-default .checkbox label > i {
  position: relative;
  top: 1px;
  margin-right: 3px;
}
::ng-deep.develop-is .card-default .checkbox label > span {
  vertical-align: middle;
}
::ng-deep.develop-is .card-default .checkbox input {
  opacity: 0;
  position: absolute;
  display: none;
}
::ng-deep.develop-is .card-default .checkbox input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.develop-is .card-default .checkbox input + span::before {
  font-size: 12px;
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.develop-is .card-default .checkbox input:checked + span {
  border-color: rgb(105, 190, 40);
  background-color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-default .checkbox input:checked + span::before {
  opacity: 1;
}
::ng-deep.develop-is .card-default .card-body__button {
  background-color: #f5f5f5;
  border-top: 1px solid #e3e3e3;
  padding: 12px 40px;
}
::ng-deep.develop-is .card-default .card-body__button .card-button {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn + .btn {
  margin-left: 15px;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .float-right {
  margin-left: auto;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-develop {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-develop:hover {
  background-color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-danger {
  background-color: #fff;
  border-color: #fff;
  color: #ef6272;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-danger:hover {
  background-color: #ED2D2D;
  border-color: #EC2121;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-warning em {
  margin: 0;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall:hover {
  background-color: #fff;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall:hover {
    padding-right: 7px;
    padding-left: 7px;
  }
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall:hover em {
  margin-right: 6px;
}
::ng-deep.develop-is .card-default .card-body__button .card-button .btn-deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body--ebtn {
  margin-top: 15px;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow {
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
  padding: 0 8px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
    width: 100%;
    text-align: center;
  }
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow > div + div {
    margin-top: 10px;
  }
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow > div.card-body--col--last {
  margin-left: auto;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  padding: 7px 16px;
  text-align: center;
  transition: all ease 0.3s;
  font-weight: 900;
  cursor: pointer;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
    font-size: 12px;
  }
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn i {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--save {
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-weight: 900;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--disable {
  opacity: 0.5;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel {
  padding: 0;
  background-color: transparent;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  cursor: pointer;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel:hover {
  color: #000;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--close {
  border-color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--converge {
  padding: 0 8px;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
  font-size: 14px;
  color: #676a6c;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
  font-weight: 900;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
  background-color: #f5f5f5;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
    padding-right: 7px;
    padding-left: 7px;
  }
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover em {
  margin-right: 6px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    background-color: #f5f5f5;
    color: #ed5562;
    padding-right: 16px;
    padding-left: 16px;
  }
}
@media only screen and (max-width: 767px) and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    padding-right: 7px;
    padding-left: 7px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall > span {
    position: relative;
    left: 0;
  }
  ::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
    margin-right: 6px !important;
  }
}
::ng-deep.develop-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .strengthen-input-tabs {
  width: 90%;
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.develop-is .card-default .strengthen-input-tabs input {
  height: 35px;
  padding: 10px 15px;
  border: 1px solid rgb(105, 190, 40);
  border-radius: 4px;
  margin-bottom: 15px;
}
::ng-deep.develop-is .card-default .input-tabs.cdk-drag {
  width: 100% !important;
}
::ng-deep.develop-is .card-default .input-tabs.cdk-drag p {
  margin-bottom: 5px;
}
::ng-deep.develop-is .card-default .note-3 {
  padding: 15px 15px 10px;
  border: 2px solid rgb(0, 173, 208);
  margin-bottom: 15px;
}
::ng-deep.develop-is .card-default .note-3 label {
  color: rgb(0, 173, 208);
}
::ng-deep.develop-is .card-default .footer-line {
  color: rgb(0, 173, 208);
}
::ng-deep.develop-is .card-default p {
  font-size: 15px;
}
::ng-deep.develop-is .card-default p:last-child {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body__edit {
  position: relative;
}
::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs,
::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs {
  width: 100%;
  margin-right: 0;
  position: relative;
}
::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs input,
::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs select,
::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs input,
::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs input,
  ::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs select,
  ::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs input,
  ::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs select {
    font-size: 13px;
  }
}
::ng-deep.develop-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__minus--hide,
::ng-deep.develop-is .card-default .card-body__edit .datadump-input-tabs .card-body__minus--hide {
  display: none;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow > div {
  padding: 0 15px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol.hideblk {
  display: none;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol--2 {
  width: 50%;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow > div > div {
  position: relative;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow select {
  appearance: none;
  background-image: url("https://assets.foursightonline.com/app/images/select.png");
  background-size: 10px;
  background-position: right 10px center;
  background-repeat: no-repeat;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow textarea {
  width: 100%;
  border: 1px solid #ccc;
  resize: none;
  border-radius: 3px;
  padding: 10px 15px;
  font-size: 15px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow textarea:focus, ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow textarea:focus-visible {
  outline: none;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel {
  width: 35px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel label,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel label {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber {
  width: 40px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-right: 0;
  border-radius: 4px 0 0 4px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput {
  width: calc(100% - 41px);
  padding-right: 60px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput input:focus, ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput input:focus-visible,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput input:focus,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput input:focus-visible {
  outline: none;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label {
  margin-bottom: 0;
  font-weight: 900;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
  width: 158px;
  padding-right: 15px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect--wd,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect--wd {
  width: 255px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect select:focus,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect select:focus {
  outline: rgb(105, 190, 40);
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect,
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
    width: 100%;
    padding-right: 0;
    margin-bottom: 10px;
  }
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
  width: calc(100% - 195px);
  padding-right: 60px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--wd,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--wd {
  width: calc(100% - 260px);
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce {
  position: relative;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 7px;
  font-size: 26px;
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip, ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:active > .card-body__tooltip,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:active > .card-body__tooltip {
  display: block;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon .card-body__tooltip,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon .card-body__tooltip {
  display: none;
  font-size: 16px;
  color: #676a6c;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: max-content;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input {
  padding-left: 26px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input:focus, ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input:focus-visible,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input:focus,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input:focus-visible {
  outline: none;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input {
  padding-right: 70px;
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus, ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus-visible,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus-visible {
  outline: none;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput,
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput .input-group-text,
  ::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput .input-group-text {
    top: auto;
    transform: translate(0);
    bottom: 9px;
  }
}
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child,
::ng-deep.develop-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child {
  width: 100%;
}
::ng-deep.develop-is .card-default .card-body__edit + .card-body__addnew button {
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  margin: 0 35px;
  color: #676a6c;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .card-body__edit + .card-body__addnew button:hover {
  background-color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}
::ng-deep.develop-is .card-default .breakthrough-input-tabs {
  width: 90%;
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.develop-is .card-default .breakthrough-input-tabs input {
  height: 35px;
  padding: 10px 15px;
  border: 1px solid rgb(105, 190, 40);
  border-radius: 4px;
}
::ng-deep.develop-is .card-default .input-group-text {
  cursor: pointer;
  padding: 3px 16px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.528571429;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #E9ECEF;
  border: 1px solid #DDE6E9;
  border-radius: 0.25rem;
  position: absolute;
  top: calc(50% + 1px);
  right: 0;
  transform: translateY(-50%);
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-default .input-group-text:hover {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.develop-is .card-default .list-columns {
  display: flex;
  flex-wrap: wrap;
  counter-reset: section;
}
::ng-deep.develop-is .card-default .list-columns > div {
  width: 50%;
}
::ng-deep.develop-is .card-default .list-columns > div.card__body--cswrapper {
  width: 100%;
  position: relative;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 5px;
  margin-bottom: 10px;
}
::ng-deep.develop-is .card-default .list-columns > div.card__body--cswrapper::before, ::ng-deep.develop-is .card-default .list-columns > div.card__body--cswrapper::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: 100%;
  width: 40px;
  height: 1px;
  background-color: #e4e4e4;
}
::ng-deep.develop-is .card-default .list-columns > div.card__body--cswrapper::after {
  right: auto;
  left: 100%;
}
::ng-deep.develop-is .card-default .list-columns.list-columns--2 > div {
  width: 100%;
}
::ng-deep.develop-is .card-default .list-columns--tc {
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 10px;
}
::ng-deep.develop-is .card-default .list-columns .brainstorm-tabs {
  position: relative;
  padding-left: 23px;
}
::ng-deep.develop-is .card-default .list-columns .brainstorm-tabs::before {
  counter-increment: section;
  content: counter(section) ".";
  position: absolute;
  top: 0;
  left: 0;
}
::ng-deep.develop-is .card-default.editmodeActive {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-shadow: none;
  background: #fff;
  padding: 40px 35px;
  position: relative;
}
::ng-deep.develop-is .card-default.editmodeActive--not {
  padding: 0;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.top_idea {
  width: 100%;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol {
    grid-template-columns: 1fr;
  }
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol .EditmodeInputs > f-col-12 {
  height: 100%;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--1 {
  grid-template-columns: 1fr;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--3 > div:nth-child(1) {
  grid-row: 1/3;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--4 > div:nth-child(1) {
  grid-row: 1/4;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--5 > div:nth-child(1) {
  grid-row: 1/5;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--6 > div:nth-child(1) {
  grid-row: 1/6;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.gridView > .card-body__petopcol--7 > div:nth-child(1) {
  grid-row: 1/7;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.listView {
  width: 100%;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.listView .EditmodeInputs + div {
  margin-top: 15px;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.listView .EditmodeInputs .f-col-12 {
  float: none;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.individualView .card-body__petopcol {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 -15px;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.individualView .card-body__petopcol .EditmodeInputs {
  flex: 1;
  padding: 0 7px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.editmodeActive .editinput.individualView .card-body__petopcol .EditmodeInputs {
    flex: none;
    width: 100%;
  }
  ::ng-deep.develop-is .card-default.editmodeActive .editinput.individualView .card-body__petopcol .EditmodeInputs + div {
    margin-top: 15px;
  }
}
::ng-deep.develop-is .card-default.editmodeActive .editinput.individualView .card-body__petopcol .EditmodeInputs .row {
  margin-right: 0;
  margin-left: 0;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 {
  background-color: #EBEBEB;
  border: 1px solid #CFDBE2;
  border-radius: 6px;
  overflow: hidden;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol {
  padding: 10px 15px;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol h3,
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol h4 {
  margin-bottom: 5px;
  color: rgb(105, 190, 40);
  font-size: 18px;
  white-space: nowrap;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol h3 a i,
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol h4 a i {
  cursor: pointer;
  font-size: 0.9em;
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol--ideateclr h3 {
  color: #676A6C;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol--ideateclr h3 a i {
  color: #676A6C;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol p {
  font-weight: 600;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate {
  position: relative;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate.SolutionHeight span svg {
  transform: rotate(0deg);
  cursor: pointer;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate span {
  position: absolute;
  bottom: -12px;
  right: -5px;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate span svg {
  transform: rotate(180deg);
  cursor: pointer;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate.TopIdeasInput span {
  cursor: pointer;
  position: relative;
  top: 0;
  left: 10px;
}
::ng-deep.develop-is .card-default.editmodeActive .editinput .f-col-12 .card-body__petopcol .card-body__finalstate.TopIdeasInput span svg {
  width: 10px;
  transform: rotate(180deg);
}
::ng-deep.develop-is .card-default.editmodeActive .editinput input:focus, ::ng-deep.develop-is .card-default.editmodeActive .editinput input:focus-visible {
  outline: none;
}
::ng-deep.develop-is .card-default.ediMode__pf {
  margin-top: 0;
}
::ng-deep.develop-is .card-default.ediMode__pf--wbg {
  background-color: #fff;
}
::ng-deep.develop-is .card-default.ediMode__pf > span {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body--ebtn {
  margin-top: 0;
  padding: 15px 40px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body--ebtn {
    padding: 12px 20px;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .new-thinking {
  background-color: #fff;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__inner {
  padding: 0;
}
::ng-deep.develop-is .card-default.ediMode__pf .info {
  padding: 14px 40px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .info {
    padding: 12px 20px;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter {
  border-bottom: 1px solid #CFDBE2;
  padding-right: 40px;
  padding-bottom: 50px;
  padding-left: 40px;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingmobile {
  display: none;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingmobile {
    display: block;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingdesk {
  padding-left: 13px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingdesk {
    display: none;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingdesk .card-body__ipwrap {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-headingdesk .card-body__ipcol {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter-pincontent {
  overflow-y: auto;
  overflow-x: hidden;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__backouter {
    padding-right: 20px;
    padding-left: 20px;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe {
  border-bottom: none;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe > div {
  padding: 0;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 {
  font-size: 25px;
  color: #fff;
  font-family: "Museo-700";
  font-weight: 700;
  white-space: nowrap;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 {
    font-size: 18px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 {
    font-size: 15px;
    padding-left: 35px;
    word-break: break-word;
    white-space: normal;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 .card__bwnh3ai {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 6px;
  padding: 6px 8px;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
  transition: opacity 0.2s ease;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 .card__bwnh3ai:hover {
  opacity: 0.7;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4 .card__bwnh3ai i {
  font-size: 14px;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4::before {
  background-color: #fff;
  color: rgb(105, 190, 40);
  font-family: "Museo-700";
  font-weight: 700;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe h4::before {
    width: 20px;
    height: 20px;
    font-size: 15px;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop {
  background-color: rgb(105, 190, 40);
  position: relative;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card__topcol--tt .tooltipicon__icon {
  color: #fff;
  cursor: pointer;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button {
  min-height: 40px;
  padding: 6px 24px;
  background-color: #fff;
  color: rgb(105, 190, 40);
}
@media only screen and (max-width: 991px) {
  ::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
    min-height: auto;
    height: auto;
    width: auto;
  }
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button svg .st0 {
  fill: #fff;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab.card-body__petopcol--ctt {
  position: relative;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab.card-body__petopcol--ctt ul li .card-body__tooltip {
  display: none;
  position: absolute;
  background: #fff;
  color: #676a6c;
  padding: 5px;
  top: -27px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  width: max-content;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab.card-body__petopcol--ctt ul li button:hover {
  opacity: 0.2 !important;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab.card-body__petopcol--ctt ul li:hover .card-body__tooltip, ::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab.card-body__petopcol--ctt ul li:active .card-body__tooltip {
  display: block;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title > div:first-child {
  width: 245px;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title .plus h4::before {
  content: "P" !important;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title .opp h4::before {
  content: "O" !important;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title .issue h4::before {
  content: "I" !important;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title .solution_pro_st {
  width: 300px !important;
  margin-left: -40px;
}
::ng-deep.develop-is .card-default.ediMode__pf .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title .solution_pro_st h4:before {
  display: none;
}
::ng-deep.develop-is .idea-shop-list {
  padding: 20px;
  margin-left: 17px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .idea-shop-list li {
  width: 50%;
  margin-bottom: 10px;
}
::ng-deep.develop-is .brainstorm__col {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 17px;
}
::ng-deep.develop-is .brainstorm__col .brainstorm-main {
  width: calc(100% - 68px);
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.develop-is .brainstorm__col .brainstorm-main .brainstorm-group {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend {
  margin-right: -1px;
  width: 45px;
}
::ng-deep.develop-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend .input-group-text {
  background: transparent;
  border-color: rgb(105, 190, 40);
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep.develop-is .brainstorm__col .brainstorm-main .brainstorm-group input {
  width: calc(100% - 45px);
  height: 35px;
  border: 1px solid rgb(255, 121, 0);
  border-radius: 0 0.25rem 0.25rem 0;
}
::ng-deep.develop-is .card-body__pe {
  padding: 0px;
  border: 1px solid #CFDBE2;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  float: none;
}
::ng-deep.develop-is .card-body__pe--npnb {
  border: none;
  margin-bottom: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .pluses {
  border: none !important;
  padding: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .pluses form {
  padding-left: 0 !important;
}
::ng-deep.develop-is .card-body__pe--npnb .opportunities {
  border: none !important;
  padding: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .opportunities form {
  padding-left: 0 !important;
}
::ng-deep.develop-is .card-body__pe--npnb .issues {
  border: none !important;
  padding: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .issues form {
  padding-left: 0 !important;
}
::ng-deep.develop-is .card-body__pe--npnb .new-thinking {
  border: none !important;
  padding: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .new-thinking form {
  padding-left: 0 !important;
}
::ng-deep.develop-is .card-body__pe--npnb .new-thinking .card-body__ipwrap {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-body__pe--npnb .new-thinking .card-body__ipwrap .card-body__ipcol:last-child {
  margin-bottom: 0;
}
::ng-deep.develop-is .card-body__pe .card-body__petop {
  margin-bottom: 13px;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol {
  padding: 0 15px;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol--full {
  width: 100% !important;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(1) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(1) {
    flex: 1;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(2) {
  width: 44%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(2) {
    width: 120px;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(3) {
  width: 28%;
  text-align: right;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol:nth-child(3) {
    width: auto;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title > div:first-child {
  width: 215px;
  padding-right: 15px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title > div:first-child {
    width: auto;
    padding-right: 5px;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title > div:nth-child(2) {
  width: calc(100% - 216px);
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title button.card__h3button {
  border: 1px solid rgb(105, 190, 40);
  background-color: transparent;
  padding: 4px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(105, 190, 40);
  font-size: 22px;
  transition: all ease 0.3s;
  cursor: pointer;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title button.card__h3button:hover {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--title button.card__h3button:focus {
  outline: none;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--startexist {
  width: 65%;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li {
  list-style: none;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topactive button {
  color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topactive button span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid rgb(105, 190, 40);
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topcomplete button span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 14px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  border: 1px solid #7bbc43;
  height: auto;
  min-height: 42px;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button svg .st0 {
  fill: rgb(105, 190, 40);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button {
    padding: 6px 0;
    border: 0 !important;
    width: 0;
    height: 24px;
    min-height: auto;
  }
}
@media only screen and (min-width: 630px) and (max-width: 991px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button {
    padding: 6px 7px;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: rgb(105, 190, 40);
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button:hover {
  color: rgb(105, 190, 40);
  opacity: 1;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--tab ul li button:hover > span.card__topcount {
  color: rgb(105, 190, 40);
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--info {
  text-align: right;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--info .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .card-body__petopcol.card-body__petopcol--info .tooltipicon i {
  color: #7bbc43;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow p.new-think-issue {
  margin-top: 10px;
}
::ng-deep.develop-is .card-body__pe .card-body__petop .card-body__petoprow .convergeMsg {
  width: 33.3333333333%;
}
::ng-deep.develop-is .card-body__pe > div {
  padding: 25px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe > div {
    width: 100%;
  }
}
::ng-deep.develop-is .card-body__pe .pluses {
  border-bottom: 1px solid #CFDBE2;
}
::ng-deep.develop-is .card-body__pe .pluses h4::before {
  content: "P";
}
::ng-deep.develop-is .card-body__pe .opportunities {
  border-bottom: 1px solid #CFDBE2;
}
::ng-deep.develop-is .card-body__pe .opportunities h4::before {
  content: "O";
}
::ng-deep.develop-is .card-body__pe .issues {
  border-bottom: 1px solid #CFDBE2;
}
::ng-deep.develop-is .card-body__pe .issues h4::before {
  content: "I";
}
::ng-deep.develop-is .card-body__pe .new-thinking h4::before {
  content: "Nt";
}
::ng-deep.develop-is .card-body__pe h4 {
  position: relative;
  padding-left: 50px;
  color: rgb(105, 190, 40);
  font-size: 19px;
  margin: 0 0 0;
  font-family: "Open Sans", sans-serif;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe h4 {
    padding-left: 35px;
  }
}
::ng-deep.develop-is .card-body__pe h4::before {
  content: "";
  background: rgb(105, 190, 40);
  color: #fff;
  font-size: 20px;
  height: 35px;
  width: 35px;
  position: absolute;
  border-radius: 50%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__pe h4::before {
    width: 25px;
    height: 25px;
  }
}
::ng-deep.develop-is .card-body__pe h4 small {
  display: block;
  margin-top: 4px;
  color: inherit;
  line-height: 1.3;
  font-size: 14px;
  color: #888;
}
::ng-deep.develop-is .card-body__pe span.fill-bottom {
  width: 100%;
  color: #888;
  font-size: 15px;
}
::ng-deep.develop-is .card-body__pe .icons-right i {
  font-size: 21px;
  color: rgb(105, 190, 40);
  cursor: pointer;
}
::ng-deep.develop-is .card-body__pe .icons-right i:not(:last-child) {
  margin-right: 10px;
}
::ng-deep.develop-is .card-body__pe .fill-input {
  width: calc(100% - 35px);
  display: inline-block;
  margin-right: 15px;
}
::ng-deep.develop-is .card-body__pe .fill-input label {
  display: inline-block;
  min-width: 20px;
}
::ng-deep.develop-is .card-body__pe .fill-input input {
  display: inline-block;
  width: calc(100% - 20px);
  height: 34px;
  border-radius: 3px;
  margin: 1px 0;
}
::ng-deep.develop-is .card-body__pe .input-tabs .input-tabs__row {
  width: calc(100% - 35px);
  display: inline-block;
  margin-right: 15px;
  position: relative;
  vertical-align: middle;
}
::ng-deep.develop-is .card-body__pe .input-tabs .input-tabs__row .pr-0 {
  padding-right: 0;
}
::ng-deep.develop-is .card-body__pe .input-tabs .input-tabs__row > i {
  position: absolute;
  top: 50%;
  right: -26px;
  transform: translateY(-50%);
}
::ng-deep.develop-is .card-body__pe .input-tabs label {
  display: inline-block;
  min-width: 20px;
}
::ng-deep.develop-is .card-body__pe .input-tabs input,
::ng-deep.develop-is .card-body__pe .input-tabs select {
  height: 34px;
  border-radius: 3px;
  margin: 1px 0;
}
::ng-deep.develop-is .card-body__pe .input-tabs select {
  display: inline-block;
  width: calc(100% - 20px);
}
::ng-deep.develop-is .card-body__pe .input-tabs .select_faded {
  opacity: 0.2;
  padding-left: 32px;
}
::ng-deep.develop-is .develop-footer-note {
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-bottom-button .button {
  font-size: 13px;
  color: #fff;
  padding: 8px 10px;
  border-radius: 3px;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .card-bottom-button .button:hover {
  opacity: 0.8;
}
::ng-deep.develop-is .card-bottom-button .button i {
  font-size: 0.8em;
}
::ng-deep.develop-is .card-bottom-button .button.btn-clarify {
  background-color: rgb(0, 173, 208);
}
::ng-deep.develop-is .card-bottom-button .button.btn-ideate {
  background-color: rgb(255, 121, 0);
}
::ng-deep.develop-is .card-bottom-button .button.btn-implement {
  background-color: rgb(245, 67, 89);
}
::ng-deep.develop-is .dotactions {
  position: relative;
}
::ng-deep.develop-is .dotactions .dotactions__inner {
  position: absolute;
  top: 0;
  right: 0;
}
::ng-deep.develop-is .dotactions .dotactions__inner--h {
  top: 5px;
}
::ng-deep.develop-is .dotactions .dotactions__inner--h .dotactions__top {
  cursor: pointer;
  width: 17px;
  justify-content: space-between;
}
::ng-deep.develop-is .dotactions .dotactions__inner--v {
  right: 10px;
  top: 11px;
}
::ng-deep.develop-is .dotactions .dotactions__inner--v .dotactions__top {
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  height: 21px;
  width: 11px;
  align-items: center;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__top {
  padding-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__top span {
  background-color: #adadad;
  width: 3px;
  height: 3px;
  border-radius: 50%;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown {
  display: none;
  background-color: #fff;
  position: absolute;
  top: 100%;
  width: 150px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);
  right: -5px;
  border-radius: 4px;
  z-index: 9;
  border: 1px solid #ddd;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__close {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 6px;
  font-size: 11px;
  transition: all ease 0.3s;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__close:hover {
  transform: rotate(360deg);
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  padding: 18px;
  background: #fff;
  border: 1px solid #ddd;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin {
  padding: 10px 10px;
  border-radius: 4px;
  min-height: 100%;
  background-color: #f4f4f4;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin h6 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown > h6 {
  text-align: center;
  margin: 0;
  font-size: 13px;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  font-weight: 400;
  margin-bottom: 2px;
  background-color: #f4f4f4;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown li {
  margin: 0;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown li a {
  padding: 6px 12px;
  color: #656565;
  display: block;
  font-weight: 400;
}
::ng-deep.develop-is .dotactions .dotactions__inner .dotactions__dropdown li a:hover {
  background-color: rgba(9, 30, 66, 0.04);
}
::ng-deep.develop-is .ideate__ipwrap {
  overflow-x: auto;
  padding: 4px 0 20px !important;
  flex-wrap: nowrap !important;
}
::ng-deep.develop-is .card-body__ipwrap {
  padding: 4px 0 100px;
  margin: 0 -15px 10px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .card-body__ipwrapm0p0 {
  margin-bottom: 0;
  padding-bottom: 0 !important;
}
::ng-deep.develop-is .card-body__ipwrap--gutter0 {
  margin: 0 !important;
  padding: 0;
}
::ng-deep.develop-is .card-body__ipwrap--scrollx {
  padding-bottom: 20px !important;
  flex-wrap: nowrap;
  overflow-x: auto;
}
::ng-deep.develop-is .card-body__ipwrap--scrollx > div:not(:last-child) {
  margin-right: 30px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn {
  max-width: 250px;
  padding: 0 0;
  width: 100%;
  flex: 0 0 250px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn .card-body__listwidthdot {
  margin-bottom: 10px;
  margin-bottom: 0;
  border: 1px solid #676a6c;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn .card-body__listwidthdot > div {
  padding: 10px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn .card-body__listwidthdot > div p {
  position: relative;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn .card-body__listwidthdot > div p::before {
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcolumn .card-body__listwidthdot_converge {
  border: none;
}
::ng-deep.develop-is .card-body__ipwrap.card-body__ipwrap--pb0 {
  padding-bottom: 0;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol {
  padding: 0 15px;
  margin-bottom: 20px;
  width: 50%;
}
@media only screen and (max-width: 1080px) {
  ::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol {
    width: 100%;
  }
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol > .form-control {
  width: calc(100% - 91px);
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend {
  width: 90px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate {
  padding: 0;
  margin-bottom: 0px;
  max-width: 270px;
  width: 100%;
  flex: 0 0 270px;
  -webkit-flex: 0 0 270px;
  -ms-flex: 0 0 270px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate .checkbox {
  padding-right: 22px;
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate + div {
  margin-left: 30px;
}
@media only screen and (max-width: 1080px) {
  ::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate {
    width: 50%;
  }
}
@media only screen and (max-width: 600px) {
  ::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate {
    width: 100%;
  }
}
::ng-deep.develop-is .card-body__ipwrap .card-body__ipcol--ideate h2 label {
  font-size: 15px;
}
::ng-deep.develop-is .card-body__ipwrap h2 {
  margin-top: 0;
  color: #656565;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}
::ng-deep.develop-is .card-body__ipwrap h2 label {
  display: inline-block;
}
::ng-deep.develop-is .card-body__ipwrap h2 input {
  opacity: 0;
  position: absolute;
}
::ng-deep.develop-is .card-body__ipwrap h2 input + span {
  position: relative;
  top: -2px;
  margin: 0 10px 0 0;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  text-align: center;
}
::ng-deep.develop-is .card-body__ipwrap h2 input + span::before {
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.develop-is .card-body__ipwrap h2 input:checked + span {
  background-color: #5D9CEC;
  border-color: #5D9CEC;
}
::ng-deep.develop-is .card-body__ipwrap h2 input:checked + span::before {
  opacity: 1;
}
::ng-deep.develop-is .card-body__ipwrap ul {
  padding: 0;
  margin: 0;
}
::ng-deep.develop-is .card-body__ipwrap ul li {
  list-style: none;
  padding: 0;
  width: 100%;
}
::ng-deep.develop-is .card-body__ipwrap ul li .card-body__edit {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.develop-is .card-body__ipwrap ul li .card-body__edit .form-control {
  height: 45px;
}
::ng-deep.develop-is .card-body__ipwrap ul li .card-body__edit > i {
  margin-left: auto;
  cursor: pointer;
  color: rgb(105, 190, 40);
}
::ng-deep.develop-is .card-body__ipwrap ul li:last-child .card-body__edit input {
  width: calc(100% - 30px);
}
::ng-deep.develop-is .card-body__ipwrap ul li .card-body__ipinner {
  display: block;
  font-size: 15px;
  position: relative;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
}
::ng-deep.develop-is .compare-sol {
  width: 49%;
  float: left;
}
::ng-deep.develop-is .fullwidth {
  width: 100%;
  display: block;
}
::ng-deep.develop-is .card_solution b {
  font-size: 15px;
}
::ng-deep.develop-is .card_solution .solution-list {
  margin-bottom: 10px;
  width: 100%;
  margin-top: 10px;
}
::ng-deep.develop-is .card_solution .solution-list span {
  display: block;
}
::ng-deep.develop-is .card_solution .solution-list__selection1 {
  margin-top: 10px;
}
::ng-deep.develop-is .card_solution .solution-list__selection2 {
  margin-left: 20px;
}

.develop-is .card-body__ipwrap ul li {
  position: relative;
}
.develop-is .card-body__ipwrap ul li input[type=checkbox] {
  position: absolute;
  top: 11px;
  left: 10px;
  z-index: 2;
}
.develop-is .card-body__ipwrap ul li input[type=checkbox] + label {
  padding-left: 31px;
}

.tooltippopup {
  max-width: 360px;
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  right: -550px;
  padding: 45px 24px 24px;
  text-align: left;
  z-index: 9999;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  transition: all ease 0.3s;
  overflow-y: auto;
}
.tooltippopup--active {
  right: 0;
}
.tooltippopup--videoexist {
  max-width: 735px;
}
.tooltippopup__btn {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 0 10px;
}
.tooltippopup__btn li {
  list-style: none;
  text-align: center;
  cursor: pointer;
  width: 33.3333333333%;
}
.tooltippopup__btn li button {
  width: 100%;
  color: rgb(105, 190, 40);
  font-size: 12px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  border: 1px solid rgb(105, 190, 40);
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
.tooltippopup__btn li button:focus {
  outline: none;
}
.tooltippopup__btn li button.tooltippopup__btncompleted {
  opacity: 0.2;
}
.tooltippopup__btn li button.tooltippopup__btncompleted:hover {
  opacity: 1;
}
.tooltippopup__btn li button.tooltippopup__btnactive {
  opacity: 1;
}
.tooltippopup__btn li button:hover {
  position: relative;
  z-index: 9;
}
.tooltippopup__btn li + li {
  margin-left: -1px;
}
.tooltippopup__btn li:first-child button {
  border-radius: 3px 0 0 3px;
}
.tooltippopup__btn li:last-child button {
  border-radius: 0 3px 3px 0;
}
.tooltippopup h4 {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 1.2;
}
.tooltippopup p {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.4;
}
.tooltippopup__close {
  position: absolute;
  top: 10px;
  right: 25px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: all ease 0.3s;
}
.tooltippopup__close:hover {
  transform: rotate(360deg);
}
.tooltippopup__close > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.tooltippopup__close > div span {
  position: absolute;
  background: #676a6c;
}
.tooltippopup__close > div span:nth-child(1) {
  top: 0;
  left: calc(50% - 1px);
  width: 2px;
  height: 100%;
}
.tooltippopup__close > div span:nth-child(2) {
  top: calc(50% - 1px);
  left: 0;
  width: 100%;
  height: 2px;
}
.tooltippopup__child {
  margin-top: 20px;
}
.tooltippopup__childdata .table-responsive {
  overflow-x: auto;
  margin-bottom: 10px;
}
.tooltippopup__childdata .table-responsive table {
  min-width: 297px;
  border: 1px solid #e7eaec;
}
.tooltippopup__childdata .table-responsive table th,
.tooltippopup__childdata .table-responsive table td {
  border: 1px solid #e7eaec;
  min-width: 120px;
}
.tooltippopup__childdata .table-responsive + * {
  margin-top: 20px;
}
.tooltippopup__childdata--clarify h4 {
  color: rgb(0, 173, 208);
}
.tooltippopup__childdata--ideate h4 {
  color: rgb(255, 121, 0);
}
.tooltippopup__childdata--develop h4 {
  color: rgb(105, 190, 40);
}
.tooltippopup__childdata--implement h4 {
  color: rgb(245, 67, 89);
}
.tooltippopup__childdata h4 {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 2px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.tooltippopup__childdata h4 + h5 {
  mask-type: 10px;
}
.tooltippopup__childdata p {
  margin-bottom: 5px;
  line-height: 1.3;
}
.tooltippopup__childdata p:last-child {
  margin-bottom: 0;
}
.tooltippopup__childdata + div {
  margin-top: 17px;
}
.tooltippopup__links {
  padding: 0;
  margin: 0;
}
.tooltippopup__links li {
  list-style: none;
  width: 100%;
}
.tooltippopup__links li a {
  position: relative;
  color: rgb(105, 190, 40);
  transition: all ease 0.3s;
}
.tooltippopup__links li a:hover {
  opacity: 0.75;
}
.tooltippopup__links li + li {
  margin-top: 4px;
}

.popaccordian__rowhead {
  position: relative;
  cursor: pointer;
  border: 1px solid rgb(105, 190, 40);
  padding: 9px;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}
.popaccordian__rowheadarrow {
  position: absolute;
  top: 0;
  left: 0;
}
.popaccordian__rowhead h5 {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  position: relative;
  color: rgb(105, 190, 40);
  padding-left: 10px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowhead h5 i {
  transition: all ease 0.3s;
}
.popaccordian__rowbody {
  border: 1px solid rgb(105, 190, 40);
  border-top: 0;
  display: none;
  border-radius: 0 0 3px 3px;
}
.popaccordian__rowbodyinner {
  padding: 10px;
}
.popaccordian__rowbodyinner > *:last-child {
  margin-bottom: 0;
}
.popaccordian__rowbodyinner h5 {
  margin: 0 0 10px;
  position: relative;
  color: rgb(105, 190, 40);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowbodyinner ul {
  margin: 0;
  padding: 0;
}
.popaccordian__rowbodyinner ul li {
  list-style: none;
  font-size: 14px;
  line-height: 1.3;
  position: relative;
  padding-left: 10px;
}
.popaccordian__rowbodyinner ul li::before {
  content: "";
  position: absolute;
  top: 7px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
.popaccordian__rowbodyinner ul li + li {
  margin-top: 5px;
}
.popaccordian__row + div {
  margin-top: 15px;
}
.popaccordian__row--active .popaccordian__rowhead {
  border-radius: 3px 3px 0 0;
}
.popaccordian__row--active .popaccordian__rowhead i {
  transform: rotate(90deg);
}
.popaccordian__row:first-child .popaccordian__rowbody {
  display: block;
}

.prevnext {
  padding: 20px 0;
}
.prevnext__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  margin: 0;
}
.prevnext li {
  list-style: none;
}
.prevnext li.prevnext__next {
  margin-left: auto;
}
.prevnext li.prevnext__prev a:hover > i {
  left: -5px;
}
.prevnext li.prevnext__next a {
  background-color: rgb(105, 190, 40);
  color: #fff;
  opacity: 1;
  padding: 6px 12px;
  border-radius: 3px;
}
.prevnext li.prevnext__next a:hover > i {
  left: 3px;
}
.prevnext li a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 14px;
  color: #676a6c;
  opacity: 0.47;
  padding: 6px 0;
  display: inline-block;
  transition: all ease 0.3s;
}
.prevnext li a i {
  position: relative;
  font-size: 1.1em;
  left: 0;
  transition: all ease 0.3s;
}

.playbtn {
  position: absolute;
  right: 8px;
  bottom: 7px;
}
.playbtn i {
  color: #7bbc43;
}

.ideate-is .info .card__toprow .card__topcol.card__topcol--tt svg {
  max-width: 16px;
  cursor: pointer;
}

.card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
.card__toprow .card__topcol {
  padding: 0 15px;
}
.card__toprow .card__topcol.card__topcol--tt {
  margin-left: auto;
  text-align: right;
}
.card__toprow .card__topcol.card__topcol--tt svg {
  max-width: 16px;
  cursor: pointer;
}
.card__toprow .card__topcol.card__topcol--tt span {
  position: absolute;
  right: -17px;
  bottom: 18px;
}
@media only screen and (max-width: 767px) {
  .card__toprow .card__topcol.card__topcol--tt span {
    right: 2px;
  }
}

.stick-challenge {
  position: relative;
}
.stick-challenge .card-body__backouter {
  min-height: auto;
  overflow-y: auto;
  z-index: 9;
  position: relative;
}
.stick-challenge .card-body__backouter .card-body__subtitle {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
}
.stick-challenge .card-body__backouter.plus {
  min-height: 400px;
}

.st0 {
  fill: #7bbc43;
  margin-right: 12px;
}

.st1 {
  fill: none;
  stroke: #7bbc43;
  stroke-miterlimit: 10;
  margin-right: 10px;
}

.Del-data-btn {
  padding: 40px 0;
}
.Del-data-btn .btn {
  margin-left: 15px;
  background-color: #fff;
  border-color: #f5f5f5;
  color: #ff485c;
}
.Del-data-btn .cancelbtn {
  color: #676a6c;
  text-align: center;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
}

.modal-body__tr {
  column-count: 2;
  column-gap: 20px;
}
.modal-body__td {
  page-break-inside: avoid;
  break-inside: avoid;
}
.modal-body__buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
}
.modal-body__buttons > button:not(:last-child) {
  margin-right: 15px;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.row--editmodebg {
  background-color: #fff;
  padding: 40px 35px;
}

.trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
.trackInfo--inputclr {
  color: rgb(105, 190, 40);
  background: transparent;
  padding-left: 0;
  font-size: 13px;
  margin-left: 11px;
  margin-bottom: 2px;
  display: inline-block;
  position: absolute;
  top: 17px;
}

.card-body__pe .card-body__petop .card__bwnh3ai {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 6px;
  padding: 6px 8px;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
  transition: opacity 0.2s ease;
}
.card-body__pe .card-body__petop .card__bwnh3ai:hover {
  opacity: 0.7;
}
.card-body__pe .card-body__petop .card__bwnh3ai i {
  font-size: 14px;
}

.EditmodeInputs .card__bwnh3ai {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 6px;
  padding: 6px 8px;
  cursor: pointer;
  color: rgb(105, 190, 40);
  font-size: 14px;
  border-radius: 4px;
  transition: opacity 0.2s ease;
}
.EditmodeInputs .card__bwnh3ai:hover {
  opacity: 0.7;
}
.EditmodeInputs .card__bwnh3ai i {
  font-size: 14px;
}
.EditmodeInputs h3, .EditmodeInputs h4 {
  white-space: nowrap;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form .form-group {
  margin-bottom: 15px;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--seagrn {
  border-color: #1dc5a3;
  background-color: #1dc5a3;
}
::ng-deep .modal .f-btn--seagrn:hover {
  border-color: #1dc5a3;
  background-color: #1dc5a3;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--white {
  background-color: #fff;
  border-color: #ddd;
  color: #6D6E71;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}

::ng-deep.modal-open {
  overflow: hidden;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

label {
  font-family: "Open Sans", sans-serif;
}

li {
  list-style: none;
}

::ng-deep#page-wrapper {
  padding-bottom: 60px;
}

::ng-deep#wrapper {
  overflow-x: initial;
}

::ng-deep.ideate-is .mainnav {
  display: flex;
  flex-wrap: wrap;
  margin: 30px 0 20px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .mainnav {
    margin: 10px 0 15px;
  }
}
::ng-deep.ideate-is .mainnav.mainnav--bottom {
  margin: 30px 0 40px;
}
::ng-deep.ideate-is .mainnav.mainnav--bottom ul li a {
  padding: 12px 30px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .mainnav.mainnav--bottom ul li a {
    padding: 10px 20px;
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .mainnav.mainnav--bottom ul li a {
    padding: 9px;
    font-size: 11px;
  }
}
::ng-deep.ideate-is .mainnav.mainnav--bottom ul li.active a {
  background-color: #bbb !important;
  border-top: 1px solid #bbb !important;
  border-bottom: 1px solid #bbb !important;
}
::ng-deep.ideate-is .mainnav--editmode {
  margin: 0 0 15px;
}
::ng-deep.ideate-is .mainnav--editmode .mainnav__list {
  flex: 1;
  border-radius: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .mainnav--editmode .mainnav__list {
    flex: none;
    width: 100%;
  }
}
::ng-deep.ideate-is .mainnav--editmode .mainnav__list li {
  width: 100%;
  flex: 1;
}
::ng-deep.ideate-is .mainnav--editmode .mainnav__list li a {
  width: 100%;
  padding: 5px 2px;
  text-align: center;
}
::ng-deep.ideate-is .mainnav__editmodeicon {
  margin-left: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .mainnav__editmodeicon {
    margin: 10px 0 0 auto;
  }
}
::ng-deep.ideate-is .mainnav__editmodeicon ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  height: 100%;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li {
  list-style: none;
  transition: none;
  width: 37px;
  height: 100%;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #CFDBE2;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.active {
  background-color: #676a6c;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li:not(:last-child) {
  margin-right: 5px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .mainnav__editmodeicon ul li:not(:last-child) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .mainnav__editmodeicon ul li {
    width: 35px;
    height: 31px;
    display: none;
  }
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.mainnav__editmodepin {
  display: flex;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st0 {
  fill: #FFFFFF;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st1 {
  fill: #cfdbe2;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st0 {
  fill: #6d6e71;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st1 {
  fill: #FFFFFF;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.listView svg .st0, ::ng-deep.ideate-is .mainnav__editmodeicon ul li.individualView svg .st0, ::ng-deep.ideate-is .mainnav__editmodeicon ul li.gridView svg .st0 {
  fill: #6d6e71;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.listView svg .st1, ::ng-deep.ideate-is .mainnav__editmodeicon ul li.individualView svg .st1, ::ng-deep.ideate-is .mainnav__editmodeicon ul li.gridView svg .st1 {
  fill: #FFFFFF;
}
::ng-deep.ideate-is .stick-challenge {
  position: relative;
}
::ng-deep.ideate-is .stick-challenge .card-body__edit {
  min-height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9;
  position: relative;
}
::ng-deep.ideate-is .stick-challenge .card-body__edit .card-body__subtitle {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
}
::ng-deep.ideate-is .stick-challenge .card-body__inner {
  overflow-y: auto;
}
::ng-deep.ideate-is .info {
  color: #fff;
  border-color: rgb(255, 121, 0);
  margin-bottom: 18px;
  padding: 20px 40px;
  border-radius: 6px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .info {
    padding: 12px 20px;
  }
}
::ng-deep.ideate-is .info.infotitle {
  background-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .info h1 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .info h1 {
    font-size: 28px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info h1 {
    font-size: 24px;
  }
}
::ng-deep.ideate-is .info h1 .info__maintitle {
  margin-right: auto;
}
::ng-deep.ideate-is .info h1 small {
  color: #fff;
  font-size: 80%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info h1 small {
    width: 100%;
    margin-top: 5px;
  }
}
::ng-deep.ideate-is .info .card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
::ng-deep.ideate-is .info .card__toprow--tne .card__topcol:first-child {
  width: 72% !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info .card__toprow--tne .card__topcol:first-child {
    flex: 1;
    width: auto !important;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol {
  padding: 0 15px;
  width: 33.3333333333%;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--full {
  width: 100% !important;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol:nth-child(1) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol:nth-child(1) {
    flex: 1;
    margin-right: auto;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--tab {
  width: 44%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol--tab {
    width: 120px;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--tt {
  width: 28%;
  margin-left: auto;
  text-align: right;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol--tt {
    width: auto;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--tt svg {
  max-width: 16px;
  cursor: pointer;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--tt .card__pinicon {
  position: absolute;
  right: -17px;
  top: -15px;
  width: 20px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol--tt .card__pinicon {
    right: -1px;
    top: -10px;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--title > div:first-child {
  margin-right: 15px;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--startexist {
  width: 65%;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
  line-height: 1;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:not(:first-child) {
  margin-left: -1px;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button {
  color: rgb(255, 121, 0);
  border: 1px solid rgb(255, 121, 0);
  cursor: pointer;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount {
  color: rgb(255, 121, 0);
  background-color: #efefef;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid rgb(255, 121, 0);
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount {
  color: rgb(255, 121, 0);
  background-color: #efefef;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg .st0 {
  fill: rgb(255, 121, 0);
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: rgb(255, 121, 0);
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover {
  color: rgb(255, 121, 0);
  opacity: 1;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover > span.card__topcount {
  color: rgb(255, 121, 0);
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--ctt {
  position: relative;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--ctt ul li .card-body__tooltip {
  display: none;
  position: absolute;
  background: #fff;
  color: #676a6c;
  padding: 5px;
  top: -27px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--ctt ul li button:hover {
  opacity: 0.2 !important;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--ctt ul li:hover .card-body__tooltip, ::ng-deep.ideate-is .info .card__toprow .card__topcol--ctt ul li:active .card-body__tooltip {
  display: block;
}
::ng-deep.ideate-is .info .card__toprow .card__h3button {
  border: 1px solid rgb(255, 121, 0);
  background-color: transparent;
  padding: 4px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(255, 121, 0);
  font-size: 22px;
  line-height: 1.2;
  transition: all ease 0.3s;
  cursor: pointer;
}
::ng-deep.ideate-is .info .card__toprow .card__h3button:hover {
  background-color: rgb(255, 121, 0);
  color: #fff;
}
::ng-deep.ideate-is .info .card__toprow .card__h3button:focus {
  outline: none;
}
::ng-deep.ideate-is .info .card__toprow .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.ideate-is .info .card__toprow .tooltipicon i {
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .info .card__toprow .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.ideate-is .info .card__toprow .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(255, 121, 0);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.ideate-is .info h3 {
  font-size: 20px;
  margin: 0;
  cursor: pointer;
  color: rgb(255, 121, 0);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .info h3 {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info h3 {
    font-size: 15px;
    word-break: break-word;
  }
}
::ng-deep.ideate-is .info h3 > *:not(:last-child) {
  margin-right: 5px;
}
::ng-deep.ideate-is .info h3 .card__bwnh3pencil a {
  color: rgb(255, 121, 0);
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info h3 .card__bwnh3button {
    width: 100%;
    margin-top: 10px;
  }
}
::ng-deep.ideate-is .info h3 .card__bwnh3button button {
  font-size: 18px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info h3 .card__bwnh3button button {
    font-size: 16px !important;
  }
}
::ng-deep.ideate-is .info h3 i {
  cursor: pointer;
  font-size: 0.9em;
}
::ng-deep.ideate-is .info h3 i + div {
  padding-left: 7px;
}
::ng-deep.ideate-is .info h3 i + div span {
  display: block;
  font-size: 0.7em;
}
::ng-deep.ideate-is .info h3 i + span {
  padding-left: 7px;
}
::ng-deep.ideate-is .info .tooltipicon {
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.ideate-is .info .tooltipicon i {
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .info .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.ideate-is .info .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(255, 121, 0);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.ideate-is app-ideate-ideas,
::ng-deep.ideate-is app-ideate-challenge-top-ideas {
  display: block;
  margin-top: 30px;
}
::ng-deep.ideate-is .card-default {
  border-radius: 6px;
  border-top-width: 3px;
  border: 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
::ng-deep.ideate-is .card-default.card-default--summary {
  box-shadow: none;
}
::ng-deep.ideate-is .card-default.card-default--summary .info {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.ideate-is .card-default.card-default--summary .card-body {
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
  border-radius: 0;
}
::ng-deep.ideate-is .card-default.card-default--summary .card-body__inner {
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.ideate-is .card-default.card-default--summary + div {
  margin-top: 20px;
}
::ng-deep.ideate-is .card-default + div {
  margin-top: 30px;
}
::ng-deep.ideate-is .card-default .info {
  margin: 0;
  border: 1px solid rgb(255, 121, 0);
  border-radius: 6px;
}
::ng-deep.ideate-is .card-default .info.card__headactive {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc {
  background-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc .card__topcol h3 {
  color: #fff;
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc .card__topcol ul li button {
  border-color: #fff;
  background-color: #fff;
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc .card__topcol ul li button span {
  color: rgb(255, 121, 0);
  background-color: #fff;
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc .card__topcol ul li button .st0 {
  fill: #fff !important;
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc i {
  color: #fff;
}
::ng-deep.ideate-is .card-default .card-body__inner {
  padding: 15px 40px;
  height: auto;
  overflow-y: auto;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .card-default .card-body__inner {
    padding: 12px 20px;
  }
}
::ng-deep.ideate-is .card-default .card-body {
  display: none;
  border: 1px solid #CFDBE2;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
::ng-deep.ideate-is .card-default .card-body.card-show {
  display: block;
}
::ng-deep.ideate-is .card-default .card-body.card-show__wbg {
  background-color: #fff;
}
::ng-deep.ideate-is .card-default .card-body .hideblk {
  display: none;
}
::ng-deep.ideate-is .card-default .card-body__finalstate p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body__finalstate p {
    font-size: 13px;
  }
}
::ng-deep.ideate-is .card-default .card-body__finalstate p:last-child {
  margin-bottom: 0;
}
::ng-deep.ideate-is .card-default .card-body__finalstate--2 {
  margin: 0 -10px;
}
::ng-deep.ideate-is .card-default .card-body__finalstate--2 > div {
  width: 50%;
  padding: 0 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body__finalstate--2 > div {
    width: 100%;
  }
}
::ng-deep.ideate-is .card-default .card-body__finalstate--2 > div p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.ideate-is .card-default .card-body__finalstate--2 > div p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.ideate-is .card-default .card-body__subtitle {
  padding-left: 35px;
  margin-bottom: 16px;
  position: relative;
}
::ng-deep.ideate-is .card-default .card-body__subtitle *:last-child {
  margin-bottom: 0;
}
::ng-deep.ideate-is .card-default .card-body__subtitle > span {
  position: absolute;
  top: 0;
  right: 2px;
  opacity: 0.7;
  cursor: pointer;
}
::ng-deep.ideate-is .card-default .card-body__subtitle > span.thinkeyebtn {
  right: 0px;
}
::ng-deep.ideate-is .card-default .card-body__subtitle--pl0 {
  padding-left: 0;
}
::ng-deep.ideate-is .card-default .card-body__subtitle p {
  color: #969798;
  font-size: 15px;
}
::ng-deep.ideate-is .card-default .card-body__subtitle p i {
  padding-left: 5px;
}
::ng-deep.ideate-is .card-default .c-radio label {
  padding-left: 0;
}
::ng-deep.ideate-is .card-default .c-radio input {
  opacity: 0;
  margin: 0;
}
::ng-deep.ideate-is .card-default .c-radio input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 5px;
  text-align: center;
}
::ng-deep.ideate-is .card-default .c-radio input + span::before {
  position: absolute;
  color: rgb(255, 121, 0);
  opacity: 0;
  font-size: 11px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.ideate-is .card-default .c-radio input:checked + span {
  border-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .c-radio input:checked + span::before {
  opacity: 1;
}
::ng-deep.ideate-is .card-default .checkbox {
  margin-top: 0;
}
::ng-deep.ideate-is .card-default .checkbox label {
  min-height: 20px;
  padding-left: 0;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.ideate-is .card-default .checkbox label > i {
  position: relative;
  top: 1px;
  margin-right: 6px;
}
::ng-deep.ideate-is .card-default .checkbox label > span {
  vertical-align: middle;
}
::ng-deep.ideate-is .card-default .checkbox input {
  opacity: 0;
  position: absolute;
  display: none;
}
::ng-deep.ideate-is .card-default .checkbox input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.ideate-is .card-default .checkbox input + span::before {
  font-size: 12px;
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.ideate-is .card-default .checkbox input:checked + span {
  border-color: rgb(255, 121, 0);
  background-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .checkbox input:checked + span::before {
  opacity: 1;
}
::ng-deep.ideate-is .card-default .card-body__button {
  background-color: #f5f5f5;
  border-top: 1px solid #e3e3e3;
  padding: 12px 40px;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn + .btn {
  margin-left: 15px;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .float-right {
  margin-left: auto;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-ideate {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
  color: #fff;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-ideate:hover {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-success {
  background-color: #27c24c;
  border-color: #27c24c;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-success:hover {
  background-color: #21A240;
  border-color: #1E983B;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-danger {
  background-color: #fff;
  border-color: #fff;
  color: #ef6272;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-danger:hover {
  background-color: #ED2D2D;
  border-color: #EC2121;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-warning em {
  margin: 0;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall:hover {
  background-color: #fff;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall:hover em {
  margin-right: 6px;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body--ebtn {
  margin-top: 15px;
  padding: 15px 40px;
  border-top: 1px solid #CFDBE2;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn {
    padding: 12px 20px;
  }
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow {
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
  padding: 0 8px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
    width: 100%;
    text-align: center;
  }
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow > div + div {
    margin-top: 10px;
  }
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow > div.card-body--col--last {
  margin-left: auto;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  padding: 7px 16px;
  text-align: center;
  transition: all ease 0.3s;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
    font-size: 12px;
  }
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn i,
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--save {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--clarify {
  background-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--ideate {
  background-color: rgb(255, 121, 0);
  color: #fff;
  border-color: rgb(255, 121, 0);
  font-weight: 900;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--disable {
  opacity: 0.5;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel {
  padding: 0;
  background-color: transparent;
  margin-left: 0;
  color: #676a6c;
  border: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel:hover {
  color: #000;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--converge {
  padding: 0 8px;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
  font-size: 14px;
  color: #676a6c;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
  background-color: #f5f5f5;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
    padding-right: 7px;
    padding-left: 7px;
  }
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover em {
  margin-right: 6px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    background-color: #f5f5f5;
    color: #ed5562;
    padding-right: 16px;
    padding-left: 16px;
  }
}
@media only screen and (max-width: 767px) and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    padding-right: 7px;
    padding-left: 7px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall > span {
    position: relative;
    left: 0;
  }
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
    margin-right: 6px !important;
  }
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .note-3 {
  padding: 15px 15px 10px;
  border: 2px solid rgb(255, 121, 0);
  margin-bottom: 15px;
}
::ng-deep.ideate-is .card-default .note-3 label {
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .footer-line {
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default p {
  font-size: 15px;
}
::ng-deep.ideate-is .card-default p:last-child {
  margin-bottom: 0;
}
::ng-deep.ideate-is .card-default .card-body__edit {
  position: relative;
}
::ng-deep.ideate-is .card-default .card-body__edit .breakthrough-input-tabs,
::ng-deep.ideate-is .card-default .card-body__edit .brainstorm-input-tabs {
  width: 100%;
  margin-right: 0;
  position: relative;
}
::ng-deep.ideate-is .card-default .card-body__edit .breakthrough-input-tabs input,
::ng-deep.ideate-is .card-default .card-body__edit .breakthrough-input-tabs select,
::ng-deep.ideate-is .card-default .card-body__edit .brainstorm-input-tabs input,
::ng-deep.ideate-is .card-default .card-body__edit .brainstorm-input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow > div {
  padding: 0 15px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow > div > div {
  position: relative;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .proposed-challenge {
  margin-top: 10px;
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .proposed-challenge label {
  padding-bottom: 4px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow select {
  appearance: none;
  background-image: url("https://assets.foursightonline.com/app/images/select.png");
  background-size: 10px;
  background-position: right 10px center;
  background-repeat: no-repeat;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow textarea {
  width: 100%;
  border: 1px solid #ccc;
  resize: none;
  border-radius: 3px;
  padding: 10px 15px;
  font-size: 15px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel {
  width: 35px;
  padding-right: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber {
  width: 40px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-right: 0;
  border-radius: 4px 0 0 4px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput {
  width: calc(100% - 41px);
  padding-right: 60px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce {
  position: relative;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 7px;
  font-size: 26px;
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip, ::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:active > .card-body__tooltip,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:active > .card-body__tooltip {
  display: block;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon .card-body__tooltip,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon .card-body__tooltip {
  display: none;
  font-size: 16px;
  color: #676a6c;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: max-content;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce input,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce input {
  padding-left: 26px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label {
  font-weight: 900;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
  width: 315px;
  padding-right: 15px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
  width: calc(100% - 351px);
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input {
  padding-right: 70px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus, ::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus-visible,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus-visible {
  outline: none;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput .card-body__minus--hide,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput .card-body__minus--hide {
  display: none;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child {
  width: 100%;
}
::ng-deep.ideate-is .card-default .card-body__edit + .card-body__addnew button {
  margin: 0 39px;
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  color: #676a6c;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body__edit + .card-body__addnew button:hover {
  background-color: rgb(255, 121, 0);
  border: 1px solid rgb(255, 121, 0);
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}
::ng-deep.ideate-is .card-default .input-tabs {
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 0 0 0 0;
  margin: 0;
}
::ng-deep.ideate-is .card-default .input-tabs + i {
  position: relative;
  top: -1px;
}
::ng-deep.ideate-is .card-default .input-tabs .select_faded {
  opacity: 0.2;
  padding-left: 32px;
}
::ng-deep.ideate-is .card-default .input-tabs input,
::ng-deep.ideate-is .card-default .input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  margin: 7px 0px;
}
::ng-deep.ideate-is .card-default .input-tabs label {
  width: 20px;
  margin: 0;
}
::ng-deep.ideate-is .card-default .input-tabs select {
  width: 9%;
}
::ng-deep.ideate-is .card-default .input-tabs input {
  width: 90%;
  margin-left: 15px;
}
::ng-deep.ideate-is .card-default .input-group-text {
  cursor: pointer;
  padding: 3px 16px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.528571429;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #E9ECEF;
  border: 1px solid #DDE6E9;
  border-radius: 0.25rem;
  position: absolute;
  top: calc(50% + 1px);
  right: 0;
  transform: translateY(-50%);
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .input-group-text:hover {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
  color: #fff;
}
::ng-deep.ideate-is .card-default .list-columns {
  display: flex;
  flex-wrap: wrap;
  counter-reset: section;
}
::ng-deep.ideate-is .card-default .list-columns > div.card__body--cswrapper {
  width: 100%;
  position: relative;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 5px;
  margin-bottom: 10px;
}
::ng-deep.ideate-is .card-default .list-columns > div.card__body--cswrapper::before, ::ng-deep.ideate-is .card-default .list-columns > div.card__body--cswrapper::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: 100%;
  width: 40px;
  height: 1px;
  background-color: #e4e4e4;
}
::ng-deep.ideate-is .card-default .list-columns > div.card__body--cswrapper::after {
  right: auto;
  left: 100%;
}
::ng-deep.ideate-is .card-default .list-columns.list-columns--2 > div {
  width: 100%;
}
::ng-deep.ideate-is .card-default .list-columns .brainstorm-tabs {
  position: relative;
  padding-left: 23px;
}
::ng-deep.ideate-is .card-default .list-columns .brainstorm-tabs::before {
  counter-increment: section;
  content: counter(section) ".";
  position: absolute;
  top: 0;
  left: 0;
}
::ng-deep.ideate-is .idea-shop-list {
  padding: 20px;
  margin-left: 17px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .idea-shop-list li {
  width: 50%;
  margin-bottom: 10px;
}
::ng-deep.ideate-is .brainstorm__col {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 17px;
}
::ng-deep.ideate-is .brainstorm__col .brainstorm-main {
  width: calc(100% - 68px);
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.ideate-is .brainstorm__col .brainstorm-main .brainstorm-group {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend {
  margin-right: -1px;
  width: 45px;
}
::ng-deep.ideate-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend .input-group-text {
  background: transparent;
  border-color: rgb(255, 121, 0);
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep.ideate-is .brainstorm__col .brainstorm-main .brainstorm-group input {
  width: calc(100% - 45px);
  height: 35px;
  border: 1px solid rgb(255, 121, 0);
  border-radius: 0 0.25rem 0.25rem 0;
}
::ng-deep.ideate-is .card-bottom-button .button {
  font-size: 13px;
  color: #fff;
  padding: 8px 10px;
  border-radius: 3px;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-bottom-button .button:hover {
  opacity: 0.8;
}
::ng-deep.ideate-is .card-bottom-button .button i {
  font-size: 0.8em;
}
::ng-deep.ideate-is .card-bottom-button .button.btn-clarify {
  background-color: rgb(0, 173, 208);
}
::ng-deep.ideate-is .card-bottom-button .button.btn-ideate {
  background-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-bottom-button .button.btn-implement {
  background-color: rgb(245, 67, 89);
}
::ng-deep.ideate-is .dotactions {
  position: relative;
}
::ng-deep.ideate-is .dotactions .dotactions__inner {
  position: absolute;
  top: 0;
  right: 0;
}
::ng-deep.ideate-is .dotactions .dotactions__inner--h {
  top: 5px;
}
::ng-deep.ideate-is .dotactions .dotactions__inner--h .dotactions__top {
  cursor: pointer;
  width: 17px;
  justify-content: space-between;
}
::ng-deep.ideate-is .dotactions .dotactions__inner--v {
  right: 10px;
  top: 11px;
}
::ng-deep.ideate-is .dotactions .dotactions__inner--v .dotactions__top {
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  height: 21px;
  width: 11px;
  align-items: center;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__top {
  padding-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__top span {
  background-color: #adadad;
  width: 3px;
  height: 3px;
  border-radius: 50%;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown {
  display: none;
  background-color: #fff;
  position: absolute;
  top: 100%;
  width: 150px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);
  right: -5px;
  border-radius: 4px;
  z-index: 9;
  border: 1px solid #ddd;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__close {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 6px;
  font-size: 11px;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__close:hover {
  transform: rotate(360deg);
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  padding: 18px;
  background: #fff;
  border: 1px solid #ddd;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin {
  padding: 10px 10px;
  border-radius: 4px;
  min-height: 100%;
  background-color: #f4f4f4;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin h6 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown > h6 {
  text-align: center;
  margin: 0;
  font-size: 13px;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  font-weight: 400;
  margin-bottom: 2px;
  background-color: #f4f4f4;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown li {
  margin: 0;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown li a {
  padding: 6px 12px;
  color: #656565;
  display: block;
  font-weight: 400;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown li a:hover {
  background-color: rgba(9, 30, 66, 0.04);
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap {
  padding: 4px 0 80px;
  overflow-x: auto;
  margin: 0 0 10px;
  display: flex;
  flex-wrap: nowrap;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol {
  padding: 0;
  margin-bottom: 0px;
  max-width: 285px;
  width: 100%;
  flex: 0 0 285px;
  -webkit-flex: 0 0 285px;
  -ms-flex: 0 0 285px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .checkbox {
  padding-right: 22px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol + div {
  margin-left: 30px;
}
@media only screen and (max-width: 1080px) {
  ::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol {
    width: 50%;
  }
}
@media only screen and (max-width: 600px) {
  ::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol {
    width: 100%;
  }
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol > .form-control {
  width: calc(100% - 91px);
  border: 1px solid #ccc;
  border-radius: 4px 0 0 4px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend {
  width: 90px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend button {
  background-color: rgb(255, 121, 0);
  box-shadow: none;
  color: #fff;
  border-color: rgb(255, 121, 0);
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend--ro {
  opacity: 0.4;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 {
  margin-top: 0;
  color: #656565;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 label {
  display: inline-block;
  padding-right: 2px;
  width: auto !important;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox] {
  opacity: 0;
  position: absolute;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox] + span {
  position: relative;
  top: -2px;
  margin: 0 5px 0 0;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  text-align: center;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox] + span::before {
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox]:checked + span {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox]:checked + span::before {
  opacity: 1;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:first-child {
  margin-right: 10px;
  width: 73%;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:first-child input:focus {
  border-color: rgb(255, 121, 0);
  outline: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:nth-child(2) {
  margin-left: auto;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:nth-child(3) {
  margin-left: 10px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div i {
  font-size: 17px;
  color: #ff0000;
  cursor: pointer;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput .topidea__btn {
  padding: 3px 5px;
  font-size: 12px;
  color: #fff;
  background-color: rgb(105, 190, 40);
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap ul {
  padding: 0;
  margin: 0;
  min-height: 10px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap ul li {
  list-style: none;
  padding: 0;
  width: 100%;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap ul li .card-body__ipinner {
  display: block;
  font-weight: 400;
  position: relative;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
}

.tooltippopup {
  max-width: 360px;
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  right: -550px;
  padding: 45px 24px 24px;
  text-align: left;
  z-index: 9999;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  transition: all ease 0.3s;
  overflow-y: auto;
}
.tooltippopup--active {
  right: 0;
}
.tooltippopup--videoexist {
  max-width: 735px;
}
.tooltippopup__btn {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 0 10px;
}
.tooltippopup__btn li {
  list-style: none;
  text-align: center;
  cursor: pointer;
  width: 33.3333333333%;
}
.tooltippopup__btn li button {
  width: 100%;
  color: rgb(255, 121, 0);
  font-size: 12px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  border: 1px solid rgb(255, 121, 0);
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
.tooltippopup__btn li button:focus {
  outline: none;
}
.tooltippopup__btn li button.tooltippopup__btncompleted {
  opacity: 0.2;
}
.tooltippopup__btn li button.tooltippopup__btncompleted:hover {
  opacity: 1;
}
.tooltippopup__btn li button.tooltippopup__btnactive {
  opacity: 1;
}
.tooltippopup__btn li button:hover {
  position: relative;
  z-index: 9;
}
.tooltippopup__btn li + li {
  margin-left: -1px;
}
.tooltippopup__btn li:first-child button {
  border-radius: 3px 0 0 3px;
}
.tooltippopup__btn li:last-child button {
  border-radius: 0 3px 3px 0;
}
.tooltippopup h4 {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 1.2;
}
.tooltippopup p {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.4;
}
.tooltippopup__close {
  position: absolute;
  top: 10px;
  right: 25px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: all ease 0.3s;
}
.tooltippopup__close:hover {
  transform: rotate(360deg);
}
.tooltippopup__close > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.tooltippopup__close > div span {
  position: absolute;
  background: #676a6c;
}
.tooltippopup__close > div span:nth-child(1) {
  top: 0;
  left: calc(50% - 1px);
  width: 2px;
  height: 100%;
}
.tooltippopup__close > div span:nth-child(2) {
  top: calc(50% - 1px);
  left: 0;
  width: 100%;
  height: 2px;
}
.tooltippopup__child {
  margin-top: 20px;
}
.tooltippopup__childdata .table-responsive {
  overflow-x: auto;
  margin-bottom: 10px;
}
.tooltippopup__childdata .table-responsive table {
  min-width: 297px;
  border: 1px solid #e7eaec;
}
.tooltippopup__childdata .table-responsive table th,
.tooltippopup__childdata .table-responsive table td {
  border: 1px solid #e7eaec;
  min-width: 120px;
}
.tooltippopup__childdata .table-responsive + * {
  margin-top: 20px;
}
.tooltippopup__childdata--clarify h4 {
  color: rgb(0, 173, 208);
}
.tooltippopup__childdata--ideate h4 {
  color: rgb(255, 121, 0);
}
.tooltippopup__childdata--develop h4 {
  color: rgb(105, 190, 40);
}
.tooltippopup__childdata--implement h4 {
  color: rgb(245, 67, 89);
}
.tooltippopup__childdata h4 {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 2px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.tooltippopup__childdata h4 + h5 {
  mask-type: 10px;
}
.tooltippopup__childdata p {
  margin-bottom: 5px;
  line-height: 1.3;
}
.tooltippopup__childdata p:last-child {
  margin-bottom: 0;
}
.tooltippopup__childdata + div {
  margin-top: 17px;
}
.tooltippopup__links {
  padding: 0;
  margin: 0;
}
.tooltippopup__links li {
  list-style: none;
  width: 100%;
}
.tooltippopup__links li a {
  position: relative;
  color: rgb(255, 121, 0);
  transition: all ease 0.3s;
}
.tooltippopup__links li a:hover {
  opacity: 0.75;
}
.tooltippopup__links li + li {
  margin-top: 4px;
}

.popaccordian__rowhead {
  position: relative;
  cursor: pointer;
  border: 1px solid rgb(255, 121, 0);
  padding: 9px;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}
.popaccordian__rowheadarrow {
  position: absolute;
  top: 0;
  left: 0;
}
.popaccordian__rowhead h5 {
  margin: 0;
  position: relative;
  color: rgb(255, 121, 0);
  padding-left: 10px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowhead h5 i {
  transition: all ease 0.3s;
}
.popaccordian__rowbody {
  border: 1px solid rgb(255, 121, 0);
  border-top: 0;
  display: none;
  border-radius: 0 0 3px 3px;
}
.popaccordian__rowbodyinner {
  padding: 10px;
}
.popaccordian__rowbodyinner > *:last-child {
  margin-bottom: 0;
}
.popaccordian__rowbodyinner h5 {
  margin: 0 0 10px;
  position: relative;
  color: rgb(255, 121, 0);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowbodyinner ul {
  margin: 0;
  padding: 0;
}
.popaccordian__rowbodyinner ul li {
  list-style: none;
  font-size: 14px;
  line-height: 1.3;
  position: relative;
  padding-left: 10px;
}
.popaccordian__rowbodyinner ul li::before {
  content: "";
  position: absolute;
  top: 7px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
.popaccordian__rowbodyinner ul li + li {
  margin-top: 5px;
}
.popaccordian__rowvideo {
  margin-top: 20px;
  padding-bottom: 15px;
}
.popaccordian__rowvideoinner {
  position: relative;
}
.popaccordian__rowvideoinner iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
.popaccordian__row + div {
  margin-top: 15px;
}
.popaccordian__row .popaccordian__rowhead {
  align-items: center;
  justify-content: space-between;
}
.popaccordian__row--active .popaccordian__rowhead {
  border-radius: 3px 3px 0 0;
}
.popaccordian__row--active .popaccordian__rowhead i {
  transform: rotate(90deg);
}
.popaccordian__row:first-child .popaccordian__rowbody {
  display: block;
}
.popaccordian__gen .slctrs {
  border-bottom: 1.5px solid #F1F1F2;
}
.popaccordian__gen select {
  width: 100%;
  border: 1px solid #CFDBE2;
  padding: 6px;
  height: 45px;
  border-radius: 4px;
}
.popaccordian__gen label {
  display: block;
}
.popaccordian__gen button {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
.popaccordian__gen__aidata {
  min-height: 400px;
  position: relative;
  display: none;
}
.popaccordian__gen__aidata--hyt {
  min-height: auto;
}
.popaccordian__gen__addbtn button {
  background-color: transparent;
  border: 0;
}
.popaccordian__gen__addbtn button:active {
  box-shadow: none;
}

.prevnext {
  padding: 20px 0;
}
.prevnext__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  margin: 0;
}
.prevnext li {
  list-style: none;
}
.prevnext li.prevnext__next {
  margin-left: auto;
}
.prevnext li.prevnext__prev a:hover > i {
  left: -5px;
}
.prevnext li.prevnext__next a {
  background-color: rgb(255, 121, 0);
  color: #fff;
  opacity: 1;
  padding: 6px 12px;
  border-radius: 3px;
}
.prevnext li.prevnext__next a:hover > i {
  left: 3px;
}
.prevnext li a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 14px;
  color: #676a6c;
  opacity: 0.47;
  padding: 6px 0;
  display: inline-block;
  transition: all ease 0.3s;
}
.prevnext li a i {
  position: relative;
  font-size: 1.1em;
  left: 0;
  transition: all ease 0.3s;
}

.playbtn {
  position: absolute;
  right: 9px;
  bottom: 7px;
  color: #06a6ce;
}

.Del-data-btn {
  padding: 40px 0;
}
.Del-data-btn .btn {
  margin-left: 15px;
  background-color: #fff;
  border-color: #f5f5f5;
  color: #ff485c;
}
.Del-data-btn .cancelbtn {
  color: #676a6c;
  text-align: center;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
}

.editmode {
  margin-bottom: 30px;
}
.editmode--btinp {
  margin-bottom: 0px;
}
.editmode--sc h3 {
  color: #676A6C !important;
}
.editmode__listrow {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
}
.editmode__listrow--nogap {
  grid-gap: 0;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow {
    grid-template-columns: 1fr;
  }
}
.editmode__listrow--equalblocks {
  display: flex;
  flex-wrap: wrap;
}
.editmode__listrow--equalblocks > .editmode__listcol {
  flex: 1;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow--equalblocks > .editmode__listcol {
    flex: none;
    width: 100%;
  }
}
.editmode__listrow--fullblocks {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid1 {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid3 > div:nth-child(1) {
  grid-row: 1/3;
}
.editmode__listrow--grid4 > div:nth-child(1) {
  grid-row: 1/4;
}
.editmode__listrow--grid5 > div:nth-child(1) {
  grid-row: 1/5;
}
.editmode__listrow--grid6 > div:nth-child(1) {
  grid-row: 1/6;
}
.editmode__listrow--grid7 > div:nth-child(1) {
  grid-row: 1/7;
}
.editmode__listcell {
  padding: 10px 15px;
  background-color: #EBEBEB;
  border: 1px solid #CFDBE2;
  border-radius: 6px;
  height: 100%;
}
.editmode__listcell--startbtn {
  border: 1px solid rgb(255, 121, 0);
  font-weight: 600;
  font-family: "Open Sans";
  font-size: 16px;
  cursor: pointer;
  line-height: 1;
  color: inherit !important;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell {
    font-size: 13px;
  }
}
.editmode__listcell h3 {
  color: rgb(255, 121, 0);
  margin-bottom: 5px;
}
.editmode__listcell h3 a,
.editmode__listcell h3 i {
  color: inherit;
}
.editmode__listcell--ls li {
  list-style-type: disc;
  color: #676a6c;
}
.editmode__listcell--sc p {
  font-weight: normal !important;
}
.editmode__listcell--sc h3 button {
  font-family: "Open Sans";
  font-size: 16px;
  color: #676a6c;
  font-weight: 600;
  cursor: pointer;
}
.editmode__listcell p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell p {
    font-size: 13px;
  }
}
.editmode__listcell p:last-child {
  margin-bottom: 0;
}

.trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
.trackInfo--inputclr {
  color: rgb(255, 121, 0);
  font-size: 11px;
  background: transparent;
  margin-left: 8px;
  padding-left: 0;
  margin-bottom: 2px;
  display: inline-block;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.row--editmodebg {
  background-color: #fff;
  padding: 0 35px;
}
.row--wbg {
  background-color: #fff;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

label {
  font-family: "Open Sans", sans-serif;
}

::ng-deep#page-wrapper {
  padding-bottom: 60px;
}

::ng-deep#wrapper {
  overflow-x: initial;
}

::ng-deep.implement-is .to-do {
  padding: 0px;
  border: 1px solid rgb(245, 67, 89);
  margin-bottom: 15px;
}
::ng-deep.implement-is .to-do p {
  display: initial;
}
::ng-deep.implement-is .to-do .col-sm-6 {
  padding: 0px;
  float: left;
}
::ng-deep.implement-is .to-do .col-sm-2 {
  padding: 0px;
  border-left: 1px dotted #ccc;
  float: left;
}
::ng-deep.implement-is .to-do .to-do-term {
  background-color: rgb(245, 67, 89);
  min-height: 30px;
}
::ng-deep.implement-is .next-input-tabs {
  width: 90%;
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 10px;
}
::ng-deep.implement-is .next-input-tabs input {
  height: 35px;
  padding: 10px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
::ng-deep.implement-is .next-input-tabs input:focus {
  border-color: rgb(0, 173, 208);
}
::ng-deep.implement-is .drag-content:hover {
  cursor: move;
}
::ng-deep.implement-is .implement-color {
  color: rgb(245, 67, 89);
}
::ng-deep.implement-is ::ng-deep #toast-container {
  margin-top: 40px;
}
::ng-deep.implement-is .input-tabs {
  min-height: 21px;
}
::ng-deep.implement-is .card-default h3 {
  cursor: pointer;
}
::ng-deep.implement-is .implement-section .to-do-term {
  padding-left: 10px;
  padding-right: 10px;
  color: #fff;
}
::ng-deep.implement-is .implement-section .ng-star-inserted label {
  min-width: 30px;
}
::ng-deep.implement-is .implement-section .ng-star-inserted input {
  width: 100%;
  margin-bottom: 0.5em;
  margin-top: 0;
}
::ng-deep.implement-is .implement-section .to-do .col-sm-2 input {
  width: 100%;
}
::ng-deep.implement-is .implement-section .col-sm-12.to-do > div:last-child.col-sm-3 .report-input {
  width: calc(100% - 56px);
  display: inline-block;
}
::ng-deep.implement-is .implement-section .col-sm-12.to-do > div:last-child.col-sm-3 input {
  width: 100%;
  margin-bottom: 0.5em;
}
::ng-deep.implement-is .implement-section .col-sm-12.to-do > div:last-child.col-sm-3 .fa {
  display: inline-block;
  width: auto;
  margin-left: 8px;
  border: none;
}
::ng-deep.implement-is .implement-inner {
  display: flex;
}
::ng-deep.implement-is .implement-inner .col-sm-5,
::ng-deep.implement-is .implement-inner .col-sm-3 {
  padding: 0;
}
::ng-deep.implement-is .implement-inner .col-sm-3 {
  border-left: 1px dotted #ccc;
}
::ng-deep.implement-is .implement-table {
  border: 1px solid #ccc;
  margin-bottom: 15px;
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}
::ng-deep.implement-is .ngx-datepicker-calendar-container {
  z-index: 999;
}
::ng-deep.implement-is .implement-table .heading-section {
  display: block;
  background-color: #e3e3e3;
  min-height: 30px;
  padding: 0 10px;
  color: #676a6c;
}
::ng-deep.implement-is .implement-table .heading-section--editbg {
  background-color: #F5F5F5;
  color: #676A6C;
}
::ng-deep.implement-is .implement-table td,
::ng-deep.implement-is .implement-table th {
  padding: 0 !important;
}
::ng-deep.implement-is .implement-table thead tr th,
::ng-deep.implement-is .implement-table tbody tr td {
  width: 15%;
  padding: 0 !important;
}
::ng-deep.implement-is .implement-table tbody tr td {
  vertical-align: top;
}
::ng-deep.implement-is .implement-table thead tr th:first-child,
::ng-deep.implement-is .implement-table tbody tr td:first-child {
  width: 40% !important;
}
::ng-deep.implement-is .implement-table thead tr th:last-child,
::ng-deep.implement-is .implement-table tbody tr td:last-child {
  width: 30% !important;
}
::ng-deep.implement-is .implement-table thead th:not(:last-child),
::ng-deep.implement-is .implement-table tbody td:not(:last-child) {
  border-right: 1px dotted #ccc;
}
::ng-deep.implement-is .implement-table tbody tr td input {
  width: 100%;
}
::ng-deep.implement-is .implement-table tbody tr td:first-child input {
  width: calc(100% - 35px);
}
::ng-deep.implement-is .implement-table tbody tr td:last-child input {
  width: calc(100% - 59px);
  margin-right: 10px;
}
::ng-deep.implement-is .implement-table th:not(:first-child) {
  text-align: left;
}
::ng-deep.implement-is .implement-table th h4 {
  color: #656565;
}
::ng-deep.implement-is app-implement-challenge-action-plan,
::ng-deep.implement-is app-implement-challenge-next24 {
  display: block;
  margin-top: 30px;
}
::ng-deep.implement-is .card-default .card-body {
  padding-top: 0;
  padding-bottom: 0;
}
::ng-deep.implement-is .card-default .list-columns {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
::ng-deep.implement-is .card-default .input-form label {
  min-width: 20px !important;
  margin-top: 10px;
}
::ng-deep.implement-is .card-show .input-form {
  padding-top: 15px;
  padding-bottom: 10px;
}
::ng-deep.implement-is ::ng-deep .card-default .alert {
  margin-bottom: 0 !important;
}
::ng-deep.implement-is .card-default .table.implement-table .list-columns {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
::ng-deep.implement-is .card-default .table.implement-table th h4,
::ng-deep.implement-is .card-default .table.implement-table td p,
::ng-deep.implement-is .card-default .table.implement-table td span {
  margin-bottom: 0 !important;
  padding: 12px !important;
}
::ng-deep.implement-is .implement-table__head td {
  background: #e3e3e3;
}
::ng-deep.implement-is .implement-table__head--editbg td {
  background: #F5F5F5;
  color: #676A6C;
}
::ng-deep.implement-is .tooltipicon {
  position: relative;
  display: inline-block;
  font-size: 18px;
}
::ng-deep.implement-is .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(245, 67, 89);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
  line-height: 1.2em;
  /* Position the tooltip */
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
@media screen and (max-width: 1199px) {
  ::ng-deep.implement-is .tooltipicon .tooltiptext {
    left: auto;
    right: 10px;
  }
}
::ng-deep.implement-is .tooltipicon:hover .tooltiptext {
  visibility: visible;
}
::ng-deep.implement-is .btn-develop {
  background-color: #66bd4a;
  color: #fff;
  padding: 0.375rem 1rem;
  border-radius: 3px;
}
::ng-deep.implement-is table.implement-table td > div,
::ng-deep.implement-is table.implement-table td > form {
  padding: 10px !important;
}
::ng-deep.implement-is .report-grid input {
  display: inline-block;
}
::ng-deep.implement-is .btn-bottom .btn-warning {
  margin-left: 10px;
}
::ng-deep.implement-is .generate-pdf {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}
@media screen and (max-width: 851px) {
  ::ng-deep.implement-is .generate-pdf {
    position: relative;
    top: 0;
    right: 0;
    margin-bottom: 20px;
  }
}
::ng-deep.implement-is .summary-pdf {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 170px;
}
@media screen and (max-width: 851px) {
  ::ng-deep.implement-is .summary-pdf {
    position: relative;
    top: 0;
    right: -7px;
    margin-bottom: 20px;
  }
}
::ng-deep.implement-is .mainnav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 30px 0 40px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .mainnav {
    margin: 10px 0 30px;
  }
}
::ng-deep.implement-is .mainnav.mainnav--bottom {
  margin: 30px 0 40px;
}
::ng-deep.implement-is .mainnav.mainnav--bottom ul li a {
  padding: 12px 30px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .mainnav.mainnav--bottom ul li a {
    padding: 10px 20px;
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .mainnav.mainnav--bottom ul li a {
    padding: 9px;
    font-size: 11px;
  }
}
::ng-deep.implement-is .mainnav.mainnav--bottom ul li.active a {
  background-color: #bbb !important;
  border-top: 1px solid #bbb !important;
  border-right: 1px solid #bbb !important;
  border-bottom: 1px solid #bbb !important;
}
::ng-deep.implement-is .mainnav--editmode {
  margin: 0 0 15px;
}
::ng-deep.implement-is .mainnav--editmode .mainnav__list {
  flex: 1;
  border-radius: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .mainnav--editmode .mainnav__list {
    flex: none;
    width: 100%;
  }
}
::ng-deep.implement-is .mainnav--editmode .mainnav__list li {
  width: 100%;
  flex: 1;
}
::ng-deep.implement-is .mainnav--editmode .mainnav__list li a {
  width: 100%;
  padding: 5px 2px;
  text-align: center;
}
::ng-deep.implement-is .mainnav__editmodeicon {
  margin-left: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .mainnav__editmodeicon {
    margin: 10px 0 0 auto;
  }
}
::ng-deep.implement-is .mainnav__editmodeicon ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  height: 100%;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li {
  list-style: none;
  transition: none;
  width: 37px;
  height: 100%;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #CFDBE2;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.active {
  background-color: #676a6c;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li:not(:last-child) {
  margin-right: 5px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .mainnav__editmodeicon ul li:not(:last-child) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .mainnav__editmodeicon ul li {
    width: 35px;
    height: 31px;
    display: none;
  }
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.mainnav__editmodepin {
  display: flex;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st0 {
  fill: #FFFFFF;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st1 {
  fill: #cfdbe2;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st0 {
  fill: #6d6e71;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st1 {
  fill: #FFFFFF;
}
::ng-deep.implement-is .stick-challenge {
  position: relative;
}
::ng-deep.implement-is .stick-challenge .card__implementtable {
  min-height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9;
  position: relative;
}
::ng-deep.implement-is .stick-challenge .card__implementtable .card-body__subtitle {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
}
::ng-deep.implement-is .info {
  color: #fff;
  border: 1px solid rgb(245, 67, 89);
  margin-bottom: 18px;
  padding: 20px 40px;
  border-radius: 6px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .info {
    padding: 12px 20px;
  }
}
::ng-deep.implement-is .info.infotitle {
  background-color: rgb(245, 67, 89);
}
::ng-deep.implement-is .info.infotitle h3 {
  color: #fff;
}
::ng-deep.implement-is .info h1 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .info h1 {
    font-size: 28px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info h1 {
    font-size: 24px;
  }
}
::ng-deep.implement-is .info h1 .info__maintitle {
  margin-right: auto;
}
::ng-deep.implement-is .info h1 small {
  color: #fff;
  font-size: 80%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info h1 small {
    width: 100%;
    margin-top: 5px;
  }
}
::ng-deep.implement-is .info .card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
::ng-deep.implement-is .info .card__toprow--tne .card__topcol:first-child {
  width: 72% !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info .card__toprow--tne .card__topcol:first-child {
    flex: 1;
    width: auto !important;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol {
  padding: 0 15px;
  width: 33.3333333333%;
}
::ng-deep.implement-is .info .card__toprow .card__topcol:nth-child(1) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol:nth-child(1) {
    flex: 1;
    margin-right: auto;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol--tab {
  width: 44%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol--tab {
    width: 120px;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol--tt {
  width: 28%;
  margin-left: auto;
  text-align: right;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol--tt {
    width: auto;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol--tt svg {
  max-width: 16px;
  cursor: pointer;
}
::ng-deep.implement-is .info .card__toprow .card__topcol--tt .card__pinicon {
  position: absolute;
  right: -17px;
  top: -15px;
  width: 20px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol--tt .card__pinicon {
    right: 2px;
    top: 1px;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--title > div:first-child {
  margin-right: 15px;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
  line-height: 1;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:not(:first-child) {
  margin-left: -1px;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button {
  color: rgb(245, 67, 89);
  border: 1px solid rgb(245, 67, 89);
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount {
  color: rgb(245, 67, 89);
  background-color: #efefef;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid rgb(245, 67, 89);
  color: rgb(245, 67, 89);
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount {
  color: rgb(245, 67, 89);
  background-color: #efefef;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg .st0 {
  fill: rgb(245, 67, 89);
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: rgb(245, 67, 89);
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover {
  color: rgb(245, 67, 89);
  opacity: 1;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover > span.card__topcount {
  color: rgb(245, 67, 89);
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.implement-is .info .card__toprow .card__h3button {
  border: 1px solid rgb(245, 67, 89);
  background-color: transparent;
  padding: 4px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(245, 67, 89);
  font-size: 22px;
  line-height: 1.2;
  transition: all ease 0.3s;
  cursor: pointer;
}
::ng-deep.implement-is .info .card__toprow .card__h3button:hover {
  background-color: rgb(245, 67, 89);
  color: #fff;
}
::ng-deep.implement-is .info .card__toprow .card__h3button:focus {
  outline: none;
}
::ng-deep.implement-is .info .card__toprow .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.implement-is .info .card__toprow .tooltipicon i {
  color: rgb(245, 67, 89);
}
::ng-deep.implement-is .info .card__toprow .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.implement-is .info .card__toprow .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(245, 67, 89);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.implement-is .info h3 {
  font-size: 20px;
  margin: 0;
  cursor: pointer;
  color: rgb(245, 67, 89);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .info h3 {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info h3 {
    font-size: 15px;
    word-break: break-word;
  }
}
::ng-deep.implement-is .info h3 > *:not(:last-child) {
  margin-right: 5px;
}
::ng-deep.implement-is .info h3 .card__bwnh3pencil a {
  color: rgb(245, 67, 89);
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info h3 .card__bwnh3button {
    width: 100%;
    margin-top: 10px;
  }
}
::ng-deep.implement-is .info h3 .card__bwnh3button button {
  font-size: 18px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info h3 .card__bwnh3button button {
    font-size: 16px !important;
  }
}
::ng-deep.implement-is .info h3 i {
  cursor: pointer;
  font-size: 0.9em;
}
::ng-deep.implement-is .info h3 i + div {
  padding-left: 7px;
}
::ng-deep.implement-is .info h3 i + div span {
  display: block;
  font-size: 0.7em;
}
::ng-deep.implement-is .info h3 i + span {
  padding-left: 7px;
}
::ng-deep.implement-is .info h3 a {
  margin-left: 10px;
  color: rgb(245, 67, 89);
}
::ng-deep.implement-is .info h3.d-flex {
  display: flex;
}
::ng-deep.implement-is .info h3.d-flex div:first-child {
  padding-right: 10px;
}
::ng-deep.implement-is .info h3.d-flex div:nth-child(2) span {
  display: block;
}
::ng-deep.implement-is .info .tooltipicon {
  position: relative;
  display: inline-block;
}
::ng-deep.implement-is .info .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.implement-is .info .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(245, 67, 89);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 15px;
  line-height: 1.2em;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.implement-is .topheading {
  color: #fff;
  background-color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
  margin-bottom: 18px;
  padding: 24px;
  border-radius: 6px;
}
::ng-deep.implement-is .topheading h1 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
}
::ng-deep.implement-is .topheading h1 small {
  color: #fff;
  font-size: 80%;
}
::ng-deep.implement-is .card-default {
  border-radius: 6px;
  border-top-width: 3px;
  border: 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
::ng-deep.implement-is .card-default.card-default--summary {
  box-shadow: none;
}
::ng-deep.implement-is .card-default.card-default--summary .info {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.implement-is .card-default.card-default--summary .card-body {
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
  border-radius: 0;
}
::ng-deep.implement-is .card-default.card-default--summary .card-body__inner {
  padding: 15px 20px;
}
::ng-deep.implement-is .card-default.card-default--summary + div {
  margin-top: 20px;
}
::ng-deep.implement-is .card-default + div {
  margin-top: 30px;
}
::ng-deep.implement-is .card-default .info {
  margin: 0;
}
::ng-deep.implement-is .card-default .info.card__headactive {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.implement-is .card-default .info.card__headactive--cc {
  background-color: rgb(245, 67, 89);
}
::ng-deep.implement-is .card-default .info.card__headactive--cc .card__topcol h3 {
  color: #fff;
}
::ng-deep.implement-is .card-default .info.card__headactive--cc .card__topcol ul li button {
  border-color: #fff;
  background-color: #fff;
}
::ng-deep.implement-is .card-default .info.card__headactive--cc .card__topcol ul li button span {
  color: rgb(245, 67, 89);
  background-color: #fff;
}
::ng-deep.implement-is .card-default .info.card__headactive--cc .card__topcol ul li button .st0 {
  fill: #fff !important;
}
::ng-deep.implement-is .card-default .info.card__headactive--cc i {
  color: #fff;
}
::ng-deep.implement-is .card-default .info.card__headactive .card__topcol--tt svg {
  max-width: 16px;
  width: 100%;
}
::ng-deep.implement-is .card-default .info.card__headactive .card__topcol--tt .tooltipicon i {
  color: #ff485c;
}
::ng-deep.implement-is .card-default .info.card__headactive.challenge__sol {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
}
::ng-deep.implement-is .card-default .info.card__headactive.challenge__sol .card__topcol--tt span {
  position: absolute;
  right: 8px;
  top: 6px;
}
::ng-deep.implement-is .card-default .card-body__inner {
  padding: 15px 40px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .card-default .card-body__inner {
    padding: 12px 20px;
  }
}
::ng-deep.implement-is .card-default .card-body {
  display: none;
  border: 1px solid #CFDBE2;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
::ng-deep.implement-is .card-default .card-body--ov {
  overflow: visible;
}
::ng-deep.implement-is .card-default .card-body.card-show {
  display: block;
}
::ng-deep.implement-is .card-default .card-body.card-show__wbg {
  background-color: #fff;
}
::ng-deep.implement-is .card-default .card-body__finalstate p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body__finalstate p {
    font-size: 13px;
  }
}
::ng-deep.implement-is .card-default .card-body__finalstate p:last-child {
  margin-bottom: 0;
}
::ng-deep.implement-is .card-default .card-body__finalstate--2 {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
::ng-deep.implement-is .card-default .card-body__finalstate--2 > div {
  width: 50%;
  padding: 0 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body__finalstate--2 > div {
    width: 100%;
  }
}
::ng-deep.implement-is .card-default .card-body__finalstate--2 > div p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.implement-is .card-default .card-body__finalstate--2 > div p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.implement-is .card-default .card-body__subtitle {
  margin-bottom: 16px;
  padding-left: 0;
}
::ng-deep.implement-is .card-default .card-body__subtitle--pl0 {
  padding-left: 0;
}
::ng-deep.implement-is .card-default .card-body__subtitle *:last-child {
  margin-bottom: 0;
}
::ng-deep.implement-is .card-default .card-body__subtitle p {
  color: #969798;
  font-size: 15px;
}
::ng-deep.implement-is .card-default .card-body__subtitle p i {
  padding-left: 5px;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown {
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li {
  list-style: none;
  position: relative;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li + li {
  margin-left: 15px;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li > a {
  font-size: 16px;
  color: #676a6a;
  font-weight: 700;
  background-color: #fff;
  border: 1px solid #ededed;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  transition: all ease 0.3s;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body__pdfdropdown > li > a {
    font-size: 13px;
  }
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li > a .page-heading__icon {
  padding: 11px 14px;
  border-right: 1px solid #ededed;
  display: flex;
  align-items: center;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li > a .page-heading__text {
  padding: 11px 14px;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li > a:hover {
  border: 1px solid #CFDBE2;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li:hover > ul {
  display: block;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li ul {
  margin: 0;
  padding: 0;
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  width: 144px;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
  background-color: #fff;
  z-index: 99;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li ul li {
  list-style: none;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li ul li + li {
  border-top: 1px solid #dcdcdc;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li ul li a {
  color: #696969;
  text-align: center;
  padding: 8px 20px;
  font-size: 13px;
  display: block;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li ul li a:hover {
  background-color: #f9f9f9;
}
::ng-deep.implement-is .card-default .c-radio label {
  padding-left: 0;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.implement-is .card-default .c-radio label > i {
  position: relative;
  top: 2px;
  margin-right: 6px;
  opacity: 0.6;
}
::ng-deep.implement-is .card-default .c-radio label > span {
  vertical-align: middle;
}
::ng-deep.implement-is .card-default .c-radio input {
  opacity: 0;
  margin: 0;
  display: none;
}
::ng-deep.implement-is .card-default .c-radio input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.implement-is .card-default .c-radio input + span::before {
  position: absolute;
  color: rgb(245, 67, 89);
  opacity: 0;
  font-size: 11px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.implement-is .card-default .c-radio input:checked + span {
  border-color: rgb(245, 67, 89);
}
::ng-deep.implement-is .card-default .c-radio input:checked + span::before {
  opacity: 1;
}
::ng-deep.implement-is .card-default .checkbox {
  margin-top: 0;
}
::ng-deep.implement-is .card-default .checkbox label {
  min-height: 20px;
  padding-left: 0;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.implement-is .card-default .checkbox label > i {
  position: relative;
  top: 1px;
  margin-right: 6px;
}
::ng-deep.implement-is .card-default .checkbox label > span {
  vertical-align: middle;
}
::ng-deep.implement-is .card-default .checkbox input {
  opacity: 0;
  position: absolute;
  display: none;
}
::ng-deep.implement-is .card-default .checkbox input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.implement-is .card-default .checkbox input + span::before {
  font-size: 12px;
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.implement-is .card-default .checkbox input:checked + span {
  border-color: #5D9CEC;
  background-color: #5D9CEC;
}
::ng-deep.implement-is .card-default .checkbox input:checked + span::before {
  opacity: 1;
}
::ng-deep.implement-is .card-default .card-body__button {
  background-color: #f5f5f5;
  border-top: 1px solid #e3e3e3;
  padding: 12px 40px;
}
::ng-deep.implement-is .card-default .card-body__button .card-button {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn + .btn {
  margin-left: 15px;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .float-right {
  margin-left: auto;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-implement {
  background-color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
  color: #fff;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-implement:hover {
  background-color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-danger {
  background-color: #fff;
  border-color: #fff;
  color: #ef6272;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-danger:hover {
  background-color: #ED2D2D;
  border-color: #EC2121;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-warning em {
  margin: 0;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall:hover {
  background-color: #fff;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall:hover em {
  margin-right: 6px;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body--ebtn {
  margin-top: 15px;
  padding: 15px 40px;
  border-top: 1px solid #CFDBE2;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn {
    padding: 12px 20px;
  }
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow {
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
  padding: 0 8px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
    width: 100%;
    text-align: center;
  }
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow > div + div {
    margin-top: 10px;
  }
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow > div.card-body--col--last {
  margin-left: auto;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  padding: 7px 16px;
  text-align: center;
  transition: all ease 0.3s;
  font-weight: 900;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
    font-size: 12px;
  }
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn i,
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--save {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--clarify {
  background-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--implement {
  background-color: rgb(245, 67, 89);
  color: #fff;
  border-color: rgb(245, 67, 89);
  font-weight: 900;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel {
  padding: 0;
  background-color: transparent;
  margin-left: 0;
  border: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #676a6c;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel:hover {
  color: #000;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--converge {
  padding: 0 8px;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
  font-size: 14px;
  color: #676a6c;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
  background-color: #f5f5f5;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
    padding-right: 7px;
    padding-left: 7px;
  }
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover em {
  margin-right: 6px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    background-color: #f5f5f5;
    color: #ed5562;
    padding-right: 16px;
    padding-left: 16px;
  }
}
@media only screen and (max-width: 767px) and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    padding-right: 7px;
    padding-left: 7px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall > span {
    position: relative;
    left: 0;
  }
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
    margin-right: 6px !important;
  }
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .note-3 {
  padding: 15px 15px 10px;
  border: 2px solid rgb(0, 173, 208);
  margin-bottom: 15px;
}
::ng-deep.implement-is .card-default .note-3 label {
  color: rgb(0, 173, 208);
}
::ng-deep.implement-is .card-default .footer-line {
  color: rgb(0, 173, 208);
}
::ng-deep.implement-is .card-default p {
  font-size: 15px;
}
::ng-deep.implement-is .card-default p:last-child {
  margin-bottom: 0;
}
::ng-deep.implement-is .card-default .card-body__edit {
  position: relative;
  overflow: hidden;
}
::ng-deep.implement-is .card-default .card-body__edit--ov {
  overflow: visible;
}
::ng-deep.implement-is .card-default .card-body__edit .breakthrough-input-tabs,
::ng-deep.implement-is .card-default .card-body__edit .datadump-input-tabs {
  width: 100%;
  margin-right: 0;
  position: relative;
}
::ng-deep.implement-is .card-default .card-body__edit .breakthrough-input-tabs input,
::ng-deep.implement-is .card-default .card-body__edit .breakthrough-input-tabs select,
::ng-deep.implement-is .card-default .card-body__edit .datadump-input-tabs input,
::ng-deep.implement-is .card-default .card-body__edit .datadump-input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #ccc !important;
  border-radius: 4px;
  font-size: 15px;
}
::ng-deep.implement-is .card-default .card-body__edit .breakthrough-input-tabs input:focus,
::ng-deep.implement-is .card-default .card-body__edit .breakthrough-input-tabs select:focus,
::ng-deep.implement-is .card-default .card-body__edit .datadump-input-tabs input:focus,
::ng-deep.implement-is .card-default .card-body__edit .datadump-input-tabs select:focus {
  outline: none !important;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow > div {
  padding: 0 15px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol--mb0 {
  margin-bottom: 0;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol--2 {
  width: 50%;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow > div > div {
  position: relative;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow select {
  appearance: none;
  background-image: url("https://assets.foursightonline.com/app/images/select.png");
  background-size: 10px;
  background-position: right 10px center;
  background-repeat: no-repeat;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow textarea {
  width: 100%;
  border: 1px solid #ccc;
  resize: none;
  border-radius: 3px;
  padding: 10px 15px;
  font-size: 15px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel {
  width: 35px;
  padding-right: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber {
  width: 40px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-right: 0;
  border-radius: 4px 0 0 4px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput {
  width: calc(100% - 41px);
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label {
  margin-bottom: 0;
  font-weight: 900;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
  width: 315px;
  padding-right: 15px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
  width: calc(100% - 351px);
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input.add-line,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input.add-line {
  padding-right: 70px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput.card-body__editinput--np input,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput.card-body__editinput--np input {
  padding-right: 15px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child {
  width: 100%;
}
::ng-deep.implement-is .card-default .card-body__edit + .card-body__addnew button {
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body__edit + .card-body__addnew button:hover {
  background-color: rgb(245, 67, 89);
  border: 1px solid rgb(245, 67, 89);
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}
::ng-deep.implement-is .card-default .breakthrough-input-tabs {
  width: 90%;
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.implement-is .card-default .breakthrough-input-tabs input {
  height: 35px;
  padding: 10px 15px;
  border: 1px solid rgb(245, 67, 89);
  border-radius: 4px;
  margin-bottom: 0;
}
::ng-deep.implement-is .card-default .input-tabs {
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 0 0 0 0;
  margin: 0;
}
::ng-deep.implement-is .card-default .input-tabs + i {
  position: relative;
  top: -1px;
}
::ng-deep.implement-is .card-default .input-tabs.card__body--cs {
  position: relative;
  border-bottom: 1px solid #e4e4e4;
}
::ng-deep.implement-is .card-default .input-tabs.card__body--cs::before, ::ng-deep.implement-is .card-default .input-tabs.card__body--cs::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: 100%;
  width: 40px;
  height: 1px;
  background-color: #e4e4e4;
}
::ng-deep.implement-is .card-default .input-tabs.card__body--cs::after {
  right: auto;
  left: 100%;
}
::ng-deep.implement-is .card-default .input-tabs .select_faded {
  opacity: 0.2;
  padding-left: 32px;
}
::ng-deep.implement-is .card-default .input-tabs input,
::ng-deep.implement-is .card-default .input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  margin: 7px 0px;
}
::ng-deep.implement-is .card-default .input-tabs label {
  width: 20px;
  margin: 0;
}
::ng-deep.implement-is .card-default .input-tabs select {
  width: 9%;
}
::ng-deep.implement-is .card-default .input-tabs input {
  width: 90%;
  margin-left: 15px;
}
::ng-deep.implement-is .card-default .input-group-text {
  cursor: pointer;
  padding: 3px 16px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.528571429;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #E9ECEF;
  border: 1px solid #DDE6E9;
  border-radius: 0.25rem;
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .input-group-text:hover {
  background-color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
  color: #fff;
}
::ng-deep.implement-is .card-default .input-group-text i {
  font-size: 12px;
}
::ng-deep.implement-is .card-default .list-columns {
  display: flex;
  flex-wrap: wrap;
  counter-reset: section;
}
::ng-deep.implement-is .card-default .list-columns.list-columns--2 > div {
  width: 100%;
}
::ng-deep.implement-is .card-default .list-columns .brainstorm-tabs {
  position: relative;
  padding-left: 23px;
}
::ng-deep.implement-is .card-default .list-columns .brainstorm-tabs::before {
  counter-increment: section;
  content: counter(section) ".";
  position: absolute;
  top: 0;
  left: 0;
}
::ng-deep.implement-is .idea-shop-list {
  padding: 20px;
  margin-left: 17px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .idea-shop-list li {
  width: 50%;
  margin-bottom: 10px;
}
::ng-deep.implement-is .brainstorm__col {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 17px;
}
::ng-deep.implement-is .brainstorm__col .brainstorm-main {
  width: calc(100% - 68px);
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.implement-is .brainstorm__col .brainstorm-main .brainstorm-group {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend {
  margin-right: -1px;
  width: 45px;
}
::ng-deep.implement-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend .input-group-text {
  background: transparent;
  border-color: rgb(245, 67, 89);
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep.implement-is .brainstorm__col .brainstorm-main .brainstorm-group input {
  width: calc(100% - 45px);
  height: 35px;
  border: 1px solid rgb(255, 121, 0);
  border-radius: 0 0.25rem 0.25rem 0;
}
::ng-deep.implement-is .point-evaluation {
  padding: 0px;
  border: 1.5px solid #66bd4a;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .point-evaluation > div {
  padding: 10px;
}
::ng-deep.implement-is .point-evaluation .pluses {
  border-right: 1.5px solid #66bd4a;
  border-bottom: 1.5px solid #66bd4a;
}
::ng-deep.implement-is .point-evaluation .pluses h4::before {
  content: "P";
}
::ng-deep.implement-is .point-evaluation .opportunities {
  border-bottom: 1.5px solid #66bd4a;
}
::ng-deep.implement-is .point-evaluation .opportunities h4::before {
  content: "O";
}
::ng-deep.implement-is .point-evaluation .issues {
  border-right: 1.5px solid #66bd4a;
}
::ng-deep.implement-is .point-evaluation .issues h4::before {
  content: "I";
}
::ng-deep.implement-is .point-evaluation .new-thinking h4::before {
  content: "Nt";
}
::ng-deep.implement-is .point-evaluation h4 {
  position: relative;
  padding-left: 50px;
  color: #66bd4a;
  font-size: 16px;
  margin: 0 0 10px;
}
::ng-deep.implement-is .point-evaluation h4::before {
  content: "";
  background: #66bd4a;
  color: #fff;
  font-size: 20px;
  height: 35px;
  width: 35px;
  position: absolute;
  border-radius: 50%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
::ng-deep.implement-is .point-evaluation h4 small {
  display: block;
  margin-top: 4px;
  color: inherit;
  line-height: 1.3;
  font-size: 82%;
}
::ng-deep.implement-is .point-evaluation p {
  color: #66bd4a;
}
::ng-deep.implement-is .point-evaluation span.fill-bottom {
  width: 100%;
}
::ng-deep.implement-is .point-evaluation .icons-right i {
  font-size: 21px;
  color: #66bd4a;
  cursor: pointer;
}
::ng-deep.implement-is .point-evaluation .icons-right i:not(:last-child) {
  margin-right: 10px;
}
::ng-deep.implement-is .point-evaluation .fill-input {
  width: calc(100% - 35px);
  display: inline-block;
  margin-right: 15px;
}
::ng-deep.implement-is .point-evaluation .fill-input label {
  display: inline-block;
  min-width: 20px;
  color: #66bd4a;
}
::ng-deep.implement-is .point-evaluation .fill-input input {
  display: inline-block;
  width: calc(100% - 20px);
  height: 34px;
  border-radius: 3px;
  margin: 1px 0;
}
::ng-deep.implement-is .point-evaluation .input-tabs .input-tabs__row {
  width: calc(100% - 35px);
  display: inline-block;
  margin-right: 15px;
  position: relative;
  vertical-align: middle;
}
::ng-deep.implement-is .point-evaluation .input-tabs .input-tabs__row .pr-0 {
  padding-right: 0;
}
::ng-deep.implement-is .point-evaluation .input-tabs .input-tabs__row > i {
  position: absolute;
  top: 50%;
  right: -26px;
  transform: translateY(-50%);
}
::ng-deep.implement-is .point-evaluation .input-tabs label {
  display: inline-block;
  min-width: 20px;
  color: #66bd4a;
}
::ng-deep.implement-is .point-evaluation .input-tabs input,
::ng-deep.implement-is .point-evaluation .input-tabs select {
  height: 34px;
  border-radius: 3px;
  margin: 1px 0;
}
::ng-deep.implement-is .point-evaluation .input-tabs select {
  display: inline-block;
  width: calc(100% - 20px);
}
::ng-deep.implement-is .develop-footer-note {
  color: #66bd4a;
}
::ng-deep.implement-is .d-flex.count-div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.implement-is .d-flex.count-div label {
  width: 35px;
}
::ng-deep.implement-is .implement-section .input-tabs {
  display: block !important;
}
::ng-deep.implement-is .card-bottom-button .button {
  font-size: 13px;
  color: #fff;
  padding: 8px 10px;
  border-radius: 3px;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-bottom-button .button:hover {
  opacity: 0.8;
}
::ng-deep.implement-is .card-bottom-button .button i {
  font-size: 0.8em;
}
::ng-deep.implement-is .card-bottom-button .button.btn-clarify {
  background-color: rgb(0, 173, 208);
}
::ng-deep.implement-is .card-bottom-button .button.btn-ideate {
  background-color: rgb(255, 121, 0);
}
::ng-deep.implement-is .card-bottom-button .button.btn-implement {
  background-color: rgb(245, 67, 89);
}
::ng-deep.implement-is .cancelTool.tooltipicon {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
::ng-deep.implement-is .cancelTool.tooltipicon .tooltiptext {
  width: 150px;
  color: #676a6c;
  text-align: center;
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
  top: -25px;
  left: 10px;
}
::ng-deep.implement-is .cancelTool.tooltipicon:hover .tooltiptext {
  visibility: visible;
}
::ng-deep.implement-is .card_solution b {
  font-size: 15px;
}
::ng-deep.implement-is .card_solution .solution-list {
  margin-bottom: 0;
  width: 100%;
  margin-top: 10px;
}
::ng-deep.implement-is .card_solution .solution-list span {
  display: block;
}
::ng-deep.implement-is .card_solution .solution-list__selection1 {
  margin-top: 10px;
}
::ng-deep.implement-is .card_solution .solution-list__selection2 {
  margin-left: 20px;
}

::ng-deep.cdk-overlay-container {
  position: absolute !important;
  top: 288px !important;
}

.tooltippopup {
  max-width: 360px;
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  right: -400px;
  padding: 45px 24px 24px;
  text-align: left;
  z-index: 9999;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  transition: all ease 0.3s;
  overflow-y: auto;
}
.tooltippopup--active {
  right: 0;
}
.tooltippopup__btn {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 0 10px;
}
.tooltippopup__btn li {
  list-style: none;
  text-align: center;
  cursor: pointer;
  width: 33.3333333333%;
}
.tooltippopup__btn li button {
  width: 100%;
  color: rgb(245, 67, 89);
  font-size: 12px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  border: 1px solid rgb(245, 67, 89);
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
.tooltippopup__btn li button:focus {
  outline: none;
}
.tooltippopup__btn li button.tooltippopup__btncompleted {
  opacity: 0.2;
}
.tooltippopup__btn li button.tooltippopup__btncompleted:hover {
  opacity: 1;
}
.tooltippopup__btn li button.tooltippopup__btnactive {
  opacity: 1;
}
.tooltippopup__btn li button:hover {
  position: relative;
  z-index: 9;
}
.tooltippopup__btn li + li {
  margin-left: -1px;
}
.tooltippopup__btn li:first-child button {
  border-radius: 3px 0 0 3px;
}
.tooltippopup__btn li:last-child button {
  border-radius: 0 3px 3px 0;
}
.tooltippopup h4 {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 1.2;
}
.tooltippopup p {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.4;
}
.tooltippopup__close {
  position: absolute;
  top: 10px;
  right: 25px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: all ease 0.3s;
}
.tooltippopup__close:hover {
  transform: rotate(360deg);
}
.tooltippopup__close > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.tooltippopup__close > div span {
  position: absolute;
  background: #676a6c;
}
.tooltippopup__close > div span:nth-child(1) {
  top: 0;
  left: calc(50% - 1px);
  width: 2px;
  height: 100%;
}
.tooltippopup__close > div span:nth-child(2) {
  top: calc(50% - 1px);
  left: 0;
  width: 100%;
  height: 2px;
}
.tooltippopup__child {
  margin-top: 20px;
}
.tooltippopup__childdata .table-responsive {
  overflow-x: auto;
  margin-bottom: 10px;
}
.tooltippopup__childdata .table-responsive table {
  min-width: 297px;
  border: 1px solid #e7eaec;
}
.tooltippopup__childdata .table-responsive table th,
.tooltippopup__childdata .table-responsive table td {
  border: 1px solid #e7eaec;
  min-width: 120px;
}
.tooltippopup__childdata .table-responsive + * {
  margin-top: 20px;
}
.tooltippopup__childdata--clarify h4 {
  color: rgb(0, 173, 208);
}
.tooltippopup__childdata--ideate h4 {
  color: rgb(255, 121, 0);
}
.tooltippopup__childdata--develop h4 {
  color: rgb(105, 190, 40);
}
.tooltippopup__childdata--implement h4 {
  color: rgb(245, 67, 89);
}
.tooltippopup__childdata h4 {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 2px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.tooltippopup__childdata h4 + h5 {
  mask-type: 10px;
}
.tooltippopup__childdata p {
  margin-bottom: 5px;
  line-height: 1.3;
}
.tooltippopup__childdata p:last-child {
  margin-bottom: 0;
}
.tooltippopup__childdata + div {
  margin-top: 17px;
}
.tooltippopup__links {
  padding: 0;
  margin: 0;
}
.tooltippopup__links li {
  list-style: none;
  width: 100%;
}
.tooltippopup__links li a {
  position: relative;
  color: rgb(245, 67, 89);
  transition: all ease 0.3s;
}
.tooltippopup__links li a:hover {
  opacity: 0.75;
}
.tooltippopup__links li + li {
  margin-top: 4px;
}

.popaccordian__rowhead {
  position: relative;
  cursor: pointer;
  border: 1px solid rgb(245, 67, 89);
  padding: 9px;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}
.popaccordian__rowheadarrow {
  position: absolute;
  top: 0;
  left: 0;
}
.popaccordian__rowhead h5 {
  margin: 0;
  position: relative;
  color: rgb(245, 67, 89);
  padding-left: 10px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowhead h5 i {
  transition: all ease 0.3s;
}
.popaccordian__rowbody {
  border: 1px solid rgb(245, 67, 89);
  border-top: 0;
  display: none;
  border-radius: 0 0 3px 3px;
}
.popaccordian__rowbodyinner {
  padding: 10px;
}
.popaccordian__rowbodyinner > *:last-child {
  margin-bottom: 0;
}
.popaccordian__rowbodyinner h5 {
  margin: 0 0 10px;
  position: relative;
  color: rgb(245, 67, 89);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowbodyinner ul {
  margin: 0;
  padding: 0;
}
.popaccordian__rowbodyinner ul li {
  list-style: none;
  font-size: 14px;
  line-height: 1.3;
  position: relative;
  padding-left: 10px;
}
.popaccordian__rowbodyinner ul li::before {
  content: "";
  position: absolute;
  top: 7px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
.popaccordian__rowbodyinner ul li + li {
  margin-top: 5px;
}
.popaccordian__row + div {
  margin-top: 15px;
}
.popaccordian__row--active .popaccordian__rowhead {
  border-radius: 3px 3px 0 0;
}
.popaccordian__row--active .popaccordian__rowhead i {
  transform: rotate(90deg);
}
.popaccordian__row:first-child .popaccordian__rowbody {
  display: block;
}

.prevnext {
  padding: 10px 0;
}
.prevnext__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  margin: 0;
}
.prevnext li {
  list-style: none;
}
.prevnext li.prevnext__next {
  margin-left: auto;
}
.prevnext li.prevnext__action {
  margin-left: auto;
}
.prevnext li.prevnext__action a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 14px;
  color: #676a6c;
  cursor: pointer;
  opacity: 0.6;
  transition: all ease 0.3s;
}
.prevnext li.prevnext__action a:hover {
  opacity: 1;
}
.prevnext li.prevnext__prev a:hover > i {
  left: -5px;
}
.prevnext li.prevnext__next a {
  background-color: rgb(245, 67, 89);
  color: #fff;
  opacity: 1;
  padding: 6px 12px;
  border-radius: 3px;
}
.prevnext li.prevnext__next a:hover > i {
  left: 3px;
}
.prevnext li a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 14px;
  color: #676a6c;
  opacity: 0.47;
  padding: 6px 0;
  display: inline-block;
  transition: all ease 0.3s;
}
.prevnext li a i {
  position: relative;
  font-size: 1.1em;
  left: 0;
  transition: all ease 0.3s;
}

::ng-deep.card__implementtable {
  overflow-y: auto;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.card__implementtable table {
    width: 700px;
    max-width: none;
  }
}
::ng-deep.card__implementtable .card-body__addnew button {
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  margin: 6px 50px;
  color: #676a6c;
  transition: all ease 0.3s;
}
::ng-deep.card__implementtable .card-body__addnew button:hover {
  background-color: rgb(245, 67, 89);
  border: 1px solid rgb(245, 67, 89);
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}

.playbtn {
  position: absolute;
  right: 9px;
  bottom: 7px;
  color: #06a6ce;
}

.Del-data-btn {
  padding: 40px 0;
}
.Del-data-btn .btn {
  margin-left: 15px;
  background-color: #fff;
  border-color: #f5f5f5;
  color: #ff485c;
}
.Del-data-btn .cancelbtn {
  color: #676a6c;
  text-align: center;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
}

.editmode {
  margin-bottom: 30px;
}
.editmode--not {
  margin-bottom: 0;
}
.editmode__listrow {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow {
    grid-template-columns: 1fr;
  }
}
.editmode__listrow--equalblocks {
  display: flex;
  flex-wrap: wrap;
}
.editmode__listrow--equalblocks > .editmode__listcol {
  flex: 1;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow--equalblocks > .editmode__listcol {
    flex: none;
    width: 100%;
  }
}
.editmode__listrow--fullblocks {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid1 {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid3 > div:nth-child(1) {
  grid-row: 1/3;
}
.editmode__listrow--grid4 > div:nth-child(1) {
  grid-row: 1/4;
}
.editmode__listrow--grid5 > div:nth-child(1) {
  grid-row: 1/5;
}
.editmode__listrow--grid6 > div:nth-child(1) {
  grid-row: 1/6;
}
.editmode__listrow--grid7 > div:nth-child(1) {
  grid-row: 1/7;
}
.editmode__listcell {
  padding: 10px 15px;
  background-color: #EBEBEB;
  border: 1px solid #CFDBE2;
  border-radius: 6px;
  height: 100%;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell {
    font-size: 13px;
  }
}
.editmode__listcell h3 {
  color: #676A6C;
  margin-bottom: 5px;
}
.editmode__listcell h3 a,
.editmode__listcell h3 i {
  color: inherit;
}
.editmode__listcell p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell p {
    font-size: 13px;
  }
}
.editmode__listcell p:last-child {
  margin-bottom: 0;
}

.trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}

.row--editmodebg {
  background-color: #fff;
  padding: 40px 35px;
}
.row--wbg {
  background-color: #fff;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.row--editmodebg {
  background-color: #fff;
  padding: 40px 35px;
}

.trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
.trackInfo--inputclr {
  color: rgb(245, 67, 89);
  font-size: 11px;
  background: transparent;
  margin-left: 8px;
  padding-left: 0;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
::ng-deep .datepicker-container input {
  padding: 8px 10px;
  font-size: 14px;
  width: 200px;
  outline: 0;
  border: 1px solid #dfe3e9;
}

.card-body__minus--hide {
  display: none;
}

.pdf-modal {
  display: none;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/*#Path_125{
	animation: blink 2s linear infinite;
	animation-delay: .25s;
}
#Path_124{
	animation: blink 2s linear infinite;
	animation-delay: .50s;
}*/
#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@media print {
  .is-contentPDF {
    padding: 50px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/summary-challenge/summary-challenge.component.scss","webpack://./src/app/components/challenges/_cn-shared.scss","webpack://./src/app/components/challenges/clarify-challenge/clarify-challenge.component.scss","webpack://./src/app/components/challenges/develop-challenge/develop-challenge.component.scss","webpack://./src/app/components/challenges/ideate-challenge/ideate-challenge.component.scss","webpack://./src/app/components/challenges/implement-challenge/implement-challenge.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;ACvUA;EACI,oCAAA;AD0UJ;;AE/YA;EACI,oBAAA;AFkZJ;;AE/YA;EACI,mBAAA;AFkZJ;;AE9YA;EACI,kBAAA;AFiZJ;;AE5YI;EDCA,aAAA;EAEA,eAAA;ECDI,mBAAA;AFmZR;AEjZQ;EAJJ;IAKQ,mBAAA;EFoZV;AACF;AElZQ;EACI,mBAAA;AFoZZ;AEhZoB;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AFkZxB;AEhZwB;EANJ;IAOQ,kBAAA;IACA,eAAA;EFmZ1B;AACF;AEjZwB;EAXJ;IAYQ,YAAA;IACA,eAAA;EFoZ1B;AACF;AEhZwB;EACI,iCAAA;EACA,qCAAA;EACA,wCAAA;EACA,sCAAA;AFkZ5B;AE3YQ;EACI,gBAAA;AF6YZ;AE3YY;EACI,OAAA;EACA,kBAAA;AF6YhB;AE3YgB;EAJJ;IAKQ,UAAA;IACA,WAAA;EF8YlB;AACF;AE5YgB;EACI,WAAA;EACA,OAAA;AF8YpB;AE5YoB;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;AF8YxB;AEvYI;EACI,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AFyYR;AEvYQ;EAPJ;IAQQ,kBAAA;EF0YV;AACF;AExYQ;EACI,kCH7EI;ACudhB;AEvYQ;EACI,eAAA;EACA,gBAAA;EACA,SAAA;ED3CR,mCAAA;EACA,8BAAA;EC4CQ,aAAA;EACA,eAAA;EACA,mBAAA;AF0YZ;AExYY;EATJ;IAUQ,eAAA;EF2Yd;AACF;AEzYY;EAbJ;IAcQ,eAAA;EF4Yd;AACF;AE1YY;EACI,kBAAA;AF4YhB;AExYY;EACI,WAAA;EACA,cAAA;AF0YhB;AExYgB;EAJJ;IAKQ,WAAA;IACA,eAAA;EF2YlB;AACF;AEvYQ;EDnHJ,aAAA;EAEA,eAAA;EAYA,mBAAA;ECwGQ,eAAA;AF+YZ;AEzYoB;EACI,qBAAA;AF2YxB;AEzYwB;EAHJ;IAIQ,OAAA;IACA,sBAAA;EF4Y1B;AACF;AEvYY;EACI,eAAA;EACA,qBAAA;AFyYhB;AEvYgB;EACI,sBAAA;AFyYpB;AEtYgB;EACI,UAAA;AFwYpB;AEtYoB;EAHJ;IAIQ,OAAA;IACA,kBAAA;EFyYtB;AACF;AEtYgB;EACI,UAAA;AFwYpB;AEtYoB;EAHJ;IAIQ,YAAA;EFyYtB;AACF;AEtYgB;EACI,UAAA;EACA,iBAAA;EACA,iBAAA;AFwYpB;AEtYoB;EALJ;IAMQ,WAAA;EFyYtB;AACF;AEtYgB;ED1KZ,aAAA;EAEA,eAAA;EAMA,uBAAA;ADkjBJ;AE5YoB;ED9KhB,aAAA;EAEA,eAAA;EC8KoB,SAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AFkZxB;AE7YoC;EACI,uBAAA;AF+YxC;AE3YwC;EADJ;IAEQ,WAAA;EF8Y1C;AACF;AEvYoC;EACI,sBAAA;AFyYxC;AErYwC;EADJ;IAEQ,YAAA;EFwY1C;AACF;AEnY4B;EACI,iBAAA;AFqYhC;AEjYgC;EACI,kBAAA;AFmYpC;AE9XgC;EACI,uBH5NpB;EG6NoB,kCAAA;AFgYpC;AE9XoC;EACI,uBHhOxB;EGiOwB,yBAAA;AFgYxC;AE9XwC;EACI,yBAAA;EACA,WAAA;AFgY5C;AEzXgC;EACI,YAAA;EACA,kCAAA;EACA,uBH/OpB;AC0mBhB;AEzXoC;EACI,uBHlPxB;EGmPwB,yBAAA;AF2XxC;AEzXwC;EACI,yBAAA;EACA,WAAA;AF2X5C;AErX4B;EACI,kBAAA;EACA,wBH7PhB;EG8PgB,eAAA;EACA,iBAAA;EDzN5B,mCAAA;EACA,8BAAA;EC0N4B,qBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EDpP5B,yBAAA;ECwP4B,gBAAA;AF0XhC;AExXgC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AF0XpC;AExXoC;EACI,sBHlRxB;AC4oBhB;AEtXgC;EAzBJ;IA0BQ,gBAAA;IACA,eAAA;EFyXlC;AACF;AEvXgC;EACI,aAAA;EACA,gBAAA;AFyXpC;AErXoC;EADJ;IAEQ,aAAA;EFwXtC;AACF;AErXgC;EACI,aAAA;AFuXpC;AErXoC;EAHJ;IAIQ,qBAAA;EFwXtC;AACF;AErXgC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCHrTpB;EGsToB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AFuXpC;AErXoC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EFwXtC;AACF;AErXgC;EACI,uBHvUpB;EGwUoB,UAAA;AFuXpC;AEpXgC;EACI,uBH5UpB;EG6UoB,yBAAA;EACA,UAAA;AFsXpC;AE/WgB;EACI,kBAAA;AFiXpB;AE7W4B;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,uCAAA;EACA,kBAAA;AF+WhC;AEzWgC;EACI,uBAAA;AF2WpC;AEnWgC;EACI,cAAA;AFqWpC;AE7VgB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;AF+VpB;AE3VY;EACI,kCAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;ED/VZ,mCAAA;EACA,8BAAA;ECgWY,uBHzYA;EG0YA,eAAA;EACA,gBAAA;EDzXZ,yBAAA;EC2XY,eAAA;AFgWhB;AE9VgB;EACI,kCHhZJ;EGiZI,WAAA;AFgWpB;AE7VgB;EACI,aAAA;AF+VpB;AE3VY;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AF6VhB;AE3VgB;EACI,uBHjaJ;AC8vBhB;AE1VgB;EACI,mBAAA;AF4VpB;AEzVgB;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBH5aJ;EG6aI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AF2VpB;AEtVQ;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,uBHhcI;EEwCZ,mCAAA;EACA,8BAAA;EA3CA,aAAA;EAEA,eAAA;EAYA,mBAAA;ADsxBJ;AE7VY;EATJ;IAUQ,eAAA;EFgWd;AACF;AE9VY;EAbJ;IAcQ,eAAA;IACA,sBAAA;EFiWd;AACF;AE/VY;EACI,iBAAA;AFiWhB;AE5VgB;EACI,uBHrdJ;ACmzBhB;AExVgB;EAFJ;IAGQ,WAAA;IACA,gBAAA;EF2VlB;AACF;AEzVgB;EACI,0BAAA;EACA,8BAAA;EACA,6BAAA;AF2VpB;AEzVoB;EALJ;IAMQ,0BAAA;EF4VtB;AACF;AExVY;EACI,eAAA;EACA,gBAAA;AF0VhB;AExVgB;EACI,iBAAA;AF0VpB;AExVoB;EACI,cAAA;EACA,gBAAA;AF0VxB;AEtVgB;EACI,iBAAA;AFwVpB;AEhVI;;EAEI,cAAA;EACA,gBAAA;AFkVR;AE/UI;EA8EI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,yCAAA;AFoQR;AEpVQ;EACI,gBAAA;AFsVZ;AEpVY;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AFsVhB;AEnVY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AFqVhB;AEnVgB;EACI,mBAAA;EACA,kBAAA;AFqVpB;AEjVY;EACI,gBAAA;AFmVhB;AE/UQ;EACI,gBAAA;AFiVZ;AE9UQ;EACI,SAAA;EACA,kCAAA;EACA,kBAAA;AFgVZ;AE9UY;EACI,6BAAA;EACA,4BAAA;AFgVhB;AE9UgB;EACI,kCHljBJ;ACk4BhB;AE7UwB;EACI,WAAA;AF+U5B;AEzUgC;EACI,kBAAA;EACA,sBAAA;EACA,eAAA;AF2UpC;AEzUoC;EACI,uBHlkBxB;EGmkBwB,sBAAA;AF2UxC;AExUoC;EACI,UAAA;AF0UxC;AEnUoB;EACI,WAAA;AFqUxB;AE1TQ;EACI,kBAAA;EACA,gBAAA;AF4TZ;AE1TY;EAJJ;IAKQ,kBAAA;EF6Td;AACF;AE1TQ;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AF4TZ;AE1TY;EACI,cAAA;AF4ThB;AE1TgB;EACI,sBAAA;AF4TpB;AEtTgB;EACI,eAAA;EACA,gBAAA;AFwTpB;AEtToB;EAJJ;IAKQ,eAAA;EFyTtB;AACF;AEvToB;EACI,gBAAA;AFyTxB;AErTgB;EDnoBZ,aAAA;EAEA,eAAA;ECmoBgB,eAAA;AF2TpB;AEzToB;EACI,UAAA;EACA,eAAA;AF2TxB;AEzTwB;EAJJ;IAKQ,WAAA;EF4T1B;AACF;AEvToB;EACI,kBAAA;EACA,kBAAA;AFyTxB;AEvTwB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AFyT5B;AEnTY;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;AFqThB;AEnTgB;EACI,eAAA;AFqTpB;AElTgB;EACI,gBAAA;AFoTpB;AEjTgB;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AFmTpB;AEjToB;EACI,QAAA;AFmTxB;AE9SgB;EACI,cAAA;EACA,eAAA;AFgTpB;AE9SoB;EACI,iBAAA;AFgTxB;AEzSY;EACI,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AF2ShB;AEzSgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AF2SpB;AExSgB;EACI,sBAAA;AF0SpB;AEtSY;EACI,UAAA;EACA,SAAA;EACA,aAAA;AFwShB;AEtSgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AFwSpB;AEtSoB;EACI,kBAAA;EACA,uBH9uBR;EG+uBQ,UAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AFwSxB;AEnSoB;EACI,8BH3vBR;ACgiChB;AElSoB;EACI,UAAA;AFoSxB;AE7RY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AF+RhB;AE7RgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;AF+RpB;AE5RgB;EACI,sBAAA;AF8RpB;AE1RY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AF4RhB;AE1RgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AF4RpB;AE1RoB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AF4RxB;AEvRoB;EACI,qBAAA;EACA,yBAAA;AFyRxB;AEtRoB;EACI,UAAA;AFwRxB;AElRQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;AFoRZ;AElRY;ED90BR,aAAA;EAEA,eAAA;EAYA,mBAAA;AD4lCJ;AExRgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EDl0BhB,yBAAA;AD+lCJ;AE1RoB;EACI,iBAAA;AF4RxB;AEzRoB;EACI,iBAAA;EACA,gBAAA;AF2RxB;AEvRgB;EACI,iBAAA;AFyRpB;AEtRgB;EACI,kCHt2BJ;EGu2BI,8BHv2BJ;EGw2BI,WAAA;AFwRpB;AEtRoB;EACI,kCH32BR;EG42BQ,8BH52BR;ACooChB;AEpRgB;EACI,UAAA;EACA,iBAAA;AFsRpB;AEnRgB;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;AFqRpB;AEnRoB;EACI,yBAAA;EACA,qBAAA;AFqRxB;AEhRoB;EACI,SAAA;AFkRxB;AE9QgB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ED33BhB,yBAAA;AD8oCJ;AEhRoB;EACI,kBAAA;EACA,UAAA;EDh4BpB,yBAAA;ADqpCJ;AEjRoB;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AFmRxB;AEjRwB;EACI,kBAAA;EACA,OAAA;AFmR5B;AEhRwB;EACI,iBAAA;AFkR5B;AE9QoB;EAEI,eAAA;EDt5BpB,yBAAA;ADwqCJ;AE3QQ;EACI,gBAAA;EACA,kBAAA;EACA,6BAAA;AF6QZ;AE1QY;EANJ;IAOQ,kBAAA;EF6Qd;AACF;AE3QY;EACI,cAAA;ED57BZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADmsCJ;AEjRgB;EACI,cAAA;AFmRpB;AEjRoB;EAHJ;IAIQ,WAAA;IACA,kBAAA;EFoRtB;EElRsB;IACI,gBAAA;EFoR1B;AACF;AEhRwB;EACI,iBAAA;AFkR5B;AE7QgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AF+QpB;AE7QoB;EARJ;IASQ,eAAA;EFgRtB;AACF;AE5QwB;EACI,YAAA;AF8Q5B;AE1QoB;;EAEI,iBAAA;EACA,gBAAA;AF4QxB;AEzQoB;EACI,mCHz+BR;EG0+BQ,WAAA;AF2QxB;AExQoB;EACI,kCHh/BR;EGi/BQ,WAAA;EACA,8BHl/BR;EGm/BQ,gBAAA;EACA,wBAAA;AF0QxB;AEtQoB;EACI,yBAAA;AFwQxB;AErQoB;EACI,UAAA;EACA,6BAAA;EACA,cAAA;EACA,cHl/BH;EGm/BG,SAAA;EACA,wEHvhCX;EGwhCW,eAAA;EACA,gBAAA;EACA,yBAAA;AFuQxB;AErQwB;EACI,yBAAA;EACA,WAAA;AFuQ5B;AEnQoB;EACI,yBAAA;EACA,WAAA;EACA,qBAAA;AFqQxB;AElQoB;EACI,cAAA;AFoQxB;AEjQoB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;ED7gCpB,yBAAA;ADmxCJ;AEpQwB;EACI,eAAA;EACA,cHrhCP;AC2xCrB;AEjQwB;EACI,kBAAA;EACA,UAAA;EDxhCxB,yBAAA;AD8xCJ;AElQwB;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AFoQ5B;AElQ4B;EANJ;IAOQ,kBAAA;IACA,iBAAA;EFqQ9B;AACF;AEnQ4B;EACI,kBAAA;EACA,OAAA;AFqQhC;AElQ4B;EACI,iBAAA;EACA,cAAA;AFoQhC;AEhQwB;EA7CJ;IA8CQ,yBAAA;IACA,cAAA;IACA,mBAAA;IACA,kBAAA;EFmQ1B;AACF;AElQ4B;EAnDR;IAoDY,kBAAA;IACA,iBAAA;EFqQ9B;AACF;AE9QwB;EAWI;IACI,kBAAA;IACA,OAAA;EFsQ9B;EEnQ0B;IACI,4BAAA;EFqQ9B;AACF;AElQwB;EAEI,eAAA;EDzkCxB,yBAAA;AD+0CJ;AE3PQ;EACI,mBAAA;AF6PZ;AE3PY;EACI,uBH1mCA;ACu2ChB;AEzPQ;EACI,uBH/mCI;EGgnCJ,eAAA;AF2PZ;AExPQ;EACI,kBAAA;AF0PZ;AExPY;;EAEI,WAAA;EACA,eAAA;EACA,kBAAA;AF0PhB;AExPgB;;;;EAEI,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AF4PpB;AEvPoB;;EACI,aAAA;AF0PxB;AEpPoB;;EACI,kBAAA;AFuPxB;AErPwB;;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;EACA,uBHvpCZ;AC+4ChB;AEtP4B;;;EAEI,cAAA;AFyPhC;AEtP4B;;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AFyPhC;AErPwB;;EACI,kBAAA;AFwP5B;AEjPY;EACI,eAAA;EDxrCZ,aAAA;EAEA,eAAA;AD86CJ;AErPgB;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AFuPpB;AErPoB;EACI,aAAA;AFuPxB;AEpPoB;EACI,aAAA;AFsPxB;AEnPoB;EACI,UAAA;AFqPxB;AElPoB;EACI,kBAAA;AFoPxB;AEhPgB;EAGI,gBAAA;EACA,iFAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,wBAAA;AFkPpB;AEhPoB;EAGI,aAAA;AFgPxB;AE5OgB;;EDluCZ,aAAA;EAEA,eAAA;ADo9CJ;AEhPoB;;EACI,WAAA;EACA,mBAAA;EDxuCpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EC6tCoB,gBAAA;AFyPxB;AEtPoB;;EACI,WAAA;EACA,kBAAA;EDhvCpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EANA,uBAAA;EC4uCoB,eAAA;EACA,0BAAA;AFiQxB;AE/PwB;;EACI,wBAAA;AFkQ5B;AE/PwB;;EACI,gBAAA;EACA,gBAAA;AFkQ5B;AE9PoB;;EACI,YAAA;EACA,mBAAA;AFiQxB;AE/PwB;EAJJ;;IAKQ,WAAA;IACA,gBAAA;IACA,mBAAA;EFmQ1B;AACF;AEhQoB;;EACI,yBAAA;EACA,mBAAA;AFmQxB;AEjQwB;;EACI,mBAAA;EACA,wBAAA;AFoQ5B;AElQ4B;;;;EAGI,aAAA;AFqQhC;AEjQwB;EAfJ;;IAgBQ,WAAA;EFqQ1B;AACF;AEjQ4B;EADJ;;IAEQ,SAAA;IACA,uBAAA;IACA,WAAA;EFqQ9B;AACF;AElQwB;;EACI,kBAAA;AFqQ5B;AEnQ4B;;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;EACA,uBH/yChB;ACqjDhB;AEpQgC;;;EAEI,cAAA;AFuQpC;AEpQgC;;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AFuQpC;AEnQ4B;;EACI,kBAAA;AFsQhC;AEhQoB;;EACI,WAAA;AFmQxB;AE5PgB;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,cH90CC;EEIjB,yBAAA;EC40CgB,gBAAA;AFgQpB;AE9PoB;EACI,kCHj2CR;EGk2CQ,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AFgQxB;AE1PQ;EAQI,oBAAA;EDv2CR,mBAAA;ECy2CQ,WAAA;EACA,gBAAA;EACA,SAAA;AFyPZ;AEpQY;EACI,kBAAA;EACA,SAAA;AFsQhB;AE1PY;EACI,kBAAA;EACA,gCAAA;AF4PhB;AE1PgB;EAEI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AF2PpB;AExPgB;EACI,WAAA;EACA,UAAA;AF0PpB;AEtPY;EACI,YAAA;EACA,kBAAA;AFwPhB;AErPY;;EAEI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AFuPhB;AEpPY;EACI,WAAA;EACA,SAAA;AFsPhB;AEnPY;EACI,SAAA;AFqPhB;AElPY;EACI,UAAA;EACA,iBAAA;AFoPhB;AEhPQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,QAAA;EAGA,2BAAA;ED56CR,yBAAA;ADiqDJ;AElPY;EACI,kCHl8CA;EGm8CA,8BHn8CA;EGo8CA,WAAA;AFoPhB;AE9OQ;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;ED57CR,yBAAA;AD+qDJ;AEhPY;EACI,YAAA;AFkPhB;AE/OY;EACI,gBAAA;AFiPhB;AE9OY;EACI,kCH19CA;AC0sDhB;AE7OY;EACI,kCH79CD;AC4sDf;AE5OY;EACI,kCH/9CE;AC6sDlB;AEzOI;EDz+CA,aAAA;EAEA,eAAA;ECy+CI,sBAAA;AF+OR;AE5OI;EACI,aAAA;AF8OR;AE3OI;EACI,kCAAA;AF6OR;AE1OI;EDt/CA,aAAA;EAEA,eAAA;EAYA,mBAAA;EC2+CI,mBAAA;AFkPR;AEhPQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AFkPZ;AEhPY;EACI,WAAA;EACA,kBAAA;EDlgDZ,aAAA;EAEA,eAAA;ADuvDJ;AEpPgB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kCAAA;AFsPpB;;AEzOA;EACI,eAAA;AF4OJ;AE1OI;ED1hDA,aAAA;EAEA,eAAA;EAYA,mBAAA;EC+gDI,UAAA;EACA,SAAA;AFkPR;AE/OI;EACI,gBAAA;AFiPR;AE/OQ;EACI,iBAAA;AFiPZ;AE7OY;EACI,UAAA;AF+OhB;AE3OQ;EACI,kCH7iDI;EG8iDJ,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AF6OZ;AE3OY;EACI,SAAA;AF6OhB;AEzOQ;EDhhDJ,mCAAA;EACA,8BAAA;ECihDQ,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;ED5iDR,yBAAA;AD2xDJ;AE5OY;EACI,kBAAA;EACA,gBAAA;EACA,OAAA;EDljDZ,yBAAA;ADmyDJ;;AEpOA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;AFuOJ;;AEpOA;EACI,eAAA;AFuOJ;AErOI;EACI,iBAAA;EAEA,sBAAA;EACA,qBAAA;EACA,cAAA;AFsOR;AEnOI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AFqOR;;AE1NQ;EACI,aAAA;EACA,qCAAA;EACA,cAAA;AF6NZ;AE3NY;EALJ;IAMQ,0BAAA;EF8Nd;AACF;AE5NY;EACI,aAAA;EACA,eAAA;AF8NhB;AE5NgB;EACI,OAAA;AF8NpB;AE5NoB;EAHJ;IAIQ,UAAA;IACA,WAAA;EF+NtB;AACF;AE1NY;EACI,0BAAA;AF4NhB;AExNgB;EACI,0BAAA;AF0NpB;AErNoB;EACI,aAAA;AFuNxB;AEjNoB;EACI,aAAA;AFmNxB;AE7MoB;EACI,aAAA;AF+MxB;AEzMoB;EACI,aAAA;AF2MxB;AErMoB;EACI,aAAA;AFuMxB;AEjMQ;EACI,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AFmMZ;AEjMY;EACI,kCAAA;EACA,uBHnsDA;EGosDA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AFmMhB;AE/LY;EAlBJ;IAmBQ,eAAA;EFkMd;AACF;AEhMY;EACI,uBHjtDA;EGktDA,kBAAA;AFkMhB;AEhMgB;;EAEI,cAAA;AFkMpB;AE9LY;EACI,eAAA;EACA,gBAAA;AFgMhB;AE9LgB;EAJJ;IAKQ,eAAA;EFiMlB;AACF;AE/LgB;EACI,gBAAA;AFiMpB;;AEzLA;EACI,kBAAA;AF4LJ;AE1LI;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AF4LR;AE1LQ;EACI,6BAAA;AF4LZ;AEzLQ;EACI,uBH7vDI;EG8vDJ,eAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AF2LZ;;AEtLA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AFyLJ;;AEtLA;EACI,kBAAA;AFyLJ;AEvLI;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AFyLR;AEvLQ;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,SAAA;AFyLZ;;AElLI;EACI,sBAAA;EACA,kBAAA;AFqLR;AElLI;EACI,sBAAA;AFoLR;;AEhLA;EACI,gCAAA;AFmLJ;;AEhLA;EACI,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AFmLJ;;AEhLA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AFmLJ;;AE/KA;EACI,mCAAA;EACA,UAAA;AFkLJ;;AE/KA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AFkLJ;;AE/KA;EACI,mCAAA;EACA,mBAAA;EACA,UAAA;AFkLJ;;AE/KA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AFkLJ;;AE/KA;EACI;IACI,UAAA;EFkLN;EE/KE;IACI,UAAA;EFiLN;EE9KE;IACI,UAAA;EFgLN;AACF;AE5KA;EACI,aAAA;AF8KJ;;ADp8DA;EACE,eAAA;ACu8DF;;ADp8DA;EACE,aAAA;EACA,eAAA;ACu8DF;;ADp8DA;EACE,sBAAA;ACu8DF;;ADp8DA;EACE,8BAAA;ACu8DF;;ADp8DA;EACE,gBAAA;ACu8DF;;ADp8DA;EACE,gBAAA;ACu8DF;;ADp8DA;EACE,aAAA;ACu8DF;;ADp8DA;EACE,gBAAA;ACu8DF;;ADz7DE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC47DJ;AD17DI;;;;;;EACE,gBAAA;ACi8DN;AD77DE;;EAEE,eA5GO;EA6GP,gBA3GO;AC0iEX;AD77DI;EALF;;IAMI,eA/GY;ECgjEhB;AACF;AD97DE;;EAEE,eAlHO;EAmHP,gBAjHO;ACijEX;AD97DI;EALF;;IAMI,eArHY;ECujEhB;AACF;AD/7DE;;EAEE,eAxHO;EAyHP,gBAvHO;ACwjEX;AD/7DI;EALF;;IAMI,eA3HY;EC8jEhB;AACF;ADh8DE;;EAEE,eA9HO;EA+HP,gBA7HO;AC+jEX;AD/7DE;;EAEE,eAhIO;EAiIP,gBAhIO;ACikEX;AD97DE;;EAEE,eAnIO;EAoIP,gBAnIO;ACmkEX;AD17DE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC47DJ;AD17DI;EACE,gBAAA;AC47DN;ADz7DI;EAXF;IAYI,eAAA;EC47DJ;AACF;ADz7DE;;EAEE,UAAA;EACA,SAAA;AC27DJ;ADx7DE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC07DJ;;ADt7DA;EACE,sBAxNQ;ACipEV;;ADt7DA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ACy7DF;ADv7DE;EALF;IAMI,cAAA;EC07DF;AACF;ADx7DE;EACE,iBA1Ka;AComEjB;ADv7DE;EACE,gBApLa;EAqLb,WAAA;ACy7DJ;;ADp7DE;EACE,kBAAA;ACu7DJ;ADp7DE;EACE,iBAAA;ACs7DJ;;ADj7DE;EACE,aAAA;ACo7DJ;;ADh7DA;EACE,kBAAA;ACm7DF;ADj7DE;EACE,mBAAA;ACm7DJ;AD/6DI;EACE,sBAAA;ACi7DN;AD76DE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;AC6oEnB;AD76DI;EACE,sBAAA;AC+6DN;AD56DI;EAVF;IAWI,eApOoB;ECmpExB;AACF;AD56DE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AC86DJ;AD56DI;EACE,sBAAA;AC86DN;AD36DI;EACE,WAAA;AC66DN;AD16DI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACwwEZ;;ADv6DA;EACE,mBA1PO;ACoqET;ADx6DE;EAHF;IAII,mBAAA;EC26DF;AACF;ADz6DE;EACE,mBAAA;AC26DJ;ADx6DE;EACE,aArQK;AC+qET;ADx6DI;EAHF;IAII,aAAA;EC26DJ;AACF;ADz6DI;EACE,aAAA;AC26DN;;ADt6DA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ACy6DF;ADv6DE;EACE,eAAA;ACy6DJ;ADt6DE;EACE,sCAAA;ACw6DJ;ADr6DE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ACu6DJ;;ADx5DE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC25DJ;ADz5DI;EACE,kBAAA;AC25DN;ADx5DI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC05DN;;ADr5DA;EACE,8BAAA;ACw5DF;;ADr5DA;EACE,8BAAA;ACw5DF;;ADr5DA;EACE,+BAAA;ACw5DF;;ADr5DA;EACE,8BAAA;ACw5DF;;ADr5DA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ACw5DF;ADt5DE;EACE,2BAAA;EACA,mBAAA;ACw5DJ;ADr5DE;EACE,yBAzbiB;EA0bjB,WA1aO;ACi0EX;ADp5DE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ACs5DJ;ADn5DE;EACE,yBAjckB;EAkclB,cArciB;AC01ErB;ADl5DE;EACE,yBAvbS;EAwbT,WA1bO;AC80EX;ADl5DI;EACE,6BAAA;ACo5DN;;AD/4DA;EACE;IACE,uBAAA;ECk5DF;ED/4DA;IACE,yBAAA;ECi5DF;AACF;AD94DA;EACE,8BAAA;ACg5DF;;AD74DA;EACE,8BAAA;ACg5DF;;AD74DA;EACE,+BAAA;ACg5DF;;AD74DA;EACE,8BAAA;ACg5DF;;AD74DA;EACE,qBAAA;ACg5DF;;AD74DA;EACE,UAAA;ACg5DF;AD94DE;EACE,qBAAA;ACg5DJ;;AD54DA;EACE,UAAA;AC+4DF;;AD34DE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;AC64DJ;AD14DM;EACE,mBAAA;AC44DR;ADv4DE;EACE,2BAAA;ACy4DJ;ADt4DE;EACE,uBAAA;ACw4DJ;ADr4DE;EACE,mBAAA;ACu4DJ;;ADl4DE;EACE,mBAAA;ACq4DJ;ADl4DE;EACE,yBAAA;ACo4DJ;ADj4DE;EACE,sBAAA;ACm4DJ;ADh4DE;EACE,uBAAA;ACk4DJ;AD/3DE;EACE,oBAAA;ACi4DJ;;AC74EA;EACI,oCAAA;ADg5EJ;;AGv9EA;EACI,oBAAA;AH09EJ;;AGv9EA;EACI,mBAAA;AH09EJ;;AGt9EI;EACI,iBAAA;EACA,mBAAA;AHy9ER;AGv9EQ;EAJJ;IAKQ,iBAAA;EH09EV;AACF;AGx9EQ;EACI,gBAAA;AH09EZ;AGr9EgB;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;AHu9EpB;AGr9EoB;EALJ;IAMQ,aAAA;EHw9EtB;EGt9EsB;IACI,cAAA;EHw9E1B;AACF;AGr9EoB;EACI,eAAA;AHu9ExB;AG/8EI;EACI,yBAAA;AHi9ER;AG98EI;EF/BA,aAAA;EAEA,eAAA;EAMA,uBAAA;EE0BI,iBAAA;EACA,mBAAA;AHs9ER;AGp9EQ;EANJ;IAOQ,mBAAA;EHu9EV;AACF;AGr9EQ;EACI,mBAAA;AHu9EZ;AGn9EoB;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AHq9ExB;AGn9EwB;EANJ;IAOQ,kBAAA;IACA,eAAA;EHs9E1B;AACF;AGp9EwB;EAXJ;IAYQ,iBAAA;IACA,eAAA;EHu9E1B;AACF;AGn9EwB;EACI,iCAAA;EACA,qCAAA;EACA,wCAAA;AHq9E5B;AG98EQ;EACI,gBAAA;AHg9EZ;AG98EY;EAHJ;IAIQ,qBAAA;EHi9Ed;AACF;AG/8EY;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AHi9EhB;AG/8EgB;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AHi9EpB;AG98EoB;EACI,yBAAA;AHg9ExB;AG78EoB;EACI,iBAAA;AH+8ExB;AG78EwB;EAHJ;IAIQ,eAAA;EHg9E1B;AACF;AG78EoB;EA1BJ;IA2BQ,WAAA;IACA,YAAA;IACA,aAAA;EHg9EtB;AACF;AG98EoB;EACI,aAAA;AHg9ExB;AG78E4B;EACI,aAAA;AH+8EhC;AG58E4B;EACI,aAAA;AH88EhC;AGx8EgC;EACI,aAAA;AH08EpC;AGv8EgC;EACI,aAAA;AHy8EpC;AG97E4B;EACI,aAAA;AHg8EhC;AG77E4B;EACI,aAAA;AH+7EhC;AGv7EQ;EACI,8BAAA;EACA,mBAAA;EACA,mBAAA;AHy7EZ;AGv7EY;EALJ;IAMQ,sBAAA;EH07Ed;AACF;AGx7EY;EACI,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;AH07EhB;AGt7EgB;EACI,mCJlLJ;AC0mFhB;AGr7EgB;EACI,sBAAA;EACA,WAAA;AHu7EpB;AGr7EoB;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;AHu7ExB;AGj7EgB;EADJ;IAEQ,qBAAA;EHo7ElB;AACF;AG/6EI;EACI,WAAA;EACA,mCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AHi7ER;AG/6EQ;EAPJ;IAQQ,kBAAA;EHk7EV;AACF;AGh7EQ;EACI,mCJrNI;ACuoFhB;AGh7EY;EACI,WAAA;AHk7EhB;AG96EQ;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EFzLR,mCAAA;EACA,8BAAA;EE0LQ,aAAA;EACA,eAAA;EACA,mBAAA;AHi7EZ;AG/6EY;EATJ;IAUQ,eAAA;EHk7Ed;AACF;AGh7EY;EAbJ;IAcQ,eAAA;EHm7Ed;AACF;AGj7EY;EACI,kBAAA;AHm7EhB;AG/6EY;EACI,WAAA;EACA,cAAA;AHi7EhB;AG/6EgB;EAJJ;IAKQ,WAAA;IACA,eAAA;EHk7ElB;AACF;AG96EQ;EFjQJ,aAAA;EAEA,eAAA;EAYA,mBAAA;EEsPQ,eAAA;AHs7EZ;AGh7EoB;EACI,qBAAA;AHk7ExB;AGh7EwB;EAHJ;IAIQ,OAAA;IACA,sBAAA;EHm7E1B;AACF;AG96EY;EACI,eAAA;EACA,qBAAA;AHg7EhB;AG96EgB;EACI,sBAAA;AHg7EpB;AG76EgB;EACI,UAAA;AH+6EpB;AG76EoB;EAHJ;IAIQ,OAAA;IACA,kBAAA;EHg7EtB;AACF;AG76EgB;EACI,UAAA;AH+6EpB;AG76EoB;EAHJ;IAIQ,YAAA;EHg7EtB;AACF;AG76EgB;EACI,UAAA;AH+6EpB;AG76EoB;EAHJ;IAIQ,WAAA;EHg7EtB;AACF;AG76EgB;EACI,UAAA;AH+6EpB;AG76EoB;EAHJ;IAIQ,WAAA;EHg7EtB;AACF;AG76EgB;EACI,iBAAA;EACA,iBAAA;AH+6EpB;AG56EgB;EFnUZ,aAAA;EAEA,eAAA;EAYA,mBAAA;AD2uFJ;AGl7EoB;EACI,kBAAA;AHo7ExB;AGh7EgB;EACI,UAAA;AHk7EpB;AGh7EoB;EACI,UAAA;AHk7ExB;AG96EgB;EFpVZ,aAAA;EAEA,eAAA;EAMA,uBAAA;ADowFJ;AGp7EoB;EFxVhB,aAAA;EAEA,eAAA;EEwVoB,SAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AH07ExB;AGr7EoC;EACI,uBAAA;AHu7ExC;AGn7EwC;EADJ;IAEQ,WAAA;EHs7E1C;AACF;AG/6EoC;EACI,sBAAA;AHi7ExC;AG76EwC;EADJ;IAEQ,YAAA;EHg7E1C;AACF;AG36E4B;EACI,iBAAA;AH66EhC;AGz6EgC;EACI,kBAAA;AH26EpC;AGt6EgC;EACI,wBJpYpB;EIqYoB,mCAAA;AHw6EpC;AGt6EoC;EACI,wBJxYxB;EIyYwB,yBAAA;AHw6ExC;AGt6EwC;EACI,yBAAA;EACA,WAAA;AHw6E5C;AGj6EgC;EACI,YAAA;EACA,mCAAA;EACA,wBJvZpB;AC0zFhB;AGj6EoC;EACI,wBJ1ZxB;EI2ZwB,yBAAA;AHm6ExC;AGj6EwC;EACI,yBAAA;EACA,WAAA;AHm6E5C;AG75E4B;EACI,kBAAA;EACA,wBJvahB;EIwagB,eAAA;EACA,iBAAA;EFnY5B,mCAAA;EACA,8BAAA;EEoY4B,qBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EF9Z5B,yBAAA;EEka4B,gBAAA;AHk6EhC;AGh6EgC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AHk6EpC;AGh6EoC;EACI,uBJ1bxB;AC41FhB;AG95EgC;EAzBJ;IA0BQ,gBAAA;IACA,eAAA;EHi6ElC;AACF;AG/5EgC;EACI,aAAA;EACA,gBAAA;AHi6EpC;AG75EoC;EADJ;IAEQ,aAAA;EHg6EtC;AACF;AG75EgC;EACI,aAAA;AH+5EpC;AG75EoC;EAHJ;IAIQ,qBAAA;EHg6EtC;AACF;AG75EgC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCJ7dpB;EI8doB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AH+5EpC;AG75EoC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EHg6EtC;AACF;AG75EgC;EACI,wBJ/epB;EIgfoB,UAAA;AH+5EpC;AG55EgC;EACI,wBJpfpB;EIqfoB,yBAAA;EACA,UAAA;AH85EpC;AGr5EY;EACI,mCAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EF7dZ,mCAAA;EACA,8BAAA;EE8dY,wBJrgBA;EIsgBA,eAAA;EACA,gBAAA;EFvfZ,yBAAA;EEyfY,eAAA;AH05EhB;AGx5EgB;EACI,mBAAA;AH05EpB;AGv5EgB;EACI,mCJhhBJ;EIihBI,WAAA;AHy5EpB;AGt5EgB;EACI,aAAA;AHw5EpB;AGp5EY;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AHs5EhB;AGp5EgB;EACI,wBJhiBJ;ACs7FhB;AGn5EgB;EACI,mBAAA;AHq5EpB;AGl5EgB;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,wBJ3iBJ;EI4iBI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AHo5EpB;AG/4EQ;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,wBJ/jBI;EEsCZ,mCAAA;EACA,8BAAA;EA3CA,aAAA;EAEA,eAAA;EAYA,mBAAA;ADg9FJ;AGt5EY;EATJ;IAUQ,eAAA;EHy5Ed;AACF;AGv5EY;EAbJ;IAcQ,eAAA;IACA,sBAAA;EH05Ed;AACF;AGx5EY;EACI,kBAAA;AH05EhB;AGr5EgB;EAFJ;IAGQ,WAAA;IACA,gBAAA;EHw5ElB;AACF;AGt5EgB;EACI,0BAAA;EACA,8BAAA;EACA,6BAAA;AHw5EpB;AGt5EoB;EALJ;IAMQ,0BAAA;EHy5EtB;AACF;AGr5EY;EACI,eAAA;EACA,gBAAA;AHu5EhB;AGr5EgB;EACI,iBAAA;AHu5EpB;AGr5EoB;EACI,cAAA;EACA,gBAAA;AHu5ExB;AGn5EgB;EACI,iBAAA;AHq5EpB;AGj5EY;EACI,iBAAA;EACA,wBJvnBA;AC0gGhB;AGh5EY;EACI,gBAAA;AHk5EhB;AG/4EY;EAGI,aAAA;AHi5EhB;AG/4EgB;EACI,mBAAA;AHi5EpB;AG74EoB;EACI,cAAA;AH+4ExB;AGz4EQ;EACI,kBAAA;EACA,eAAA;EACA,qBAAA;AH24EZ;AGz4EY;EACI,wBJrpBA;ACgiGhB;AGx4EY;EACI,mBAAA;AH04EhB;AGv4EY;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,wBJhqBA;EIiqBA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AHy4EhB;AGn4EI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;EACA,0BAAA;AHq4ER;AGn4EQ;EAVJ;IAWQ,kBAAA;IACA,gBAAA;EHs4EV;AACF;AGp4EQ;EACI,eAAA;EACA,mCAAA;EACA,8BAAA;EACA,wBJpsBI;EIqsBJ,SAAA;EACA,gBAAA;EACA,qBAAA;AHs4EZ;AGp4EY;EATJ;IAUQ,eAAA;EHu4Ed;AACF;AGp4EQ;EACI,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,WAAA;EACA,mCJrtBI;EIstBJ,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AHs4EZ;AGp4EY;EACI,aAAA;AHs4EhB;AGj4EI;;;;;;;EAOI,cAAA;EACA,gBAAA;AHm4ER;AGh4EI;EACI,gBAAA;AHk4ER;AG/3EI;EACI,gBAAA;AHi4ER;AG93EI;EA6CI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,yCAAA;AHo1ER;AGl4EQ;EACI,gBAAA;AHo4EZ;AGl4EY;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AHo4EhB;AGj4EY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AHm4EhB;AGj4EgB;EACI,kBAAA;AHm4EpB;AG/3EY;EACI,gBAAA;AHi4EhB;AG73EQ;EACI,gBAAA;AH+3EZ;AG53EQ;EACI,SAAA;EACA,mCAAA;EACA,kBAAA;AH83EZ;AG53EY;EACI,6BAAA;EACA,4BAAA;AH83EhB;AGp3EQ;EACI,kBAAA;AHs3EZ;AGp3EY;EAHJ;IAIQ,kBAAA;EHu3Ed;AACF;AGp3EQ;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AHs3EZ;AGp3EY;EACI,YAAA;AHs3EhB;AGp3EgB;EACI,qBAAA;AHs3EpB;AGn3EgB;EACI,8BAAA;EACA,gBAAA;AHq3EpB;AGj3EY;EACI,cAAA;AHm3EhB;AG/2EgB;EACI,eAAA;EACA,gBAAA;AHi3EpB;AG/2EoB;EAJJ;IAKQ,eAAA;EHk3EtB;AACF;AGh3EoB;EACI,gBAAA;AHk3ExB;AG92EgB;EFx1BZ,aAAA;EAEA,eAAA;EEy1BgB,eAAA;AHm3EpB;AGj3EoB;EACI,UAAA;EACA,eAAA;EACA,mBAAA;AHm3ExB;AGj3EwB;EALJ;IAMQ,WAAA;EHo3E1B;AACF;AGl3EwB;EACI,kBAAA;EACA,kBAAA;AHo3E5B;AGl3E4B;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AHo3EhC;AG92EgB;EACI,cAAA;EACA,eAAA;AHg3EpB;AG92EoB;EAJJ;IAKQ,eAAA;EHi3EtB;AACF;AG/2EoB;EAEI,wBAAA;EACA,mBAAA;AHi3ExB;AG72EgB;EACI,eAAA;AH+2EpB;AG72EoB;EACI,UAAA;EACA,eAAA;EACA,mBAAA;AH+2ExB;AG72EwB;EALJ;IAMQ,WAAA;EHg3E1B;AACF;AG92EwB;EACI,kBAAA;EACA,kBAAA;AHg3E5B;AG92E4B;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AHg3EhC;AGv2EgB;EACI,kBAAA;AHy2EpB;AGr2EY;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;AHu2EhB;AGr2EgB;EACI,kBAAA;AHu2EpB;AGp2EgB;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AHs2EpB;AGp2EoB;EACI,WAAA;AHs2ExB;AGj2EgB;EACI,eAAA;AHm2EpB;AGh2EgB;EACI,gBAAA;AHk2EpB;AG/1EgB;EACI,cAAA;EACA,eAAA;AHi2EpB;AG/1EoB;EACI,iBAAA;AHi2ExB;AG11EoB;EACI,kBAAA;AH41ExB;AGx1EgB;EACI,gBAAA;AH01EpB;AGx1EoB;EACI,eAAA;AH01ExB;AGt1EgB;EACI,gBAAA;AHw1EpB;AGp1EY;EACI,mBAAA;AHs1EhB;AGp1EgB;EACI,WAAA;AHs1EpB;AGn1EgB;;EAEI,yBAAA;EACA,mBAAA;EACA,UAAA;AHq1EpB;AG90EY;EACI,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AHg1EhB;AG90EgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AHg1EpB;AG70EgB;EACI,sBAAA;AH+0EpB;AG30EY;EACI,UAAA;EACA,SAAA;EACA,aAAA;AH60EhB;AG30EgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AH60EpB;AG30EoB;EACI,kBAAA;EACA,uBJ/hCR;EIgiCQ,UAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AH60ExB;AGx0EoB;EACI,8BJ5iCR;ACs3GhB;AGv0EoB;EACI,UAAA;AHy0ExB;AGn0EQ;EACI,aAAA;AHq0EZ;AGl0EgB;EACI,cAAA;AHo0EpB;AGh0EY;EACI,YAAA;AHk0EhB;AG/zEY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AHi0EhB;AG/zEgB;EAXJ;IAYQ,eAAA;EHk0ElB;AACF;AGh0EgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;AHk0EpB;AG/zEgB;EACI,sBAAA;AHi0EpB;AG7zEY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AH+zEhB;AG7zEgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AH+zEpB;AG7zEoB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AH+zExB;AG1zEoB;EACI,+BJ3nCR;EI4nCQ,mCJ5nCR;ACw7GhB;AGzzEoB;EACI,UAAA;AH2zExB;AGrzEQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;AHuzEZ;AGrzEY;EACI,SAAA;EFhpCZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADi8GJ;AG3zEgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EFpoChB,yBAAA;ADo8GJ;AG7zEoB;EACI,iBAAA;AH+zExB;AG5zEoB;EACI,iBAAA;EACA,gBAAA;AH8zExB;AG1zEgB;EACI,iBAAA;AH4zEpB;AGzzEgB;EACI,mCJtqCJ;EIuqCI,+BJvqCJ;EIwqCI,WAAA;AH2zEpB;AGzzEoB;EACI,mCJ3qCR;EI4qCQ,mCAAA;AH2zExB;AGvzEgB;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;AHyzEpB;AGvzEoB;EACI,yBAAA;EACA,qBAAA;AHyzExB;AGpzEoB;EACI,SAAA;AHszExB;AGlzEgB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EFxrChB,yBAAA;AD++GJ;AGpzEoB;EACI,kBAAA;EACA,UAAA;EF7rCpB,yBAAA;ADs/GJ;AGrzEoB;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AHuzExB;AGrzEwB;EANJ;IAOQ,kBAAA;IACA,iBAAA;EHwzE1B;AACF;AGtzEwB;EACI,kBAAA;EACA,OAAA;AHwzE5B;AGrzEwB;EACI,iBAAA;AHuzE5B;AGnzEoB;EACI,cAAA;EACA,eAAA;EFxtCpB,yBAAA;ADghHJ;AGjzEQ;EACI,gBAAA;AHmzEZ;AGjzEY;EACI,cAAA;EFvvCZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADoiHJ;AGvzEgB;EACI,cAAA;AHyzEpB;AGvzEoB;EAHJ;IAIQ,WAAA;IACA,kBAAA;EH0zEtB;EGxzEsB;IACI,gBAAA;EH0zE1B;AACF;AGtzEwB;EACI,iBAAA;AHwzE5B;AGnzEgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AHqzEpB;AGnzEoB;EAVJ;IAWQ,eAAA;EHszEtB;AACF;AGpzEoB;EACI,iBAAA;EACA,gBAAA;AHszExB;AGnzEoB;EACI,mCJ9xCR;EI+xCQ,WAAA;EACA,gBAAA;AHqzExB;AGlzEoB;EACI,YAAA;AHozExB;AGjzEoB;EACI,UAAA;EACA,6BAAA;EACA,cJ9xCH;EI+xCG,wEJl0CX;EIm0CW,eAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AHmzExB;AGjzEwB;EACI,WAAA;AHmzE5B;AG/yEoB;EACI,+BJvzCR;ACwmHhB;AG9yEoB;EACI,yBAAA;EACA,WAAA;EACA,qBAAA;AHgzExB;AG7yEoB;EACI,cAAA;AH+yExB;AG5yEoB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EF3zCpB,yBAAA;AD4mHJ;AG9yEwB;EACI,eAAA;EACA,cJp0CP;AConHrB;AG7yEwB;EACI,kBAAA;EACA,UAAA;EFr0CxB,yBAAA;EEu0CwB,gBAAA;AHizE5B;AG9yEwB;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AHgzE5B;AG9yE4B;EANJ;IAOQ,kBAAA;IACA,iBAAA;EHizE9B;AACF;AG/yE4B;EACI,kBAAA;EACA,OAAA;AHizEhC;AG9yE4B;EACI,iBAAA;AHgzEhC;AG5yEwB;EA3CJ;IA4CQ,yBAAA;IACA,cAAA;IACA,mBAAA;IACA,kBAAA;EH+yE1B;AACF;AG9yE4B;EAjDR;IAkDY,kBAAA;IACA,iBAAA;EHizE9B;AACF;AG1zEwB;EAWI;IACI,kBAAA;IACA,OAAA;EHkzE9B;EG/yE0B;IACI,4BAAA;EHizE9B;AACF;AG9yEwB;EACI,cAAA;EACA,eAAA;EFt3CxB,yBAAA;ADyqHJ;AG3yEQ;EACI,UAAA;EACA,qBAAA;EACA,kBAAA;AH6yEZ;AG3yEY;EACI,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;AH6yEhB;AGzyEQ;EACI,sBAAA;AH2yEZ;AGzyEY;EACI,kBAAA;AH2yEhB;AGvyEQ;EACI,uBAAA;EACA,kCAAA;EACA,mBAAA;AHyyEZ;AGvyEY;EACI,uBJ56CA;ACqtHhB;AGryEQ;EACI,uBJj7CI;ACwtHhB;AGpyEQ;EACI,eAAA;AHsyEZ;AGpyEY;EACI,gBAAA;AHsyEhB;AGlyEQ;EACI,kBAAA;AHoyEZ;AGlyEY;;EAEI,WAAA;EACA,eAAA;EACA,kBAAA;AHoyEhB;AGlyEgB;;;;EAEI,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AHsyEpB;AGpyEoB;EARJ;;;;IASQ,eAAA;EH0yEtB;AACF;AGryEoB;;EACI,aAAA;AHwyExB;AGnyEY;EACI,eAAA;EF79CZ,aAAA;EAEA,eAAA;ADqwHJ;AGvyEgB;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AHyyEpB;AGvyEoB;EACI,aAAA;AHyyExB;AGtyEoB;EACI,UAAA;AHwyExB;AGryEoB;EACI,kBAAA;AHuyExB;AGnyEgB;EAGI,gBAAA;EACA,iFAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;AHqyEpB;AGlyEgB;EACI,WAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AHoyEpB;AGlyEoB;EAEI,aAAA;AHmyExB;AG/xEgB;;EF1gDZ,aAAA;EAEA,eAAA;AD+yHJ;AGnyEoB;;EACI,WAAA;EF/gDpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EEogDoB,uBAAA;EACA,kBAAA;AH4yExB;AG1yEwB;;EACI,gBAAA;AH6yE5B;AGzyEoB;;EACI,WAAA;EACA,kBAAA;EF5hDpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EANA,uBAAA;EEwhDoB,eAAA;EACA,0BAAA;AHozExB;AGlzEwB;;EACI,wBAAA;EACA,mBAAA;AHqzE5B;AGjzEgC;;;EAEI,aAAA;AHozEpC;AG/yEwB;;EACI,gBAAA;EACA,gBAAA;AHkzE5B;AG9yEoB;;EAEI,YAAA;EACA,mBAAA;AHgzExB;AG9yEwB;;EACI,YAAA;AHizE5B;AG5yE4B;;EACI,0BJ9jDhB;AC62HhB;AG1yEwB;EAjBJ;;IAkBQ,WAAA;IACA,gBAAA;IACA,mBAAA;EH8yE1B;AACF;AG3yEoB;;EAEI,yBAAA;EACA,mBAAA;AH6yExB;AG3yEwB;;EACI,yBAAA;AH8yE5B;AG3yEwB;;EACI,kBAAA;AH8yE5B;AG5yE4B;;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;EACA,wBJ5lDhB;AC24HhB;AG7yEgC;;;EAEI,cAAA;AHgzEpC;AG7yEgC;;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AHgzEpC;AG5yE4B;;EACI,kBAAA;AH+yEhC;AG7yEgC;;;EAEI,aAAA;AHgzEpC;AG1yEwB;;EACI,mBAAA;AH6yE5B;AG3yE4B;;;EAEI,aAAA;AH8yEhC;AG1yEwB;EA5DJ;;IA6DQ,WAAA;EH8yE1B;AACF;AG1yE4B;EADJ;;IAEQ,SAAA;IACA,uBAAA;IACA,WAAA;EH8yE9B;AACF;AG1yEoB;;EACI,WAAA;AH6yExB;AGtyEgB;EACI,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cJxpDC;EEIjB,yBAAA;AD+7HJ;AGxyEoB;EACI,mCJxqDR;EIyqDQ,mCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AH0yExB;AGpyEQ;EACI,UAAA;EACA,qBAAA;EACA,kBAAA;AHsyEZ;AGpyEY;EACI,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;AHsyEhB;AGlyEQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,QAAA;EAGA,2BAAA;EFjsDR,yBAAA;ADw+HJ;AGpyEY;EACI,mCJrtDA;EIstDA,+BJttDA;EIutDA,WAAA;AHsyEhB;AGlyEQ;EAGI,aAAA;EAEA,eAAA;EACA,sBAAA;AHoyEZ;AGlyEY;EACI,UAAA;AHoyEhB;AGlyEgB;EACI,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;AHoyEpB;AGhyEoB;EAEI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AHiyExB;AG9xEoB;EACI,WAAA;EACA,UAAA;AHgyExB;AGvxEgB;EACI,WAAA;AHyxEpB;AGrxEY;EACI,gCAAA;EACA,mBAAA;AHuxEhB;AGpxEY;EACI,kBAAA;EACA,kBAAA;AHsxEhB;AGpxEgB;EACI,0BAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AHsxEpB;AGjxEQ;EFjyDJ,aAAA;EAEA,eAAA;EEiyDQ,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AHuxEZ;AGrxEY;EACI,UAAA;AHuxEhB;AGnxEgB;EACI,WAAA;AHqxEpB;AGjxEoB;EACI,aAAA;EACA,qCAAA;EACA,cAAA;AHmxExB;AGjxEwB;EALJ;IAMQ,0BAAA;EHoxE1B;AACF;AGhxE4B;EACI,YAAA;AHkxEhC;AG9wEwB;EACI,0BAAA;AHgxE5B;AG3wE4B;EACI,aAAA;AH6wEhC;AGvwE4B;EACI,aAAA;AHywEhC;AGnwE4B;EACI,aAAA;AHqwEhC;AG/vE4B;EACI,aAAA;AHiwEhC;AG3vE4B;EACI,aAAA;AH6vEhC;AGtvEgB;EACI,WAAA;AHwvEpB;AGpvEwB;EACI,gBAAA;AHsvE5B;AGnvEwB;EACI,WAAA;AHqvE5B;AG9uEoB;EF93DhB,aAAA;EAEA,eAAA;EE83DoB,8BAAA;EACA,eAAA;AHovExB;AGlvEwB;EACI,OAAA;EACA,cAAA;AHovE5B;AGlvE4B;EAJJ;IAKQ,UAAA;IACA,WAAA;EHqvE9B;EGnvE8B;IACI,gBAAA;EHqvElC;AACF;AGlvE4B;EACI,eAAA;EACA,cAAA;AHovEhC;AG9uEgB;EACI,yBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,gBAAA;AH+uEpB;AG7uEoB;EACI,kBAAA;AH+uExB;AG7uEwB;;EAEI,kBAAA;EACA,wBJj6DZ;EIk6DY,eAAA;EACA,mBAAA;AH+uE5B;AG5uEgC;;EACI,eAAA;EACA,gBAAA;EACA,wBJz6DpB;ACwpIhB;AGzuE4B;EACI,cAAA;AH2uEhC;AGxuEoC;EACI,cAAA;AH0uExC;AGpuEwB;EACI,gBAAA;AHsuE5B;AGnuEwB;EACI,kBAAA;AHquE5B;AG/tEoC;EACI,uBAAA;EACA,eAAA;AHiuExC;AG5tE4B;EACI,kBAAA;EACA,aAAA;EACA,WAAA;AH8tEhC;AG5tEgC;EACI,yBAAA;EACA,eAAA;AH8tEpC;AGztEgC;EACI,eAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AH2tEpC;AGztEoC;EACI,WAAA;EACA,yBAAA;AH2tExC;AGjtEoB;EAEI,aAAA;AHktExB;AG5sEQ;EACI,aAAA;AH8sEZ;AG5sEY;EACI,sBAAA;AH8sEhB;AG3sEY;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AH6sEhB;AG1sEY;EACI,aAAA;EACA,kBAAA;AH4sEhB;AG1sEgB;EAJJ;IAKQ,kBAAA;EH6sElB;AACF;AGtsEY;EACI,sBAAA;AHwsEhB;AG5rEY;EACI,UAAA;AH8rEhB;AG3rEY;EACI,kBAAA;AH6rEhB;AG3rEgB;EAHJ;IAIQ,kBAAA;EH8rElB;AACF;AG1rEY;EACI,gCAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AH4rEhB;AGrrEgB;EACI,aAAA;AHurEpB;AGrrEoB;EAHJ;IAIQ,cAAA;EHwrEtB;AACF;AGrrEgB;EACI,kBAAA;AHurEpB;AGrrEoB;EAHJ;IAIQ,aAAA;EHwrEtB;AACF;AGtrEoB;EACI,gBAAA;AHwrExB;AGrrEoB;EACI,gBAAA;AHurExB;AGnrEgB;EACI,gBAAA;EACA,kBAAA;AHqrEpB;AGlrEgB;EAxCJ;IAyCQ,mBAAA;IACA,kBAAA;EHqrElB;AACF;AGjrEY;EACI,mBAAA;AHmrEhB;AGjrEgB;EACI,UAAA;AHmrEpB;AGhrEgB;EACI,eAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;AHkrEpB;AGhrEoB;EAPJ;IAQQ,eAAA;EHmrEtB;AACF;AGjrEoB;EAXJ;IAYQ,eAAA;IACA,kBAAA;IACA,sBAAA;IACA,mBAAA;EHorEtB;AACF;AGlrEoB;EACI,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;AHorExB;AGlrEwB;EACI,YAAA;AHorE5B;AGjrEwB;EACI,eAAA;AHmrE5B;AG/qEoB;EACI,sBAAA;EACA,wBJ1oER;EI2oEQ,wBAAA;EACA,gBAAA;AHirExB;AG/qEwB;EANJ;IAOQ,WAAA;IACA,YAAA;IACA,eAAA;EHkrE1B;AACF;AG9qEgB;EACI,mCJvpEJ;EIwpEI,kBAAA;AHgrEpB;AG5qEwB;EACI,WAAA;EACA,eAAA;AH8qE5B;AG1pEwC;EACI,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBJtrE5B;ACk1IhB;AG1pE4C;EANJ;IAOQ,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,WAAA;EH6pE9C;AACF;AG1pEgD;EACI,UAAA;AH4pEpD;AGppEgC;EACI,kBAAA;AHspEpC;AGlpE4C;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;AHopEhD;AG9oEgD;EACI,uBAAA;AHgpEpD;AGxoEgD;EACI,cAAA;AH0oEpD;AG/nEgC;EACI,YAAA;AHioEpC;AG7nEoC;EACI,uBAAA;AH+nExC;AG1nEoC;EACI,uBAAA;AH4nExC;AGvnEoC;EACI,uBAAA;AHynExC;AGrnEgC;EACI,uBAAA;EACA,kBAAA;AHunEpC;AGrnEoC;EACI,aAAA;AHunExC;AG5mEI;EACI,aAAA;EACA,iBAAA;EAGA,aAAA;EAEA,eAAA;AH8mER;AG5mEQ;EACI,UAAA;EACA,mBAAA;AH8mEZ;AG1mEI;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;EACA,mBAAA;AH4mER;AG1mEQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AH4mEZ;AG1mEY;EACI,WAAA;EACA,kBAAA;EAGA,aAAA;EAEA,eAAA;AH4mEhB;AG1mEgB;EACI,kBAAA;EACA,WAAA;AH4mEpB;AG1mEoB;EACI,uBAAA;EACA,+BJv0ER;EIw0EQ,YAAA;EACA,UAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AH4mExB;AGxmEgB;EACI,wBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCAAA;AH0mEpB;AGpmEI;EACI,YAAA;EACA,yBAAA;EACA,mBAAA;EFv2EJ,aAAA;EAEA,eAAA;EEu2EI,WAAA;AH0mER;AGxmEQ;EACI,YAAA;EACA,gBAAA;AH0mEZ;AGxmEY;EACI,uBAAA;EACA,UAAA;AH0mEhB;AGxmEgB;EACI,0BAAA;AH0mEpB;AGtmEY;EACI,uBAAA;EACA,UAAA;AHwmEhB;AGtmEgB;EACI,0BAAA;AHwmEpB;AGpmEY;EACI,uBAAA;EACA,UAAA;AHsmEhB;AGpmEgB;EACI,0BAAA;AHsmEpB;AGlmEY;EACI,uBAAA;EACA,UAAA;AHomEhB;AGlmEgB;EACI,0BAAA;AHomEpB;AGjmEgB;EACI,gBAAA;AHmmEpB;AGjmEoB;EACI,gBAAA;AHmmExB;AG7lEQ;EACI,mBAAA;AH+lEZ;AG7lEY;EF/5ER,aAAA;EAEA,eAAA;ADigJJ;AGjmEgB;EACI,eAAA;AHmmEpB;AGjmEoB;EACI,sBAAA;AHmmExB;AGhmEoB;EACI,UAAA;AHkmExB;AGhmEwB;EAHJ;IAIQ,OAAA;EHmmE1B;AACF;AGhmEoB;EACI,UAAA;AHkmExB;AGhmEwB;EAHJ;IAIQ,YAAA;EHmmE1B;AACF;AGhmEoB;EACI,UAAA;EACA,iBAAA;AHkmExB;AGhmEwB;EAJJ;IAKQ,WAAA;EHmmE1B;AACF;AG9lEoB;EFp8EhB,aAAA;EAEA,eAAA;EAYA,mBAAA;AD8hJJ;AGpmEwB;EACI,YAAA;EACA,mBAAA;AHsmE5B;AGpmE4B;EAJJ;IAKQ,WAAA;IACA,kBAAA;EHumE9B;AACF;AGpmEwB;EACI,yBAAA;AHsmE5B;AGnmEwB;EACI,mCAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EFh7ExB,mCAAA;EACA,8BAAA;EEi7EwB,wBJx9EZ;EIy9EY,eAAA;EACA,yBAAA;EACA,eAAA;AHsmE5B;AGpmE4B;EACI,mCJ99EhB;EI+9EgB,WAAA;AHsmEhC;AGnmE4B;EACI,aAAA;AHqmEhC;AGhmEoB;EACI,UAAA;AHkmExB;AG/lEoB;EFh/EhB,aAAA;EAEA,eAAA;EAMA,uBAAA;ADilJJ;AGrmEwB;EFp/EpB,aAAA;EAEA,eAAA;EEo/EwB,iBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AH2mE5B;AGzmE4B;EACI,gBAAA;AH2mEhC;AGvmEwC;EACI,uBAAA;AHymE5C;AGrmE4C;EADJ;IAEQ,WAAA;EHwmE9C;AACF;AGjmEwC;EACI,sBAAA;AHmmE5C;AG/lE4C;EADJ;IAEQ,YAAA;EHkmE9C;AACF;AG5lEoC;EACI,kBAAA;AH8lExC;AGzlEoC;EACI,wBJ9hFxB;EI+hFwB,mCAAA;AH2lExC;AGzlEwC;EACI,wBJliF5B;EImiF4B,yBAAA;AH2lE5C;AGzlE4C;EACI,yBAAA;EACA,WAAA;AH2lEhD;AGplEoC;EACI,YAAA;EACA,mCAAA;EACA,wBJjjFxB;ACuoJhB;AGplEwC;EACI,wBJpjF5B;EIqjF4B,yBAAA;AHslE5C;AGplE4C;EACI,yBAAA;EACA,WAAA;AHslEhD;AGhlEgC;EACI,kBAAA;EACA,wBJjkFpB;EIkkFoB,eAAA;EACA,iBAAA;EF7hFhC,mCAAA;EACA,8BAAA;EE8hFgC,qBAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EF3jFhC,yBAAA;EE+jFgC,gBAAA;AHqlEpC;AGnlEoC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AHqlExC;AGnlEwC;EACI,uBJvlF5B;AC4qJhB;AGjlEoC;EA5BJ;IA6BQ,cAAA;IACA,oBAAA;IACA,QAAA;IACA,YAAA;IACA,gBAAA;EHolEtC;AACF;AGllEoC;EApCJ;IAqCQ,gBAAA;EHqlEtC;AACF;AGnlEoC;EACI,aAAA;EACA,gBAAA;AHqlExC;AGjlEwC;EADJ;IAEQ,aAAA;EHolE1C;AACF;AGjlEoC;EACI,aAAA;AHmlExC;AGjlEwC;EAHJ;IAIQ,qBAAA;EHolE1C;AACF;AGhlEoC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCJloFxB;EImoFwB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AHklExC;AGhlEwC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EHmlE1C;AACF;AGhlEoC;EACI,wBJppFxB;EIqpFwB,UAAA;AHklExC;AG/kEoC;EACI,wBJzpFxB;EI0pFwB,yBAAA;EACA,UAAA;AHilExC;AG1kEoB;EACI,iBAAA;AH4kExB;AG1kEwB;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AH4kE5B;AG1kE4B;EACI,cAAA;AH4kEhC;AGrkEgB;EACI,gBAAA;AHukEpB;AGpkEgB;EACI,qBAAA;AHskEpB;AG/jEQ;EACI,aAAA;AHikEZ;AG/jEY;EAHJ;IAIQ,WAAA;EHkkEd;AACF;AG/jEQ;EACI,gCAAA;AHikEZ;AG/jEY;EACI,YAAA;AHikEhB;AG7jEQ;EACI,gCAAA;AH+jEZ;AG7jEY;EACI,YAAA;AH+jEhB;AG3jEQ;EACI,gCAAA;AH6jEZ;AG3jEY;EACI,YAAA;AH6jEhB;AGxjEY;EACI,aAAA;AH0jEhB;AGnjEQ;EACI,kBAAA;EACA,kBAAA;EACA,wBJ3uFI;EI4uFJ,eAAA;EACA,aAAA;EACA,oCAAA;AHqjEZ;AGnjEY;EARJ;IASQ,kBAAA;EHsjEd;AACF;AGpjEY;EACI,WAAA;EACA,6BJtvFA;EIuvFA,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EAGA,aAAA;EAGA,uBAAA;EAGA,mBAAA;AHsjEhB;AGpjEgB;EArBJ;IAsBQ,WAAA;IACA,YAAA;EHujElB;AACF;AGpjEY;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AHsjEhB;AGljEQ;EACI,WAAA;EACA,WAAA;EACA,eAAA;AHojEZ;AGhjEY;EACI,eAAA;EACA,wBJlyFA;EImyFA,eAAA;AHkjEhB;AGhjEgB;EACI,kBAAA;AHkjEpB;AG7iEQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AH+iEZ;AG7iEY;EACI,qBAAA;EACA,eAAA;AH+iEhB;AG5iEY;EACI,qBAAA;EACA,wBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AH8iEhB;AGziEY;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AH2iEhB;AGziEgB;EACI,gBAAA;AH2iEpB;AGxiEgB;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EAGA,2BAAA;AH0iEpB;AGtiEY;EACI,qBAAA;EACA,eAAA;AHwiEhB;AGriEY;;EAEI,YAAA;EACA,kBAAA;EACA,aAAA;AHuiEhB;AGpiEY;EACI,qBAAA;EACA,wBAAA;AHsiEhB;AGniEY;EACI,YAAA;EACA,kBAAA;AHqiEhB;AGhiEI;EACI,wBJ72FQ;AC+4JhB;AG9hEQ;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EAGA,yBAAA;AHgiEZ;AG9hEY;EACI,YAAA;AHgiEhB;AG7hEY;EACI,gBAAA;AH+hEhB;AG5hEY;EACI,kCJr4FA;ACm6JhB;AG3hEY;EACI,kCJx4FD;ACq6Jf;AG1hEY;EACI,kCJ14FE;ACs6JlB;AGvhEI;EACI,kBAAA;AHyhER;AGvhEQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AHyhEZ;AGvhEY;EACI,QAAA;AHyhEhB;AGvhEgB;EACI,eAAA;EACA,WAAA;EAGA,8BAAA;AHyhEpB;AGrhEY;EACI,WAAA;EACA,SAAA;AHuhEhB;AGrhEgB;EACI,eAAA;EAIA,sBAAA;EAGA,8BAAA;EACA,YAAA;EACA,WAAA;EAGA,mBAAA;AHuhEpB;AGnhEY;EACI,mBAAA;EAGA,aAAA;EAEA,eAAA;AHqhEhB;AGnhEgB;EACI,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AHqhEpB;AGjhEY;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,wCAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;AHmhEhB;AGjhEgB;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EAGA,yBAAA;AHmhEpB;AGjhEoB;EAGI,yBAAA;AHmhExB;AG/gEgB;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AHihEpB;AG/gEoB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AHihExB;AG/gEwB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AHihE5B;AG5gEgB;EACI,kBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AH8gEpB;AG3gEgB;EACI,SAAA;AH6gEpB;AG3gEoB;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AH6gExB;AG3gEwB;EACI,uCAAA;AH6gE5B;AGrgEI;EACI,gBAAA;EACA,8BAAA;EACA,4BAAA;AHugER;AGpgEI;EACI,oBAAA;EACA,oBAAA;EAGA,aAAA;EAEA,eAAA;AHsgER;AGpgEQ;EACI,gBAAA;EACA,4BAAA;AHsgEZ;AGngEQ;EACI,oBAAA;EACA,UAAA;AHqgEZ;AGlgEQ;EACI,+BAAA;EAEA,iBAAA;EACA,gBAAA;AHogEZ;AGjgEgB;EACI,kBAAA;AHmgEpB;AG9/DQ;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EAGA,eAAA;AHggEZ;AG9/DY;EACI,mBAAA;EACA,gBAAA;EACA,yBAAA;AHggEhB;AG9/DgB;EACI,aAAA;AHggEpB;AG9/DoB;EACI,kBAAA;AHggExB;AG9/DwB;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AHggE5B;AG3/DgB;EACI,YAAA;AH6/DpB;AG/+DQ;EACI,iBAAA;AHi/DZ;AG9+DQ;EACI,eAAA;EACA,mBAAA;EACA,UAAA;AHg/DZ;AG9+DY;EALJ;IAMQ,UAAA;EHi/Dd;AACF;AG/+DY;EATJ;IAUQ,WAAA;EHk/Dd;AACF;AGh/DY;EAGI,aAAA;EAEA,eAAA;AHk/DhB;AGh/DgB;EACI,wBAAA;AHk/DpB;AG/+DgB;EACI,WAAA;AHi/DpB;AG/+DoB;EACI,yBAAA;EACA,4BAAA;AHi/DxB;AG5+DY;EACI,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AH8+DhB;AG5+DgB;EACI,mBAAA;AH8+DpB;AG3+DgB;EACI,iBAAA;AH6+DpB;AG1+DgB;EAjBJ;IAkBQ,UAAA;EH6+DlB;AACF;AG3+DgB;EArBJ;IAsBQ,WAAA;EH8+DlB;AACF;AG5+DgB;EACI,eAAA;AH8+DpB;AGz+DQ;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AH2+DZ;AGz+DY;EACI,qBAAA;AH2+DhB;AGx+DY;EACI,UAAA;EACA,kBAAA;AH0+DhB;AGx+DgB;EACI,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AH0+DpB;AGx+DoB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AH0+DxB;AGt+DgB;EACI,yBAAA;EACA,qBAAA;AHw+DpB;AGr+DgB;EACI,UAAA;AHu+DpB;AGl+DQ;EACI,UAAA;EACA,SAAA;AHo+DZ;AGl+DY;EACI,gBAAA;EACA,UAAA;EACA,WAAA;AHo+DhB;AGl+DgB;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;AHo+DpB;AGl+DoB;EACI,YAAA;AHo+DxB;AGj+DoB;EACI,iBAAA;EACA,eAAA;EACA,wBJnwGR;ACsuKhB;AG79DwB;EACI,wBAAA;AH+9D5B;AG19DgB;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AH49DpB;AGt9DI;EACI,UAAA;EACA,WAAA;AHw9DR;AGr9DI;EACI,WAAA;EACA,cAAA;AHu9DR;AGn9DQ;EACI,eAAA;AHq9DZ;AGl9DQ;EACI,mBAAA;EACA,WAAA;EACA,gBAAA;AHo9DZ;AGl9DY;EACI,cAAA;AHo9DhB;AGj9DY;EACI,gBAAA;AHm9DhB;AGh9DY;EACI,iBAAA;AHk9DhB;;AG38DA;EACI,kBAAA;AH88DJ;AG58DI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AH88DR;AG58DQ;EACI,kBAAA;AH88DZ;;AGz8DA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,wCAAA;EFz0GA,yBAAA;EE20GA,gBAAA;AH88DJ;AG58DI;EACI,QAAA;AH88DR;AG38DI;EACI,gBAAA;AH68DR;AG18DI;EFz2GA,aAAA;EAEA,eAAA;EEy2GI,UAAA;EACA,gBAAA;AHg9DR;AG98DQ;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AHg9DZ;AG98DY;EACI,WAAA;EACA,wBJl3GA;EIm3GA,eAAA;EACA,iBAAA;EF90GZ,mCAAA;EACA,8BAAA;EE+0GY,qBAAA;EACA,YAAA;EACA,SAAA;EACA,mCAAA;EACA,6BAAA;EACA,yBAAA;EF/1GZ,gBAAA;ADmzKJ;AGj9DgB;EACI,aAAA;AHm9DpB;AGh9DgB;EACI,YAAA;AHk9DpB;AGh9DoB;EACI,UAAA;AHk9DxB;AG98DgB;EACI,UAAA;AHg9DpB;AG78DgB;EACI,kBAAA;EACA,UAAA;AH+8DpB;AG38DY;EACI,iBAAA;AH68DhB;AGz8DgB;EACI,0BAAA;AH28DpB;AGt8DgB;EACI,0BAAA;AHw8DpB;AGl8DI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AHo8DR;AGj8DI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AHm8DR;AGh8DI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EF16GJ,yBAAA;AD+2KJ;AGl8DQ;EAGI,yBAAA;AHo8DZ;AGj8DQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAGA,wBAAA;AHm8DZ;AGj8DY;EACI,kBAAA;EACA,mBAAA;AHm8DhB;AGj8DgB;EACI,MAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AHm8DpB;AGh8DgB;EACI,oBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AHk8DpB;AG57DI;EACI,gBAAA;AH87DR;AG37DY;EACI,gBAAA;EACA,mBAAA;AH67DhB;AG37DgB;EACI,gBAAA;EACA,yBAAA;AH67DpB;AG37DoB;;EAEI,yBAAA;EACA,gBAAA;AH67DxB;AGz7DgB;EACI,gBAAA;AH27DpB;AGt7DgB;EACI,uBJ9/GJ;ACs7KhB;AGn7DgB;EACI,uBJngHL;ACw7Kf;AGh7DgB;EACI,wBJxgHJ;AC07KhB;AG76DgB;EACI,uBJ7gHF;AC47KlB;AG36DY;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EF/+GZ,mCAAA;EACA,8BAAA;AD65KJ;AG56DgB;EACI,eAAA;AH86DpB;AG16DY;EACI,kBAAA;EACA,gBAAA;AH46DhB;AG16DgB;EACI,gBAAA;AH46DpB;AGx6DY;EACI,gBAAA;AH06DhB;AGr6DI;EACI,UAAA;EACA,SAAA;AHu6DR;AGr6DQ;EACI,gBAAA;EACA,WAAA;AHu6DZ;AGr6DY;EACI,kBAAA;EACA,wBJtjHA;EEgBZ,yBAAA;ADg9KJ;AGr6DgB;EACI,aAAA;AHu6DpB;AGn6DY;EACI,eAAA;AHq6DhB;;AG15DQ;EACI,kBAAA;EACA,eAAA;EACA,mCAAA;EACA,YAAA;EACA,kBAAA;EFrlHR,aAAA;EAEA,eAAA;ADq/KJ;AG/5DY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AHi6DhB;AG95DY;EF9lHR,aAAA;EAEA,eAAA;EE8lHY,SAAA;EACA,kBAAA;EACA,wBJ9lHA;EI+lHA,kBAAA;EFzjHZ,mCAAA;EACA,8BAAA;AD89KJ;AGn6DgB;EFllHZ,yBAAA;AD0/KJ;AGl6DQ;EACI,mCAAA;EACA,aAAA;EACA,aAAA;EACA,0BAAA;AHo6DZ;AGl6DY;EACI,aAAA;AHo6DhB;AGl6DgB;EACI,gBAAA;AHo6DpB;AGj6DgB;EACI,gBAAA;EACA,kBAAA;EACA,wBJxnHJ;EEsCZ,mCAAA;EACA,8BAAA;ADs/KJ;AGj6DgB;EACI,SAAA;EACA,UAAA;AHm6DpB;AGj6DoB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AHm6DxB;AGj6DwB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AHm6D5B;AGh6DwB;EACI,eAAA;AHk6D5B;AG35DQ;EACI,gBAAA;AH65DZ;AGz5DY;EACI,0BAAA;AH25DhB;AGz5DgB;EFhoHZ,wBAAA;AD8hLJ;AGv5DY;EACI,cAAA;AHy5DhB;;AGh5DA;EACI,eAAA;AHm5DJ;AGj5DI;EF1rHA,aAAA;EAEA,eAAA;EAYA,mBAAA;EE+qHI,UAAA;EACA,SAAA;AHy5DR;AGt5DI;EACI,gBAAA;AHw5DR;AGt5DQ;EACI,iBAAA;AHw5DZ;AGp5DY;EACI,UAAA;AHs5DhB;AGl5DQ;EACI,mCJ3sHI;EI4sHJ,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AHo5DZ;AGl5DY;EACI,SAAA;AHo5DhB;AGh5DQ;EFhrHJ,mCAAA;EACA,8BAAA;EEirHQ,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EF5sHR,yBAAA;ADkmLJ;AGn5DY;EACI,kBAAA;EACA,gBAAA;EACA,OAAA;EFltHZ,yBAAA;AD0mLJ;;AGj5DA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;AHo5DJ;AGl5DI;EACI,cAAA;AHo5DR;;AGh5DA;EACI,eAAA;EACA,eAAA;AHm5DJ;;AGh5DA;EF5vHI,aAAA;EAEA,eAAA;EAYA,mBAAA;EEivHA,eAAA;AHy5DJ;AGv5DI;EACI,eAAA;AHy5DR;AGt5DQ;EACI,iBAAA;EACA,iBAAA;AHw5DZ;AGt5DY;EACI,eAAA;EACA,eAAA;AHw5DhB;AGr5DY;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AHu5DhB;AGr5DgB;EALJ;IAMQ,UAAA;EHw5DlB;AACF;;AGl5DA;EACI,kBAAA;AHq5DJ;AGn5DI;EACI,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AHq5DR;AGn5DQ;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AHq5DZ;AGl5DQ;EACI,iBAAA;AHo5DZ;;AGh4DA;EACI,aAAA;EACA,kBAAA;AHm4DJ;;AGh4DA;EACI,UAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AHm4DJ;;AGh4DA;EACI,eAAA;AHm4DJ;AGj4DI;EACI,iBAAA;EAEA,sBAAA;EACA,qBAAA;EACA,cAAA;AHk4DR;AG/3DI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AHi4DR;;AG33DI;EACI,eAAA;EACA,gBAAA;AH83DR;AG33DI;EAEI,wBAAA;EACA,mBAAA;AH63DR;AG13DI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AH43DR;AGx3DY;EACI,kBAAA;AH03DhB;;AGp3DA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AHu3DJ;;AGp3DA;EACI,sBAAA;EACA,kBAAA;AHu3DJ;;AGp3DA;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AHu3DJ;AGr3DI;EACI,wBJ/5HQ;EIg6HR,uBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;AHu3DR;;AGh3DQ;EACI,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;AHm3DZ;AGj3DY;EACI,YAAA;AHm3DhB;AGh3DY;EACI,eAAA;AHk3DhB;;AG32DI;EACI,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBJ78HQ;EI88HR,eAAA;EACA,kBAAA;EACA,6BAAA;AH82DR;AG52DQ;EACI,YAAA;AH82DZ;AG32DQ;EACI,eAAA;AH62DZ;AGz2DI;EACI,mBAAA;AH22DR;;AGv2DA;EACI,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AH02DJ;;AGv2DA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AH02DJ;;AGt2DA;EACI,mCAAA;EACA,UAAA;AHy2DJ;;AGt2DA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AHy2DJ;;AGt2DA;EACI,mCAAA;EACA,mBAAA;EACA,UAAA;AHy2DJ;;AGt2DA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AHy2DJ;;AGt2DA;EACI;IACI,UAAA;EHy2DN;EGt2DE;IACI,UAAA;EHw2DN;EGr2DE;IACI,UAAA;EHu2DN;AACF;AGl2DA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AHo2DJ;AGl2DI;EACI,yBAAA;AHo2DR;AGj2DI;EACI,oCAAA;AHm2DR;AG/1DQ;EACI,mCAAA;AHi2DZ;AG91DQ;EACI,UAAA;AHg2DZ;AG31DQ;EACI,0BAAA;AH61DZ;AGz1DI;EACI,kBAAA;EACA,gBAAA;AH21DR;AGx1DI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AH01DR;AGx1DQ;EALJ;IAMQ,YAAA;IACA,iBAAA;EH21DV;AACF;AGz1DQ;EACI,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AH21DZ;AGz1DY;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AH21DhB;AGz1DgB;EACI,aAAA;AH21DpB;AGv1DY;EACI,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AHy1DhB;AGl1DoB;EACI,mBAAA;AHo1DxB;AG70DI;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AH+0DR;AG70DQ;EACI,qBAAA;EACA,yBAAA;AH+0DZ;AG50DQ;EACI,qBAAA;EACA,yBAAA;AH80DZ;AG50DY;EACI,qBAAA;EACA,yBAAA;AH80DhB;AG10DQ;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;AH40DZ;AG10DY;EACI,qBAAA;EACA,yBAAA;AH40DhB;AGx0DQ;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;AH00DZ;AGx0DY;EACI,qBAAA;EACA,yBAAA;AH00DhB;AGt0DQ;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;AHw0DZ;AGr0DQ;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;AHu0DZ;AGr0DY;EACI,qBAAA;EACA,yBAAA;AHu0DhB;;AGj0DA;EACI,gBAAA;AHo0DJ;;ADn5LA;EACE,eAAA;ACs5LF;;ADn5LA;EACE,aAAA;EACA,eAAA;ACs5LF;;ADn5LA;EACE,sBAAA;ACs5LF;;ADn5LA;EACE,8BAAA;ACs5LF;;ADn5LA;EACE,gBAAA;ACs5LF;;ADn5LA;EACE,gBAAA;ACs5LF;;ADn5LA;EACE,aAAA;ACs5LF;;ADn5LA;EACE,gBAAA;ACs5LF;;ADx4LE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC24LJ;ADz4LI;;;;;;EACE,gBAAA;ACg5LN;AD54LE;;EAEE,eA5GO;EA6GP,gBA3GO;ACy/LX;AD54LI;EALF;;IAMI,eA/GY;EC+/LhB;AACF;AD74LE;;EAEE,eAlHO;EAmHP,gBAjHO;ACggMX;AD74LI;EALF;;IAMI,eArHY;ECsgMhB;AACF;AD94LE;;EAEE,eAxHO;EAyHP,gBAvHO;ACugMX;AD94LI;EALF;;IAMI,eA3HY;EC6gMhB;AACF;AD/4LE;;EAEE,eA9HO;EA+HP,gBA7HO;AC8gMX;AD94LE;;EAEE,eAhIO;EAiIP,gBAhIO;ACghMX;AD74LE;;EAEE,eAnIO;EAoIP,gBAnIO;ACkhMX;ADz4LE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC24LJ;ADz4LI;EACE,gBAAA;AC24LN;ADx4LI;EAXF;IAYI,eAAA;EC24LJ;AACF;ADx4LE;;EAEE,UAAA;EACA,SAAA;AC04LJ;ADv4LE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ACy4LJ;;ADr4LA;EACE,sBAxNQ;ACgmMV;;ADr4LA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ACw4LF;ADt4LE;EALF;IAMI,cAAA;ECy4LF;AACF;ADv4LE;EACE,iBA1Ka;ACmjMjB;ADt4LE;EACE,gBApLa;EAqLb,WAAA;ACw4LJ;;ADn4LE;EACE,kBAAA;ACs4LJ;ADn4LE;EACE,iBAAA;ACq4LJ;;ADh4LE;EACE,aAAA;ACm4LJ;;AD/3LA;EACE,kBAAA;ACk4LF;ADh4LE;EACE,mBAAA;ACk4LJ;AD93LI;EACE,sBAAA;ACg4LN;AD53LE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;AC4lMnB;AD53LI;EACE,sBAAA;AC83LN;AD33LI;EAVF;IAWI,eApOoB;ECkmMxB;AACF;AD33LE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AC63LJ;AD33LI;EACE,sBAAA;AC63LN;AD13LI;EACE,WAAA;AC43LN;ADz3LI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACutMZ;;ADt3LA;EACE,mBA1PO;ACmnMT;ADv3LE;EAHF;IAII,mBAAA;EC03LF;AACF;ADx3LE;EACE,mBAAA;AC03LJ;ADv3LE;EACE,aArQK;AC8nMT;ADv3LI;EAHF;IAII,aAAA;EC03LJ;AACF;ADx3LI;EACE,aAAA;AC03LN;;ADr3LA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ACw3LF;ADt3LE;EACE,eAAA;ACw3LJ;ADr3LE;EACE,sCAAA;ACu3LJ;ADp3LE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ACs3LJ;;ADv2LE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC02LJ;ADx2LI;EACE,kBAAA;AC02LN;ADv2LI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ACy2LN;;ADp2LA;EACE,8BAAA;ACu2LF;;ADp2LA;EACE,8BAAA;ACu2LF;;ADp2LA;EACE,+BAAA;ACu2LF;;ADp2LA;EACE,8BAAA;ACu2LF;;ADp2LA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ACu2LF;ADr2LE;EACE,2BAAA;EACA,mBAAA;ACu2LJ;ADp2LE;EACE,yBAzbiB;EA0bjB,WA1aO;ACgxMX;ADn2LE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ACq2LJ;ADl2LE;EACE,yBAjckB;EAkclB,cArciB;ACyyMrB;ADj2LE;EACE,yBAvbS;EAwbT,WA1bO;AC6xMX;ADj2LI;EACE,6BAAA;ACm2LN;;AD91LA;EACE;IACE,uBAAA;ECi2LF;ED91LA;IACE,yBAAA;ECg2LF;AACF;AD71LA;EACE,8BAAA;AC+1LF;;AD51LA;EACE,8BAAA;AC+1LF;;AD51LA;EACE,+BAAA;AC+1LF;;AD51LA;EACE,8BAAA;AC+1LF;;AD51LA;EACE,qBAAA;AC+1LF;;AD51LA;EACE,UAAA;AC+1LF;AD71LE;EACE,qBAAA;AC+1LJ;;AD31LA;EACE,UAAA;AC81LF;;AD11LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;AC41LJ;ADz1LM;EACE,mBAAA;AC21LR;ADt1LE;EACE,2BAAA;ACw1LJ;ADr1LE;EACE,uBAAA;ACu1LJ;ADp1LE;EACE,mBAAA;ACs1LJ;;ADj1LE;EACE,mBAAA;ACo1LJ;ADj1LE;EACE,yBAAA;ACm1LJ;ADh1LE;EACE,sBAAA;ACk1LJ;AD/0LE;EACE,uBAAA;ACi1LJ;AD90LE;EACE,oBAAA;ACg1LJ;;AC51MA;EACI,oCAAA;AD+1MJ;;AIt6MA;EACI,gBAAA;AJy6MJ;;AIh6MA;EACI,oBAAA;AJm6MJ;;AIh6MA;EACI,mBAAA;AJm6MJ;;AI95MI;EHFA,aAAA;EAEA,eAAA;EGEI,mBAAA;AJq6MR;AIn6MQ;EAJJ;IAKQ,mBAAA;EJs6MV;AACF;AIp6MQ;EACI,mBAAA;AJs6MZ;AIl6MoB;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AJo6MxB;AIl6MwB;EANJ;IAOQ,kBAAA;IACA,eAAA;EJq6M1B;AACF;AIn6MwB;EAXJ;IAYQ,YAAA;IACA,eAAA;EJs6M1B;AACF;AIl6MwB;EACI,iCAAA;EACA,qCAAA;EACA,wCAAA;AJo6M5B;AI75MQ;EACI,gBAAA;AJ+5MZ;AI75MY;EACI,OAAA;EACA,kBAAA;AJ+5MhB;AI75MgB;EAJJ;IAKQ,UAAA;IACA,WAAA;EJg6MlB;AACF;AI95MgB;EACI,WAAA;EACA,OAAA;AJg6MpB;AI95MoB;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;AJg6MxB;AI15MQ;EACI,gBAAA;AJ45MZ;AI15MY;EAHJ;IAIQ,qBAAA;EJ65Md;AACF;AI35MY;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AJ65MhB;AI35MgB;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AJ65MpB;AI15MoB;EACI,yBAAA;AJ45MxB;AIz5MoB;EACI,iBAAA;AJ25MxB;AIz5MwB;EAHJ;IAIQ,eAAA;EJ45M1B;AACF;AIz5MoB;EA1BJ;IA2BQ,WAAA;IACA,YAAA;IACA,aAAA;EJ45MtB;AACF;AI15MoB;EACI,aAAA;AJ45MxB;AIz5M4B;EACI,aAAA;AJ25MhC;AIx5M4B;EACI,aAAA;AJ05MhC;AIp5MgC;EACI,aAAA;AJs5MpC;AIn5MgC;EACI,aAAA;AJq5MpC;AI14M4B;EACI,aAAA;AJ44MhC;AIz4M4B;EACI,aAAA;AJ24MhC;AIj4MI;EACI,kBAAA;AJm4MR;AIj4MQ;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AJm4MZ;AIj4MY;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AJm4MhB;AI/3MQ;EACI,gBAAA;AJi4MZ;AI53MI;EACI,WAAA;EACA,8BLvLO;EKwLP,mBAAA;EACA,kBAAA;EACA,kBAAA;AJ83MR;AI53MQ;EAPJ;IAQQ,kBAAA;EJ+3MV;AACF;AI73MQ;EACI,kCLjMG;ACgkNf;AI53MQ;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EHhKR,mCAAA;EACA,8BAAA;EGiKQ,aAAA;EACA,eAAA;EACA,mBAAA;AJ+3MZ;AI73MY;EATJ;IAUQ,eAAA;EJg4Md;AACF;AI93MY;EAbJ;IAcQ,eAAA;EJi4Md;AACF;AI/3MY;EACI,kBAAA;AJi4MhB;AI73MY;EACI,WAAA;EACA,cAAA;AJ+3MhB;AI73MgB;EAJJ;IAKQ,WAAA;IACA,eAAA;EJg4MlB;AACF;AI53MQ;EHxOJ,aAAA;EAEA,eAAA;EAYA,mBAAA;EG6NQ,eAAA;AJo4MZ;AI93MoB;EACI,qBAAA;AJg4MxB;AI93MwB;EAHJ;IAIQ,OAAA;IACA,sBAAA;EJi4M1B;AACF;AI53MY;EACI,eAAA;EACA,qBAAA;AJ83MhB;AI53MgB;EACI,sBAAA;AJ83MpB;AI33MgB;EACI,UAAA;AJ63MpB;AI33MoB;EAHJ;IAIQ,OAAA;IACA,kBAAA;EJ83MtB;AACF;AI33MgB;EACI,UAAA;AJ63MpB;AI33MoB;EAHJ;IAIQ,YAAA;EJ83MtB;AACF;AI33MgB;EACI,UAAA;EACA,iBAAA;EACA,iBAAA;AJ63MpB;AI33MoB;EALJ;IAMQ,WAAA;EJ83MtB;AACF;AI53MoB;EACI,eAAA;EACA,eAAA;AJ83MxB;AI33MoB;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AJ63MxB;AI33MwB;EANJ;IAOQ,WAAA;IACA,UAAA;EJ83M1B;AACF;AI13MgB;EHhTZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADsqNJ;AIh4MoB;EACI,kBAAA;AJk4MxB;AI93MgB;EACI,UAAA;AJg4MpB;AI73MgB;EH7TZ,aAAA;EAEA,eAAA;EAMA,uBAAA;AD4rNJ;AIn4MoB;EHjUhB,aAAA;EAEA,eAAA;EGiUoB,SAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AJy4MxB;AIp4MoC;EACI,uBAAA;AJs4MxC;AIl4MwC;EADJ;IAEQ,WAAA;EJq4M1C;AACF;AI93MoC;EACI,sBAAA;AJg4MxC;AI53MwC;EADJ;IAEQ,YAAA;EJ+3M1C;AACF;AI13M4B;EACI,iBAAA;AJ43MhC;AIx3MgC;EACI,kBAAA;AJ03MpC;AIr3MgC;EACI,uBL9WrB;EK+WqB,kCAAA;EACA,eAAA;AJu3MpC;AIr3MoC;EACI,uBLnXzB;EKoXyB,yBAAA;AJu3MxC;AIr3MwC;EACI,yBAAA;EACA,WAAA;AJu3M5C;AIh3MgC;EACI,YAAA;EACA,kCAAA;EACA,uBLlYrB;ACovNf;AIh3MoC;EACI,uBLrYzB;EKsYyB,yBAAA;AJk3MxC;AIh3MwC;EACI,yBAAA;EACA,WAAA;AJk3M5C;AI52M4B;EACI,kBAAA;EACA,wBLjZhB;EKkZgB,eAAA;EACA,iBAAA;EH7W5B,mCAAA;EACA,8BAAA;EG8W4B,qBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EHxY5B,yBAAA;EG4Y4B,gBAAA;AJi3MhC;AI/2MgC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AJi3MpC;AI/2MoC;EACI,sBLrazB;ACsxNf;AI72MgC;EAzBJ;IA0BQ,gBAAA;IACA,eAAA;EJg3MlC;AACF;AI92MgC;EACI,aAAA;EACA,gBAAA;AJg3MpC;AI52MoC;EADJ;IAEQ,aAAA;EJ+2MtC;AACF;AI52MgC;EACI,aAAA;AJ82MpC;AI52MoC;EAHJ;IAIQ,qBAAA;EJ+2MtC;AACF;AI52MgC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCLxcrB;EKycqB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AJ82MpC;AI52MoC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EJ+2MtC;AACF;AI52MgC;EACI,uBL1drB;EK2dqB,UAAA;AJ82MpC;AI32MgC;EACI,uBL/drB;EKgeqB,yBAAA;EACA,UAAA;AJ62MpC;AIt2MgB;EACI,kBAAA;AJw2MpB;AIp2M4B;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,uCAAA;EACA,kBAAA;AJs2MhC;AIh2MgC;EACI,uBAAA;AJk2MpC;AI11MgC;EACI,cAAA;AJ41MpC;AI50MY;EACI,kCAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EHlfZ,mCAAA;EACA,8BAAA;EGmfY,uBL3hBD;EK4hBC,eAAA;EACA,gBAAA;EH5gBZ,yBAAA;EG8gBY,eAAA;AJi1MhB;AI/0MgB;EACI,kCLliBL;EKmiBK,WAAA;AJi1MpB;AI90MgB;EACI,aAAA;AJg1MpB;AI50MY;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AJ80MhB;AI50MgB;EACI,uBLljBL;ACg4Nf;AI30MgB;EACI,mBAAA;AJ60MpB;AI10MgB;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBL7jBL;EK8jBK,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AJ40MpB;AIv0MQ;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,uBLjlBG;EEuCX,mCAAA;EACA,8BAAA;EA3CA,aAAA;EAEA,eAAA;EAYA,mBAAA;ADy5NJ;AI90MY;EATJ;IAUQ,eAAA;EJi1Md;AACF;AI/0MY;EAbJ;IAcQ,eAAA;IACA,sBAAA;EJk1Md;AACF;AIh1MY;EACI,iBAAA;AJk1MhB;AI70MgB;EACI,uBLtmBL;ACq7Nf;AIz0MgB;EAFJ;IAGQ,WAAA;IACA,gBAAA;EJ40MlB;AACF;AI10MgB;EACI,0BAAA;EACA,8BAAA;EACA,6BAAA;AJ40MpB;AI10MoB;EALJ;IAMQ,0BAAA;EJ60MtB;AACF;AIz0MY;EACI,eAAA;EACA,gBAAA;AJ20MhB;AIz0MgB;EACI,iBAAA;AJ20MpB;AIz0MoB;EACI,cAAA;EACA,gBAAA;AJ20MxB;AIv0MgB;EACI,iBAAA;AJy0MpB;AIn0MQ;EACI,kBAAA;EACA,eAAA;EACA,qBAAA;AJq0MZ;AIn0MY;EACI,uBLtpBD;AC29Nf;AIl0MY;EACI,mBAAA;AJo0MhB;AIj0MY;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBLjqBD;EKkqBC,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AJm0MhB;AI9zMI;;EAEI,cAAA;EACA,gBAAA;AJg0MR;AI7zMI;EA6EI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,yCAAA;AJmvMR;AIl0MQ;EACI,gBAAA;AJo0MZ;AIl0MY;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AJo0MhB;AIj0MY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AJm0MhB;AIj0MgB;EACI,mBAAA;EACA,kBAAA;AJm0MpB;AI/zMY;EACI,gBAAA;AJi0MhB;AI7zMQ;EACI,gBAAA;AJ+zMZ;AI5zMQ;EACI,SAAA;EACA,kCAAA;EACA,kBAAA;AJ8zMZ;AI5zMY;EACI,6BAAA;EACA,4BAAA;AJ8zMhB;AI5zMgB;EACI,kCLluBL;ACgiOf;AI3zMwB;EACI,WAAA;AJ6zM5B;AIvzMgC;EACI,kBAAA;EACA,sBAAA;AJyzMpC;AIvzMoC;EACI,uBLjvBzB;EKkvByB,sBAAA;AJyzMxC;AItzMoC;EACI,qBAAA;AJwzMxC;AIjzMoB;EACI,WAAA;AJmzMxB;AIxyMQ;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;AJ0yMZ;AIxyMY;EALJ;IAMQ,kBAAA;EJ2yMd;AACF;AIxyMQ;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AJ0yMZ;AIxyMY;EACI,cAAA;AJ0yMhB;AIxyMgB;EACI,sBAAA;AJ0yMpB;AIryMY;EACI,aAAA;AJuyMhB;AInyMgB;EACI,eAAA;EACA,gBAAA;AJqyMpB;AInyMoB;EAJJ;IAKQ,eAAA;EJsyMtB;AACF;AIpyMoB;EACI,gBAAA;AJsyMxB;AIlyMgB;EACI,eAAA;AJoyMpB;AIlyMoB;EACI,UAAA;EACA,eAAA;AJoyMxB;AIlyMwB;EAJJ;IAKQ,WAAA;EJqyM1B;AACF;AInyMwB;EACI,kBAAA;EACA,kBAAA;AJqyM5B;AInyM4B;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AJqyMhC;AI9xMY;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;AJgyMhB;AI9xMgB;EACI,gBAAA;AJgyMpB;AI7xMgB;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AJ+xMpB;AI7xMoB;EACI,UAAA;AJ+xMxB;AI1xMgB;EACI,eAAA;AJ4xMpB;AIzxMgB;EACI,cAAA;EACA,eAAA;AJ2xMpB;AIzxMoB;EACI,iBAAA;AJ2xMxB;AIpxMY;EACI,eAAA;AJsxMhB;AInxMY;EACI,UAAA;EACA,SAAA;AJqxMhB;AInxMgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AJqxMpB;AInxMoB;EACI,kBAAA;EACA,uBL94BT;EK+4BS,UAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AJqxMxB;AIhxMoB;EACI,8BL35BT;AC6qOf;AI/wMoB;EACI,UAAA;AJixMxB;AI3wMQ;EACI,aAAA;AJ6wMZ;AI3wMY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AJ6wMhB;AI3wMgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;AJ6wMpB;AI1wMgB;EACI,sBAAA;AJ4wMpB;AIxwMY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AJ0wMhB;AIxwMgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AJ0wMpB;AIxwMoB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AJ0wMxB;AIrwMoB;EACI,8BL99BT;EK+9BS,kCL/9BT;ACsuOf;AIpwMoB;EACI,UAAA;AJswMxB;AIhwMQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;AJkwMZ;AIhwMY;EHj/BR,aAAA;EAEA,eAAA;EAYA,mBAAA;AD6uOJ;AItwMgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EHr+BhB,yBAAA;ADgvOJ;AIxwMoB;EACI,iBAAA;AJ0wMxB;AIvwMoB;EACI,iBAAA;EACA,gBAAA;AJywMxB;AIrwMgB;EACI,iBAAA;AJuwMpB;AIpwMgB;EACI,kCLxgCL;EKygCK,8BLzgCL;EK0gCK,WAAA;AJswMpB;AIpwMoB;EACI,kCL7gCT;EK8gCS,8BL9gCT;ACoxOf;AIlwMgB;EACI,yBAAA;EACA,qBAAA;AJowMpB;AIlwMoB;EACI,yBAAA;EACA,qBAAA;AJowMxB;AIhwMgB;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;AJkwMpB;AIhwMoB;EACI,yBAAA;EACA,qBAAA;AJkwMxB;AI7vMoB;EACI,SAAA;AJ+vMxB;AI3vMgB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EHniChB,yBAAA;ADmyOJ;AI7vMoB;EACI,kBAAA;EACA,UAAA;EHxiCpB,yBAAA;AD0yOJ;AI9vMoB;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AJgwMxB;AI9vMwB;EACI,kBAAA;EACA,OAAA;AJgwM5B;AI7vMwB;EACI,iBAAA;AJ+vM5B;AI3vMoB;EACI,cAAA;EACA,eAAA;EH9jCpB,yBAAA;AD8zOJ;AIzvMQ;EACI,gBAAA;EACA,kBAAA;EACA,6BAAA;AJ2vMZ;AIxvMY;EANJ;IAOQ,kBAAA;EJ2vMd;AACF;AIzvMY;EACI,cAAA;EHpmCZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADy1OJ;AI/vMgB;EACI,cAAA;AJiwMpB;AI/vMoB;EAHJ;IAIQ,WAAA;IACA,kBAAA;EJkwMtB;EIhwMsB;IACI,gBAAA;EJkwM1B;AACF;AI9vMwB;EACI,iBAAA;AJgwM5B;AI3vMgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AJ6vMpB;AI3vMoB;EARJ;IASQ,eAAA;EJ8vMtB;AACF;AI5vMoB;;EAEI,iBAAA;EACA,gBAAA;AJ8vMxB;AI3vMoB;EACI,mCL1oCR;EK2oCQ,WAAA;AJ6vMxB;AI1vMoB;EACI,kCLjpCR;EKkpCQ,WAAA;AJ4vMxB;AIzvMoB;EACI,kCLrpCT;EKspCS,WAAA;EACA,8BLvpCT;EKwpCS,gBAAA;AJ2vMxB;AIxvMoB;EACI,YAAA;AJ0vMxB;AIvvMoB;EACI,yBAAA;EACA,WAAA;EACA,qBAAA;AJyvMxB;AItvMoB;EACI,UAAA;EACA,6BAAA;EACA,cAAA;EACA,cL5pCH;EK6pCG,SAAA;EACA,wELjsCX;EKksCW,eAAA;EACA,gBAAA;AJwvMxB;AItvMwB;EACI,WAAA;AJwvM5B;AIpvMoB;EACI,yBAAA;EACA,WAAA;AJsvMxB;AInvMoB;EACI,cAAA;AJqvMxB;AIlvMoB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EHnrCpB,yBAAA;AD06OJ;AIrvMwB;EACI,eAAA;EACA,cL3rCP;ACk7OrB;AIlvMwB;EACI,kBAAA;EACA,UAAA;EH9rCxB,yBAAA;ADq7OJ;AInvMwB;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AJqvM5B;AInvM4B;EANJ;IAOQ,kBAAA;IACA,iBAAA;EJsvM9B;AACF;AIpvM4B;EACI,kBAAA;EACA,OAAA;AJsvMhC;AInvM4B;EACI,iBAAA;AJqvMhC;AIjvMwB;EA3CJ;IA4CQ,yBAAA;IACA,cAAA;IACA,mBAAA;IACA,kBAAA;EJovM1B;AACF;AInvM4B;EAjDR;IAkDY,kBAAA;IACA,iBAAA;EJsvM9B;AACF;AI/vMwB;EAWI;IACI,kBAAA;IACA,OAAA;EJuvM9B;EIpvM0B;IACI,4BAAA;EJsvM9B;AACF;AInvMwB;EACI,cAAA;EACA,eAAA;EH9uCxB,yBAAA;ADs+OJ;AI/uMQ;EACI,uBAAA;EACA,kCAAA;EACA,mBAAA;AJivMZ;AI/uMY;EACI,uBL9wCD;AC+/Of;AI7uMQ;EACI,uBLnxCG;ACkgPf;AI5uMQ;EACI,eAAA;AJ8uMZ;AI5uMY;EACI,gBAAA;AJ8uMhB;AI1uMQ;EACI,kBAAA;AJ4uMZ;AI1uMY;;EAEI,WAAA;EACA,eAAA;EACA,kBAAA;AJ4uMhB;AI1uMgB;;;;EAEI,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AJ8uMpB;AI1uMY;EACI,eAAA;EHrzCZ,aAAA;EAEA,eAAA;ADoiPJ;AI9uMgB;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AJgvMpB;AI9uMoB;EACI,kBAAA;AJgvMxB;AI5uMgB;EACI,gBAAA;EACA,oCAAA;EACA,eAAA;AJ8uMpB;AI5uMoB;EACI,mBAAA;AJ8uMxB;AI1uMgB;EAGI,gBAAA;EACA,iFAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;AJ4uMpB;AIzuMgB;EACI,WAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AJ2uMpB;AIxuMgB;;EH/1CZ,aAAA;EAEA,eAAA;AD6kPJ;AI5uMoB;;EACI,WAAA;EACA,mBAAA;EHr2CpB,aAAA;EAEA,eAAA;EAYA,mBAAA;AD8kPJ;AIlvMoB;;EACI,WAAA;EACA,kBAAA;EH52CpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EANA,uBAAA;EGw2CoB,eAAA;EACA,0BAAA;AJ6vMxB;AI3vMwB;;EACI,wBAAA;EACA,mBAAA;AJ8vM5B;AI5vM4B;;EACI,kBAAA;AJ+vMhC;AI7vMgC;;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;EACA,uBL73CrB;AC6nPf;AI9vMoC;;;EAEI,cAAA;AJiwMxC;AI9vMoC;;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AJiwMxC;AI7vMgC;;EACI,kBAAA;AJgwMpC;AIxvMwB;;EACI,gBAAA;AJ2vM5B;AIvvMoB;;EACI,YAAA;EACA,mBAAA;AJ0vMxB;AIvvMoB;;EACI,yBAAA;AJ0vMxB;AIxvMwB;;EACI,mBAAA;AJ2vM5B;AIzvM4B;;;EAEI,aAAA;AJ4vMhC;AItvM4B;;EACI,aAAA;AJyvMhC;AIpvMoB;;EACI,WAAA;AJuvMxB;AIhvMgB;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,cL77CC;EEIjB,yBAAA;AD8qPJ;AIlvMoB;EACI,kCL98CT;EK+8CS,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AJovMxB;AI9uMQ;EAQI,oBAAA;EHr9CR,mBAAA;EGu9CQ,WAAA;EACA,gBAAA;EACA,SAAA;AJ6uMZ;AIxvMY;EACI,kBAAA;EACA,SAAA;AJ0vMhB;AI5uMY;EACI,YAAA;EACA,kBAAA;AJ8uMhB;AI3uMY;;EAEI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AJ6uMhB;AI1uMY;EACI,WAAA;EACA,SAAA;AJ4uMhB;AIzuMY;EACI,SAAA;AJ2uMhB;AIxuMY;EACI,UAAA;EACA,iBAAA;AJ0uMhB;AItuMQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,QAAA;EAGA,2BAAA;EHvgDR,yBAAA;ADkvPJ;AIxuMY;EACI,kCL5hDD;EK6hDC,8BL7hDD;EK8hDC,WAAA;AJ0uMhB;AItuMQ;EAGI,aAAA;EAEA,eAAA;EACA,sBAAA;AJwuMZ;AIruMgB;EACI,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;AJuuMpB;AInuMoB;EAEI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AJouMxB;AIjuMoB;EACI,WAAA;EACA,UAAA;AJmuMxB;AI7tMgB;EACI,WAAA;AJ+tMpB;AI3tMY;EACI,kBAAA;EACA,kBAAA;AJ6tMhB;AI3tMgB;EACI,0BAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AJ6tMpB;AIvtMI;EACI,aAAA;EACA,iBAAA;EAGA,aAAA;EAEA,eAAA;AJytMR;AIvtMQ;EACI,UAAA;EACA,mBAAA;AJytMZ;AIrtMI;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;EACA,mBAAA;AJutMR;AIrtMQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AJutMZ;AIrtMY;EACI,WAAA;EACA,kBAAA;EAGA,aAAA;EAEA,eAAA;AJutMhB;AIrtMgB;EACI,kBAAA;EACA,WAAA;AJutMpB;AIrtMoB;EACI,uBAAA;EACA,8BLzoDT;EK0oDS,YAAA;EACA,UAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AJutMxB;AIntMgB;EACI,wBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCAAA;AJqtMpB;AI9sMQ;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EAGA,yBAAA;AJgtMZ;AI9sMY;EACI,YAAA;AJgtMhB;AI7sMY;EACI,gBAAA;AJ+sMhB;AI5sMY;EACI,kCLtrDA;ACo4PhB;AI3sMY;EACI,kCLzrDD;ACs4Pf;AI1sMY;EACI,kCL3rDE;ACu4PlB;AIvsMI;EACI,kBAAA;AJysMR;AIvsMQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AJysMZ;AIvsMY;EACI,QAAA;AJysMhB;AIvsMgB;EACI,eAAA;EACA,WAAA;EAGA,8BAAA;AJysMpB;AIrsMY;EACI,WAAA;EACA,SAAA;AJusMhB;AIrsMgB;EACI,eAAA;EAIA,sBAAA;EAGA,8BAAA;EACA,YAAA;EACA,WAAA;EAGA,mBAAA;AJusMpB;AInsMY;EACI,mBAAA;EAGA,aAAA;EAEA,eAAA;AJqsMhB;AInsMgB;EACI,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AJqsMpB;AIjsMY;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,wCAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;AJmsMhB;AIjsMgB;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EAGA,yBAAA;AJmsMpB;AIjsMoB;EAGI,yBAAA;AJmsMxB;AI/rMgB;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AJisMpB;AI/rMoB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AJisMxB;AI/rMwB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AJisM5B;AI5rMgB;EACI,kBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AJ8rMpB;AI3rMgB;EACI,SAAA;AJ6rMpB;AI3rMoB;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AJ6rMxB;AI3rMwB;EACI,uCAAA;AJ6rM5B;AIprMQ;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;EAGA,aAAA;EAEA,iBAAA;AJsrMZ;AIprMY;EACI,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AJsrMhB;AIprMgB;EACI,mBAAA;AJsrMpB;AInrMgB;EACI,iBAAA;AJqrMpB;AIlrMgB;EAjBJ;IAkBQ,UAAA;EJqrMlB;AACF;AInrMgB;EArBJ;IAsBQ,WAAA;EJsrMlB;AACF;AIprMgB;EAGI,aAAA;EAEA,eAAA;AJsrMpB;AIprMoB;EACI,wBAAA;EACA,sBAAA;EACA,0BAAA;AJsrMxB;AInrMoB;EACI,WAAA;AJqrMxB;AInrMwB;EACI,kCLr4Db;EKs4Da,gBAAA;EACA,WAAA;EACA,8BLx4Db;EKy4Da,wEL/5Df;AColQb;AIlrMwB;EACI,YAAA;AJorM5B;AI9qMY;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AJgrMhB;AI9qMgB;EACI,qBAAA;EACA,kBAAA;EACA,sBAAA;AJgrMpB;AI7qMgB;EACI,UAAA;EACA,kBAAA;AJ+qMpB;AI7qMoB;EACI,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AJ+qMxB;AI7qMwB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AJ+qM5B;AI3qMoB;EACI,kCL77DT;EK87DS,8BL97DT;AC2mQf;AI1qMoB;EACI,UAAA;AJ4qMxB;AIvqMY;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;AJyqMhB;AIvqMgB;EACI,kBAAA;EACA,UAAA;AJyqMpB;AIvqMoB;EACI,8BLt9DT;EKu9DS,yBLv9DT;ACgoQf;AIrqMgB;EACI,iBAAA;AJuqMpB;AIpqMgB;EACI,iBAAA;AJsqMpB;AIlqMoB;EACI,eAAA;EACA,cAAA;EACA,eAAA;AJoqMxB;AIhqMgB;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mCL9+DJ;ACgpQhB;AI9pMY;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AJgqMhB;AI9pMgB;EACI,gBAAA;EACA,UAAA;EACA,WAAA;AJgqMpB;AI9pMoB;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AJgqMxB;;AIxpMA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,wCAAA;EHrgEA,yBAAA;EGugEA,gBAAA;AJ6pMJ;AI3pMI;EACI,QAAA;AJ6pMR;AI1pMI;EACI,gBAAA;AJ4pMR;AIzpMI;EHriEA,aAAA;EAEA,eAAA;EGqiEI,UAAA;EACA,gBAAA;AJ+pMR;AI7pMQ;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AJ+pMZ;AI7pMY;EACI,WAAA;EACA,uBL/iED;EKgjEC,eAAA;EACA,iBAAA;EH1gEZ,mCAAA;EACA,8BAAA;EG2gEY,qBAAA;EACA,YAAA;EACA,SAAA;EACA,kCAAA;EACA,6BAAA;EACA,yBAAA;EH3hEZ,gBAAA;AD8rQJ;AIhqMgB;EACI,aAAA;AJkqMpB;AI/pMgB;EACI,YAAA;AJiqMpB;AI/pMoB;EACI,UAAA;AJiqMxB;AI7pMgB;EACI,UAAA;AJ+pMpB;AI5pMgB;EACI,kBAAA;EACA,UAAA;AJ8pMpB;AI1pMY;EACI,iBAAA;AJ4pMhB;AIxpMgB;EACI,0BAAA;AJ0pMpB;AIrpMgB;EACI,0BAAA;AJupMpB;AIjpMI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AJmpMR;AIhpMI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AJkpMR;AI/oMI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EHtmEJ,yBAAA;AD0vQJ;AIjpMQ;EAGI,yBAAA;AJmpMZ;AIhpMQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAGA,wBAAA;AJkpMZ;AIhpMY;EACI,kBAAA;EACA,mBAAA;AJkpMhB;AIhpMgB;EACI,MAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AJkpMpB;AI/oMgB;EACI,oBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AJipMpB;AI3oMI;EACI,gBAAA;AJ6oMR;AI1oMY;EACI,gBAAA;EACA,mBAAA;AJ4oMhB;AI1oMgB;EACI,gBAAA;EACA,yBAAA;AJ4oMpB;AI1oMoB;;EAEI,yBAAA;EACA,gBAAA;AJ4oMxB;AIxoMgB;EACI,gBAAA;AJ0oMpB;AIroMgB;EACI,uBL1rEJ;ACi0QhB;AIloMgB;EACI,uBL/rEL;ACm0Qf;AI/nMgB;EACI,wBLpsEJ;ACq0QhB;AI5nMgB;EACI,uBLzsEF;ACu0QlB;AI1nMY;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EH3qEZ,mCAAA;EACA,8BAAA;ADwyQJ;AI3nMgB;EACI,eAAA;AJ6nMpB;AIznMY;EACI,kBAAA;EACA,gBAAA;AJ2nMhB;AIznMgB;EACI,gBAAA;AJ2nMpB;AIvnMY;EACI,gBAAA;AJynMhB;AIpnMI;EACI,UAAA;EACA,SAAA;AJsnMR;AIpnMQ;EACI,gBAAA;EACA,WAAA;AJsnMZ;AIpnMY;EACI,kBAAA;EACA,uBLnvED;EEiBX,yBAAA;AD21QJ;AIpnMgB;EACI,aAAA;AJsnMpB;AIlnMY;EACI,eAAA;AJonMhB;;AIzmMQ;EACI,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;EACA,kBAAA;EHjxER,aAAA;EAEA,eAAA;ADg4QJ;AI9mMY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AJgnMhB;AI7mMY;EACI,SAAA;EACA,kBAAA;EACA,uBL1xED;EK2xEC,kBAAA;EHpvEZ,mCAAA;EACA,8BAAA;ADo2QJ;AI9mMgB;EH7wEZ,yBAAA;ADg4QJ;AI7mMQ;EACI,kCAAA;EACA,aAAA;EACA,aAAA;EACA,0BAAA;AJ+mMZ;AI7mMY;EACI,aAAA;AJ+mMhB;AI7mMgB;EACI,gBAAA;AJ+mMpB;AI5mMgB;EACI,gBAAA;EACA,kBAAA;EACA,uBLpzEL;EEuCX,mCAAA;EACA,8BAAA;AD43QJ;AI5mMgB;EACI,SAAA;EACA,UAAA;AJ8mMpB;AI5mMoB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AJ8mMxB;AI5mMwB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AJ8mM5B;AI3mMwB;EACI,eAAA;AJ6mM5B;AItmMQ;EACI,gBAAA;EACA,oBAAA;AJwmMZ;AItmMY;EACI,kBAAA;AJwmMhB;AIrmMgB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;AJumMpB;AIlmMQ;EACI,gBAAA;AJomMZ;AIjmMQ;EACI,mBAAA;EACA,8BAAA;AJmmMZ;AI/lMY;EACI,0BAAA;AJimMhB;AI/lMgB;EAn4EZ,wBAAA;AJu+QJ;AI7lMY;EACI,cAAA;AJ+lMhB;AIxlMQ;EACI,kCAAA;AJ0lMZ;AIvlMQ;EACI,WAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AJylMZ;AItlMQ;EACI,cAAA;AJwlMZ;AIrlMQ;EACI,kCLr5EG;EKs5EH,8BLt5EG;AC6+Qf;AIplMQ;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;AJslMZ;AIplMY;EACI,gBAAA;AJslMhB;AIhlMY;EACI,6BAAA;EACA,SAAA;AJklMhB;AIhlMgB;EACI,gBAAA;AJklMpB;;AIzkMA;EACI,eAAA;AJ4kMJ;AI1kMI;EHz7EA,aAAA;EAEA,eAAA;EAYA,mBAAA;EG86EI,UAAA;EACA,SAAA;AJklMR;AI/kMI;EACI,gBAAA;AJilMR;AI/kMQ;EACI,iBAAA;AJilMZ;AI7kMY;EACI,UAAA;AJ+kMhB;AI3kMQ;EACI,kCL38EG;EK48EH,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AJ6kMZ;AI3kMY;EACI,SAAA;AJ6kMhB;AIzkMQ;EH/6EJ,mCAAA;EACA,8BAAA;EGg7EQ,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EH38ER,yBAAA;AD0hRJ;AI5kMY;EACI,kBAAA;EACA,gBAAA;EACA,OAAA;EHj9EZ,yBAAA;ADkiRJ;;AI1kMA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AJ6kMJ;;AI1kMA;EACI,eAAA;AJ6kMJ;AI3kMI;EACI,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;AJ6kMR;AI1kMI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AJ4kMR;;AIvkMA;EACI,mBAAA;AJ0kMJ;AIxkMI;EACI,kBAAA;AJ0kMR;AIrkMQ;EACI,yBAAA;AJukMZ;AIjkMQ;EACI,aAAA;EACA,qCAAA;EACA,cAAA;AJmkMZ;AIjkMY;EACI,WAAA;AJmkMhB;AIhkMY;EATJ;IAUQ,0BAAA;EJmkMd;AACF;AIjkMY;EACI,aAAA;EACA,eAAA;AJmkMhB;AIjkMgB;EACI,OAAA;AJmkMpB;AIjkMoB;EAHJ;IAIQ,UAAA;IACA,WAAA;EJokMtB;AACF;AI/jMY;EACI,0BAAA;AJikMhB;AI7jMgB;EACI,0BAAA;AJ+jMpB;AI1jMoB;EACI,aAAA;AJ4jMxB;AItjMoB;EACI,aAAA;AJwjMxB;AIljMoB;EACI,aAAA;AJojMxB;AI9iMoB;EACI,aAAA;AJgjMxB;AI1iMoB;EACI,aAAA;AJ4iMxB;AItiMQ;EACI,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AJwiMZ;AItiMY;EACI,kCAAA;EAEA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AJuiMhB;AIpiMY;EAlBJ;IAmBQ,eAAA;EJuiMd;AACF;AIriMY;EACI,uBLtnFD;EKunFC,kBAAA;AJuiMhB;AIriMgB;;EAEI,cAAA;AJuiMpB;AIliMgB;EACI,qBAAA;EACA,cAAA;AJoiMpB;AI/hMgB;EACI,8BAAA;AJiiMpB;AI7hMoB;EACI,wBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AJ+hMxB;AI1hMY;EACI,eAAA;EACA,gBAAA;AJ4hMhB;AI1hMgB;EAJJ;IAKQ,eAAA;EJ6hMlB;AACF;AI3hMgB;EACI,gBAAA;AJ6hMpB;;AIrhMA;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AJwhMJ;AIthMI;EACI,uBLlrFO;EKmrFP,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AJwhMR;;AIphMA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AJuhMJ;;AInhMI;EACI,sBAAA;EACA,eAAA;AJshMR;AInhMI;EACI,sBAAA;AJqhMR;;AIjhMA;EACI,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AJohMJ;;AIjhMA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AJohMJ;;AIhhMA;EACI,mCAAA;EACA,UAAA;AJmhMJ;;AIhhMA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AJmhMJ;;AIhhMA;EACI,mCAAA;EACA,mBAAA;EACA,UAAA;AJmhMJ;;AIhhMA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AJmhMJ;;AIhhMA;EACI;IACI,UAAA;EJmhMN;EIhhME;IACI,UAAA;EJkhMN;EI/gME;IACI,UAAA;EJihMN;AACF;ADxrRA;EACE,eAAA;AC0rRF;;ADvrRA;EACE,aAAA;EACA,eAAA;AC0rRF;;ADvrRA;EACE,sBAAA;AC0rRF;;ADvrRA;EACE,8BAAA;AC0rRF;;ADvrRA;EACE,gBAAA;AC0rRF;;ADvrRA;EACE,gBAAA;AC0rRF;;ADvrRA;EACE,aAAA;AC0rRF;;ADvrRA;EACE,gBAAA;AC0rRF;;AD5qRE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC+qRJ;AD7qRI;;;;;;EACE,gBAAA;ACorRN;ADhrRE;;EAEE,eA5GO;EA6GP,gBA3GO;AC6xRX;ADhrRI;EALF;;IAMI,eA/GY;ECmyRhB;AACF;ADjrRE;;EAEE,eAlHO;EAmHP,gBAjHO;ACoyRX;ADjrRI;EALF;;IAMI,eArHY;EC0yRhB;AACF;ADlrRE;;EAEE,eAxHO;EAyHP,gBAvHO;AC2yRX;ADlrRI;EALF;;IAMI,eA3HY;ECizRhB;AACF;ADnrRE;;EAEE,eA9HO;EA+HP,gBA7HO;ACkzRX;ADlrRE;;EAEE,eAhIO;EAiIP,gBAhIO;ACozRX;ADjrRE;;EAEE,eAnIO;EAoIP,gBAnIO;ACszRX;AD7qRE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC+qRJ;AD7qRI;EACE,gBAAA;AC+qRN;AD5qRI;EAXF;IAYI,eAAA;EC+qRJ;AACF;AD5qRE;;EAEE,UAAA;EACA,SAAA;AC8qRJ;AD3qRE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC6qRJ;;ADzqRA;EACE,sBAxNQ;ACo4RV;;ADzqRA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC4qRF;AD1qRE;EALF;IAMI,cAAA;EC6qRF;AACF;AD3qRE;EACE,iBA1Ka;ACu1RjB;AD1qRE;EACE,gBApLa;EAqLb,WAAA;AC4qRJ;;ADvqRE;EACE,kBAAA;AC0qRJ;ADvqRE;EACE,iBAAA;ACyqRJ;;ADpqRE;EACE,aAAA;ACuqRJ;;ADnqRA;EACE,kBAAA;ACsqRF;ADpqRE;EACE,mBAAA;ACsqRJ;ADlqRI;EACE,sBAAA;ACoqRN;ADhqRE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACg4RnB;ADhqRI;EACE,sBAAA;ACkqRN;AD/pRI;EAVF;IAWI,eApOoB;ECs4RxB;AACF;AD/pRE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACiqRJ;AD/pRI;EACE,sBAAA;ACiqRN;AD9pRI;EACE,WAAA;ACgqRN;AD7pRI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;AC2/RZ;;AD1pRA;EACE,mBA1PO;ACu5RT;AD3pRE;EAHF;IAII,mBAAA;EC8pRF;AACF;AD5pRE;EACE,mBAAA;AC8pRJ;AD3pRE;EACE,aArQK;ACk6RT;AD3pRI;EAHF;IAII,aAAA;EC8pRJ;AACF;AD5pRI;EACE,aAAA;AC8pRN;;ADzpRA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC4pRF;AD1pRE;EACE,eAAA;AC4pRJ;ADzpRE;EACE,sCAAA;AC2pRJ;ADxpRE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC0pRJ;;AD3oRE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC8oRJ;AD5oRI;EACE,kBAAA;AC8oRN;AD3oRI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC6oRN;;ADxoRA;EACE,8BAAA;AC2oRF;;ADxoRA;EACE,8BAAA;AC2oRF;;ADxoRA;EACE,+BAAA;AC2oRF;;ADxoRA;EACE,8BAAA;AC2oRF;;ADxoRA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC2oRF;ADzoRE;EACE,2BAAA;EACA,mBAAA;AC2oRJ;ADxoRE;EACE,yBAzbiB;EA0bjB,WA1aO;ACojSX;ADvoRE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ACyoRJ;ADtoRE;EACE,yBAjckB;EAkclB,cArciB;AC6kSrB;ADroRE;EACE,yBAvbS;EAwbT,WA1bO;ACikSX;ADroRI;EACE,6BAAA;ACuoRN;;ADloRA;EACE;IACE,uBAAA;ECqoRF;EDloRA;IACE,yBAAA;ECooRF;AACF;ADjoRA;EACE,8BAAA;ACmoRF;;ADhoRA;EACE,8BAAA;ACmoRF;;ADhoRA;EACE,+BAAA;ACmoRF;;ADhoRA;EACE,8BAAA;ACmoRF;;ADhoRA;EACE,qBAAA;ACmoRF;;ADhoRA;EACE,UAAA;ACmoRF;ADjoRE;EACE,qBAAA;ACmoRJ;;AD/nRA;EACE,UAAA;ACkoRF;;AD9nRE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACgoRJ;AD7nRM;EACE,mBAAA;AC+nRR;AD1nRE;EACE,2BAAA;AC4nRJ;ADznRE;EACE,uBAAA;AC2nRJ;ADxnRE;EACE,mBAAA;AC0nRJ;;ADrnRE;EACE,mBAAA;ACwnRJ;ADrnRE;EACE,yBAAA;ACunRJ;ADpnRE;EACE,sBAAA;ACsnRJ;ADnnRE;EACE,uBAAA;ACqnRJ;ADlnRE;EACE,oBAAA;AConRJ;;AChoSA;EACI,oCAAA;ADmoSJ;;AK1sSA;EACI,oBAAA;AL6sSJ;;AK1sSA;EACI,mBAAA;AL6sSJ;;AKzsSI;EACI,YAAA;EACA,kCAAA;EACA,mBAAA;AL4sSR;AK1sSQ;EACI,gBAAA;AL4sSZ;AKxsSI;EACI,YAAA;EACA,WAAA;AL0sSR;AKvsSI;EACI,YAAA;EACA,4BAAA;EACA,WAAA;ALysSR;AKtsSI;EACI,kCNRU;EMSV,gBAAA;ALwsSR;AKrsSI;EACI,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;ALusSR;AKrsSQ;EACI,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;ALusSZ;AKrsSY;EACI,8BN5BA;ACmuShB;AKlsSI;EACI,YAAA;ALosSR;AKjsSI;EACI,uBNnCU;ACsuSlB;AKhsSI;EACI,gBAAA;ALksSR;AK/rSI;EACI,gBAAA;ALisSR;AK9rSI;EACI,eAAA;ALgsSR;AK7rSI;EACI,kBAAA;EACA,mBAAA;EACA,WAAA;AL+rSR;AK5rSI;EACI,eAAA;AL8rSR;AK3rSI;EACI,WAAA;EACA,oBAAA;EACA,aAAA;AL6rSR;AK1rSI;EACI,WAAA;AL4rSR;AKzrSI;EACI,wBAAA;EACA,qBAAA;AL2rSR;AKxrSI;EACI,WAAA;EACA,oBAAA;AL0rSR;AKvrSI;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;ALyrSR;AKtrSI;EAGI,aAAA;ALwrSR;AKrrSI;;EAEI,UAAA;ALurSR;AKprSI;EACI,4BAAA;ALsrSR;AKnrSI;EACI,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;ALqrSR;AKlrSI;EACI,YAAA;ALorSR;AKjrSI;EACI,cAAA;EACA,yBN7GW;EM8GX,gBAAA;EACA,eAAA;EACA,cN5Ga;AC+xSrB;AKhrSI;EACI,yBAAA;EACA,cAAA;ALkrSR;AK/qSI;;EAEI,qBAAA;ALirSR;AK9qSI;;EAEI,UAAA;EACA,qBAAA;ALgrSR;AK7qSI;EACI,mBAAA;AL+qSR;AK5qSI;;EAEI,qBAAA;AL8qSR;AK3qSI;;EAEI,qBAAA;AL6qSR;AK1qSI;;EAEI,6BAAA;AL4qSR;AKzqSI;EACI,WAAA;AL2qSR;AKxqSI;EACI,wBAAA;AL0qSR;AKvqSI;EACI,wBAAA;EACA,kBAAA;ALyqSR;AKtqSI;EACI,gBAAA;ALwqSR;AKrqSI;EACI,cAAA;ALuqSR;AKpqSI;;EAEI,cAAA;EACA,gBAAA;ALsqSR;AKlqSQ;EACI,cAAA;EACA,iBAAA;ALoqSZ;AKjqSQ;EACI,4BAAA;EACA,+BAAA;ALmqSZ;AK/pSY;EACI,0BAAA;EACA,gBAAA;ALiqShB;AK5pSI;EACI,iBAAA;EACA,oBAAA;AL8pSR;AK3pSI;EACI,2BAAA;AL6pSR;AK1pSI;EACI,yBAAA;EACA,4BAAA;AL4pSR;AKzpSI;;;EAGI,2BAAA;EACA,wBAAA;AL2pSR;AKxpSI;EACI,mBN1NW;ACo3SnB;AKvpSI;EACI,mBAAA;EACA,cAAA;ALypSR;AKtpSI;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;ALwpSR;AKrpSI;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBNnPU;EMoPV,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;ALupSR;AKrpSQ;EAlBJ;IAmBQ,UAAA;IACA,WAAA;ELwpSV;AACF;AKrpSI;EACI,mBAAA;ALupSR;AKppSI;EACI,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;ALspSR;AKnpSI;;EAEI,wBAAA;ALqpSR;AKjpSQ;EACI,qBAAA;ALmpSZ;AK/oSI;EACI,iBAAA;ALipSR;AK9oSI;EACI,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;ALgpSR;AK9oSQ;EANJ;IAOQ,kBAAA;IACA,MAAA;IACA,QAAA;IACA,mBAAA;ELipSV;AACF;AK9oSI;EACI,eAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;ALgpSR;AK9oSQ;EANJ;IAOQ,kBAAA;IACA,MAAA;IACA,WAAA;IACA,mBAAA;ELipSV;AACF;AK7oSI;EJnUA,aAAA;EAEA,eAAA;EAMA,uBAAA;EI8TI,mBAAA;ALqpSR;AKnpSQ;EALJ;IAMQ,mBAAA;ELspSV;AACF;AKppSQ;EACI,mBAAA;ALspSZ;AKlpSoB;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;ALopSxB;AKlpSwB;EANJ;IAOQ,kBAAA;IACA,eAAA;ELqpS1B;AACF;AKnpSwB;EAXJ;IAYQ,YAAA;IACA,eAAA;ELspS1B;AACF;AKlpSwB;EACI,iCAAA;EACA,qCAAA;EACA,uCAAA;EACA,wCAAA;ALopS5B;AK7oSQ;EACI,gBAAA;AL+oSZ;AK7oSY;EACI,OAAA;EACA,kBAAA;AL+oShB;AK7oSgB;EAJJ;IAKQ,UAAA;IACA,WAAA;ELgpSlB;AACF;AK9oSgB;EACI,WAAA;EACA,OAAA;ALgpSpB;AK9oSoB;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;ALgpSxB;AK1oSQ;EACI,gBAAA;AL4oSZ;AK1oSY;EAHJ;IAIQ,qBAAA;EL6oSd;AACF;AK3oSY;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AL6oShB;AK3oSgB;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AL6oSpB;AK1oSoB;EACI,yBAAA;AL4oSxB;AKzoSoB;EACI,iBAAA;AL2oSxB;AKzoSwB;EAHJ;IAIQ,eAAA;EL4oS1B;AACF;AKzoSoB;EA1BJ;IA2BQ,WAAA;IACA,YAAA;IACA,aAAA;EL4oStB;AACF;AK1oSoB;EACI,aAAA;AL4oSxB;AKzoS4B;EACI,aAAA;AL2oShC;AKxoS4B;EACI,aAAA;AL0oShC;AKpoSgC;EACI,aAAA;ALsoSpC;AKnoSgC;EACI,aAAA;ALqoSpC;AK1nSI;EACI,kBAAA;AL4nSR;AK1nSQ;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AL4nSZ;AK1nSY;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AL4nShB;AKtnSI;EACI,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ALwnSR;AKtnSQ;EAPJ;IAQQ,kBAAA;ELynSV;AACF;AKvnSQ;EACI,kCN/eM;ACwmTlB;AKvnSY;EACI,WAAA;ALynShB;AKrnSQ;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EJpdR,mCAAA;EACA,8BAAA;EIqdQ,aAAA;EACA,eAAA;EACA,mBAAA;ALwnSZ;AKtnSY;EATJ;IAUQ,eAAA;ELynSd;AACF;AKvnSY;EAbJ;IAcQ,eAAA;EL0nSd;AACF;AKxnSY;EACI,kBAAA;AL0nShB;AKtnSY;EACI,WAAA;EACA,cAAA;ALwnShB;AKtnSgB;EAJJ;IAKQ,WAAA;IACA,eAAA;ELynSlB;AACF;AKrnSQ;EJ5hBJ,aAAA;EAEA,eAAA;EAYA,mBAAA;EIihBQ,eAAA;AL6nSZ;AKvnSoB;EACI,qBAAA;ALynSxB;AKvnSwB;EAHJ;IAIQ,OAAA;IACA,sBAAA;EL0nS1B;AACF;AKrnSY;EACI,eAAA;EACA,qBAAA;ALunShB;AKrnSgB;EACI,UAAA;ALunSpB;AKrnSoB;EAHJ;IAIQ,OAAA;IACA,kBAAA;ELwnStB;AACF;AKrnSgB;EACI,UAAA;ALunSpB;AKrnSoB;EAHJ;IAIQ,YAAA;ELwnStB;AACF;AKrnSgB;EACI,UAAA;EACA,iBAAA;EACA,iBAAA;ALunSpB;AKrnSoB;EALJ;IAMQ,WAAA;ELwnStB;AACF;AKtnSoB;EACI,eAAA;EACA,eAAA;ALwnSxB;AKrnSoB;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;ALunSxB;AKrnSwB;EANJ;IAOQ,UAAA;IACA,QAAA;ELwnS1B;AACF;AKpnSgB;EJhmBZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADgtTJ;AK1nSoB;EACI,kBAAA;AL4nSxB;AKxnSgB;EJzmBZ,aAAA;EAEA,eAAA;EAMA,uBAAA;ADmuTJ;AK9nSoB;EJ7mBhB,aAAA;EAEA,eAAA;EI6mBoB,SAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;ALooSxB;AK/nSoC;EACI,uBAAA;ALioSxC;AK7nSwC;EADJ;IAEQ,WAAA;ELgoS1C;AACF;AKznSoC;EACI,sBAAA;AL2nSxC;AKvnSwC;EADJ;IAEQ,YAAA;EL0nS1C;AACF;AKrnS4B;EACI,iBAAA;ALunShC;AKnnSgC;EACI,kBAAA;ALqnSpC;AKhnSgC;EACI,uBNxpBlB;EMypBkB,kCAAA;ALknSpC;AKhnSoC;EACI,uBN5pBtB;EM6pBsB,yBAAA;ALknSxC;AKhnSwC;EACI,yBAAA;EACA,WAAA;ALknS5C;AK3mSgC;EACI,YAAA;EACA,kCAAA;EACA,uBN3qBlB;ACwxTlB;AK3mSoC;EACI,uBN9qBtB;EM+qBsB,yBAAA;AL6mSxC;AK3mSwC;EACI,yBAAA;EACA,WAAA;AL6mS5C;AKvmS4B;EACI,kBAAA;EACA,wBN5rBhB;EM6rBgB,eAAA;EACA,iBAAA;EJxpB5B,mCAAA;EACA,8BAAA;EIypB4B,qBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EJnrB5B,yBAAA;EIurB4B,gBAAA;AL4mShC;AK1mSgC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AL4mSpC;AK1mSoC;EACI,sBN9sBtB;AC0zTlB;AKxmSgC;EAzBJ;IA0BQ,gBAAA;IACA,eAAA;EL2mSlC;AACF;AKzmSgC;EACI,aAAA;EACA,gBAAA;AL2mSpC;AKvmSoC;EADJ;IAEQ,aAAA;EL0mStC;AACF;AKvmSgC;EACI,aAAA;ALymSpC;AKvmSoC;EAHJ;IAIQ,qBAAA;EL0mStC;AACF;AKvmSgC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCNjvBlB;EMkvBkB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;ALymSpC;AKvmSoC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EL0mStC;AACF;AKvmSgC;EACI,uBNnwBlB;EMowBkB,UAAA;ALymSpC;AKtmSgC;EACI,uBNxwBlB;EMywBkB,yBAAA;EACA,UAAA;ALwmSpC;AKhmSY;EACI,kCAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EJjvBZ,mCAAA;EACA,8BAAA;EIkvBY,uBNxxBE;EMyxBF,eAAA;EACA,gBAAA;EJ3wBZ,yBAAA;EI6wBY,eAAA;ALqmShB;AKnmSgB;EACI,kCN/xBF;EMgyBE,WAAA;ALqmSpB;AKlmSgB;EACI,aAAA;ALomSpB;AKhmSY;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;ALkmShB;AKhmSgB;EACI,uBN/yBF;ACi5TlB;AK/lSgB;EACI,mBAAA;ALimSpB;AK9lSgB;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBN1zBF;EM2zBE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;ALgmSpB;AK3lSQ;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,uBN90BM;EEqCd,mCAAA;EACA,8BAAA;EA3CA,aAAA;EAEA,eAAA;EAYA,mBAAA;AD46TJ;AKlmSY;EATJ;IAUQ,eAAA;ELqmSd;AACF;AKnmSY;EAbJ;IAcQ,eAAA;IACA,sBAAA;ELsmSd;AACF;AKpmSY;EACI,iBAAA;ALsmShB;AKjmSgB;EACI,uBNn2BF;ACs8TlB;AK7lSgB;EAFJ;IAGQ,WAAA;IACA,gBAAA;ELgmSlB;AACF;AK9lSgB;EACI,0BAAA;EACA,8BAAA;EACA,6BAAA;ALgmSpB;AK9lSoB;EALJ;IAMQ,0BAAA;ELimStB;AACF;AK7lSY;EACI,eAAA;EACA,gBAAA;AL+lShB;AK7lSgB;EACI,iBAAA;AL+lSpB;AK7lSoB;EACI,cAAA;EACA,gBAAA;AL+lSxB;AK3lSgB;EACI,iBAAA;AL6lSpB;AKzlSY;EACI,iBAAA;EACA,uBN74BE;ACw+TlB;AKxlSY;EAGI,aAAA;AL0lShB;AKxlSgB;EACI,mBAAA;AL0lSpB;AKtlSoB;EACI,cAAA;ALwlSxB;AKllSQ;EACI,kBAAA;EACA,qBAAA;ALolSZ;AKllSY;EACI,mBAAA;ALolShB;AKjlSY;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBN76BE;EM86BF,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;ALmlShB;AK9kSI;EACI,WAAA;EACA,kCN97BU;EM+7BV,8BN/7BU;EMg8BV,mBAAA;EACA,aAAA;EACA,kBAAA;ALglSR;AK9kSQ;EACI,eAAA;EACA,gBAAA;EACA,SAAA;ALglSZ;AK9kSY;EACI,WAAA;EACA,cAAA;ALglShB;AK3kSI;EAsGI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,yCAAA;ALw+RR;AKhlSQ;EACI,gBAAA;ALklSZ;AKhlSY;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;ALklShB;AK/kSY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;ALilShB;AK/kSgB;EACI,kBAAA;ALilSpB;AK7kSY;EACI,gBAAA;AL+kShB;AK3kSQ;EACI,gBAAA;AL6kSZ;AK1kSQ;EACI,SAAA;AL4kSZ;AK1kSY;EACI,6BAAA;EACA,4BAAA;AL4kShB;AK1kSgB;EACI,kCNx/BF;ACokUlB;AKzkSwB;EACI,WAAA;AL2kS5B;AKrkSgC;EACI,kBAAA;EACA,sBAAA;ALukSpC;AKrkSoC;EACI,uBNvgCtB;EMwgCsB,sBAAA;ALukSxC;AKpkSoC;EACI,qBAAA;ALskSxC;AK/jSoB;EACI,WAAA;ALikSxB;AK5jSoB;EACI,eAAA;EACA,WAAA;AL8jSxB;AK1jSwB;EACI,cAAA;AL4jS5B;AKvjSgB;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;ALyjSpB;AKtjSwB;EACI,kBAAA;EACA,UAAA;EACA,QAAA;ALwjS5B;AK5iSQ;EACI,kBAAA;AL8iSZ;AK5iSY;EAHJ;IAIQ,kBAAA;EL+iSd;AACF;AK3iSQ;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AL6iSZ;AK3iSY;EACI,iBAAA;AL6iShB;AK1iSY;EACI,cAAA;AL4iShB;AK1iSgB;EACI,sBAAA;AL4iSpB;AKtiSgB;EACI,eAAA;EACA,gBAAA;ALwiSpB;AKtiSoB;EAJJ;IAKQ,eAAA;ELyiStB;AACF;AKviSoB;EACI,gBAAA;ALyiSxB;AKriSgB;EJ3mCZ,aAAA;EAEA,eAAA;EI2mCgB,eAAA;AL2iSpB;AKziSoB;EACI,UAAA;EACA,eAAA;AL2iSxB;AKziSwB;EAJJ;IAKQ,WAAA;EL4iS1B;AACF;AK1iSwB;EACI,kBAAA;EACA,kBAAA;AL4iS5B;AK1iS4B;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AL4iShC;AKriSY;EACI,mBAAA;EACA,eAAA;ALuiShB;AKriSgB;EACI,eAAA;ALuiSpB;AKpiSgB;EACI,gBAAA;ALsiSpB;AKniSgB;EACI,cAAA;EACA,eAAA;ALqiSpB;AKniSoB;EACI,iBAAA;ALqiSxB;AKhiSY;EACI,UAAA;EACA,SAAA;EAGA,aAAA;EAEA,eAAA;ALkiShB;AKhiSgB;EACI,gBAAA;EACA,kBAAA;ALkiSpB;AKhiSoB;EACI,iBAAA;ALkiSxB;AK/hSoB;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EAGA,aAAA;EAEA,eAAA;EAGA,yBAAA;ALiiSxB;AK/hSwB;EAjBJ;IAkBQ,eAAA;ELkiS1B;AACF;AKhiSwB;EACI,kBAAA;EACA,+BAAA;EAGA,aAAA;EAGA,mBAAA;ALkiS5B;AK/hSwB;EACI,kBAAA;ALiiS5B;AK9hSwB;EACI,yBAAA;ALgiS5B;AK5hSoB;EACI,cAAA;AL8hSxB;AK3hSoB;EACI,SAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AL6hSxB;AK3hSwB;EACI,gBAAA;AL6hS5B;AK3hS4B;EACI,6BAAA;AL6hShC;AK1hS4B;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EAGA,yBAAA;AL4hShC;AK1hSgC;EACI,yBAAA;AL4hSpC;AKlhSY;EACI,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ALohShB;AKlhSgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;ALohSpB;AKjhSgB;EACI,sBAAA;ALmhSpB;AK/gSY;EACI,UAAA;EACA,SAAA;EACA,aAAA;ALihShB;AK/gSgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;ALihSpB;AK/gSoB;EACI,kBAAA;EACA,uBNxyCN;EMyyCM,UAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;ALihSxB;AK5gSoB;EACI,8BNrzCN;ACm0UlB;AK3gSoB;EACI,UAAA;AL6gSxB;AKvgSQ;EACI,aAAA;ALygSZ;AKvgSY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ALygShB;AKvgSgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;ALygSpB;AKtgSgB;EACI,sBAAA;ALwgSpB;AKpgSY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;ALsgShB;AKpgSgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;ALsgSpB;AKpgSoB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;ALsgSxB;AKjgSoB;EACI,qBAAA;EACA,yBAAA;ALmgSxB;AKhgSoB;EACI,UAAA;ALkgSxB;AK5/RQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;AL8/RZ;AK5/RY;EACI,SAAA;EJ94CZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADs4UJ;AKlgSgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EJl4ChB,yBAAA;ADy4UJ;AKpgSoB;EACI,iBAAA;ALsgSxB;AKngSoB;EACI,iBAAA;EACA,gBAAA;ALqgSxB;AKjgSgB;EACI,iBAAA;ALmgSpB;AKhgSgB;EACI,kCNn6CF;EMo6CE,8BNp6CF;EMq6CE,WAAA;ALkgSpB;AKhgSoB;EACI,kCNx6CN;EMy6CM,8BNz6CN;AC26UlB;AK9/RgB;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;ALggSpB;AK9/RoB;EACI,yBAAA;EACA,qBAAA;ALggSxB;AK3/RoB;EACI,SAAA;AL6/RxB;AKz/RgB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EJt7ChB,yBAAA;ADo7UJ;AK3/RoB;EACI,kBAAA;EACA,UAAA;EJ37CpB,yBAAA;AD27UJ;AK5/RoB;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AL8/RxB;AK5/RwB;EACI,kBAAA;EACA,OAAA;AL8/R5B;AK3/RwB;EACI,iBAAA;AL6/R5B;AKz/RoB;EACI,cAAA;EACA,eAAA;EJj9CpB,yBAAA;AD+8UJ;AKv/RQ;EACI,gBAAA;EACA,kBAAA;EACA,6BAAA;ALy/RZ;AKt/RY;EANJ;IAOQ,kBAAA;ELy/Rd;AACF;AKv/RY;EACI,cAAA;EJv/CZ,aAAA;EAEA,eAAA;EAYA,mBAAA;AD0+UJ;AK7/RgB;EACI,cAAA;AL+/RpB;AK7/RoB;EAHJ;IAIQ,WAAA;IACA,kBAAA;ELggStB;EK9/RsB;IACI,gBAAA;ELggS1B;AACF;AK5/RwB;EACI,iBAAA;AL8/R5B;AKz/RgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AL2/RpB;AKz/RoB;EATJ;IAUQ,eAAA;EL4/RtB;AACF;AK1/RoB;;EAEI,iBAAA;EACA,gBAAA;AL4/RxB;AKz/RoB;EACI,mCN9hDR;EM+hDQ,WAAA;AL2/RxB;AKx/RoB;EACI,kCNriDR;EMsiDQ,WAAA;AL0/RxB;AKv/RoB;EACI,kCNviDN;EMwiDM,WAAA;EACA,8BNziDN;EM0iDM,gBAAA;ALy/RxB;AKt/RoB;EACI,yBAAA;EACA,WAAA;ALw/RxB;AKr/RoB;EACI,UAAA;EACA,6BAAA;EACA,cAAA;EACA,SAAA;EACA,wEN/kDX;EMglDW,eAAA;EACA,gBAAA;EACA,cN/iDH;ACsiVrB;AKr/RwB;EACI,WAAA;ALu/R5B;AKn/RoB;EACI,yBAAA;EACA,WAAA;ALq/RxB;AKl/RoB;EACI,cAAA;ALo/RxB;AKj/RoB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EJlkDpB,yBAAA;ADwjVJ;AKn/RwB;EACI,eAAA;EACA,cN3kDP;ACgkVrB;AKl/RwB;EACI,kBAAA;EACA,UAAA;EJ5kDxB,yBAAA;ADmkVJ;AKn/RwB;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;ALq/R5B;AKn/R4B;EANJ;IAOQ,kBAAA;IACA,iBAAA;ELs/R9B;AACF;AKp/R4B;EACI,kBAAA;EACA,OAAA;ALs/RhC;AKn/R4B;EACI,iBAAA;ALq/RhC;AKj/RwB;EA1CJ;IA2CQ,yBAAA;IACA,cAAA;IACA,mBAAA;IACA,kBAAA;ELo/R1B;AACF;AKn/R4B;EAhDR;IAiDY,kBAAA;IACA,iBAAA;ELs/R9B;AACF;AK//RwB;EAWI;IACI,kBAAA;IACA,OAAA;ELu/R9B;EKp/R0B;IACI,4BAAA;ELs/R9B;AACF;AKn/RwB;EACI,cAAA;EACA,eAAA;EJ5nDxB,yBAAA;ADonVJ;AK/+RQ;EACI,uBAAA;EACA,kCAAA;EACA,mBAAA;ALi/RZ;AK/+RY;EACI,uBN7pDA;AC8oVhB;AK7+RQ;EACI,uBNlqDI;ACipVhB;AK5+RQ;EACI,eAAA;AL8+RZ;AK5+RY;EACI,gBAAA;AL8+RhB;AK1+RQ;EACI,kBAAA;EACA,gBAAA;AL4+RZ;AK1+RY;EACI,iBAAA;AL4+RhB;AKz+RY;;EAEI,WAAA;EACA,eAAA;EACA,kBAAA;AL2+RhB;AKz+RgB;;;;EAEI,YAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AL6+RpB;AK3+RoB;;;;EACI,wBAAA;ALg/RxB;AK3+RY;EACI,eAAA;EJ5sDZ,aAAA;EAEA,eAAA;AD4rVJ;AK/+RgB;EACI,eAAA;EACA,WAAA;EACA,mBAAA;ALi/RpB;AK/+RoB;EACI,gBAAA;ALi/RxB;AK9+RoB;EACI,UAAA;ALg/RxB;AK7+RoB;EACI,kBAAA;AL++RxB;AK3+RgB;EAGI,gBAAA;EACA,iFAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;AL6+RpB;AK1+RgB;EACI,WAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AL4+RpB;AKz+RgB;;EJpvDZ,aAAA;EAEA,eAAA;ADmuVJ;AK7+RoB;;EACI,WAAA;EACA,mBAAA;EJ1vDpB,aAAA;EAEA,eAAA;EAYA,mBAAA;ADouVJ;AKn/RoB;;EACI,WAAA;EACA,kBAAA;EJjwDpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EANA,uBAAA;EI6vDoB,eAAA;EACA,0BAAA;AL8/RxB;AK5/RwB;;EACI,wBAAA;AL+/R5B;AK5/RwB;;EACI,gBAAA;EACA,gBAAA;AL+/R5B;AK3/RoB;;EACI,YAAA;EACA,mBAAA;AL8/RxB;AK3/RoB;;EACI,yBAAA;AL8/RxB;AK5/RwB;;EAEI,mBAAA;AL8/R5B;AK1/R4B;;EACI,mBAAA;AL6/RhC;AKx/RoB;;EACI,WAAA;AL2/RxB;AKp/RgB;EACI,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EJhyDhB,yBAAA;ADyxVJ;AKt/RoB;EACI,kCNnzDN;EMozDM,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;ALw/RxB;AKl/RQ;EACI,UAAA;EACA,qBAAA;EACA,kBAAA;ALo/RZ;AKl/RY;EACI,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;ALo/RhB;AKh/RQ;EAQI,oBAAA;EJ10DR,mBAAA;EI40DQ,WAAA;EACA,gBAAA;EACA,SAAA;AL++RZ;AK1/RY;EACI,kBAAA;EACA,SAAA;AL4/RhB;AKh/RY;EACI,kBAAA;EACA,gCAAA;ALk/RhB;AKh/RgB;EAEI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;ALi/RpB;AK9+RgB;EACI,WAAA;EACA,UAAA;ALg/RpB;AK5+RY;EACI,YAAA;EACA,kBAAA;AL8+RhB;AK3+RY;;EAEI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AL6+RhB;AK1+RY;EACI,WAAA;EACA,SAAA;AL4+RhB;AKz+RY;EACI,SAAA;AL2+RhB;AKx+RY;EACI,UAAA;EACA,iBAAA;AL0+RhB;AKt+RQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EAGA,2BAAA;EJ/4DR,yBAAA;AD03VJ;AKx+RY;EACI,kCNl6DE;EMm6DF,8BNn6DE;EMo6DF,WAAA;AL0+RhB;AKv+RY;EACI,eAAA;ALy+RhB;AKr+RQ;EAGI,aAAA;EAEA,eAAA;EACA,sBAAA;ALu+RZ;AKp+RgB;EACI,WAAA;ALs+RpB;AKl+RY;EACI,kBAAA;EACA,kBAAA;ALo+RhB;AKl+RgB;EACI,0BAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ALo+RpB;AK99RI;EACI,aAAA;EACA,iBAAA;EAGA,aAAA;EAEA,eAAA;ALg+RR;AK99RQ;EACI,UAAA;EACA,mBAAA;ALg+RZ;AK59RI;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;EACA,mBAAA;AL89RR;AK59RQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AL89RZ;AK59RY;EACI,WAAA;EACA,kBAAA;EAGA,aAAA;EAEA,eAAA;AL89RhB;AK59RgB;EACI,kBAAA;EACA,WAAA;AL89RpB;AK59RoB;EACI,uBAAA;EACA,8BNv/DN;EMw/DM,YAAA;EACA,UAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AL89RxB;AK19RgB;EACI,wBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCAAA;AL49RpB;AKt9RI;EACI,YAAA;EACA,2BAAA;EACA,mBAAA;EAGA,aAAA;EAEA,eAAA;ALw9RR;AKt9RQ;EACI,aAAA;ALw9RZ;AKr9RQ;EACI,iCAAA;EACA,kCAAA;ALu9RZ;AKr9RY;EACI,YAAA;ALu9RhB;AKn9RQ;EACI,kCAAA;ALq9RZ;AKn9RY;EACI,YAAA;ALq9RhB;AKj9RQ;EACI,iCAAA;ALm9RZ;AKj9RY;EACI,YAAA;ALm9RhB;AK98RY;EACI,aAAA;ALg9RhB;AK58RQ;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AL88RZ;AK58RY;EACI,WAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EAGA,aAAA;EAGA,uBAAA;EAGA,mBAAA;AL88RhB;AK38RY;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AL68RhB;AKz8RQ;EACI,cAAA;AL28RZ;AKx8RQ;EACI,WAAA;AL08RZ;AKt8RY;EACI,eAAA;EACA,cAAA;EACA,eAAA;ALw8RhB;AKt8RgB;EACI,kBAAA;ALw8RpB;AKn8RQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;ALq8RZ;AKn8RY;EACI,qBAAA;EACA,eAAA;EACA,cAAA;ALq8RhB;AKl8RY;EACI,qBAAA;EACA,wBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;ALo8RhB;AK/7RY;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;ALi8RhB;AK/7RgB;EACI,gBAAA;ALi8RpB;AK97RgB;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EAGA,2BAAA;ALg8RpB;AK57RY;EACI,qBAAA;EACA,eAAA;EACA,cAAA;AL87RhB;AK37RY;;EAEI,YAAA;EACA,kBAAA;EACA,aAAA;AL67RhB;AK17RY;EACI,qBAAA;EACA,wBAAA;AL47RhB;AKv7RI;EACI,cAAA;ALy7RR;AKt7RI;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;ALw7RR;AKt7RQ;EACI,WAAA;ALw7RZ;AKp7RI;EACI,yBAAA;ALs7RR;AKl7RQ;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EAGA,yBAAA;ALo7RZ;AKl7RY;EACI,YAAA;ALo7RhB;AKj7RY;EACI,gBAAA;ALm7RhB;AKh7RY;EACI,kCNluEA;ACopWhB;AK/6RY;EACI,kCNruED;ACspWf;AK96RY;EACI,kCNvuEE;ACupWlB;AK36RI;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;AL66RR;AK36RQ;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AL66RZ;AKz6RY;EACI,mBAAA;AL26RhB;AKr6RQ;EACI,eAAA;ALu6RZ;AKp6RQ;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;ALs6RZ;AKp6RY;EACI,cAAA;ALs6RhB;AKn6RY;EACI,gBAAA;ALq6RhB;AKl6RY;EACI,iBAAA;ALo6RhB;;AK95RA;EACI,6BAAA;EACA,qBAAA;ALi6RJ;;AK95RA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,wCAAA;EJ9xEA,yBAAA;EIgyEA,gBAAA;ALm6RJ;AKj6RI;EACI,QAAA;ALm6RR;AKh6RI;EJ1zEA,aAAA;EAEA,eAAA;EI0zEI,UAAA;EACA,gBAAA;ALs6RR;AKp6RQ;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;ALs6RZ;AKp6RY;EACI,WAAA;EACA,uBNl0EE;EMm0EF,eAAA;EACA,iBAAA;EJ/xEZ,mCAAA;EACA,8BAAA;EIgyEY,qBAAA;EACA,YAAA;EACA,SAAA;EACA,kCAAA;EACA,6BAAA;EACA,yBAAA;EJhzEZ,gBAAA;AD0tWJ;AKv6RgB;EACI,aAAA;ALy6RpB;AKt6RgB;EACI,YAAA;ALw6RpB;AKt6RoB;EACI,UAAA;ALw6RxB;AKp6RgB;EACI,UAAA;ALs6RpB;AKn6RgB;EACI,kBAAA;EACA,UAAA;ALq6RpB;AKj6RY;EACI,iBAAA;ALm6RhB;AK/5RgB;EACI,0BAAA;ALi6RpB;AK55RgB;EACI,0BAAA;AL85RpB;AKx5RI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AL05RR;AKv5RI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;ALy5RR;AKt5RI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EJ33EJ,yBAAA;ADsxWJ;AKx5RQ;EAGI,yBAAA;AL05RZ;AKv5RQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAGA,wBAAA;ALy5RZ;AKv5RY;EACI,kBAAA;EACA,mBAAA;ALy5RhB;AKv5RgB;EACI,MAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;ALy5RpB;AKt5RgB;EACI,oBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;ALw5RpB;AKl5RI;EACI,gBAAA;ALo5RR;AKj5RY;EACI,gBAAA;EACA,mBAAA;ALm5RhB;AKj5RgB;EACI,gBAAA;EACA,yBAAA;ALm5RpB;AKj5RoB;;EAEI,yBAAA;EACA,gBAAA;ALm5RxB;AK/4RgB;EACI,gBAAA;ALi5RpB;AK54RgB;EACI,uBN/8EJ;AC61WhB;AKz4RgB;EACI,uBNp9EL;AC+1Wf;AKt4RgB;EACI,wBNz9EJ;ACi2WhB;AKn4RgB;EACI,uBN99EF;ACm2WlB;AKj4RY;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EJh8EZ,mCAAA;EACA,8BAAA;ADo0WJ;AKl4RgB;EACI,eAAA;ALo4RpB;AKh4RY;EACI,kBAAA;EACA,gBAAA;ALk4RhB;AKh4RgB;EACI,gBAAA;ALk4RpB;AK93RY;EACI,gBAAA;ALg4RhB;AK33RI;EACI,UAAA;EACA,SAAA;AL63RR;AK33RQ;EACI,gBAAA;EACA,WAAA;AL63RZ;AK33RY;EACI,kBAAA;EACA,uBNtgFE;EEed,yBAAA;ADu3WJ;AK33RgB;EACI,aAAA;AL63RpB;AKz3RY;EACI,eAAA;AL23RhB;;AKh3RQ;EACI,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;EACA,kBAAA;EJtiFR,aAAA;EAEA,eAAA;AD45WJ;AKr3RY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;ALu3RhB;AKp3RY;EACI,SAAA;EACA,kBAAA;EACA,uBN7iFE;EM8iFF,kBAAA;EJzgFZ,mCAAA;EACA,8BAAA;ADg4WJ;AKr3RgB;EJliFZ,yBAAA;AD45WJ;AKp3RQ;EACI,kCAAA;EACA,aAAA;EACA,aAAA;EACA,0BAAA;ALs3RZ;AKp3RY;EACI,aAAA;ALs3RhB;AKp3RgB;EACI,gBAAA;ALs3RpB;AKn3RgB;EACI,gBAAA;EACA,kBAAA;EACA,uBNvkFF;EEqCd,mCAAA;EACA,8BAAA;ADw5WJ;AKn3RgB;EACI,SAAA;EACA,UAAA;ALq3RpB;AKn3RoB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ALq3RxB;AKn3RwB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;ALq3R5B;AKl3RwB;EACI,eAAA;ALo3R5B;AK52RQ;EACI,gBAAA;AL82RZ;AK12RY;EACI,0BAAA;AL42RhB;AK12RgB;EJjlFZ,wBAAA;ADg8WJ;AKx2RY;EACI,cAAA;AL02RhB;;AKj2RA;EACI,eAAA;ALo2RJ;AKl2RI;EJ3oFA,aAAA;EAEA,eAAA;EAYA,mBAAA;EIgoFI,UAAA;EACA,SAAA;AL02RR;AKv2RI;EACI,gBAAA;ALy2RR;AKv2RQ;EACI,iBAAA;ALy2RZ;AKt2RQ;EACI,iBAAA;ALw2RZ;AKt2RY;EJlnFR,mCAAA;EACA,8BAAA;EImnFY,eAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EJ7oFZ,yBAAA;ADy/WJ;AKz2RgB;EACI,UAAA;AL22RpB;AKr2RY;EACI,UAAA;ALu2RhB;AKn2RQ;EACI,kCN5qFM;EM6qFN,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;ALq2RZ;AKn2RY;EACI,SAAA;ALq2RhB;AKj2RQ;EJlpFJ,mCAAA;EACA,8BAAA;EImpFQ,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EJ9qFR,yBAAA;ADqhXJ;AKp2RY;EACI,kBAAA;EACA,gBAAA;EACA,OAAA;EJprFZ,yBAAA;AD6hXJ;;AKj2RA;EACI,gBAAA;ALo2RJ;AKh2RQ;EAFJ;IAGQ,YAAA;IACA,eAAA;ELm2RV;AACF;AK/1RQ;EACI,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cNptFS;EEIjB,yBAAA;ADojXJ;AKj2RY;EACI,kCNnuFE;EMouFF,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;ALm2RhB;;AK51RA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AL+1RJ;;AK51RA;EACI,eAAA;AL+1RJ;AK71RI;EACI,iBAAA;EAEA,sBAAA;EACA,qBAAA;EACA,cAAA;AL81RR;AK31RI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AL61RR;;AKv1RA;EACI,mBAAA;AL01RJ;AKx1RI;EACI,gBAAA;AL01RR;AKp1RQ;EACI,aAAA;EACA,qCAAA;EACA,cAAA;ALs1RZ;AKp1RY;EALJ;IAMQ,0BAAA;ELu1Rd;AACF;AKr1RY;EACI,aAAA;EACA,eAAA;ALu1RhB;AKr1RgB;EACI,OAAA;ALu1RpB;AKr1RoB;EAHJ;IAIQ,UAAA;IACA,WAAA;ELw1RtB;AACF;AKn1RY;EACI,0BAAA;ALq1RhB;AKj1RgB;EACI,0BAAA;ALm1RpB;AK90RoB;EACI,aAAA;ALg1RxB;AK10RoB;EACI,aAAA;AL40RxB;AKt0RoB;EACI,aAAA;ALw0RxB;AKl0RoB;EACI,aAAA;ALo0RxB;AK9zRoB;EACI,aAAA;ALg0RxB;AK1zRQ;EACI,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AL4zRZ;AKzzRY;EARJ;IASQ,eAAA;EL4zRd;AACF;AK1zRY;EACI,cAAA;EACA,kBAAA;AL4zRhB;AK1zRgB;;EAEI,cAAA;AL4zRpB;AKxzRY;EACI,eAAA;EACA,gBAAA;AL0zRhB;AKxzRgB;EAJJ;IAKQ,eAAA;EL2zRlB;AACF;AKzzRgB;EACI,gBAAA;AL2zRpB;;AKnzRA;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;ALszRJ;;AKjzRI;EACI,sBAAA;EACA,kBAAA;ALozRR;AKjzRI;EACI,sBAAA;ALmzRR;;AK/yRA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;ALkzRJ;;AK/yRA;EACI,sBAAA;EACA,kBAAA;ALkzRJ;;AK/yRA;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;ALkzRJ;AKhzRI;EACI,uBNh8FU;EMi8FV,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;ALkzRR;;AK9yRA;EACI,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;ALizRJ;;AK9yRA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;ALizRJ;;AK7yRA;EACI,mCAAA;EACA,UAAA;ALgzRJ;;AK7yRA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;ALgzRJ;;AK7yRA;EACI,mCAAA;EACA,mBAAA;EACA,UAAA;ALgzRJ;;AK7yRA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;ALgzRJ;;AK7yRA;EACI;IACI,UAAA;ELgzRN;EK7yRE;IACI,UAAA;EL+yRN;EK5yRE;IACI,UAAA;EL8yRN;AACF;AKxyRI;EACI,iBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AL0yRR;;AKpyRI;EACI,aAAA;ALuyRR;;AKnyRA;EACI,aAAA;ALsyRJ;;AAnzXA;EACI,yCAAA;EACH,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAszXD;;AApzXA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAuzXD;;AAnzXA;;;;;;;EAAA;AAQA;EACC,mCAAA;EACA,UAAA;AAszXD;;AApzXA;EACC,mCAAA;EACA,qBAAA;EACA,UAAA;AAuzXD;;AArzXA;EACC,mCAAA;EACA,mBAAA;EACA,UAAA;AAwzXD;;AAtzXA;EACC,mCAAA;EACA,qBAAA;EACA,UAAA;AAyzXD;;AAvzXA;EACC;IACC,UAAA;EA0zXA;EAxzXD;IACC,UAAA;EA0zXA;EAxzXD;IACC,UAAA;EA0zXA;AACF;AArzXA;EACI;IACI,wBAAA;EAuzXN;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../app/components/challenges/clarify-challenge/clarify-challenge.component.scss';\n@import './../../../../app/components/challenges/develop-challenge/develop-challenge.component.scss';\n@import './../../../../app/components/challenges/ideate-challenge/ideate-challenge.component.scss';\n@import './../../../../app/components/challenges/implement-challenge/implement-challenge.component.scss';\n// .loader-container {\n//     position: absolute;\n//     left: 0;\n//     right: 0;\n//     text-align: center;\n//     top: 0;\n//     bottom: 0;\n//     background: rgba(236,236,236,.9);\n//     display: -webkit-box;\n//     display: -ms-flexbox;\n//     display: flex;\n//     -webkit-box-pack: center;\n//         -ms-flex-pack: center;\n//             justify-content: center;\n//     -webkit-box-align: center;\n//         -ms-flex-align: center;\n//             align-items: center;\n//     z-index: 9999999999;\n//     height: 100vh;\n//     margin: 0 auto;\n// }\n\n// #clarify-content, #ideate-content, #develop-content, #implement-content{\n//     margin: 10px;\n// }\n\n.loader-spin{\n    background-color: hsla(0,0%,92.5%,.9);\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tbottom: 0;\n\tright: 0;\n}\n.loader__inner {\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\n}\n\n/*#Path_125{\n\tanimation: blink 2s linear infinite;\n\tanimation-delay: .25s;\n}\n#Path_124{\n\tanimation: blink 2s linear infinite;\n\tanimation-delay: .50s;\n}*/\n#Path_129{\n\tanimation: blink 2s linear infinite;\n\topacity: 0;\n}\n#Path_130{\n\tanimation: blink 2s linear infinite;\n\tanimation-delay: .5s;\n\topacity: 0;\n}\n#Path_132{\n\tanimation: blink 2s linear infinite;\n\tanimation-delay: 1s;\n\topacity: 0;\n}\n#Path_131{\n\tanimation: blink 2s linear infinite;\n\tanimation-delay: 1.5s;\n\topacity: 0;\n}\n@keyframes blink {\n\t0% {\n\t\topacity: 0;\n\t}\n\t50%{\n\t\topacity: 1;\n\t}\n\t100%{\n\t\topacity: 0;\t\n\t}\n\n}\n\n\n@media print {\n    .is-contentPDF {\n        padding: 50px !important;\n    }\n\n}","// Shared Challenge Navigator mixins, breakpoints, and variables\n// Import this at the top of each stage component SCSS\n\n@import './../../../assets/styles/variables';\n\n// CN-specific variables\n$cn-border-color: #CFDBE2;\n$cn-edit-bg: #ebebeb;\n$cn-card-bg: #f5f5f5;\n\n// Breakpoints\n$mq-pc: 'only screen and (max-width: 1200px)';\n$mq-md: 'only screen and (max-width: 991px)';\n$mq-sm: 'only screen and (max-width: 767px)';\n$mq-mobile: 'only screen and (max-width: 480px)';\n\n// Mixins\n@mixin fflex() {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n@mixin fflex-jcc() {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@mixin fflex-aic() {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n@mixin transition-slow() {\n    -webkit-transition: all ease 0.3s;\n    -o-transition: all ease 0.3s;\n    transition: all ease 0.3s;\n}\n\n@mixin transition-none() {\n    -webkit-transition: none;\n    -o-transition: none;\n    transition: none;\n}\n\n@mixin appearance-none() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@mixin transRotate($rotate) {\n    -webkit-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    transform: rotate($rotate);\n}\n\n@mixin headingfont() {\n    font-family: $muso-700 !important;\n    font-weight: normal !important;\n}\n\n@mixin contentfont() {\n    font-family: $muso-300 !important;\n    font-weight: normal !important;\n}\n\n// Common element resets\nlabel {\n    font-family: 'Open Sans', sans-serif;\n}\n","@import './../cn-shared';\n\n\n\n::ng-deep#page-wrapper {\n    padding-bottom: 60px;\n}\n\n::ng-deep#wrapper {\n    overflow-x: initial;\n\n}\n\n::ng-deep.wrapper-content {\n    position: relative;\n}\n\n::ng-deep.clarify-is {\n\n    .mainnav {\n        @include fflex();\n        margin: 30px 0 40px;\n\n        @media #{$mq-sm} {\n            margin: 10px 0 30px;\n        }\n\n        &.mainnav--bottom {\n            margin: 30px 0 40px;\n\n            ul {\n                li {\n                    a {\n                        padding: 12px 30px;\n                        font-family: 'Open Sans', sans-serif;\n                        font-weight: 700;\n                        font-size: 16px;\n\n                        @media only screen and (max-width: 991px) {\n                            padding: 10px 20px;\n                            font-size: 14px;\n                        }\n\n                        @media only screen and (max-width: 767px) {\n                            padding: 9px;\n                            font-size: 11px;\n                        }\n                    }\n\n                    &.active {\n                        a {\n                            background-color: #bbb !important;\n                            border-top: 1px solid #bbb !important;\n                            border-bottom: 1px solid #bbb !important;\n                            border-left: 1px solid #bbb !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        &--editmode {\n            margin: 0 0 15px;\n\n            .mainnav__list {\n                flex: 1;\n                border-radius: 5px;\n\n                @media #{$mq-sm} {\n                    flex: none;\n                    width: 100%;\n                }\n\n                li {\n                    width: 100%;\n                    flex: 1;\n\n                    a {\n                        width: 100%;\n                        padding: 5px 2px;\n                        text-align: center;\n                    }\n                }\n            }\n        }\n    }\n\n    .info {\n        color: #fff;\n        border: 1px solid $clarify-color;\n        margin-bottom: 18px;\n        padding: 20px 40px;\n        border-radius: 6px;\n\n        @media #{$mq-md} {\n            padding: 12px 20px;\n        }\n\n        &.infotitle {\n            background-color: $clarify-color;\n        }\n\n        h1 {\n            font-size: 36px;\n            font-weight: 500;\n            margin: 0;\n            @include headingfont();\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n\n            @media #{$mq-md} {\n                font-size: 28px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 24px;\n            }\n\n            .info__maintitle {\n                margin-right: auto;\n\n            }\n\n            small {\n                color: #fff;\n                font-size: 80%;\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 5px;\n                }\n            }\n        }\n\n        .card__toprow {\n            @include fflex();\n            @include fflex-aic();\n            margin: 0 -15px;\n\n            &--tne {\n\n                .card__topcol {\n\n                    &:first-child {\n                        width: 72% !important;\n\n                        @media #{$mq-sm} {\n                            flex: 1;\n                            width: auto !important;\n                        }\n                    }\n                }\n            }\n\n            .card__topcol {\n                padding: 0 15px;\n                width: calc(100% / 3);\n\n                &--full {\n                    width: 100% !important;\n                }\n\n                &:nth-child(1) {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        flex: 1;\n                        margin-right: auto;\n                    }\n                }\n\n                &--tab {\n                    width: 44%;\n\n                    @media #{$mq-sm} {\n                        width: 120px;\n                    }\n                }\n\n                &--tt {\n                    width: 28%;\n                    margin-left: auto;\n                    text-align: right;\n\n                    @media #{$mq-sm} {\n                        width: auto;\n                    }\n                }\n\n                &.card__topcol--tab {\n                    @include fflex();\n                    @include fflex-jcc();\n\n                    ul {\n                        @include fflex();\n                        margin: 0;\n                        padding: 0;\n                        border-radius: 3px;\n                        line-height: 1;\n\n                        li {\n                            &:first-child {\n                                button {\n                                    svg {\n                                        right: calc(100% + 1px)\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            left: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:last-child {\n                                button {\n                                    svg {\n                                        left: calc(100% + 1px);\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            right: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:not(:first-child) {\n                                margin-left: -1px;\n                            }\n\n                            &:only-child {\n                                button {\n                                    border-radius: 3px;\n                                }\n                            }\n\n                            &.card__topactive {\n                                button {\n                                    color: $clarify-color;\n                                    border: 1px solid $clarify-color;\n\n                                    span.card__topcount {\n                                        color: $clarify-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &.card__topcomplete {\n                                button {\n                                    opacity: 0.2;\n                                    border: 1px solid $clarify-color;\n                                    color: $clarify-color;\n\n                                    span.card__topcount {\n                                        color: $clarify-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            button {\n                                position: relative;\n                                color: $develop-color;\n                                font-size: 17px;\n                                padding: 6px 16px;\n                                @include headingfont();\n                                display: inline-block;\n                                height: 100%;\n                                border: 0;\n                                background-color: transparent;\n                                @include transition-slow();\n                                -webkit-appearance: none;\n                                -moz-appearance: none;\n                                appearance: none;\n\n                                svg {\n                                    position: absolute;\n                                    top: -1px;\n                                    height: calc(100% + 2px);\n\n                                    .st0 {\n                                        fill: $clarify-color;\n                                    }\n                                }\n\n                                @media #{$mq-md} {\n                                    padding: 4px 6px;\n                                    font-size: 13px;\n                                }\n\n                                &:focus {\n                                    outline: none;\n                                    box-shadow: none;\n                                }\n\n                                &>.card__topdesktext {\n                                    @media only screen and (max-width: 1180px) {\n                                        display: none;\n                                    }\n                                }\n\n                                &>.card__topmobiletext {\n                                    display: none;\n\n                                    @media only screen and (max-width: 1180px) {\n                                        display: inline-block;\n                                    }\n                                }\n\n                                &>span.card__topcount {\n                                    width: 16px;\n                                    height: 16px;\n                                    line-height: 16px;\n                                    display: inline-block;\n                                    text-align: center;\n                                    font-size: 0.5em;\n                                    background-color: $clarify-color;\n                                    color: #fff;\n                                    margin-left: 4px;\n                                    border-radius: 50%;\n                                    vertical-align: bottom;\n                                    position: relative;\n                                    top: -1px;\n\n                                    @media only screen and (max-width: 630px) {\n                                        position: absolute;\n                                        top: auto;\n                                        bottom: -2px;\n                                        right: 0;\n                                        margin: 0;\n                                    }\n                                }\n\n                                &:hover {\n                                    color: $clarify-color;\n                                    opacity: 1;\n                                }\n\n                                &:hover>span.card__topcount {\n                                    color: $clarify-color;\n                                    background-color: #efefef;\n                                    opacity: 1;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                &--ctt {\n                    position: relative;\n\n                    ul {\n                        li {\n                            .card-body__tooltip {\n                                display: none;\n                                position: absolute;\n                                background: #fff;\n                                color: #676a6c;\n                                padding: 5px;\n                                top: -27px;\n                                box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                border-radius: 5px;\n\n                            }\n\n                            button {\n\n                                &:hover {\n                                    opacity: 0.2 !important;\n                                }\n\n                            }\n\n                            &:hover,\n                            &:active {\n\n                                .card-body__tooltip {\n                                    display: block;\n                                }\n                            }\n\n                        }\n                    }\n                }\n\n                span.flagicon {\n                    position: relative;\n                    right: -6px;\n                    top: -11px;\n                    color: #ff0000;\n                    margin-left: 0;\n                }\n            }\n\n            .card__h3button {\n                border: 1px solid $clarify-color;\n                background-color: transparent;\n                padding: 2px 26px;\n                border-radius: 3px;\n                @include headingfont();\n                color: $clarify-color;\n                font-size: 22px;\n                line-height: 1.2;\n                @include transition-slow();\n                cursor: pointer;\n\n                &:hover {\n                    background-color: $clarify-color;\n                    color: #fff;\n                }\n\n                &:focus {\n                    outline: none;\n                }\n            }\n\n            .tooltipicon {\n                cursor: pointer;\n                position: relative;\n                font-size: 18px;\n                display: inline-block;\n                text-align: right;\n\n                i {\n                    color: $clarify-color;\n                }\n\n                &:hover>i>.tooltiptext {\n                    visibility: visible;\n                }\n\n                .tooltiptext {\n                    visibility: hidden;\n                    width: 250px;\n                    background-color: #fff;\n                    color: $clarify-color;\n                    text-align: center;\n                    border-radius: 6px;\n                    padding: 10px;\n                    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                    font-size: 13px;\n                    font-family: 'Open Sans', sans-serif;\n                    line-height: 1.5;\n                    position: absolute;\n                    top: 15px;\n                    right: 10px;\n                    z-index: 1;\n                }\n            }\n        }\n\n        h3 {\n            font-size: 20px;\n            margin: 0;\n            cursor: pointer;\n            color: $clarify-color;\n            @include headingfont();\n            @include fflex();\n            @include fflex-aic();\n\n            @media #{$mq-md} {\n                font-size: 16px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 15px;\n                word-break: break-word;\n            }\n\n            &>*:not(:last-child) {\n                margin-right: 5px;\n            }\n\n            .card__bwnh3pencil {\n\n                a {\n                    color: $clarify-color;\n                }\n            }\n\n            .card__bwnh3button {\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 10px;\n                }\n\n                button {\n                    font-size: 18px !important;\n                    padding-right: 15px !important;\n                    padding-left: 15px !important;\n\n                    @media #{$mq-sm} {\n                        font-size: 16px !important;\n                    }\n                }\n            }\n\n            i {\n                cursor: pointer;\n                font-size: 0.9em;\n\n                &+div {\n                    padding-left: 7px;\n\n                    span {\n                        display: block;\n                        font-size: 0.7em;\n                    }\n                }\n\n                &+span {\n                    padding-left: 7px;\n                }\n            }\n\n        }\n\n    }\n\n    app-clarify-data,\n    app-clarify-sub-challenge {\n        display: block;\n        margin-top: 30px;\n    }\n\n    .card-default {\n        &.card-default--summary {\n            box-shadow: none;\n\n            .info {\n                border-top: 0;\n                border-right: 0;\n                border-left: 0;\n                padding-right: 20px;\n                padding-left: 20px;\n            }\n\n            .card-body {\n                border-right: 0;\n                border-bottom: 0;\n                border-left: 0;\n                border-radius: 0;\n\n                &__inner {\n                    padding-right: 20px;\n                    padding-left: 20px;\n                }\n            }\n\n            &+div {\n                margin-top: 20px;\n            }\n        }\n\n        &+div {\n            margin-top: 30px;\n        }\n\n        .info {\n            margin: 0;\n            border: 1px solid $clarify-color;\n            border-radius: 6px;\n\n            &.card__headactive {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n\n                &.card__headactive--cc {\n                    background-color: $clarify-color;\n\n                    .card__topcol {\n                        h3 {\n                            color: #fff;\n                        }\n\n                        ul {\n                            li {\n\n                                button {\n                                    border-color: #fff;\n                                    background-color: #fff;\n                                    cursor: pointer;\n\n                                    span {\n                                        color: $clarify-color;\n                                        background-color: #fff;\n                                    }\n\n                                    .st0 {\n                                        fill: #fff;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    i {\n                        color: #fff;\n                    }\n                }\n            }\n        }\n\n        border-radius: 6px;\n        border-top-width: 3px;\n        border: 0;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n\n        .card-body__inner {\n            padding: 15px 40px;\n            overflow-y: auto;\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n        }\n\n        .card-body {\n            display: none;\n            border: 1px solid $cn-border-color;\n            border-top: 0;\n            border-radius: 0 0 6px 6px;\n            overflow: hidden;\n\n            &.card-show {\n                display: block;\n\n                &__wbg {\n                    background-color: #fff;\n                }\n\n            }\n\n            &__finalstate {\n                p {\n                    font-size: 15px;\n                    font-weight: 600;\n\n                    @media #{$mq-sm} {\n                        font-size: 13px;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &--2 {\n                    @include fflex();\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n                    }\n                }\n\n                &--list {\n                    p {\n                        position: relative;\n                        padding-left: 10px;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 8px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n                    }\n                }\n            }\n\n            &__subtitle {\n                padding-left: 35px;\n                margin-bottom: 16px;\n                position: relative;\n\n                &--pl0 {\n                    padding-left: 0;\n                }\n\n                *:last-child {\n                    margin-bottom: 0;\n                }\n\n                &>span {\n                    position: absolute;\n                    top: 0;\n                    right: 2px;\n                    opacity: 0.7;\n                    cursor: pointer;\n\n                    &.eyebtn {\n                        right: 0;\n                    }\n\n                }\n\n                p {\n                    color: #969798;\n                    font-size: 15px;\n\n                    i {\n                        padding-left: 5px;\n                    }\n                }\n            }\n        }\n\n        .c-radio {\n            label {\n                padding-left: 0;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 2px;\n                    margin-right: 6px;\n                    opacity: 0.6;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                margin: 0;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 50%;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        position: absolute;\n                        color: $clarify-color;\n                        opacity: 0;\n                        font-size: 11px;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $clarify-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .checkbox {\n            label {\n                min-height: 20px;\n                padding-left: 0;\n                margin-bottom: 0;\n                font-weight: 400;\n                cursor: pointer;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 1px;\n                    margin-right: 6px;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        font-size: 12px;\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: #5D9CEC;\n                        background-color: #5D9CEC;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .card-body__button {\n            background-color: #f5f5f5;\n            border-top: 1px solid #e3e3e3;\n            padding: 12px 40px;\n\n            .card-button {\n                @include fflex();\n                @include fflex-aic();\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    text-align: center;\n                    @include transition-slow();\n\n                    &+.btn {\n                        margin-left: 15px;\n                    }\n\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n                }\n\n                .float-right {\n                    margin-left: auto;\n                }\n\n                .btn-clarify {\n                    background-color: $clarify-color;\n                    border-color: $clarify-color;\n                    color: #fff;\n\n                    &:hover {\n                        background-color: $clarify-color;\n                        border-color: $clarify-color;\n                    }\n                }\n\n                .btn-cancel {\n                    padding: 0;\n                    margin-left: 25px;\n                }\n\n                .btn-danger {\n                    background-color: #fff;\n                    border-color: #fff;\n                    color: #ef6272;\n\n                    &:hover {\n                        background-color: #ED2D2D;\n                        border-color: #EC2121;\n                    }\n                }\n\n                .btn-warning {\n                    em {\n                        margin: 0;\n                    }\n                }\n\n                .btn-deleteall {\n                    border: 0;\n                    background-color: transparent;\n                    position: relative;\n                    overflow: hidden;\n                    box-shadow: none;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n\n                    span {\n                        position: absolute;\n                        left: 110%;\n                        @include transition-slow();\n                    }\n\n                    &:hover {\n                        background-color: #fff;\n                        color: #ed5562;\n                        padding-right: 16px;\n                        padding-left: 16px;\n\n                        &>span {\n                            position: relative;\n                            left: 0;\n                        }\n\n                        i {\n                            margin-right: 6px;\n                        }\n                    }\n\n                    i {\n\n                        margin-right: 0;\n                        @include transition-slow();\n                    }\n                }\n            }\n        }\n\n        .card-body--ebtn {\n            margin-top: 15px;\n            padding: 15px 40px;\n            border-top: 1px solid $cn-border-color;\n\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n\n            .card-body--ebtnrow {\n                margin: 0 -8px;\n                @include fflex();\n                @include fflex-aic();\n\n                &>div {\n                    padding: 0 8px;\n\n                    @media #{$mq-sm} {\n                        width: 100%;\n                        text-align: center;\n\n                        &+div {\n                            margin-top: 10px;\n                        }\n                    }\n\n                    &.card-body--col {\n                        &--last {\n                            margin-left: auto;\n                        }\n                    }\n                }\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    padding: 7px 16px;\n                    text-align: center;\n                    transition: all ease 0.3s;\n\n                    @media #{$mq-md} {\n                        font-size: 12px;\n                    }\n\n                    &-bottom {\n\n                        &--disable {\n                            opacity: 0.5;\n                        }\n                    }\n\n                    i,\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n\n                    &--save {\n                        background-color: $develop-color;\n                        color: #fff;\n                    }\n\n                    &--clarify {\n                        background-color: $clarify-color;\n                        color: #fff;\n                        border-color: $clarify-color;\n                        font-weight: 900;\n                        font-family: 'Open Sans';\n\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                    }\n\n                    &--cancel {\n                        padding: 0;\n                        background-color: transparent;\n                        margin-left: 0;\n                        color: $body-content-color;\n                        border: 0;\n                        font-family: $font-stack;\n                        font-size: 14px;\n                        font-weight: 700;\n                        transition: all ease .3s;\n\n                        &:hover {\n                            transition: all ease .3s;\n                            color: #000;\n                        }\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                        border-color: #6d6e71;\n                    }\n\n                    &--converge {\n                        padding: 0 8px;\n                    }\n\n                    &--deleteall {\n                        border: 0;\n                        background-color: transparent;\n                        position: relative;\n                        overflow: hidden;\n                        box-shadow: none;\n                        padding-right: 0;\n                        padding-left: 0;\n                        cursor: pointer;\n\n                        i {\n                            font-size: 14px;\n                            color: $body-content-color;\n                        }\n\n                        @include transition-slow();\n\n                        span {\n                            position: absolute;\n                            left: 110%;\n                            @include transition-slow();\n                        }\n\n                        &:hover {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            i {\n                                margin-right: 6px;\n                                color: #ed5562;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            i {\n                                margin-right: 6px !important;\n                            }\n                        }\n\n                        i {\n                            // font-size: 1em;\n                            margin-right: 0;\n                            @include transition-slow();\n                        }\n                    }\n                }\n            }\n        }\n\n\n\n\n        .note-3 {\n            margin-bottom: 15px;\n\n            label {\n                color: $clarify-color;\n            }\n        }\n\n        .footer-line {\n            color: $clarify-color;\n            font-size: 15px;\n        }\n\n        .card-body__edit {\n            position: relative;\n\n            .breakthrough-input-tabs,\n            .datadump-input-tabs {\n                width: 100%;\n                margin-right: 0;\n                position: relative;\n\n                input,\n                select {\n                    height: 45px;\n                    padding: 5px 15px;\n                    border: 1px solid $color-neutral-mid;\n                    border-radius: 4px;\n                    font-size: 15px;\n                }\n\n                .card-body__minus {\n\n                    &--hide {\n                        display: none;\n                    }\n                }\n\n                .card-body__editinput {\n\n                    &--ce {\n                        position: relative;\n\n                        .converge-icon {\n                            position: absolute;\n                            top: 50%;\n                            transform: translateY(-50%);\n                            left: 7px;\n                            font-size: 26px;\n                            color: $clarify-color;\n\n                            &:hover>.card-body__tooltip,\n                            &:active>.card-body__tooltip {\n                                display: block;\n                            }\n\n                            .card-body__tooltip {\n                                display: none;\n                                font-size: 16px;\n                                color: #676a6c;\n                                position: absolute;\n                                bottom: 100%;\n                                left: 0;\n                                background: #fff;\n                                padding: 5px;\n                                border-radius: 5px;\n                                box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                width: max-content;\n                            }\n                        }\n\n                        input {\n                            padding-left: 26px;\n                        }\n\n                    }\n                }\n            }\n\n            .card-body__editrow {\n                margin: 0 -15px;\n                @include fflex();\n\n                &>div {\n                    padding: 0 15px;\n                    width: 100%;\n                    margin-bottom: 15px;\n\n                    &:first-child {\n                        display: none;\n                    }\n\n                    &.card-body__editcol.hideblk {\n                        display: none;\n                    }\n\n                    &.card-body__editcol--2 {\n                        width: calc(100% / 2);\n                    }\n\n                    &>div {\n                        position: relative;\n                    }\n                }\n\n                select {\n                    -webkit-appearance: none;\n                    -moz-appearance: none;\n                    appearance: none;\n                    background-image: url($assets+'/images/select.png');\n                    background-size: 10px;\n                    background-position: right 10px center;\n                    background-repeat: no-repeat;\n                    font-family: 'Open Sans';\n\n                    &:hover,\n                    &:focus,\n                    &:active {\n                        outline: none\n                    }\n                }\n\n                .datadump-input-tabs,\n                .breakthrough-input-tabs {\n                    @include fflex();\n\n                    &>.card-body__editlabel {\n                        width: 35px;\n                        padding-right: 15px;\n                        @include fflex();\n                        @include fflex-aic();\n                        font-weight: 700;\n                    }\n\n                    &>.card-body__editnumber {\n                        width: 40px;\n                        text-align: center;\n                        @include fflex();\n                        @include fflex-aic();\n                        @include fflex-jcc;\n                        border-right: 0;\n                        border-radius: 4px 0 0 4px;\n\n                        &+.card-body__editinput {\n                            width: calc(100% - 41px);\n                        }\n\n                        label {\n                            margin-bottom: 0;\n                            font-weight: 900;\n                        }\n                    }\n\n                    &>.card-body__editselect {\n                        width: 315px;\n                        padding-right: 15px;\n\n                        @media #{$mq-sm} {\n                            width: 100%;\n                            padding-right: 0;\n                            margin-bottom: 10px;\n                        }\n                    }\n\n                    &>.card-body__editinput {\n                        width: calc(100% - 351px);\n                        padding-right: 60px;\n\n                        input {\n                            padding-right: 70px;\n                            font-family: 'Open Sans';\n\n                            &:hover,\n                            &:focus,\n                            &:active {\n                                outline: none;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            width: 100%;\n                            ;\n                        }\n\n                        .input-group-text {\n                            @media #{$mq-sm} {\n                                top: auto;\n                                transform: translate(0);\n                                bottom: 9px;\n                            }\n                        }\n\n                        &--ce {\n                            position: relative;\n\n                            .converge-icon {\n                                position: absolute;\n                                top: 50%;\n                                transform: translateY(-50%);\n                                left: 7px;\n                                font-size: 26px;\n                                color: $clarify-color;\n\n                                &:hover>.card-body__tooltip,\n                                &:active>.card-body__tooltip {\n                                    display: block;\n                                }\n\n                                .card-body__tooltip {\n                                    display: none;\n                                    font-size: 16px;\n                                    color: #676a6c;\n                                    position: absolute;\n                                    bottom: 100%;\n                                    left: 0;\n                                    background: #fff;\n                                    padding: 5px;\n                                    border-radius: 5px;\n                                    box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                    width: max-content;\n                                }\n                            }\n\n                            input {\n                                padding-left: 26px;\n                            }\n\n                        }\n                    }\n\n                    &>.card-body__editinput:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n\n            &+.card-body__addnew {\n\n                button {\n                    margin: 0 36px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding-right: 0;\n                    padding-left: 0;\n                    color: $body-content-color;\n                    @include transition-slow();\n                    font-weight: 900;\n\n                    &:hover {\n                        background-color: $clarify-color;\n                        border: 1px solid $clarify-color;\n                        color: #fff;\n                        padding-right: 12px;\n                        padding-left: 12px;\n                    }\n                }\n            }\n        }\n\n        .input-tabs {\n            &+i {\n                position: relative;\n                top: -1px;\n            }\n\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            @include fflex-aic();\n            width: calc(100%);\n            padding: 0 0 0 0;\n            margin: 0;\n\n\n            &.card__body--cs {\n                position: relative;\n                border-bottom: 1px solid #e4e4e4;\n\n                &::before,\n                &::after {\n                    content: \"\";\n                    position: absolute;\n                    bottom: -1px;\n                    right: calc(100%);\n                    width: 40px;\n                    height: 1px;\n                    background-color: #e4e4e4;\n                }\n\n                &::after {\n                    right: auto;\n                    left: calc(100%);\n                }\n            }\n\n            .select_faded {\n                opacity: 0.2;\n                padding-left: 32px;\n            }\n\n            input,\n            select {\n                height: 45px;\n                padding: 9px 15px;\n                border: 1px solid #e3e3e3;\n                border-radius: 4px;\n                margin: 7px 0px;\n            }\n\n            label {\n                width: 20px;\n                margin: 0;\n            }\n\n            select {\n                width: 9%;\n            }\n\n            input {\n                width: 90%;\n                margin-left: 15px;\n            }\n        }\n\n        .input-group-text {\n            cursor: pointer;\n            padding: 3px 16px;\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 1.528571429;\n            color: #495057;\n            text-align: center;\n            white-space: nowrap;\n            background-color: #E9ECEF;\n            border: 1px solid #DDE6E9;\n            border-radius: 0.25rem;\n            position: absolute;\n            top: calc(50% + 1px);\n            right: 0;\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n            @include transition-slow();\n\n            &:hover {\n                background-color: $clarify-color;\n                border-color: $clarify-color;\n                color: #fff;\n            }\n        }\n    }\n\n    .card-bottom-button {\n        .button {\n            font-size: 13px;\n            color: #fff;\n            padding: 8px 10px;\n            border-radius: 3px;\n            @include transition-slow();\n\n            &:hover {\n                opacity: .8;\n            }\n\n            i {\n                font-size: 0.8em;\n            }\n\n            &.btn-clarify {\n                background-color: $clarify-color;\n            }\n\n            &.btn-ideate {\n                background-color: $ideate-color;\n            }\n\n            &.btn-implement {\n                background-color: $implement-color;\n            }\n        }\n    }\n\n    .datadump-content-tabs {\n        @include fflex();\n        counter-reset: section;\n    }\n\n    .dump-tabs:first-child {\n        display: none;\n    }\n\n    .dump-tabs {\n        width: calc(50% - 50px) !important;\n    }\n\n    .datadump__col {\n        @include fflex();\n        @include fflex-aic();\n        margin-bottom: 17px;\n\n        .datadump-main {\n            width: calc(100% - 68px);\n            display: inline-block;\n            margin-right: 20px;\n\n            .datadump-group {\n                width: 100%;\n                position: relative;\n                @include fflex();\n\n                input {\n                    margin-bottom: 0px;\n                    width: calc(100%);\n                    height: 35px;\n                    border: 1px solid $color-neutral-mid;\n                    border-radius: 0 0.25rem 0.25rem 0;\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n.prevnext {\n    padding: 20px 0;\n\n    &__inner {\n        @include fflex();\n        @include fflex-aic();\n        padding: 0;\n        margin: 0;\n    }\n\n    li {\n        list-style: none;\n\n        &.prevnext__next {\n            margin-left: auto;\n        }\n\n        &.prevnext__prev a {\n            &:hover>i {\n                left: -5px;\n            }\n        }\n\n        &.prevnext__next a {\n            background-color: $clarify-color;\n            color: #fff;\n            opacity: 1;\n            padding: 6px 12px;\n            border-radius: 3px;\n\n            &:hover>i {\n                left: 3px;\n            }\n        }\n\n        a {\n            @include headingfont();\n            font-size: 14px;\n            color: #676a6c;\n            opacity: 0.47;\n            padding: 6px 0;\n            display: inline-block;\n            @include transition-slow();\n\n            i {\n                position: relative;\n                font-size: 1.1em;\n                left: 0;\n                @include transition-slow();\n            }\n        }\n    }\n}\n\n.popaccordian__row--active {\n    // .playbtn{\n    //     transform: rotate(28deg);\n    // }\n}\n\n.playbtn {\n    position: absolute;\n    right: 10px;\n    bottom: 7px;\n    color: #06a6ce;\n}\n\n.Del-data-btn {\n    padding: 40px 0;\n\n    .btn {\n        margin-left: 15px;\n        // border-color: #007bff;\n        background-color: #fff;\n        border-color: #f5f5f5;\n        color: #ff485c;\n    }\n\n    .cancelbtn {\n        color: #676a6c;\n        text-align: center;\n        font-size: 15px;\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.5;\n        padding: 6px;\n    }\n}\n\n\n.editmode {\n    // margin-bottom: 30px;\n\n\n    &__list {\n\n        &row {\n            display: grid;\n            grid-template-columns: repeat(2, 1fr);\n            grid-gap: 15px;\n\n            @media #{$mq-sm} {\n                grid-template-columns: 1fr;\n            }\n\n            &--equalblocks {\n                display: flex;\n                flex-wrap: wrap;\n\n                &>.editmode__listcol {\n                    flex: 1;\n\n                    @media #{$mq-sm} {\n                        flex: none;\n                        width: 100%;\n                    }\n                }\n\n            }\n\n            &--fullblocks {\n                grid-template-columns: 1fr;\n            }\n\n            &--grid {\n                &1 {\n                    grid-template-columns: 1fr;\n                }\n\n                &3 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 3;\n                    }\n                }\n\n                &4 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 4;\n                    }\n                }\n\n                &5 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 5;\n                    }\n                }\n\n                &6 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 6;\n                    }\n                }\n\n                &7 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 7;\n                    }\n                }\n            }\n        }\n\n        &cell {\n            padding: 10px 15px;\n            background-color: #EBEBEB;\n            border: 1px solid $cn-border-color;\n            border-radius: 6px;\n            height: 100%;\n\n            &--startbtn {\n                border: 1px solid $clarify-color;\n                color: $clarify-color;\n                font-weight: 600;\n                font-family: 'Open Sans';\n                font-size: 16px;\n                cursor: pointer;\n                line-height: 1;\n            }\n\n\n            @media #{$mq-sm} {\n                font-size: 13px;\n            }\n\n            h3 {\n                color: $clarify-color;\n                margin-bottom: 5px;\n\n                a,\n                i {\n                    color: inherit;\n                }\n            }\n\n            p {\n                font-size: 15px;\n                font-weight: 600;\n\n                @media #{$mq-sm} {\n                    font-size: 13px;\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n\n}\n\n.container-fluid {\n    position: relative;\n\n    .trackInfo {\n        padding: 2px 16px;\n        background-color: #6d6e71;\n        color: #fff;\n        margin-left: 40px;\n        border-radius: 5px;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        font-size: 10px;\n\n        &--clr {\n            color: transparent !important;\n        }\n\n        &--inputclr {\n            color: $clarify-color;\n            font-size: 18px;\n            background: transparent;\n            margin-left: 0;\n            padding-left: 0;\n            position: absolute;\n            left: 40px;\n            top: 18px;\n            font-size: 11px;\n            background: transparent;\n            margin-left: 8px;\n        }\n    }\n}\n\n.loader-container {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    top: 0;\n    bottom: 0;\n    background: rgba(236, 236, 236, .9);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: none;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    z-index: 9999999999;\n    height: 100vh;\n    margin: 0 auto;\n}\n\n.stick-challenge {\n    position: relative;\n\n    .card-body__inner {\n        min-height: auto;\n        overflow-y: auto;\n        overflow-x: hidden;\n        z-index: 9;\n        position: relative;\n        padding-top: 0;\n\n        .card-body__subtitle {\n            position: sticky;\n            top: 0;\n            z-index: 99;\n            background-color: #fff;\n            padding: 15px 0 15px 35px;\n            margin: 0;\n        }\n    }\n\n}\n\n.row {\n    &--editmodebg {\n        background-color: #fff;\n        padding: 40px 35px;\n    }\n\n    &--wbg {\n        background-color: #fff;\n    }\n}\n\n.swal2-show button.swal2-cancel.swal2-styled.wbg {\n    background-color: red !important;\n}\n\n.loader-spin {\n    background-color: hsla(0, 0%, 92.5%, .9);\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.loader__inner {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n    animation: blink 2s linear infinite;\n    opacity: 0;\n}\n\n#Path_130 {\n    animation: blink 2s linear infinite;\n    animation-delay: .5s;\n    opacity: 0;\n}\n\n#Path_132 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1s;\n    opacity: 0;\n}\n\n#Path_131 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1.5s;\n    opacity: 0;\n}\n\n@keyframes blink {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n\n}\n\n.cn-dmodal {\n    display: none;\n}","@import './../cn-shared';\n\n::ng-deep#page-wrapper {\n    padding-bottom: 60px;\n}\n\n::ng-deep#wrapper {\n    overflow-x: initial;\n}\n\n::ng-deep.develop-is {\n    &.editmode {\n        padding: 5px 60px;\n        background: #ebebeb;\n\n        @media only screen and (max-width: 991px) {\n            padding: 40px 0 0;\n        }\n\n        .mainnav {\n            margin: 0 0 15px;\n        }\n\n        .editmode_icons {\n            .formattingIcon {\n                li {\n                    border-radius: 5px;\n                    height: 31px;\n                    margin-left: 5px;\n\n                    @media only screen and (max-width: 991px) {\n                        display: none;\n\n                        &:first-child {\n                            display: block;\n                        }\n                    }\n\n                    svg {\n                        cursor: pointer;\n                    }\n                }\n            }\n\n        }\n    }\n\n    .highlight {\n        background-color: #B4D5FF\n    }\n\n    .mainnav {\n        @include fflex();\n        @include fflex-jcc();\n        flex-wrap: nowrap;\n        margin: 30px 0 40px;\n\n        @media #{$mq-sm} {\n            margin: 10px 0 30px;\n        }\n\n        &.mainnav--bottom {\n            margin: 30px 0 40px;\n\n            ul {\n                li {\n                    a {\n                        padding: 12px 30px;\n                        font-family: 'Open Sans', sans-serif;\n                        font-weight: 700;\n                        font-size: 16px;\n\n                        @media #{$mq-md} {\n                            padding: 10px 20px;\n                            font-size: 14px;\n                        }\n\n                        @media #{$mq-sm} {\n                            padding: 11px 5px;\n                            font-size: 11px;\n                        }\n                    }\n\n                    &.active {\n                        a {\n                            background-color: #bbb !important;\n                            border-top: 1px solid #bbb !important;\n                            border-bottom: 1px solid #bbb !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        &__editmodeicon {\n            margin-left: 5px;\n\n            @media #{$mq-sm} {\n                margin: 10px 0 0 auto;\n            }\n\n            ul {\n                display: flex;\n                flex-wrap: wrap;\n                margin: 0;\n                padding: 0;\n                height: 100%;\n\n                li {\n                    list-style: none;\n                    transition: none;\n                    width: 37px;\n                    height: 100%;\n                    border-radius: 5px;\n                    background-color: #fff;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    cursor: pointer;\n                    border: 1px solid $cn-border-color;\n\n\n                    &.active {\n                        background-color: #676a6c;\n                    }\n\n                    &:not(:last-child) {\n                        margin-right: 5px;\n\n                        @media #{$mq-md} {\n                            margin-right: 0;\n                        }\n                    }\n\n                    @media #{$mq-md} {\n                        width: 35px;\n                        height: 31px;\n                        display: none;\n                    }\n\n                    &.mainnav__editmodepin {\n                        display: flex;\n\n                        svg {\n                            .st0 {\n                                fill: #FFFFFF;\n                            }\n\n                            .st1 {\n                                fill: #cfdbe2;\n                            }\n                        }\n\n                        &--pinactive {\n                            svg {\n                                .st0 {\n                                    fill: #6d6e71;\n                                }\n\n                                .st1 {\n                                    fill: #FFFFFF;\n                                }\n                            }\n                        }\n                    }\n\n                    &.listView,\n                    &.individualView,\n                    &.gridView {\n\n                        svg {\n                            .st0 {\n                                fill: #6d6e71;\n                            }\n\n                            .st1 {\n                                fill: #FFFFFF;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        &.editnav {\n            justify-content: space-between;\n            align-items: center;\n            background: #EBEBEB;\n\n            @media #{$mq-sm} {\n                flex-direction: column;\n            }\n\n            ul {\n                background-color: #ebebeb;\n                border-radius: 5px;\n                width: 100%;\n                flex: 1;\n\n\n\n                .develop.active {\n                    background-color: $develop-color;\n                }\n\n                li {\n                    background-color: #fff;\n                    width: 100%;\n\n                    a {\n                        padding: 5px 2px;\n                        width: 100%;\n                        text-align: center;\n                    }\n                }\n            }\n\n            .editmode_icons {\n                @media #{$mq-sm} {\n                    margin: 10px 0 0 auto;\n                }\n            }\n        }\n    }\n\n    .info {\n        color: #fff;\n        border: 1px solid $develop-color;\n        margin-bottom: 18px;\n        padding: 20px 40px;\n        border-radius: 6px;\n\n        @media #{$mq-md} {\n            padding: 12px 20px;\n        }\n\n        &.infotitle {\n            background-color: $develop-color;\n\n            h3 {\n                color: #fff\n            }\n        }\n\n        h1 {\n            font-size: 36px;\n            font-weight: 500;\n            margin: 0;\n            @include headingfont();\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n\n            @media #{$mq-md} {\n                font-size: 28px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 24px;\n            }\n\n            .info__maintitle {\n                margin-right: auto;\n\n            }\n\n            small {\n                color: #fff;\n                font-size: 80%;\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 5px;\n                }\n            }\n        }\n\n        .card__toprow {\n            @include fflex();\n            @include fflex-aic();\n            margin: 0 -15px;\n\n            &--tne {\n\n                .card__topcol {\n\n                    &:first-child {\n                        width: 72% !important;\n\n                        @media #{$mq-sm} {\n                            flex: 1;\n                            width: auto !important;\n                        }\n                    }\n                }\n            }\n\n            .card__topcol {\n                padding: 0 15px;\n                width: calc(100% / 3);\n\n                &--full {\n                    width: 100% !important;\n                }\n\n                &:nth-child(1) {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        flex: 1;\n                        margin-right: auto;\n                    }\n                }\n\n                &--tab {\n                    width: 44%;\n\n                    @media #{$mq-sm} {\n                        width: 120px;\n                    }\n                }\n\n                &--tt {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        width: auto;\n                    }\n                }\n\n                &:nth-child(3) {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        width: auto;\n                    }\n                }\n\n                &.card__topcol--tt {\n                    margin-left: auto;\n                    text-align: right;\n                }\n\n                &.card__topcol--title {\n                    @include fflex();\n                    @include fflex-aic();\n\n                    &>div:first-child {\n                        margin-right: 15px;\n                    }\n                }\n\n                &.card__topcol--startexist {\n                    width: calc(65%);\n\n                    &+div {\n                        width: calc(100% - 65%);\n                    }\n                }\n\n                &.card__topcol--tab {\n                    @include fflex();\n                    @include fflex-jcc();\n\n                    ul {\n                        @include fflex();\n                        margin: 0;\n                        padding: 0;\n                        border-radius: 3px;\n                        line-height: 1;\n\n                        li {\n                            &:first-child {\n                                button {\n                                    svg {\n                                        right: calc(100% + 1px)\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            left: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:last-child {\n                                button {\n                                    svg {\n                                        left: calc(100% + 1px);\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            right: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:not(:first-child) {\n                                margin-left: -1px;\n                            }\n\n                            &:only-child {\n                                button {\n                                    border-radius: 3px;\n                                }\n                            }\n\n                            &.card__topactive {\n                                button {\n                                    color: $develop-color;\n                                    border: 1px solid $develop-color;\n\n                                    span.card__topcount {\n                                        color: $develop-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &.card__topcomplete {\n                                button {\n                                    opacity: 0.2;\n                                    border: 1px solid $develop-color;\n                                    color: $develop-color;\n\n                                    span.card__topcount {\n                                        color: $develop-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            button {\n                                position: relative;\n                                color: $develop-color;\n                                font-size: 17px;\n                                padding: 6px 16px;\n                                @include headingfont();\n                                display: inline-block;\n                                height: 100%;\n                                border: 0;\n                                background-color: transparent;\n                                @include transition-slow();\n                                -webkit-appearance: none;\n                                -moz-appearance: none;\n                                appearance: none;\n\n                                svg {\n                                    position: absolute;\n                                    top: -1px;\n                                    height: calc(100% + 2px);\n\n                                    .st0 {\n                                        fill: $develop-color;\n                                    }\n                                }\n\n                                @media #{$mq-md} {\n                                    padding: 4px 6px;\n                                    font-size: 13px;\n                                }\n\n                                &:focus {\n                                    outline: none;\n                                    box-shadow: none;\n                                }\n\n                                &>.card__topdesktext {\n                                    @media only screen and (max-width: 1180px) {\n                                        display: none;\n                                    }\n                                }\n\n                                &>.card__topmobiletext {\n                                    display: none;\n\n                                    @media only screen and (max-width: 1180px) {\n                                        display: inline-block;\n                                    }\n                                }\n\n                                &>span.card__topcount {\n                                    width: 16px;\n                                    height: 16px;\n                                    line-height: 16px;\n                                    display: inline-block;\n                                    text-align: center;\n                                    font-size: 0.5em;\n                                    background-color: $develop-color;\n                                    color: #fff;\n                                    margin-left: 4px;\n                                    border-radius: 50%;\n                                    vertical-align: bottom;\n                                    position: relative;\n                                    top: -1px;\n\n                                    @media only screen and (max-width: 630px) {\n                                        position: absolute;\n                                        top: auto;\n                                        bottom: -2px;\n                                        right: 0;\n                                        margin: 0;\n                                    }\n                                }\n\n                                &:hover {\n                                    color: $develop-color;\n                                    opacity: 1;\n                                }\n\n                                &:hover>span.card__topcount {\n                                    color: $develop-color;\n                                    background-color: #efefef;\n                                    opacity: 1;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n\n            .card__h3button {\n                border: 1px solid $develop-color;\n                background-color: transparent;\n                padding: 2px 26px;\n                border-radius: 3px;\n                @include headingfont();\n                color: $develop-color;\n                font-size: 22px;\n                line-height: 1.2;\n                @include transition-slow();\n                cursor: pointer;\n\n                &.disabled {\n                    cursor: not-allowed;\n                }\n\n                &:hover {\n                    background-color: $develop-color;\n                    color: #fff;\n                }\n\n                &:focus {\n                    outline: none;\n                }\n            }\n\n            .tooltipicon {\n                cursor: pointer;\n                position: relative;\n                font-size: 18px;\n                display: inline-block;\n\n                i {\n                    color: $develop-color;\n                }\n\n                &:hover>i>.tooltiptext {\n                    visibility: visible;\n                }\n\n                .tooltiptext {\n                    visibility: hidden;\n                    width: 250px;\n                    background-color: #fff;\n                    color: $develop-color;\n                    text-align: center;\n                    border-radius: 6px;\n                    padding: 10px;\n                    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                    font-size: 13px;\n                    font-family: 'Open Sans', sans-serif;\n                    line-height: 1.5;\n                    position: absolute;\n                    top: 15px;\n                    right: 10px;\n                    z-index: 1;\n                }\n            }\n        }\n\n        h3 {\n            font-size: 20px;\n            margin: 0;\n            cursor: pointer;\n            color: $develop-color;\n            @include headingfont();\n            @include fflex();\n            @include fflex-aic();\n\n            @media #{$mq-md} {\n                font-size: 16px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 15px;\n                word-break: break-word;\n            }\n\n            .card__bwnh3title {\n                margin-right: 10px;\n            }\n\n            .card__bwnh3button {\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 10px;\n                }\n\n                button {\n                    font-size: 18px !important;\n                    padding-right: 15px !important;\n                    padding-left: 15px !important;\n\n                    @media #{$mq-sm} {\n                        font-size: 16px !important;\n                    }\n                }\n            }\n\n            i {\n                cursor: pointer;\n                font-size: 0.9em;\n\n                &+div {\n                    padding-left: 7px;\n\n                    span {\n                        display: block;\n                        font-size: 0.7em;\n                    }\n                }\n\n                &+span {\n                    padding-left: 7px;\n                }\n            }\n\n            a {\n                margin-left: 10px;\n                color: $develop-color;\n            }\n\n            &>a {\n                margin-left: 0px;\n            }\n\n            &.d-flex {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n\n                div:first-child {\n                    padding-right: 10px;\n                }\n\n                div:nth-child(2) {\n                    span {\n                        display: block;\n                    }\n                }\n            }\n        }\n\n        .tooltipicon {\n            position: relative;\n            font-size: 18px;\n            display: inline-block;\n\n            i {\n                color: $develop-color;\n            }\n\n            &:hover>i>.tooltiptext {\n                visibility: visible;\n            }\n\n            .tooltiptext {\n                visibility: hidden;\n                width: 250px;\n                background-color: #fff;\n                color: $develop-color;\n                text-align: center;\n                border-radius: 6px;\n                padding: 10px;\n                box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                font-size: 13px;\n                font-family: 'Open Sans', sans-serif;\n                line-height: 1.5;\n                position: absolute;\n                top: 15px;\n                right: 10px;\n                z-index: 1;\n            }\n        }\n\n    }\n\n    .cn-section-heading {\n        display: flex;\n        align-items: center;\n        margin-top: 40px;\n        margin-bottom: 10px;\n        padding: 14px 24px;\n        background-color: lighten($develop-color, 48%);\n        border-left: 4px solid $develop-color;\n        border-radius: 0 6px 6px 0;\n\n        @media #{$mq-sm} {\n            padding: 12px 16px;\n            margin-top: 30px;\n        }\n\n        &__title {\n            font-size: 22px;\n            font-family: $muso-700 !important;\n            font-weight: normal !important;\n            color: $develop-color;\n            margin: 0;\n            line-height: 1.3;\n            letter-spacing: 0.5px;\n\n            @media #{$mq-sm} {\n                font-size: 18px;\n            }\n        }\n\n        &__btn {\n            margin-left: 16px;\n            padding: 6px 20px;\n            font-size: 14px;\n            font-family: 'Open Sans', sans-serif;\n            font-weight: 600;\n            color: #fff;\n            background-color: $develop-color;\n            border: none;\n            border-radius: 4px;\n            cursor: pointer;\n            transition: opacity 0.2s ease;\n\n            &:hover {\n                opacity: 0.85;\n            }\n        }\n    }\n\n    app-develop-challenge-top-ideas,\n    app-develop-challenge-solution-prototype,\n    app-develop-challenge-pluses,\n    app-develop-challenge-opportunities,\n    app-develop-challenge-issues,\n    app-develop-challenge-new-thinking,\n    app-develop-challenge-solution {\n        display: block;\n        margin-top: 30px;\n    }\n\n    app-develop-challenge-pluses {\n        margin-top: 10px;\n    }\n\n    app-develop-challenge-solution {\n        margin-top: 40px;\n    }\n\n    .card-default {\n\n        &.card-default--summary {\n            box-shadow: none;\n\n            .info {\n                border-top: 0;\n                border-right: 0;\n                border-left: 0;\n                padding-right: 20px;\n                padding-left: 20px;\n            }\n\n            .card-body {\n                border-right: 0;\n                border-bottom: 0;\n                border-left: 0;\n                border-radius: 0;\n\n                &__inner {\n                    padding: 15px 20px;\n                }\n            }\n\n            &+div {\n                margin-top: 20px;\n            }\n        }\n\n        &+div {\n            margin-top: 30px;\n        }\n\n        .info {\n            margin: 0;\n            border: 1px solid $develop-color;\n            border-radius: 6px;\n\n            &.card__headactive {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n            }\n\n        }\n\n        border-radius: 6px;\n        border-top-width: 3px;\n        border: 0;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n\n        .card-body__inner {\n            padding: 15px 40px;\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n        }\n\n        .card-body {\n            display: none;\n            border: 1px solid $cn-border-color;\n            border-top: 0;\n            border-radius: 0 0 6px 6px;\n            overflow: hidden;\n\n            &.stCard__body {\n                border: none;\n\n                .card-body__inner {\n                    padding: 0 !important;\n                }\n\n                .card-body__subtitle {\n                    padding: 0 40px 5px !important;\n                    margin-bottom: 0;\n                }\n            }\n\n            &.card-show {\n                display: block;\n            }\n\n            &__finalstate {\n                p {\n                    font-size: 15px;\n                    font-weight: 600;\n\n                    @media #{$mq-sm} {\n                        font-size: 13px;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &--2,\n                &--row {\n                    @include fflex();\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n                        margin-bottom: 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n\n                        p {\n                            position: relative;\n                            padding-left: 10px;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 8px;\n                                left: 0;\n                                width: 5px;\n                                height: 5px;\n                                border-radius: 50%;\n                                background-color: #444;\n                            }\n                        }\n                    }\n                }\n\n                &--cc {\n                    display: block;\n                    column-count: 2;\n\n                    @media #{$mq-sm} {\n                        column-count: 1;\n                    }\n\n                    &>div {\n                        -webkit-column-break-inside: avoid;\n                        page-break-inside: avoid;\n                        break-inside: avoid;\n                    }\n                }\n\n                &--3 {\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n                        margin-bottom: 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n\n                        p {\n                            position: relative;\n                            padding-left: 10px;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 8px;\n                                left: 0;\n                                width: 5px;\n                                height: 5px;\n                                border-radius: 50%;\n                                background-color: #444;\n                            }\n                        }\n                    }\n                }\n            }\n\n            &__listwidthdot {\n\n                ul {\n                    padding-left: 30px;\n                }\n            }\n\n            &__subtitle {\n                padding-left: 35px;\n                margin-bottom: 16px;\n                position: relative;\n\n                &--convtxt {\n                    padding-left: 31px;\n                }\n\n                &>span {\n                    position: absolute;\n                    top: 0;\n                    right: 2px;\n                    opacity: 0.7;\n                    cursor: pointer;\n\n                    &.thinkeyebtn {\n                        right: 40px;\n                    }\n\n                }\n\n                &--pl0 {\n                    padding-left: 0;\n                }\n\n                *:last-child {\n                    margin-bottom: 0;\n                }\n\n                p {\n                    color: #969798;\n                    font-size: 15px;\n\n                    i {\n                        padding-left: 5px;\n                    }\n                }\n            }\n\n            &__strength {\n                p {\n                    &.pl20 {\n                        padding-left: 20px;\n                    }\n                }\n\n                &>* {\n                    margin-bottom: 0;\n\n                    &+* {\n                        margin-top: 4px;\n                    }\n                }\n\n                &+div {\n                    margin-top: 20px;\n                }\n            }\n\n            &__solutionstable {\n                margin-bottom: 20px;\n\n                table {\n                    width: 100%;\n                }\n\n                th,\n                td {\n                    padding: 15px 15px 15px 0;\n                    vertical-align: top;\n                    width: 50%;\n                }\n\n            }\n        }\n\n        .c-radio {\n            label {\n                padding-left: 0;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 2px;\n                    margin-right: 6px;\n                    opacity: 0.6;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                margin: 0;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 50%;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        position: absolute;\n                        color: $clarify-color;\n                        opacity: 0;\n                        font-size: 11px;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $clarify-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .checkbox {\n            margin-top: 0;\n\n            a {\n                i {\n                    color: #676a6c;\n                }\n            }\n\n            .fa.fa-check.disabled {\n                opacity: 0.7;\n            }\n\n            label {\n                min-height: 20px;\n                padding-left: 0;\n                margin-bottom: 0;\n                font-weight: 400;\n                cursor: pointer;\n                width: auto !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                @media #{$mq-sm} {\n                    font-size: 14px;\n                }\n\n                &>i {\n                    position: relative;\n                    top: 1px;\n                    margin-right: 3px;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        font-size: 12px;\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $develop-color;\n                        background-color: $develop-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .card-body__button {\n            background-color: #f5f5f5;\n            border-top: 1px solid #e3e3e3;\n            padding: 12px 40px;\n\n            .card-button {\n                margin: 0;\n                @include fflex();\n                @include fflex-aic();\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    text-align: center;\n                    @include transition-slow();\n\n                    &+.btn {\n                        margin-left: 15px;\n                    }\n\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n                }\n\n                .float-right {\n                    margin-left: auto;\n                }\n\n                .btn-develop {\n                    background-color: $develop-color;\n                    border-color: $develop-color;\n                    color: #fff;\n\n                    &:hover {\n                        background-color: $develop-color;\n                        border: 1px solid $develop-color;\n                    }\n                }\n\n                .btn-danger {\n                    background-color: #fff;\n                    border-color: #fff;\n                    color: #ef6272;\n\n                    &:hover {\n                        background-color: #ED2D2D;\n                        border-color: #EC2121;\n                    }\n                }\n\n                .btn-warning {\n                    em {\n                        margin: 0;\n                    }\n                }\n\n                .btn-deleteall {\n                    border: 0;\n                    background-color: transparent;\n                    position: relative;\n                    overflow: hidden;\n                    box-shadow: none;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n\n                    span {\n                        position: absolute;\n                        left: 110%;\n                        @include transition-slow();\n                    }\n\n                    &:hover {\n                        background-color: #fff;\n                        color: #ed5562;\n                        padding-right: 16px;\n                        padding-left: 16px;\n\n                        @media #{$mq-sm} {\n                            padding-right: 7px;\n                            padding-left: 7px;\n                        }\n\n                        &>span {\n                            position: relative;\n                            left: 0;\n                        }\n\n                        em {\n                            margin-right: 6px;\n                        }\n                    }\n\n                    em {\n                        font-size: 1em;\n                        margin-right: 0;\n                        @include transition-slow();\n                    }\n                }\n            }\n        }\n\n        .card-body--ebtn {\n            margin-top: 15px;\n\n            .card-body--ebtnrow {\n                margin: 0 -8px;\n                @include fflex();\n                @include fflex-aic();\n\n                &>div {\n                    padding: 0 8px;\n\n                    @media #{$mq-sm} {\n                        width: 100%;\n                        text-align: center;\n\n                        &+div {\n                            margin-top: 10px;\n                        }\n                    }\n\n                    &.card-body--col {\n                        &--last {\n                            margin-left: auto;\n                        }\n                    }\n                }\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    padding: 7px 16px;\n                    text-align: center;\n                    transition: all ease 0.3s;\n                    font-weight: 900;\n                    cursor: pointer;\n\n                    @media #{$mq-md} {\n                        font-size: 12px;\n                    }\n\n                    i {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n\n                    &--save {\n                        background-color: $develop-color;\n                        color: #fff;\n                        font-weight: 900;\n                    }\n\n                    &--disable {\n                        opacity: 0.5;\n                    }\n\n                    &--cancel {\n                        padding: 0;\n                        background-color: transparent;\n                        color: $body-content-color;\n                        font-family: $font-stack;\n                        font-size: 14px;\n                        font-weight: 700;\n                        border: 0;\n                        cursor: pointer;\n\n                        &:hover {\n                            color: #000;\n                        }\n                    }\n\n                    &--close {\n                        border-color: $develop-color;\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                        border-color: #6d6e71;\n                    }\n\n                    &--converge {\n                        padding: 0 8px;\n                    }\n\n                    &--deleteall {\n                        border: 0;\n                        background-color: transparent;\n                        position: relative;\n                        overflow: hidden;\n                        box-shadow: none;\n                        padding-right: 0;\n                        padding-left: 0;\n                        @include transition-slow();\n\n                        i {\n                            font-size: 14px;\n                            color: $body-content-color;\n                        }\n\n                        span {\n                            position: absolute;\n                            left: 110%;\n                            @include transition-slow();\n                            font-weight: 900;\n                        }\n\n                        &:hover {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px !important;\n                            }\n                        }\n\n                        em {\n                            font-size: 1em;\n                            margin-right: 0;\n                            @include transition-slow();\n                        }\n                    }\n                }\n            }\n        }\n\n        .strengthen-input-tabs {\n            width: 90%;\n            display: inline-block;\n            margin-right: 20px;\n\n            input {\n                height: 35px;\n                padding: 10px 15px;\n                border: 1px solid $develop-color;\n                border-radius: 4px;\n                margin-bottom: 15px;\n            }\n        }\n\n        .input-tabs.cdk-drag {\n            width: 100% !important;\n\n            p {\n                margin-bottom: 5px;\n            }\n        }\n\n        .note-3 {\n            padding: 15px 15px 10px;\n            border: 2px solid $clarify-color;\n            margin-bottom: 15px;\n\n            label {\n                color: $clarify-color;\n            }\n        }\n\n        .footer-line {\n            color: $clarify-color;\n        }\n\n        p {\n            font-size: 15px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        .card-body__edit {\n            position: relative;\n\n            .breakthrough-input-tabs,\n            .datadump-input-tabs {\n                width: 100%;\n                margin-right: 0;\n                position: relative;\n\n                input,\n                select {\n                    height: 45px;\n                    padding: 5px 15px;\n                    border: 1px solid $color-neutral-mid;\n                    border-radius: 4px;\n                    font-size: 15px;\n\n                    @media #{$mq-sm} {\n                        font-size: 13px;\n                    }\n                }\n\n                .card-body__minus {\n\n                    &--hide {\n                        display: none;\n                    }\n                }\n            }\n\n            .card-body__editrow {\n                margin: 0 -15px;\n                @include fflex();\n\n                &>div {\n                    padding: 0 15px;\n                    width: 100%;\n                    margin-bottom: 15px;\n\n                    &.card-body__editcol.hideblk {\n                        display: none;\n                    }\n\n                    &.card-body__editcol--2 {\n                        width: calc(100% / 2);\n                    }\n\n                    &>div {\n                        position: relative;\n                    }\n                }\n\n                select {\n                    -webkit-appearance: none;\n                    -moz-appearance: none;\n                    appearance: none;\n                    background-image: url($assets+'/images/select.png');\n                    background-size: 10px;\n                    background-position: right 10px center;\n                    background-repeat: no-repeat;\n                }\n\n                textarea {\n                    width: 100%;\n                    border: 1px solid $color-neutral-mid;\n                    resize: none;\n                    border-radius: 3px;\n                    padding: 10px 15px;\n                    font-size: 15px;\n\n                    &:focus,\n                    &:focus-visible {\n                        outline: none;\n                    }\n                }\n\n                .breakthrough-input-tabs,\n                .breakthrough-input-tabs {\n                    @include fflex();\n\n                    &>.card-body__editlabel {\n                        width: 35px;\n                        @include fflex();\n                        @include fflex-aic();\n                        justify-content: center;\n                        text-align: center;\n\n                        label {\n                            margin-bottom: 0;\n                        }\n                    }\n\n                    &>.card-body__editnumber {\n                        width: 40px;\n                        text-align: center;\n                        @include fflex();\n                        @include fflex-aic();\n                        @include fflex-jcc;\n                        border-right: 0;\n                        border-radius: 4px 0 0 4px;\n\n                        &+.card-body__editinput {\n                            width: calc(100% - 41px);\n                            padding-right: 60px;\n\n                            input {\n\n                                &:focus,\n                                &:focus-visible {\n                                    outline: none;\n                                }\n                            }\n                        }\n\n                        label {\n                            margin-bottom: 0;\n                            font-weight: 900;\n                        }\n                    }\n\n                    &>.card-body__editselect {\n                        // width: 315px;\n                        width: 158px;\n                        padding-right: 15px;\n\n                        &--wd {\n                            width: 255px;\n                        }\n\n                        select {\n\n                            &:focus {\n                                outline: $develop-color;\n                            }\n                        }\n\n\n                        @media #{$mq-sm} {\n                            width: 100%;\n                            padding-right: 0;\n                            margin-bottom: 10px;\n                        }\n                    }\n\n                    &>.card-body__editinput {\n                        // width: calc(100% - 351px);\n                        width: calc(100% - 195px);\n                        padding-right: 60px;\n\n                        &--wd {\n                            width: calc(100% - 260px);\n                        }\n\n                        &--ce {\n                            position: relative;\n\n                            .converge-icon {\n                                position: absolute;\n                                top: 50%;\n                                transform: translateY(-50%);\n                                left: 7px;\n                                font-size: 26px;\n                                color: $develop-color;\n\n                                &:hover>.card-body__tooltip,\n                                &:active>.card-body__tooltip {\n                                    display: block;\n                                }\n\n                                .card-body__tooltip {\n                                    display: none;\n                                    font-size: 16px;\n                                    color: #676a6c;\n                                    position: absolute;\n                                    bottom: 100%;\n                                    left: 0;\n                                    background: #fff;\n                                    padding: 5px;\n                                    border-radius: 5px;\n                                    box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                    width: max-content;\n                                }\n                            }\n\n                            input {\n                                padding-left: 26px;\n\n                                &:focus,\n                                &:focus-visible {\n                                    outline: none;\n                                }\n                            }\n\n                        }\n\n                        input {\n                            padding-right: 70px;\n\n                            &:focus,\n                            &:focus-visible {\n                                outline: none;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            width: 100%;\n                            ;\n                        }\n\n                        .input-group-text {\n                            @media #{$mq-sm} {\n                                top: auto;\n                                transform: translate(0);\n                                bottom: 9px;\n                            }\n                        }\n                    }\n\n                    &>.card-body__editinput:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n\n            &+.card-body__addnew {\n\n                button {\n                    font-size: 14px;\n                    font-weight: bold;\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding-right: 0;\n                    padding-left: 0;\n                    margin: 0 35px;\n                    color: $body-content-color;\n                    @include transition-slow();\n\n                    &:hover {\n                        background-color: $develop-color;\n                        border: 1px solid $develop-color;\n                        color: #fff;\n                        padding-right: 12px;\n                        padding-left: 12px;\n                    }\n                }\n            }\n        }\n\n        .breakthrough-input-tabs {\n            width: 90%;\n            display: inline-block;\n            margin-right: 20px;\n\n            input {\n                height: 35px;\n                padding: 10px 15px;\n                border: 1px solid $develop-color;\n                border-radius: 4px;\n            }\n        }\n\n        .input-group-text {\n            cursor: pointer;\n            padding: 3px 16px;\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 1.528571429;\n            color: #495057;\n            text-align: center;\n            white-space: nowrap;\n            background-color: #E9ECEF;\n            border: 1px solid #DDE6E9;\n            border-radius: 0.25rem;\n            position: absolute;\n            top: calc(50% + 1px);\n            right: 0;\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n            @include transition-slow();\n\n            &:hover {\n                background-color: $develop-color;\n                border-color: $develop-color;\n                color: #fff;\n            }\n        }\n\n        .list-columns {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n            counter-reset: section;\n\n            &>div {\n                width: 50%;\n\n                &.card__body--cswrapper {\n                    width: 100%;\n                    position: relative;\n                    border-bottom: 1px solid #e4e4e4;\n                    padding-bottom: 5px;\n                    margin-bottom: 10px;\n\n                    &>div {}\n\n                    &::before,\n                    &::after {\n                        content: \"\";\n                        position: absolute;\n                        bottom: -1px;\n                        right: calc(100%);\n                        width: 40px;\n                        height: 1px;\n                        background-color: #e4e4e4;\n                    }\n\n                    &::after {\n                        right: auto;\n                        left: calc(100%);\n                    }\n                }\n            }\n\n            // &>div {\n            //     width: 50%;\n            // }\n            &.list-columns--2 {\n                &>div {\n                    width: 100%;\n                }\n            }\n\n            &--tc {\n                border-bottom: 1px solid #e4e4e4;\n                margin-bottom: 10px;\n            }\n\n            .brainstorm-tabs {\n                position: relative;\n                padding-left: 23px;\n\n                &::before {\n                    counter-increment: section;\n                    content: counter(section) \".\";\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                }\n            }\n        }\n\n        &.editmodeActive {\n            @include fflex();\n            justify-content: space-between;\n            box-shadow: none;\n            background: #fff;\n            padding: 40px 35px;\n            position: relative;\n\n            &--not {\n                padding: 0;\n            }\n\n            .editinput {\n                &.top_idea {\n                    width: 100%;\n                }\n\n                &.gridView {\n                    &>.card-body__petopcol {\n                        display: grid;\n                        grid-template-columns: repeat(2, 1fr);\n                        grid-gap: 15px;\n\n                        @media #{$mq-sm} {\n                            grid-template-columns: 1fr;\n                        }\n\n                        .EditmodeInputs {\n\n                            &>f-col-12 {\n                                height: 100%;\n                            }\n                        }\n\n                        &--1 {\n                            grid-template-columns: 1fr;\n                        }\n\n                        &--3 {\n\n                            &>div:nth-child(1) {\n                                grid-row: 1 / 3;\n                            }\n                        }\n\n                        &--4 {\n\n                            &>div:nth-child(1) {\n                                grid-row: 1 / 4;\n                            }\n                        }\n\n                        &--5 {\n\n                            &>div:nth-child(1) {\n                                grid-row: 1 / 5;\n                            }\n                        }\n\n                        &--6 {\n\n                            &>div:nth-child(1) {\n                                grid-row: 1 / 6;\n                            }\n                        }\n\n                        &--7 {\n\n                            &>div:nth-child(1) {\n                                grid-row: 1 / 7;\n                            }\n                        }\n\n                    }\n                }\n\n                &.listView {\n                    width: 100%;\n\n                    .EditmodeInputs {\n\n                        &+div {\n                            margin-top: 15px;\n                        }\n\n                        .f-col-12 {\n                            float: none;\n                        }\n                    }\n\n                }\n\n                &.individualView {\n                    .card-body__petopcol {\n                        @include fflex();\n                        justify-content: space-between;\n                        margin: 0 -15px;\n\n                        .EditmodeInputs {\n                            flex: 1;\n                            padding: 0 7px;\n\n                            @media #{$mq-sm} {\n                                flex: none;\n                                width: 100%;\n\n                                &+div {\n                                    margin-top: 15px;\n                                }\n                            }\n\n                            .row {\n                                margin-right: 0;\n                                margin-left: 0;\n                            }\n                        }\n                    }\n                }\n\n                .f-col-12 {\n                    background-color: #EBEBEB;\n                    // margin: 5px;\n                    border: 1px solid $cn-border-color;\n                    border-radius: 6px;\n                    overflow: hidden;\n\n                    .card-body__petopcol {\n                        padding: 10px 15px;\n\n                        h3,\n                        h4 {\n                            margin-bottom: 5px;\n                            color: $develop-color;\n                            font-size: 18px;\n                            white-space: nowrap;\n\n                            a {\n                                i {\n                                    cursor: pointer;\n                                    font-size: 0.9em;\n                                    color: $develop-color;\n                                }\n                            }\n                        }\n\n                        &--ideateclr {\n                            h3 {\n                                color: #676A6C;\n\n                                a {\n                                    i {\n                                        color: #676A6C;\n                                    }\n                                }\n                            }\n                        }\n\n                        p {\n                            font-weight: 600;\n                        }\n\n                        .card-body__finalstate {\n                            position: relative;\n\n                            &.SolutionHeight {\n\n                                // height: 100%!important;\n                                span {\n                                    svg {\n                                        transform: rotate(0deg);\n                                        cursor: pointer;\n                                    }\n                                }\n                            }\n\n                            span {\n                                position: absolute;\n                                bottom: -12px;\n                                right: -5px;\n\n                                svg {\n                                    transform: rotate(180deg);\n                                    cursor: pointer;\n                                }\n                            }\n\n                            &.TopIdeasInput {\n                                span {\n                                    cursor: pointer;\n                                    position: relative;\n                                    top: 0;\n                                    left: 10px;\n\n                                    svg {\n                                        width: 10px;\n                                        transform: rotate(180deg);\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n\n                input {\n\n                    &:focus,\n                    &:focus-visible {\n                        outline: none;\n                    }\n                }\n            }\n        }\n\n        &.ediMode__pf {\n            margin-top: 0;\n\n            &--wbg {\n                background-color: #fff;\n            }\n\n            &>span {\n                padding: 2px 16px;\n                background-color: #6d6e71;\n                color: #fff;\n                margin-left: 40px;\n                border-radius: 5px;\n                border-bottom-left-radius: 0;\n                border-bottom-right-radius: 0;\n                font-size: 10px;\n            }\n\n            .card-body--ebtn {\n                margin-top: 0;\n                padding: 15px 40px;\n\n                @media #{$mq-md} {\n                    padding: 12px 20px;\n                }\n\n                .card-body--ebtnrow {\n                    // padding: 0 15px;\n                }\n            }\n\n            .new-thinking {\n                background-color: #fff;\n            }\n\n            .card-body__ipwrap {\n                // padding-right: 24px;\n            }\n\n            .card-body--ebtnrow>div {\n                // margin-left: 25px;\n                // padding: 10px;\n            }\n\n            .card-body__inner {\n                padding: 0;\n            }\n\n            .info {\n                padding: 14px 40px;\n\n                @media #{$mq-md} {\n                    padding: 12px 20px;\n                }\n\n            }\n\n            .card-body__backouter {\n                border-bottom: 1px solid $cn-border-color;\n                padding-right: 40px;\n                padding-bottom: 50px;\n                padding-left: 40px;\n\n                // min-height: 400px;\n                &.plus {\n                    // min-height: 480px;\n                }\n\n                &-headingmobile {\n                    display: none;\n\n                    @media #{$mq-sm} {\n                        display: block;\n                    }\n                }\n\n                &-headingdesk {\n                    padding-left: 13px;\n\n                    @media #{$mq-sm} {\n                        display: none;\n                    }\n\n                    .card-body__ipwrap {\n                        margin-bottom: 0;\n                    }\n\n                    .card-body__ipcol {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &-pincontent {\n                    overflow-y: auto;\n                    overflow-x: hidden;\n                }\n\n                @media #{$mq-md} {\n                    padding-right: 20px;\n                    padding-left: 20px;\n                }\n\n            }\n\n            .card-body__pe {\n                border-bottom: none;\n\n                &>div {\n                    padding: 0;\n                }\n\n                h4 {\n                    font-size: 25px;\n                    color: #fff;\n                    font-family: \"Museo-700\";\n                    font-weight: 700;\n                    white-space: nowrap;\n\n                    @media #{$mq-md} {\n                        font-size: 18px;\n                    }\n\n                    @media #{$mq-sm} {\n                        font-size: 15px;\n                        padding-left: 35px;\n                        word-break: break-word;\n                        white-space: normal;\n                    }\n\n                    .card__bwnh3ai {\n                        display: inline-flex;\n                        align-items: center;\n                        vertical-align: middle;\n                        margin-left: 6px;\n                        padding: 6px 8px;\n                        cursor: pointer;\n                        color: #fff;\n                        font-size: 14px;\n                        border-radius: 4px;\n                        transition: opacity 0.2s ease;\n\n                        &:hover {\n                            opacity: 0.7;\n                        }\n\n                        i {\n                            font-size: 14px;\n                        }\n                    }\n\n                    &::before {\n                        background-color: #fff;\n                        color: $develop-color;\n                        font-family: \"Museo-700\";\n                        font-weight: 700;\n\n                        @media #{$mq-sm} {\n                            width: 20px;\n                            height: 20px;\n                            font-size: 15px;\n                        }\n                    }\n                }\n\n                .card-body__petop {\n                    background-color: $develop-color;\n                    position: relative;\n\n                    .card__topcol--tt {\n\n                        .tooltipicon__icon {\n                            color: #fff;\n                            cursor: pointer;\n                        }\n                    }\n\n                    .card-body__petoprow {\n\n                        // width: 85%;\n                        @media only screen and (max-width:1199px) {\n                            // width: 90%;\n                        }\n\n                        .card-body__petopcol {\n\n                            @media only screen and (max-width: 1199px) {\n                                // width: calc(100% /2);\n                            }\n\n                            &.card-body__petopcol--tab {\n                                ul {\n                                    li {\n                                        button {\n                                            min-height: 40px;\n                                            padding: 6px 24px;\n                                            background-color: #fff;\n                                            color: $develop-color;\n\n                                            @media #{$mq-md} {\n                                                padding: 4px 6px;\n                                                font-size: 13px;\n                                                min-height: auto;\n                                                height: auto;\n                                                width: auto;\n                                            }\n\n                                            svg {\n                                                .st0 {\n                                                    fill: #fff\n                                                }\n                                            }\n                                        }\n                                    }\n\n                                }\n\n                                &.card-body__petopcol--ctt {\n                                    position: relative;\n\n                                    ul {\n                                        li {\n                                            .card-body__tooltip {\n                                                display: none;\n                                                position: absolute;\n                                                background: #fff;\n                                                color: #676a6c;\n                                                padding: 5px;\n                                                top: -27px;\n                                                box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                                border-radius: 5px;\n                                                width: max-content;\n\n                                            }\n\n                                            button {\n\n                                                &:hover {\n                                                    opacity: 0.2 !important;\n                                                }\n\n                                            }\n\n                                            &:hover,\n                                            &:active {\n\n                                                .card-body__tooltip {\n                                                    display: block;\n                                                }\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n\n\n\n                            &.card-body__petopcol--title {\n                                &>div:first-child {\n                                    width: 245px;\n                                }\n\n                                .plus {\n                                    h4::before {\n                                        content: \"P\" !important;\n                                    }\n                                }\n\n                                .opp {\n                                    h4::before {\n                                        content: \"O\" !important;\n                                    }\n                                }\n\n                                .issue {\n                                    h4::before {\n                                        content: \"I\" !important;\n                                    }\n                                }\n\n                                .solution_pro_st {\n                                    width: 300px !important;\n                                    margin-left: -40px;\n\n                                    h4:before {\n                                        display: none;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .idea-shop-list {\n        padding: 20px;\n        margin-left: 17px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        li {\n            width: calc(100% / 2);\n            margin-bottom: 10px;\n        }\n    }\n\n    .brainstorm__col {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        margin-bottom: 17px;\n\n        .brainstorm-main {\n            width: calc(100% - 68px);\n            display: inline-block;\n            margin-right: 20px;\n\n            .brainstorm-group {\n                width: 100%;\n                position: relative;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                .input-group-prepend {\n                    margin-right: -1px;\n                    width: 45px;\n\n                    .input-group-text {\n                        background: transparent;\n                        border-color: $develop-color;\n                        height: 35px;\n                        padding: 0;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        align-items: center;\n                        -webkit-box-pack: center;\n                        -ms-flex-pack: center;\n                        justify-content: center;\n                    }\n                }\n\n                input {\n                    width: calc(100% - 45px);\n                    height: 35px;\n                    border: 1px solid $ideate-color;\n                    border-radius: 0 0.25rem 0.25rem 0;\n                }\n            }\n        }\n    }\n\n    .card-body__pe {\n        padding: 0px;\n        border: 1px solid $cn-border-color;\n        margin-bottom: 20px;\n        @include fflex();\n        float: none;\n\n        &--npnb {\n            border: none;\n            margin-bottom: 0;\n\n            .pluses {\n                border: none !important;\n                padding: 0;\n\n                form {\n                    padding-left: 0 !important;\n                }\n            }\n\n            .opportunities {\n                border: none !important;\n                padding: 0;\n\n                form {\n                    padding-left: 0 !important;\n                }\n            }\n\n            .issues {\n                border: none !important;\n                padding: 0;\n\n                form {\n                    padding-left: 0 !important;\n                }\n            }\n\n            .new-thinking {\n                border: none !important;\n                padding: 0;\n\n                form {\n                    padding-left: 0 !important;\n                }\n\n                .card-body__ipwrap {\n                    margin-bottom: 0;\n\n                    .card-body__ipcol:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n\n        .card-body__petop {\n            margin-bottom: 13px;\n\n            .card-body__petoprow {\n                @include fflex();\n\n                .card-body__petopcol {\n                    padding: 0 15px;\n\n                    &--full {\n                        width: 100% !important;\n                    }\n\n                    &:nth-child(1) {\n                        width: 28%;\n\n                        @media #{$mq-sm} {\n                            flex: 1;\n                        }\n                    }\n\n                    &:nth-child(2) {\n                        width: 44%;\n\n                        @media #{$mq-sm} {\n                            width: 120px;\n                        }\n                    }\n\n                    &:nth-child(3) {\n                        width: 28%;\n                        text-align: right;\n\n                        @media #{$mq-sm} {\n                            width: auto;\n                        }\n                    }\n\n\n\n                    &.card-body__petopcol--title {\n                        @include fflex();\n                        @include fflex-aic();\n\n                        &>div:first-child {\n                            width: 215px;\n                            padding-right: 15px;\n\n                            @media #{$mq-sm} {\n                                width: auto;\n                                padding-right: 5px;\n                            }\n                        }\n\n                        &>div:nth-child(2) {\n                            width: calc(100% - 216px);\n                        }\n\n                        button.card__h3button {\n                            border: 1px solid $develop-color;\n                            background-color: transparent;\n                            padding: 4px 26px;\n                            border-radius: 3px;\n                            @include headingfont();\n                            color: $develop-color;\n                            font-size: 22px;\n                            transition: all ease 0.3s;\n                            cursor: pointer;\n\n                            &:hover {\n                                background-color: $develop-color;\n                                color: #fff;\n                            }\n\n                            &:focus {\n                                outline: none;\n                            }\n                        }\n                    }\n\n                    &.card-body__petopcol--startexist {\n                        width: 65%;\n                    }\n\n                    &.card-body__petopcol--tab {\n                        @include fflex();\n                        @include fflex-jcc();\n\n                        ul {\n                            @include fflex();\n                            flex-wrap: nowrap;\n                            margin: 0;\n                            padding: 0;\n                            border-radius: 3px;\n\n                            li {\n                                list-style: none;\n\n                                &:first-child {\n                                    button {\n                                        svg {\n                                            right: calc(100% + 1px)\n                                        }\n\n                                        span.card__topcount {\n                                            @media only screen and (max-width: 630px) {\n                                                left: -30px;\n                                            }\n                                        }\n                                    }\n                                }\n\n                                &:last-child {\n                                    button {\n                                        svg {\n                                            left: calc(100% + 1px);\n                                        }\n\n                                        span.card__topcount {\n                                            @media only screen and (max-width: 630px) {\n                                                right: -30px;\n                                            }\n                                        }\n                                    }\n                                }\n\n                                &:only-child {\n                                    button {\n                                        border-radius: 3px;\n                                    }\n                                }\n\n                                &.card__topactive {\n                                    button {\n                                        color: $develop-color;\n                                        border: 1px solid $develop-color;\n\n                                        span.card__topcount {\n                                            color: $develop-color;\n                                            background-color: #efefef;\n\n                                            &.redConverge_count {\n                                                background-color: #EC2121;\n                                                color: #fff;\n                                            }\n                                        }\n                                    }\n                                }\n\n                                &.card__topcomplete {\n                                    button {\n                                        opacity: 0.2;\n                                        border: 1px solid $develop-color;\n                                        color: $develop-color;\n\n                                        span.card__topcount {\n                                            color: $develop-color;\n                                            background-color: #efefef;\n\n                                            &.redConverge_count {\n                                                background-color: #EC2121;\n                                                color: #fff;\n                                            }\n                                        }\n                                    }\n                                }\n\n                                button {\n                                    position: relative;\n                                    color: $develop-color;\n                                    font-size: 17px;\n                                    padding: 6px 14px;\n                                    @include headingfont();\n                                    display: inline-block;\n                                    height: 100%;\n                                    border: 0;\n                                    border: 1px solid #7bbc43;\n                                    height: auto;\n                                    min-height: 42px;\n                                    background-color: transparent;\n                                    @include transition-slow();\n                                    -webkit-appearance: none;\n                                    -moz-appearance: none;\n                                    appearance: none;\n\n                                    svg {\n                                        position: absolute;\n                                        top: -1px;\n                                        height: calc(100% + 2px);\n\n                                        .st0 {\n                                            fill: $develop-color;\n                                        }\n                                    }\n\n                                    @media only screen and (max-width: 630px) {\n                                        padding: 6px 0;\n                                        border: 0 !important;\n                                        width: 0;\n                                        height: 24px;\n                                        min-height: auto;\n                                    }\n\n                                    @media only screen and (min-width:630px) and (max-width: 991px) {\n                                        padding: 6px 7px;\n                                    }\n\n                                    &:focus {\n                                        outline: none;\n                                        box-shadow: none;\n                                    }\n\n                                    &>.card__topdesktext {\n                                        @media only screen and (max-width: 1180px) {\n                                            display: none;\n                                        }\n                                    }\n\n                                    &>.card__topmobiletext {\n                                        display: none;\n\n                                        @media only screen and (max-width: 1180px) {\n                                            display: inline-block;\n                                        }\n\n                                    }\n\n                                    &>span.card__topcount {\n                                        width: 16px;\n                                        height: 16px;\n                                        line-height: 16px;\n                                        display: inline-block;\n                                        text-align: center;\n                                        font-size: 0.5em;\n                                        background-color: $develop-color;\n                                        color: #fff;\n                                        margin-left: 4px;\n                                        border-radius: 50%;\n                                        vertical-align: bottom;\n                                        position: relative;\n                                        top: -1px;\n\n                                        @media only screen and (max-width: 630px) {\n                                            position: absolute;\n                                            top: auto;\n                                            bottom: -2px;\n                                            right: 0;\n                                            margin: 0;\n                                        }\n                                    }\n\n                                    &:hover {\n                                        color: $develop-color;\n                                        opacity: 1;\n                                    }\n\n                                    &:hover>span.card__topcount {\n                                        color: $develop-color;\n                                        background-color: #efefef;\n                                        opacity: 1;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    &.card-body__petopcol--info {\n                        text-align: right;\n\n                        .tooltipicon {\n                            cursor: pointer;\n                            position: relative;\n                            font-size: 18px;\n                            display: inline-block;\n\n                            i {\n                                color: #7bbc43;\n                            }\n                        }\n                    }\n\n                }\n\n                p.new-think-issue {\n                    margin-top: 10px;\n                }\n\n                .convergeMsg {\n                    width: calc(100%/3);\n                }\n            }\n\n\n        }\n\n        &>div {\n            padding: 25px;\n\n            @media only screen and (max-width: 767px) {\n                width: 100%;\n            }\n        }\n\n        .pluses {\n            border-bottom: 1px solid $cn-border-color;\n\n            h4::before {\n                content: \"P\";\n            }\n        }\n\n        .opportunities {\n            border-bottom: 1px solid $cn-border-color;\n\n            h4::before {\n                content: \"O\";\n            }\n        }\n\n        .issues {\n            border-bottom: 1px solid $cn-border-color;\n\n            h4::before {\n                content: \"I\";\n            }\n        }\n\n        .new-thinking {\n            h4::before {\n                content: \"Nt\";\n            }\n        }\n\n        // .pluses > form, .opportunities > form, .issues > form, .new-thinking > form, .card-body__backouter {\n        //     padding-left: 52px;\n        // }\n        h4 {\n            position: relative;\n            padding-left: 50px;\n            color: $develop-color;\n            font-size: 19px;\n            margin: 0 0 0;\n            font-family: 'Open Sans', sans-serif;\n\n            @media #{$mq-sm} {\n                padding-left: 35px;\n            }\n\n            &::before {\n                content: \"\";\n                background: $develop-color;\n                color: #fff;\n                font-size: 20px;\n                height: 35px;\n                width: 35px;\n                position: absolute;\n                border-radius: 50%;\n                top: 0;\n                left: 0;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-pack: center;\n                -ms-flex-pack: center;\n                justify-content: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n\n                @media #{$mq-sm} {\n                    width: 25px;\n                    height: 25px;\n                }\n            }\n\n            small {\n                display: block;\n                margin-top: 4px;\n                color: inherit;\n                line-height: 1.3;\n                font-size: 14px;\n                color: #888;\n            }\n        }\n\n        span.fill-bottom {\n            width: 100%;\n            color: #888;\n            font-size: 15px;\n        }\n\n        .icons-right {\n            i {\n                font-size: 21px;\n                color: $develop-color;\n                cursor: pointer;\n\n                &:not(:last-child) {\n                    margin-right: 10px;\n                }\n            }\n        }\n\n        .fill-input {\n            width: calc(100% - 35px);\n            display: inline-block;\n            margin-right: 15px;\n\n            label {\n                display: inline-block;\n                min-width: 20px;\n            }\n\n            input {\n                display: inline-block;\n                width: calc(100% - 20px);\n                height: 34px;\n                border-radius: 3px;\n                margin: 1px 0;\n            }\n        }\n\n        .input-tabs {\n            .input-tabs__row {\n                width: calc(100% - 35px);\n                display: inline-block;\n                margin-right: 15px;\n                position: relative;\n                vertical-align: middle;\n\n                .pr-0 {\n                    padding-right: 0;\n                }\n\n                &>i {\n                    position: absolute;\n                    top: 50%;\n                    right: -26px;\n                    -webkit-transform: translateY(-50%);\n                    -ms-transform: translateY(-50%);\n                    transform: translateY(-50%);\n                }\n            }\n\n            label {\n                display: inline-block;\n                min-width: 20px;\n            }\n\n            input,\n            select {\n                height: 34px;\n                border-radius: 3px;\n                margin: 1px 0;\n            }\n\n            select {\n                display: inline-block;\n                width: calc(100% - 20px);\n            }\n\n            .select_faded {\n                opacity: 0.2;\n                padding-left: 32px;\n            }\n        }\n    }\n\n    .develop-footer-note {\n        color: $develop-color;\n    }\n\n    .card-bottom-button {\n        .button {\n            font-size: 13px;\n            color: #fff;\n            padding: 8px 10px;\n            border-radius: 3px;\n            -webkit-transition: all ease 0.3s;\n            -o-transition: all ease 0.3s;\n            transition: all ease 0.3s;\n\n            &:hover {\n                opacity: .8;\n            }\n\n            i {\n                font-size: 0.8em;\n            }\n\n            &.btn-clarify {\n                background-color: $clarify-color;\n            }\n\n            &.btn-ideate {\n                background-color: $ideate-color;\n            }\n\n            &.btn-implement {\n                background-color: $implement-color;\n            }\n        }\n    }\n\n    .dotactions {\n        position: relative;\n\n        .dotactions__inner {\n            position: absolute;\n            top: 0;\n            right: 0;\n\n            &--h {\n                top: 5px;\n\n                .dotactions__top {\n                    cursor: pointer;\n                    width: 17px;\n                    -webkit-box-pack: justify;\n                    -ms-flex-pack: justify;\n                    justify-content: space-between;\n                }\n            }\n\n            &--v {\n                right: 10px;\n                top: 11px;\n\n                .dotactions__top {\n                    cursor: pointer;\n                    -webkit-box-orient: vertical;\n                    -webkit-box-direction: normal;\n                    -ms-flex-direction: column;\n                    flex-direction: column;\n                    -webkit-box-pack: justify;\n                    -ms-flex-pack: justify;\n                    justify-content: space-between;\n                    height: 21px;\n                    width: 11px;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    align-items: center;\n                }\n            }\n\n            .dotactions__top {\n                padding-bottom: 4px;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                span {\n                    background-color: #adadad;\n                    width: 3px;\n                    height: 3px;\n                    border-radius: 50%;\n                }\n            }\n\n            .dotactions__dropdown {\n                display: none;\n                background-color: #fff;\n                position: absolute;\n                top: 100%;\n                width: 150px;\n                box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);\n                right: -5px;\n                border-radius: 4px;\n                z-index: 9;\n                border: 1px solid #ddd;\n\n                .dotactions__close {\n                    cursor: pointer;\n                    position: absolute;\n                    top: 5px;\n                    right: 6px;\n                    font-size: 11px;\n                    -webkit-transition: all ease 0.3s;\n                    -o-transition: all ease 0.3s;\n                    transition: all ease 0.3s;\n\n                    &:hover {\n                        -webkit-transform: rotate(360deg);\n                        -ms-transform: rotate(360deg);\n                        transform: rotate(360deg);\n                    }\n                }\n\n                .dotactions__dropdowninner {\n                    display: none;\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    width: 200px;\n                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);\n                    border-radius: 4px;\n                    padding: 18px;\n                    background: #fff;\n                    border: 1px solid #ddd;\n\n                    .dotactions__dropdownin {\n                        padding: 10px 10px;\n                        border-radius: 4px;\n                        min-height: 100%;\n                        background-color: #f4f4f4;\n\n                        h6 {\n                            margin: 0;\n                            font-size: 13px;\n                            font-weight: 600;\n                            margin-bottom: 6px;\n                        }\n                    }\n                }\n\n                &>h6 {\n                    text-align: center;\n                    margin: 0;\n                    font-size: 13px;\n                    padding: 8px 10px;\n                    border-bottom: 1px solid #eee;\n                    font-weight: 400;\n                    margin-bottom: 2px;\n                    background-color: #f4f4f4;\n                }\n\n                li {\n                    margin: 0;\n\n                    a {\n                        padding: 6px 12px;\n                        color: #656565;\n                        display: block;\n                        font-weight: 400;\n\n                        &:hover {\n                            background-color: rgba(9, 30, 66, .04);\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .ideate__ipwrap {\n        overflow-x: auto;\n        padding: 4px 0 20px !important;\n        flex-wrap: nowrap !important;\n    }\n\n    .card-body__ipwrap {\n        padding: 4px 0 100px;\n        margin: 0 -15px 10px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        &m0p0 {\n            margin-bottom: 0;\n            padding-bottom: 0 !important;\n        }\n\n        &--gutter0 {\n            margin: 0 !important;\n            padding: 0;\n        }\n\n        &--scrollx {\n            padding-bottom: 20px !important;\n            -ms-flex-wrap: nowrap;\n            flex-wrap: nowrap;\n            overflow-x: auto;\n\n            &>div {\n                &:not(:last-child) {\n                    margin-right: 30px;\n                }\n            }\n        }\n\n        .card-body__ipcolumn {\n            max-width: 250px;\n            padding: 0 0;\n            width: 100%;\n            -webkit-box-flex: 0;\n            -ms-flex: 0 0 250px;\n            flex: 0 0 250px;\n\n            .card-body__listwidthdot {\n                margin-bottom: 10px;\n                margin-bottom: 0;\n                border: 1px solid $body-content-color;\n\n                &>div {\n                    padding: 10px;\n\n                    p {\n                        position: relative;\n\n                        &::before {\n                            position: absolute;\n                            top: 8px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n                    }\n                }\n\n                &_converge {\n                    border: none;\n                }\n            }\n\n            // &:first-child{\n            //     .card-body__listwidthdot {\n            //         border: 0;\n            //         & > div {\n            //             padding: 10px 10px 10px 0;\n            //         }\n            //     }\n            // }\n        }\n\n        &.card-body__ipwrap--pb0 {\n            padding-bottom: 0;\n        }\n\n        .card-body__ipcol {\n            padding: 0 15px;\n            margin-bottom: 20px;\n            width: calc(100% / 2);\n\n            @media only screen and (max-width: 1080px) {\n                width: calc(100% / 2);\n            }\n\n            @media #{$mq-sm} {\n                width: 100%;\n            }\n\n            .card-body__ipaddcol {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                &>.form-control {\n                    width: calc(100% - 91px);\n                }\n\n                .input-group-postpend {\n                    width: 90px;\n\n                    button {\n                        border-top-left-radius: 0;\n                        border-bottom-left-radius: 0;\n                    }\n                }\n            }\n\n            &--ideate {\n                padding: 0;\n                margin-bottom: 0px;\n                max-width: 270px;\n                width: 100%;\n                flex: 0 0 270px;\n                -webkit-flex: 0 0 270px;\n                -ms-flex: 0 0 270px;\n\n                .checkbox {\n                    padding-right: 22px;\n                }\n\n                &+div {\n                    margin-left: 30px;\n                }\n\n                @media only screen and (max-width: 1080px) {\n                    width: calc(100% / 2);\n                }\n\n                @media only screen and (max-width: 600px) {\n                    width: calc(100%);\n                }\n\n                h2 label {\n                    font-size: 15px;\n                }\n            }\n        }\n\n        h2 {\n            margin-top: 0;\n            color: #656565;\n            font-size: 14px;\n            font-weight: 500;\n            margin-bottom: 12px;\n\n            label {\n                display: inline-block;\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n\n                &+span {\n                    position: relative;\n                    top: -2px;\n                    margin: 0 10px 0 0;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    text-align: center;\n\n                    &::before {\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked+span {\n                    background-color: #5D9CEC;\n                    border-color: #5D9CEC;\n                }\n\n                &:checked+span::before {\n                    opacity: 1;\n                }\n            }\n        }\n\n        ul {\n            padding: 0;\n            margin: 0;\n\n            li {\n                list-style: none;\n                padding: 0;\n                width: 100%;\n\n                .card-body__edit {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    -ms-flex-wrap: wrap;\n                    flex-wrap: wrap;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    align-items: center;\n\n                    .form-control {\n                        height: 45px;\n                    }\n\n                    &>i {\n                        margin-left: auto;\n                        cursor: pointer;\n                        color: $develop-color;\n                    }\n                }\n\n                &:last-child {\n                    .card-body__edit {\n                        input {\n                            width: calc(100% - 30px);\n                        }\n                    }\n                }\n\n                .card-body__ipinner {\n                    display: block;\n                    font-size: 15px;\n                    position: relative;\n                    border: 1px solid #ccc;\n                    padding: 10px;\n                    border-radius: 5px;\n                }\n            }\n        }\n    }\n\n    .compare-sol {\n        width: 49%;\n        float: left;\n    }\n\n    .fullwidth {\n        width: 100%;\n        display: block;\n    }\n\n    .card_solution {\n        b {\n            font-size: 15px;\n        }\n\n        .solution-list {\n            margin-bottom: 10px;\n            width: 100%;\n            margin-top: 10px;\n\n            span {\n                display: block;\n            }\n\n            &__selection1 {\n                margin-top: 10px;\n            }\n\n            &__selection2 {\n                margin-left: 20px;\n            }\n        }\n    }\n}\n\n\n.develop-is .card-body__ipwrap ul li {\n    position: relative;\n\n    input[type=\"checkbox\"] {\n        position: absolute;\n        top: 11px;\n        left: 10px;\n        z-index: 2;\n\n        &+label {\n            padding-left: 31px;\n        }\n    }\n}\n\n.tooltippopup {\n    max-width: 360px;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    position: fixed;\n    top: 0;\n    right: -550px;\n    padding: 45px 24px 24px;\n    text-align: left;\n    z-index: 9999;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n    @include transition-slow();\n    overflow-y: auto;\n\n    &--active {\n        right: 0;\n    }\n\n    &--videoexist {\n        max-width: 735px;\n    }\n\n    &__btn {\n        @include fflex();\n        padding: 0;\n        margin: 0 0 10px;\n\n        li {\n            list-style: none;\n            text-align: center;\n            cursor: pointer;\n            width: calc(100% / 3);\n\n            button {\n                width: 100%;\n                color: $develop-color;\n                font-size: 12px;\n                padding: 6px 16px;\n                @include headingfont();\n                display: inline-block;\n                height: 100%;\n                border: 0;\n                border: 1px solid $develop-color;\n                background-color: transparent;\n                transition: all ease 0.3s;\n                @include appearance-none();\n\n                &:focus {\n                    outline: none;\n                }\n\n                &.tooltippopup__btncompleted {\n                    opacity: 0.2;\n\n                    &:hover {\n                        opacity: 1;\n                    }\n                }\n\n                &.tooltippopup__btnactive {\n                    opacity: 1;\n                }\n\n                &:hover {\n                    position: relative;\n                    z-index: 9;\n                }\n            }\n\n            &+li {\n                margin-left: -1px;\n            }\n\n            &:first-child {\n                button {\n                    border-radius: 3px 0 0 3px\n                }\n            }\n\n            &:last-child {\n                button {\n                    border-radius: 0 3px 3px 0;\n                }\n            }\n        }\n    }\n\n    h4 {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 16px;\n        line-height: 1.2;\n    }\n\n    p {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 14px;\n        line-height: 1.4;\n    }\n\n    &__close {\n        position: absolute;\n        top: 10px;\n        right: 25px;\n        width: 18px;\n        height: 18px;\n        cursor: pointer;\n        @include transition-slow();\n\n        &:hover {\n            -webkit-transform: rotate(360deg);\n            -ms-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n\n        &>div {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n\n            span {\n                position: absolute;\n                background: #676a6c;\n\n                &:nth-child(1) {\n                    top: 0;\n                    left: calc(50% - 1px);\n                    width: 2px;\n                    height: 100%;\n                }\n\n                &:nth-child(2) {\n                    top: calc(50% - 1px);\n                    left: 0;\n                    width: 100%;\n                    height: 2px;\n                }\n            }\n        }\n    }\n\n    &__child {\n        margin-top: 20px;\n\n        &data {\n            .table-responsive {\n                overflow-x: auto;\n                margin-bottom: 10px;\n\n                table {\n                    min-width: 297px;\n                    border: 1px solid #e7eaec;\n\n                    th,\n                    td {\n                        border: 1px solid #e7eaec;\n                        min-width: 120px;\n                    }\n                }\n\n                &+* {\n                    margin-top: 20px;\n                }\n            }\n\n            &--clarify {\n                h4 {\n                    color: $clarify-color;\n                }\n            }\n\n            &--ideate {\n                h4 {\n                    color: $ideate-color;\n                }\n            }\n\n            &--develop {\n                h4 {\n                    color: $develop-color;\n                }\n            }\n\n            &--implement {\n                h4 {\n                    color: $implement-color;\n                }\n            }\n\n            h4 {\n                font-size: 16px;\n                font-weight: 500;\n                margin: 0 0 2px;\n                @include headingfont();\n\n                &+h5 {\n                    mask-type: 10px;\n                }\n            }\n\n            p {\n                margin-bottom: 5px;\n                line-height: 1.3;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            &+div {\n                margin-top: 17px;\n            }\n        }\n    }\n\n    &__links {\n        padding: 0;\n        margin: 0;\n\n        li {\n            list-style: none;\n            width: 100%;\n\n            a {\n                position: relative;\n                color: $develop-color;\n                @include transition-slow();\n\n                &::before {}\n\n                &:hover {\n                    opacity: 0.75;\n                }\n            }\n\n            &+li {\n                margin-top: 4px;\n\n            }\n        }\n    }\n}\n\n\n\n.popaccordian {\n    &__row {\n        &head {\n            position: relative;\n            cursor: pointer;\n            border: 1px solid $develop-color;\n            padding: 9px;\n            border-radius: 3px;\n            @include fflex();\n\n            &arrow {\n                position: absolute;\n                top: 0;\n                left: 0;\n            }\n\n            h5 {\n                @include fflex();\n                margin: 0;\n                position: relative;\n                color: $develop-color;\n                padding-left: 10px;\n                @include headingfont();\n\n                i {\n                    @include transition-slow();\n                }\n            }\n        }\n\n        &body {\n            border: 1px solid $develop-color;\n            border-top: 0;\n            display: none;\n            border-radius: 0 0 3px 3px;\n\n            &inner {\n                padding: 10px;\n\n                &>*:last-child {\n                    margin-bottom: 0;\n                }\n\n                h5 {\n                    margin: 0 0 10px;\n                    position: relative;\n                    color: $develop-color;\n                    @include headingfont();\n                }\n\n                ul {\n                    margin: 0;\n                    padding: 0;\n\n                    li {\n                        list-style: none;\n                        font-size: 14px;\n                        line-height: 1.3;\n                        position: relative;\n                        padding-left: 10px;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 7px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n\n                        &+li {\n                            margin-top: 5px;\n                        }\n                    }\n                }\n            }\n        }\n\n        &+div {\n            margin-top: 15px;\n        }\n\n        &--active {\n            .popaccordian__rowhead {\n                border-radius: 3px 3px 0 0;\n\n                i {\n                    @include transRotate (90deg);\n                }\n            }\n        }\n\n        &:first-child {\n            .popaccordian__rowbody {\n                display: block;\n            }\n        }\n\n    }\n\n}\n\n\n.prevnext {\n    padding: 20px 0;\n\n    &__inner {\n        @include fflex();\n        @include fflex-aic();\n        padding: 0;\n        margin: 0;\n    }\n\n    li {\n        list-style: none;\n\n        &.prevnext__next {\n            margin-left: auto;\n        }\n\n        &.prevnext__prev a {\n            &:hover>i {\n                left: -5px;\n            }\n        }\n\n        &.prevnext__next a {\n            background-color: $develop-color;\n            color: #fff;\n            opacity: 1;\n            padding: 6px 12px;\n            border-radius: 3px;\n\n            &:hover>i {\n                left: 3px;\n            }\n        }\n\n        a {\n            @include headingfont();\n            font-size: 14px;\n            color: #676a6c;\n            opacity: 0.47;\n            padding: 6px 0;\n            display: inline-block;\n            @include transition-slow();\n\n            i {\n                position: relative;\n                font-size: 1.1em;\n                left: 0;\n                @include transition-slow();\n            }\n        }\n    }\n}\n\n.playbtn {\n    position: absolute;\n    right: 8px;\n    bottom: 7px;\n\n    i {\n        color: #7bbc43;\n    }\n}\n\n.ideate-is .info .card__toprow .card__topcol.card__topcol--tt svg {\n    max-width: 16px;\n    cursor: pointer;\n}\n\n.card__toprow {\n    @include fflex();\n    @include fflex-aic();\n    margin: 0 -15px;\n\n    .card__topcol {\n        padding: 0 15px;\n\n        // width: calc( 100% / 3 );\n        &.card__topcol--tt {\n            margin-left: auto;\n            text-align: right;\n\n            svg {\n                max-width: 16px;\n                cursor: pointer;\n            }\n\n            span {\n                position: absolute;\n                right: -17px;\n                bottom: 18px;\n\n                @media only screen and (max-width: 767px) {\n                    right: 2px;\n                }\n            }\n        }\n    }\n}\n\n.stick-challenge {\n    position: relative;\n\n    .card-body__backouter {\n        min-height: auto;\n        overflow-y: auto;\n        z-index: 9;\n        position: relative;\n\n        .card-body__subtitle {\n            position: sticky;\n            top: 0;\n            z-index: 99;\n            background-color: #fff;\n        }\n\n        &.plus {\n            min-height: 400px;\n        }\n    }\n\n}\n\n// .stick-challenge-solpropin {\n//     position: relative;\n//     overflow-y: auto;\n//     height: calc(100vh - 368px);\n\n//     .card.card-default:nth-child(2) {\n//         position: sticky;\n//         top: 0;\n//         left: 0;\n//         width: 100%;\n//         background: #fff;\n//         z-index: 9;\n//     }\n// }\n.st0 {\n    fill: #7bbc43;\n    margin-right: 12px;\n}\n\n.st1 {\n    fill: none;\n    stroke: #7bbc43;\n    stroke-miterlimit: 10;\n    margin-right: 10px;\n}\n\n.Del-data-btn {\n    padding: 40px 0;\n\n    .btn {\n        margin-left: 15px;\n        // border-color: #007bff;\n        background-color: #fff;\n        border-color: #f5f5f5;\n        color: #ff485c;\n    }\n\n    .cancelbtn {\n        color: #676a6c;\n        text-align: center;\n        font-size: 15px;\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.5;\n        padding: 6px;\n    }\n}\n\n.modal-body {\n\n    &__tr {\n        column-count: 2;\n        column-gap: 20px;\n    }\n\n    &__td {\n        -webkit-column-break-inside: avoid;\n        page-break-inside: avoid;\n        break-inside: avoid;\n    }\n\n    &__buttons {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: flex-end;\n\n        &>button {\n\n            &:not(:last-child) {\n                margin-right: 15px;\n            }\n        }\n    }\n}\n\n.loader-container {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    top: 0;\n    bottom: 0;\n    background: rgba(236, 236, 236, .9);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: none;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    z-index: 9999999999;\n    height: 100vh;\n    margin: 0 auto;\n}\n\n.row--editmodebg {\n    background-color: #fff;\n    padding: 40px 35px;\n}\n\n.trackInfo {\n    padding: 2px 16px;\n    background-color: #6d6e71;\n    color: #fff;\n    margin-left: 40px;\n    border-radius: 5px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    font-size: 10px;\n\n    &--inputclr {\n        color: $develop-color;\n        background: transparent;\n        padding-left: 0;\n        font-size: 13px;\n        margin-left: 11px;\n        margin-bottom: 2px;\n        display: inline-block;\n        position: absolute;\n        top: 17px;\n    }\n}\n\n// AI icon styling for develop stage\n.card-body__pe {\n    .card-body__petop {\n        .card__bwnh3ai {\n            display: inline-flex;\n            align-items: center;\n            vertical-align: middle;\n            margin-left: 6px;\n            padding: 6px 8px;\n            cursor: pointer;\n            color: #fff;\n            font-size: 14px;\n            border-radius: 4px;\n            transition: opacity 0.2s ease;\n\n            &:hover {\n                opacity: 0.7;\n            }\n\n            i {\n                font-size: 14px;\n            }\n        }\n    }\n}\n\n.EditmodeInputs {\n    .card__bwnh3ai {\n        display: inline-flex;\n        align-items: center;\n        vertical-align: middle;\n        margin-left: 6px;\n        padding: 6px 8px;\n        cursor: pointer;\n        color: $develop-color;\n        font-size: 14px;\n        border-radius: 4px;\n        transition: opacity 0.2s ease;\n\n        &:hover {\n            opacity: 0.7;\n        }\n\n        i {\n            font-size: 14px;\n        }\n    }\n\n    h3, h4 {\n        white-space: nowrap;\n    }\n}\n\n.loader-spin {\n    background-color: hsla(0, 0%, 92.5%, .9);\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.loader__inner {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n    animation: blink 2s linear infinite;\n    opacity: 0;\n}\n\n#Path_130 {\n    animation: blink 2s linear infinite;\n    animation-delay: .5s;\n    opacity: 0;\n}\n\n#Path_132 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1s;\n    opacity: 0;\n}\n\n#Path_131 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1.5s;\n    opacity: 0;\n}\n\n@keyframes blink {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n\n}\n\n// Modal Design\n::ng-deep .modal {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1050;\n    display: none;\n    overflow: hidden;\n    -webkit-overflow-scrolling: touch;\n    outline: 0;\n\n    &.show {\n        display: block !important;\n    }\n\n    &.grey {\n        background: rgba(236, 236, 236, 0.9);\n    }\n\n    &.fade {\n        .modal-dialog {\n            transition: transform 0.3s ease-out;\n        }\n\n        &.in {\n            opacity: 1;\n        }\n    }\n\n    &.in {\n        .modal-dialog {\n            transform: translate(0, 0);\n        }\n    }\n\n    &.modal-open {\n        overflow-x: hidden;\n        overflow-y: auto;\n    }\n\n    .modal-dialog {\n        position: relative;\n        width: auto;\n        margin: 10px;\n\n        @media (min-width: 768px) {\n            width: 600px;\n            margin: 30px auto;\n        }\n\n        .modal-content {\n            background-clip: padding-box;\n            background-color: #FFFFFF;\n            border: 1px solid rgba(0, 0, 0, 0);\n            border-radius: 4px;\n            box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n            outline: 0 none;\n            position: relative;\n\n            .close {\n                float: right;\n                font-size: 21px;\n                font-weight: bold;\n                line-height: 1;\n                color: #000;\n                text-shadow: 0 1px 0 #fff;\n                filter: alpha(opacity=20);\n                opacity: 0.2;\n\n                &:focus-visible {\n                    outline: none;\n                }\n            }\n\n            button.close {\n                padding: 0;\n                cursor: pointer;\n                background: transparent;\n                border: 0;\n                -webkit-appearance: none;\n                appearance: none;\n            }\n\n            .modal-body {\n\n                form {\n\n                    .form-group {\n                        margin-bottom: 15px;\n                    }\n                }\n            }\n        }\n    }\n\n    .f-btn {\n        color: #fff;\n        font-size: 14px;\n        border-color: #73BF38;\n        background-color: #73BF38;\n\n        &:hover {\n            border-color: #4cae4c;\n            background-color: #4cae4c;\n        }\n\n        &--seagrn {\n            border-color: #1dc5a3;\n            background-color: #1dc5a3;\n\n            &:hover {\n                border-color: #1dc5a3;\n                background-color: #1dc5a3;\n            }\n        }\n\n        &--dngr {\n            color: #fff;\n            border-color: #ED5565;\n            background-color: #ED5565;\n\n            &:hover {\n                border-color: #ec4758;\n                background-color: #ec4758;\n            }\n        }\n\n        &--info {\n            color: #fff;\n            border-color: #23c6c8;\n            background-color: #23c6c8;\n\n            &:hover {\n                border-color: #21b9bb;\n                background-color: #21b9bb;\n            }\n        }\n\n        &--white {\n            background-color: #fff;\n            border-color: #ddd;\n            color: #6D6E71;\n        }\n\n        &--wrng {\n            color: #fff;\n            border-color: #f8ac59;\n            background-color: #f8ac59;\n\n            &:hover {\n                border-color: #f7a54a;\n                background-color: #f7a54a;\n            }\n        }\n    }\n}\n\n::ng-deep.modal-open {\n    overflow: hidden;\n}","@import './../cn-shared';\n\nli {\n    list-style: none;\n}\n\n@mixin transRotate ($rotate) {\n    -webkit-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    transform: rotate($rotate);\n}\n\n::ng-deep#page-wrapper {\n    padding-bottom: 60px;\n}\n\n::ng-deep#wrapper {\n    overflow-x: initial;\n}\n\n::ng-deep.ideate-is {\n\n    .mainnav {\n        @include fflex();\n        margin: 30px 0 20px;\n\n        @media #{$mq-sm} {\n            margin: 10px 0 15px;\n        }\n\n        &.mainnav--bottom {\n            margin: 30px 0 40px;\n\n            ul {\n                li {\n                    a {\n                        padding: 12px 30px;\n                        font-family: 'Open Sans', sans-serif;\n                        font-weight: 700;\n                        font-size: 16px;\n\n                        @media only screen and (max-width: 991px) {\n                            padding: 10px 20px;\n                            font-size: 14px;\n                        }\n\n                        @media only screen and (max-width: 767px) {\n                            padding: 9px;\n                            font-size: 11px;\n                        }\n                    }\n\n                    &.active {\n                        a {\n                            background-color: #bbb !important;\n                            border-top: 1px solid #bbb !important;\n                            border-bottom: 1px solid #bbb !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        &--editmode {\n            margin: 0 0 15px;\n\n            .mainnav__list {\n                flex: 1;\n                border-radius: 5px;\n\n                @media #{$mq-sm} {\n                    flex: none;\n                    width: 100%;\n                }\n\n                li {\n                    width: 100%;\n                    flex: 1;\n\n                    a {\n                        width: 100%;\n                        padding: 5px 2px;\n                        text-align: center;\n                    }\n                }\n            }\n        }\n\n        &__editmodeicon {\n            margin-left: 5px;\n\n            @media #{$mq-sm} {\n                margin: 10px 0 0 auto;\n            }\n\n            ul {\n                display: flex;\n                flex-wrap: wrap;\n                margin: 0;\n                padding: 0;\n                height: 100%;\n\n                li {\n                    list-style: none;\n                    transition: none;\n                    width: 37px;\n                    height: 100%;\n                    border-radius: 5px;\n                    background-color: #fff;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    cursor: pointer;\n                    border: 1px solid $cn-border-color;\n\n\n                    &.active {\n                        background-color: #676a6c;\n                    }\n\n                    &:not(:last-child) {\n                        margin-right: 5px;\n\n                        @media #{$mq-md} {\n                            margin-right: 0;\n                        }\n                    }\n\n                    @media #{$mq-md} {\n                        width: 35px;\n                        height: 31px;\n                        display: none;\n                    }\n\n                    &.mainnav__editmodepin {\n                        display: flex;\n\n                        svg {\n                            .st0 {\n                                fill: #FFFFFF;\n                            }\n\n                            .st1 {\n                                fill: #cfdbe2;\n                            }\n                        }\n\n                        &--pinactive {\n                            svg {\n                                .st0 {\n                                    fill: #6d6e71;\n                                }\n\n                                .st1 {\n                                    fill: #FFFFFF;\n                                }\n                            }\n                        }\n                    }\n\n                    &.listView,\n                    &.individualView,\n                    &.gridView {\n\n                        svg {\n                            .st0 {\n                                fill: #6d6e71;\n                            }\n\n                            .st1 {\n                                fill: #FFFFFF;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n    }\n\n    .stick-challenge {\n        position: relative;\n\n        .card-body__edit {\n            min-height: auto;\n            overflow-y: auto;\n            overflow-x: hidden;\n            z-index: 9;\n            position: relative;\n\n            .card-body__subtitle {\n                position: sticky;\n                top: 0;\n                z-index: 99;\n                background-color: #fff;\n            }\n        }\n\n        .card-body__inner {\n            overflow-y: auto;\n        }\n\n    }\n\n    .info {\n        color: #fff;\n        border-color: $ideate-color;\n        margin-bottom: 18px;\n        padding: 20px 40px;\n        border-radius: 6px;\n\n        @media #{$mq-md} {\n            padding: 12px 20px;\n        }\n\n        &.infotitle {\n            background-color: $ideate-color;\n        }\n\n        h1 {\n            font-size: 36px;\n            font-weight: 500;\n            margin: 0;\n            @include headingfont();\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n\n            @media #{$mq-md} {\n                font-size: 28px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 24px;\n            }\n\n            .info__maintitle {\n                margin-right: auto;\n\n            }\n\n            small {\n                color: #fff;\n                font-size: 80%;\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 5px;\n                }\n            }\n        }\n\n        .card__toprow {\n            @include fflex();\n            @include fflex-aic();\n            margin: 0 -15px;\n\n            &--tne {\n\n                .card__topcol {\n\n                    &:first-child {\n                        width: 72% !important;\n\n                        @media #{$mq-sm} {\n                            flex: 1;\n                            width: auto !important;\n                        }\n                    }\n                }\n            }\n\n            .card__topcol {\n                padding: 0 15px;\n                width: calc(100% / 3);\n\n                &--full {\n                    width: 100% !important;\n                }\n\n                &:nth-child(1) {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        flex: 1;\n                        margin-right: auto;\n                    }\n                }\n\n                &--tab {\n                    width: 44%;\n\n                    @media #{$mq-sm} {\n                        width: 120px;\n                    }\n                }\n\n                &--tt {\n                    width: 28%;\n                    margin-left: auto;\n                    text-align: right;\n\n                    @media #{$mq-sm} {\n                        width: auto;\n                    }\n\n                    svg {\n                        max-width: 16px;\n                        cursor: pointer;\n                    }\n\n                    .card__pinicon {\n                        position: absolute;\n                        right: -17px;\n                        top: -15px;\n                        width: 20px;\n\n                        @media #{$mq-md} {\n                            right: -1px;\n                            top: -10px;\n                        }\n                    }\n                }\n\n                &.card__topcol--title {\n                    @include fflex();\n                    @include fflex-aic();\n\n                    &>div:first-child {\n                        margin-right: 15px;\n                    }\n                }\n\n                &.card__topcol--startexist {\n                    width: 65%;\n                }\n\n                &.card__topcol--tab {\n                    @include fflex();\n                    @include fflex-jcc();\n\n                    ul {\n                        @include fflex();\n                        margin: 0;\n                        padding: 0;\n                        border-radius: 3px;\n                        line-height: 1;\n\n                        li {\n                            &:first-child {\n                                button {\n                                    svg {\n                                        right: calc(100% + 1px)\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            left: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:last-child {\n                                button {\n                                    svg {\n                                        left: calc(100% + 1px);\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            right: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:not(:first-child) {\n                                margin-left: -1px;\n                            }\n\n                            &:only-child {\n                                button {\n                                    border-radius: 3px;\n                                }\n                            }\n\n                            &.card__topactive {\n                                button {\n                                    color: $ideate-color;\n                                    border: 1px solid $ideate-color;\n                                    cursor: pointer;\n\n                                    span.card__topcount {\n                                        color: $ideate-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &.card__topcomplete {\n                                button {\n                                    opacity: 0.2;\n                                    border: 1px solid $ideate-color;\n                                    color: $ideate-color;\n\n                                    span.card__topcount {\n                                        color: $ideate-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            button {\n                                position: relative;\n                                color: $develop-color;\n                                font-size: 17px;\n                                padding: 6px 16px;\n                                @include headingfont();\n                                display: inline-block;\n                                height: 100%;\n                                border: 0;\n                                background-color: transparent;\n                                @include transition-slow();\n                                -webkit-appearance: none;\n                                -moz-appearance: none;\n                                appearance: none;\n\n                                svg {\n                                    position: absolute;\n                                    top: -1px;\n                                    height: calc(100% + 2px);\n\n                                    .st0 {\n                                        fill: $ideate-color;\n                                    }\n                                }\n\n                                @media #{$mq-md} {\n                                    padding: 4px 6px;\n                                    font-size: 13px;\n                                }\n\n                                &:focus {\n                                    outline: none;\n                                    box-shadow: none;\n                                }\n\n                                &>.card__topdesktext {\n                                    @media only screen and (max-width: 1180px) {\n                                        display: none;\n                                    }\n                                }\n\n                                &>.card__topmobiletext {\n                                    display: none;\n\n                                    @media only screen and (max-width: 1180px) {\n                                        display: inline-block;\n                                    }\n                                }\n\n                                &>span.card__topcount {\n                                    width: 16px;\n                                    height: 16px;\n                                    line-height: 16px;\n                                    display: inline-block;\n                                    text-align: center;\n                                    font-size: 0.5em;\n                                    background-color: $ideate-color;\n                                    color: #fff;\n                                    margin-left: 4px;\n                                    border-radius: 50%;\n                                    vertical-align: bottom;\n                                    position: relative;\n                                    top: -1px;\n\n                                    @media only screen and (max-width: 630px) {\n                                        position: absolute;\n                                        top: auto;\n                                        bottom: -2px;\n                                        right: 0;\n                                        margin: 0;\n                                    }\n                                }\n\n                                &:hover {\n                                    color: $ideate-color;\n                                    opacity: 1;\n                                }\n\n                                &:hover>span.card__topcount {\n                                    color: $ideate-color;\n                                    background-color: #efefef;\n                                    opacity: 1;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                &--ctt {\n                    position: relative;\n\n                    ul {\n                        li {\n                            .card-body__tooltip {\n                                display: none;\n                                position: absolute;\n                                background: #fff;\n                                color: #676a6c;\n                                padding: 5px;\n                                top: -27px;\n                                box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                border-radius: 5px;\n\n                            }\n\n                            button {\n\n                                &:hover {\n                                    opacity: 0.2 !important;\n                                }\n\n                            }\n\n                            &:hover,\n                            &:active {\n\n                                .card-body__tooltip {\n                                    display: block;\n                                }\n                            }\n\n                            // &:hover .card-body__tooltip,\n                            // &:active .card-body__tooltip {\n                            //     display: block;\n\n                            // }\n\n                        }\n                    }\n                }\n\n            }\n\n            .card__h3button {\n                border: 1px solid $ideate-color;\n                background-color: transparent;\n                padding: 4px 26px;\n                border-radius: 3px;\n                @include headingfont();\n                color: $ideate-color;\n                font-size: 22px;\n                line-height: 1.2;\n                @include transition-slow();\n                cursor: pointer;\n\n                &:hover {\n                    background-color: $ideate-color;\n                    color: #fff;\n                }\n\n                &:focus {\n                    outline: none;\n                }\n            }\n\n            .tooltipicon {\n                cursor: pointer;\n                position: relative;\n                font-size: 18px;\n                display: inline-block;\n\n                i {\n                    color: $ideate-color;\n                }\n\n                &:hover>i>.tooltiptext {\n                    visibility: visible;\n                }\n\n                .tooltiptext {\n                    visibility: hidden;\n                    width: 250px;\n                    background-color: #fff;\n                    color: $ideate-color;\n                    text-align: center;\n                    border-radius: 6px;\n                    padding: 10px;\n                    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                    font-size: 13px;\n                    font-family: 'Open Sans', sans-serif;\n                    line-height: 1.5;\n                    position: absolute;\n                    top: 15px;\n                    right: 10px;\n                    z-index: 1;\n                }\n            }\n        }\n\n        h3 {\n            font-size: 20px;\n            margin: 0;\n            cursor: pointer;\n            color: $ideate-color;\n            @include headingfont();\n            @include fflex();\n            @include fflex-aic();\n\n            @media #{$mq-md} {\n                font-size: 16px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 15px;\n                word-break: break-word;\n            }\n\n            &>*:not(:last-child) {\n                margin-right: 5px;\n            }\n\n            .card__bwnh3pencil {\n\n                a {\n                    color: $ideate-color;\n                }\n            }\n\n            .card__bwnh3button {\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 10px;\n                }\n\n                button {\n                    font-size: 18px !important;\n                    padding-right: 15px !important;\n                    padding-left: 15px !important;\n\n                    @media #{$mq-sm} {\n                        font-size: 16px !important;\n                    }\n                }\n            }\n\n            i {\n                cursor: pointer;\n                font-size: 0.9em;\n\n                &+div {\n                    padding-left: 7px;\n\n                    span {\n                        display: block;\n                        font-size: 0.7em;\n                    }\n                }\n\n                &+span {\n                    padding-left: 7px;\n                }\n            }\n\n        }\n\n        .tooltipicon {\n            position: relative;\n            font-size: 18px;\n            display: inline-block;\n\n            i {\n                color: $ideate-color;\n            }\n\n            &:hover>i>.tooltiptext {\n                visibility: visible;\n            }\n\n            .tooltiptext {\n                visibility: hidden;\n                width: 250px;\n                background-color: #fff;\n                color: $ideate-color;\n                text-align: center;\n                border-radius: 6px;\n                padding: 10px;\n                box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                font-size: 13px;\n                font-family: 'Open Sans', sans-serif;\n                line-height: 1.5;\n                position: absolute;\n                top: 15px;\n                right: 10px;\n                z-index: 1;\n            }\n        }\n    }\n\n    app-ideate-ideas,\n    app-ideate-challenge-top-ideas {\n        display: block;\n        margin-top: 30px;\n    }\n\n    .card-default {\n        &.card-default--summary {\n            box-shadow: none;\n\n            .info {\n                border-top: 0;\n                border-right: 0;\n                border-left: 0;\n                padding-right: 20px;\n                padding-left: 20px;\n            }\n\n            .card-body {\n                border-right: 0;\n                border-bottom: 0;\n                border-left: 0;\n                border-radius: 0;\n\n                &__inner {\n                    padding-right: 20px;\n                    padding-left: 20px;\n                }\n            }\n\n            &+div {\n                margin-top: 20px;\n            }\n        }\n\n        &+div {\n            margin-top: 30px;\n        }\n\n        .info {\n            margin: 0;\n            border: 1px solid $ideate-color;\n            border-radius: 6px;\n\n            &.card__headactive {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n\n                &--cc {\n                    background-color: $ideate-color;\n\n                    .card__topcol {\n                        h3 {\n                            color: #fff;\n                        }\n\n                        ul {\n                            li {\n\n                                button {\n                                    border-color: #fff;\n                                    background-color: #fff;\n\n                                    span {\n                                        color: $ideate-color;\n                                        background-color: #fff;\n                                    }\n\n                                    .st0 {\n                                        fill: #fff !important;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    i {\n                        color: #fff;\n                    }\n                }\n            }\n        }\n\n        border-radius: 6px;\n        border-top-width: 3px;\n        border: 0;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n\n        .card-body__inner {\n            padding: 15px 40px;\n            height: auto;\n            overflow-y: auto;\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n        }\n\n        .card-body {\n            display: none;\n            border: 1px solid $cn-border-color;\n            border-top: 0;\n            border-radius: 0 0 6px 6px;\n            overflow: hidden;\n\n            &.card-show {\n                display: block;\n\n                &__wbg {\n                    background-color: #fff;\n                }\n\n            }\n\n            .hideblk {\n                display: none;\n            }\n\n            &__finalstate {\n                p {\n                    font-size: 15px;\n                    font-weight: 600;\n\n                    @media #{$mq-sm} {\n                        font-size: 13px;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &--2 {\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n\n                        p {\n                            position: relative;\n                            padding-left: 10px;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 8px;\n                                left: 0;\n                                width: 5px;\n                                height: 5px;\n                                border-radius: 50%;\n                                background-color: #444;\n                            }\n                        }\n                    }\n                }\n            }\n\n            &__subtitle {\n                padding-left: 35px;\n                margin-bottom: 16px;\n                position: relative;\n\n                *:last-child {\n                    margin-bottom: 0;\n                }\n\n                &>span {\n                    position: absolute;\n                    top: 0;\n                    right: 2px;\n                    opacity: 0.7;\n                    cursor: pointer;\n\n                    &.thinkeyebtn {\n                        right: 0px;\n                    }\n\n                }\n\n                &--pl0 {\n                    padding-left: 0;\n                }\n\n                p {\n                    color: #969798;\n                    font-size: 15px;\n\n                    i {\n                        padding-left: 5px;\n                    }\n                }\n            }\n        }\n\n        .c-radio {\n            label {\n                padding-left: 0;\n            }\n\n            input {\n                opacity: 0;\n                margin: 0;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 50%;\n                    border: 1px solid #ccc;\n                    margin-right: 5px;\n                    text-align: center;\n\n                    &::before {\n                        position: absolute;\n                        color: $ideate-color;\n                        opacity: 0;\n                        font-size: 11px;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $ideate-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .checkbox {\n            margin-top: 0;\n\n            label {\n                min-height: 20px;\n                padding-left: 0;\n                margin-bottom: 0;\n                font-weight: 400;\n                cursor: pointer;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 1px;\n                    margin-right: 6px;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        font-size: 12px;\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $ideate-color;\n                        background-color: $ideate-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .card-body__button {\n            background-color: #f5f5f5;\n            border-top: 1px solid #e3e3e3;\n            padding: 12px 40px;\n\n            .card-button {\n                @include fflex();\n                @include fflex-aic();\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    text-align: center;\n                    @include transition-slow();\n\n                    &+.btn {\n                        margin-left: 15px;\n                    }\n\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n                }\n\n                .float-right {\n                    margin-left: auto;\n                }\n\n                .btn-ideate {\n                    background-color: $ideate-color;\n                    border-color: $ideate-color;\n                    color: #fff;\n\n                    &:hover {\n                        background-color: $ideate-color;\n                        border-color: $ideate-color;\n                    }\n                }\n\n                .btn-success {\n                    background-color: #27c24c;\n                    border-color: #27c24c;\n\n                    &:hover {\n                        background-color: #21A240;\n                        border-color: #1E983B;\n                    }\n                }\n\n                .btn-danger {\n                    background-color: #fff;\n                    border-color: #fff;\n                    color: #ef6272;\n\n                    &:hover {\n                        background-color: #ED2D2D;\n                        border-color: #EC2121;\n                    }\n                }\n\n                .btn-warning {\n                    em {\n                        margin: 0;\n                    }\n                }\n\n                .btn-deleteall {\n                    border: 0;\n                    background-color: transparent;\n                    position: relative;\n                    overflow: hidden;\n                    box-shadow: none;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n\n                    span {\n                        position: absolute;\n                        left: 110%;\n                        @include transition-slow();\n                    }\n\n                    &:hover {\n                        background-color: #fff;\n                        color: #ed5562;\n                        padding-right: 16px;\n                        padding-left: 16px;\n\n                        &>span {\n                            position: relative;\n                            left: 0;\n                        }\n\n                        em {\n                            margin-right: 6px;\n                        }\n                    }\n\n                    em {\n                        font-size: 1em;\n                        margin-right: 0;\n                        @include transition-slow();\n                    }\n                }\n            }\n        }\n\n        .card-body--ebtn {\n            margin-top: 15px;\n            padding: 15px 40px;\n            border-top: 1px solid $cn-border-color;\n\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n\n            .card-body--ebtnrow {\n                margin: 0 -8px;\n                @include fflex();\n                @include fflex-aic();\n\n                &>div {\n                    padding: 0 8px;\n\n                    @media #{$mq-sm} {\n                        width: 100%;\n                        text-align: center;\n\n                        &+div {\n                            margin-top: 10px;\n                        }\n                    }\n\n                    &.card-body--col {\n                        &--last {\n                            margin-left: auto;\n                        }\n                    }\n                }\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    padding: 7px 16px;\n                    text-align: center;\n                    transition: all ease 0.3s;\n\n                    @media #{$mq-md} {\n                        font-size: 12px;\n                    }\n\n                    i,\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n\n                    &--save {\n                        background-color: $develop-color;\n                        color: #fff;\n                    }\n\n                    &--clarify {\n                        background-color: $clarify-color;\n                        color: #fff;\n                    }\n\n                    &--ideate {\n                        background-color: $ideate-color;\n                        color: #fff;\n                        border-color: $ideate-color;\n                        font-weight: 900;\n                    }\n\n                    &--disable {\n                        opacity: 0.5;\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                        border-color: #6d6e71;\n                    }\n\n                    &--cancel {\n                        padding: 0;\n                        background-color: transparent;\n                        margin-left: 0;\n                        color: $body-content-color;\n                        border: 0;\n                        font-family: $font-stack;\n                        font-size: 14px;\n                        font-weight: 700;\n\n                        &:hover {\n                            color: #000;\n                        }\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                    }\n\n                    &--converge {\n                        padding: 0 8px;\n                    }\n\n                    &--deleteall {\n                        border: 0;\n                        background-color: transparent;\n                        position: relative;\n                        overflow: hidden;\n                        box-shadow: none;\n                        padding-right: 0;\n                        padding-left: 0;\n\n                        i {\n                            font-size: 14px;\n                            color: $body-content-color;\n                        }\n\n                        @include transition-slow();\n\n                        span {\n                            position: absolute;\n                            left: 110%;\n                            @include transition-slow();\n                        }\n\n                        &:hover {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px !important;\n                            }\n                        }\n\n                        em {\n                            font-size: 1em;\n                            margin-right: 0;\n                            @include transition-slow();\n                        }\n                    }\n                }\n            }\n        }\n\n\n        .note-3 {\n            padding: 15px 15px 10px;\n            border: 2px solid $ideate-color;\n            margin-bottom: 15px;\n\n            label {\n                color: $ideate-color;\n            }\n        }\n\n        .footer-line {\n            color: $ideate-color;\n        }\n\n        p {\n            font-size: 15px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        .card-body__edit {\n            position: relative;\n\n            .breakthrough-input-tabs,\n            .brainstorm-input-tabs {\n                width: 100%;\n                margin-right: 0;\n                position: relative;\n\n                input,\n                select {\n                    height: 45px;\n                    padding: 5px 15px;\n                    border: 1px solid $color-neutral-mid;\n                    border-radius: 4px;\n                    font-size: 15px;\n                }\n            }\n\n            .card-body__editrow {\n                margin: 0 -15px;\n                @include fflex();\n\n                &>div {\n                    padding: 0 15px;\n                    width: 100%;\n                    margin-bottom: 15px;\n\n                    &>div {\n                        position: relative;\n                    }\n                }\n\n                .proposed-challenge {\n                    margin-top: 10px;\n                    font-family: 'Open Sans', sans-serif;\n                    font-size: 15px;\n\n                    label {\n                        padding-bottom: 4px;\n                    }\n                }\n\n                select {\n                    -webkit-appearance: none;\n                    -moz-appearance: none;\n                    appearance: none;\n                    background-image: url($assets+'/images/select.png');\n                    background-size: 10px;\n                    background-position: right 10px center;\n                    background-repeat: no-repeat;\n                }\n\n                textarea {\n                    width: 100%;\n                    border: 1px solid $color-neutral-mid;\n                    resize: none;\n                    border-radius: 3px;\n                    padding: 10px 15px;\n                    font-size: 15px;\n                }\n\n                .breakthrough-input-tabs,\n                .breakthrough-input-tabs {\n                    @include fflex();\n\n                    &>.card-body__editlabel {\n                        width: 35px;\n                        padding-right: 15px;\n                        @include fflex();\n                        @include fflex-aic();\n                    }\n\n                    &>.card-body__editnumber {\n                        width: 40px;\n                        text-align: center;\n                        @include fflex();\n                        @include fflex-aic();\n                        @include fflex-jcc;\n                        border-right: 0;\n                        border-radius: 4px 0 0 4px;\n\n                        &+.card-body__editinput {\n                            width: calc(100% - 41px);\n                            padding-right: 60px;\n\n                            &--ce {\n                                position: relative;\n\n                                .converge-icon {\n                                    position: absolute;\n                                    top: 50%;\n                                    transform: translateY(-50%);\n                                    left: 7px;\n                                    font-size: 26px;\n                                    color: $ideate-color;\n\n                                    &:hover>.card-body__tooltip,\n                                    &:active>.card-body__tooltip {\n                                        display: block;\n                                    }\n\n                                    .card-body__tooltip {\n                                        display: none;\n                                        font-size: 16px;\n                                        color: #676a6c;\n                                        position: absolute;\n                                        bottom: 100%;\n                                        left: 0;\n                                        background: #fff;\n                                        padding: 5px;\n                                        border-radius: 5px;\n                                        box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                        width: max-content;\n                                    }\n                                }\n\n                                input {\n                                    padding-left: 26px;\n\n\n                                }\n\n                            }\n                        }\n\n                        label {\n                            font-weight: 900;\n                        }\n                    }\n\n                    &>.card-body__editselect {\n                        width: 315px;\n                        padding-right: 15px;\n                    }\n\n                    &>.card-body__editinput {\n                        width: calc(100% - 351px);\n\n                        input {\n                            padding-right: 70px;\n\n                            &:focus,\n                            &:focus-visible {\n                                outline: none;\n                            }\n                        }\n\n                        .card-body__minus {\n\n                            &--hide {\n                                display: none;\n                            }\n                        }\n                    }\n\n                    &>.card-body__editinput:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n\n            &+.card-body__addnew {\n\n                button {\n                    margin: 0 39px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding-right: 0;\n                    padding-left: 0;\n                    color: $body-content-color;\n                    @include transition-slow();\n\n                    &:hover {\n                        background-color: $ideate-color;\n                        border: 1px solid $ideate-color;\n                        color: #fff;\n                        padding-right: 12px;\n                        padding-left: 12px;\n                    }\n                }\n            }\n        }\n\n        .input-tabs {\n            &+i {\n                position: relative;\n                top: -1px;\n            }\n\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            @include fflex-aic();\n            width: calc(100%);\n            padding: 0 0 0 0;\n            margin: 0;\n\n\n\n\n            .select_faded {\n                opacity: 0.2;\n                padding-left: 32px;\n            }\n\n            input,\n            select {\n                height: 45px;\n                padding: 5px 15px;\n                border: 1px solid #e3e3e3;\n                border-radius: 4px;\n                margin: 7px 0px;\n            }\n\n            label {\n                width: 20px;\n                margin: 0;\n            }\n\n            select {\n                width: 9%;\n            }\n\n            input {\n                width: 90%;\n                margin-left: 15px;\n            }\n        }\n\n        .input-group-text {\n            cursor: pointer;\n            padding: 3px 16px;\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 1.528571429;\n            color: #495057;\n            text-align: center;\n            white-space: nowrap;\n            background-color: #E9ECEF;\n            border: 1px solid #DDE6E9;\n            border-radius: 0.25rem;\n            position: absolute;\n            top: calc(50% + 1px);\n            right: 0;\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n            @include transition-slow();\n\n            &:hover {\n                background-color: $ideate-color;\n                border-color: $ideate-color;\n                color: #fff;\n            }\n        }\n\n        .list-columns {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n            counter-reset: section;\n\n            &>div {\n                &.card__body--cswrapper {\n                    width: 100%;\n                    position: relative;\n                    border-bottom: 1px solid #e4e4e4;\n                    padding-bottom: 5px;\n                    margin-bottom: 10px;\n\n                    // & > div {\n                    // }\n                    &::before,\n                    &::after {\n                        content: \"\";\n                        position: absolute;\n                        bottom: -1px;\n                        right: calc(100%);\n                        width: 40px;\n                        height: 1px;\n                        background-color: #e4e4e4;\n                    }\n\n                    &::after {\n                        right: auto;\n                        left: calc(100%);\n                    }\n                }\n            }\n\n            &.list-columns--2 {\n                &>div {\n                    width: 100%;\n                }\n            }\n\n            .brainstorm-tabs {\n                position: relative;\n                padding-left: 23px;\n\n                &::before {\n                    counter-increment: section;\n                    content: counter(section) \".\";\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                }\n            }\n        }\n    }\n\n    .idea-shop-list {\n        padding: 20px;\n        margin-left: 17px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        li {\n            width: calc(100% / 2);\n            margin-bottom: 10px;\n        }\n    }\n\n    .brainstorm__col {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        margin-bottom: 17px;\n\n        .brainstorm-main {\n            width: calc(100% - 68px);\n            display: inline-block;\n            margin-right: 20px;\n\n            .brainstorm-group {\n                width: 100%;\n                position: relative;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                .input-group-prepend {\n                    margin-right: -1px;\n                    width: 45px;\n\n                    .input-group-text {\n                        background: transparent;\n                        border-color: $ideate-color;\n                        height: 35px;\n                        padding: 0;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        align-items: center;\n                        -webkit-box-pack: center;\n                        -ms-flex-pack: center;\n                        justify-content: center;\n                    }\n                }\n\n                input {\n                    width: calc(100% - 45px);\n                    height: 35px;\n                    border: 1px solid $ideate-color;\n                    border-radius: 0 0.25rem 0.25rem 0;\n                }\n            }\n        }\n    }\n\n    .card-bottom-button {\n        .button {\n            font-size: 13px;\n            color: #fff;\n            padding: 8px 10px;\n            border-radius: 3px;\n            -webkit-transition: all ease 0.3s;\n            -o-transition: all ease 0.3s;\n            transition: all ease 0.3s;\n\n            &:hover {\n                opacity: .8;\n            }\n\n            i {\n                font-size: 0.8em;\n            }\n\n            &.btn-clarify {\n                background-color: $clarify-color;\n            }\n\n            &.btn-ideate {\n                background-color: $ideate-color;\n            }\n\n            &.btn-implement {\n                background-color: $implement-color;\n            }\n        }\n    }\n\n    .dotactions {\n        position: relative;\n\n        .dotactions__inner {\n            position: absolute;\n            top: 0;\n            right: 0;\n\n            &--h {\n                top: 5px;\n\n                .dotactions__top {\n                    cursor: pointer;\n                    width: 17px;\n                    -webkit-box-pack: justify;\n                    -ms-flex-pack: justify;\n                    justify-content: space-between;\n                }\n            }\n\n            &--v {\n                right: 10px;\n                top: 11px;\n\n                .dotactions__top {\n                    cursor: pointer;\n                    -webkit-box-orient: vertical;\n                    -webkit-box-direction: normal;\n                    -ms-flex-direction: column;\n                    flex-direction: column;\n                    -webkit-box-pack: justify;\n                    -ms-flex-pack: justify;\n                    justify-content: space-between;\n                    height: 21px;\n                    width: 11px;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    align-items: center;\n                }\n            }\n\n            .dotactions__top {\n                padding-bottom: 4px;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                span {\n                    background-color: #adadad;\n                    width: 3px;\n                    height: 3px;\n                    border-radius: 50%;\n                }\n            }\n\n            .dotactions__dropdown {\n                display: none;\n                background-color: #fff;\n                position: absolute;\n                top: 100%;\n                width: 150px;\n                box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);\n                right: -5px;\n                border-radius: 4px;\n                z-index: 9;\n                border: 1px solid #ddd;\n\n                .dotactions__close {\n                    cursor: pointer;\n                    position: absolute;\n                    top: 5px;\n                    right: 6px;\n                    font-size: 11px;\n                    -webkit-transition: all ease 0.3s;\n                    -o-transition: all ease 0.3s;\n                    transition: all ease 0.3s;\n\n                    &:hover {\n                        -webkit-transform: rotate(360deg);\n                        -ms-transform: rotate(360deg);\n                        transform: rotate(360deg);\n                    }\n                }\n\n                .dotactions__dropdowninner {\n                    display: none;\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    width: 200px;\n                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);\n                    border-radius: 4px;\n                    padding: 18px;\n                    background: #fff;\n                    border: 1px solid #ddd;\n\n                    .dotactions__dropdownin {\n                        padding: 10px 10px;\n                        border-radius: 4px;\n                        min-height: 100%;\n                        background-color: #f4f4f4;\n\n                        h6 {\n                            margin: 0;\n                            font-size: 13px;\n                            font-weight: 600;\n                            margin-bottom: 6px;\n                        }\n                    }\n                }\n\n                &>h6 {\n                    text-align: center;\n                    margin: 0;\n                    font-size: 13px;\n                    padding: 8px 10px;\n                    border-bottom: 1px solid #eee;\n                    font-weight: 400;\n                    margin-bottom: 2px;\n                    background-color: #f4f4f4;\n                }\n\n                li {\n                    margin: 0;\n\n                    a {\n                        padding: 6px 12px;\n                        color: #656565;\n                        display: block;\n                        font-weight: 400;\n\n                        &:hover {\n                            background-color: rgba(9, 30, 66, .04);\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .card-body__ip {\n        .card-body__ipwrap {\n            padding: 4px 0 80px;\n            overflow-x: auto;\n            margin: 0 0 10px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: nowrap;\n            flex-wrap: nowrap;\n\n            .card-body__ipcol {\n                padding: 0;\n                margin-bottom: 0px;\n                max-width: 285px;\n                width: 100%;\n                flex: 0 0 285px;\n                -webkit-flex: 0 0 285px;\n                -ms-flex: 0 0 285px;\n\n                .checkbox {\n                    padding-right: 22px;\n                }\n\n                &+div {\n                    margin-left: 30px;\n                }\n\n                @media only screen and (max-width: 1080px) {\n                    width: calc(100% / 2);\n                }\n\n                @media only screen and (max-width: 600px) {\n                    width: calc(100%);\n                }\n\n                .card-body__ipaddcol {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    -ms-flex-wrap: wrap;\n                    flex-wrap: wrap;\n\n                    &>.form-control {\n                        width: calc(100% - 91px);\n                        border: 1px solid #ccc;\n                        border-radius: 4px 0 0 4px;\n                    }\n\n                    .input-group-postpend {\n                        width: 90px;\n\n                        button {\n                            background-color: $ideate-color;\n                            box-shadow: none;\n                            color: #fff;\n                            border-color: $ideate-color;\n                            font-family: $font-stack;\n                        }\n\n                        &--ro {\n                            opacity: 0.4;\n                        }\n                    }\n                }\n            }\n\n            h2 {\n                margin-top: 0;\n                color: #656565;\n                font-size: 14px;\n                font-weight: 500;\n                margin-bottom: 12px;\n\n                label {\n                    display: inline-block;\n                    padding-right: 2px;\n                    width: auto !important;\n                }\n\n                input[type=\"checkbox\"] {\n                    opacity: 0;\n                    position: absolute;\n\n                    &+span {\n                        position: relative;\n                        top: -2px;\n                        margin: 0 5px 0 0;\n                        display: inline-block;\n                        vertical-align: top;\n                        width: 20px;\n                        height: 20px;\n                        border-radius: 2px;\n                        border: 1px solid #ccc;\n                        text-align: center;\n\n                        &::before {\n                            position: absolute;\n                            color: #fff;\n                            opacity: 0;\n                            top: 50%;\n                            left: 50%;\n                            -webkit-transform: translate(-50%, -50%);\n                            -ms-transform: translate(-50%, -50%);\n                            transform: translate(-50%, -50%);\n                        }\n                    }\n\n                    &:checked+span {\n                        background-color: $ideate-color;\n                        border-color: $ideate-color;\n                    }\n\n                    &:checked+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n\n            .dotactions__editinput {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n\n                &>div:first-child {\n                    margin-right: 10px;\n                    width: 73%;\n\n                    input:focus {\n                        border-color: $ideate-color;\n                        outline: $ideate-color;\n                    }\n                }\n\n                &>div:nth-child(2) {\n                    margin-left: auto;\n                }\n\n                &>div:nth-child(3) {\n                    margin-left: 10px;\n                }\n\n                &>div {\n                    i {\n                        font-size: 17px;\n                        color: #ff0000;\n                        cursor: pointer;\n                    }\n                }\n\n                .topidea__btn {\n                    padding: 3px 5px;\n                    font-size: 12px;\n                    color: #fff;\n                    background-color: $develop-color;\n                }\n            }\n\n            ul {\n                padding: 0;\n                margin: 0;\n                min-height: 10px;\n\n                li {\n                    list-style: none;\n                    padding: 0;\n                    width: 100%;\n\n                    .card-body__ipinner {\n                        display: block;\n                        font-weight: 400;\n                        position: relative;\n                        border: 1px solid #ccc;\n                        padding: 10px;\n                        border-radius: 5px;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.tooltippopup {\n    max-width: 360px;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    position: fixed;\n    top: 0;\n    right: -550px;\n    padding: 45px 24px 24px;\n    text-align: left;\n    z-index: 9999;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n    @include transition-slow();\n    overflow-y: auto;\n\n    &--active {\n        right: 0;\n    }\n\n    &--videoexist {\n        max-width: 735px;\n    }\n\n    &__btn {\n        @include fflex();\n        padding: 0;\n        margin: 0 0 10px;\n\n        li {\n            list-style: none;\n            text-align: center;\n            cursor: pointer;\n            width: calc(100% / 3);\n\n            button {\n                width: 100%;\n                color: $ideate-color;\n                font-size: 12px;\n                padding: 6px 16px;\n                @include headingfont();\n                display: inline-block;\n                height: 100%;\n                border: 0;\n                border: 1px solid $ideate-color;\n                background-color: transparent;\n                transition: all ease 0.3s;\n                @include appearance-none();\n\n                &:focus {\n                    outline: none;\n                }\n\n                &.tooltippopup__btncompleted {\n                    opacity: 0.2;\n\n                    &:hover {\n                        opacity: 1;\n                    }\n                }\n\n                &.tooltippopup__btnactive {\n                    opacity: 1;\n                }\n\n                &:hover {\n                    position: relative;\n                    z-index: 9;\n                }\n            }\n\n            &+li {\n                margin-left: -1px;\n            }\n\n            &:first-child {\n                button {\n                    border-radius: 3px 0 0 3px\n                }\n            }\n\n            &:last-child {\n                button {\n                    border-radius: 0 3px 3px 0;\n                }\n            }\n        }\n    }\n\n    h4 {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 16px;\n        line-height: 1.2;\n    }\n\n    p {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 14px;\n        line-height: 1.4;\n    }\n\n    &__close {\n        position: absolute;\n        top: 10px;\n        right: 25px;\n        width: 18px;\n        height: 18px;\n        cursor: pointer;\n        @include transition-slow();\n\n        &:hover {\n            -webkit-transform: rotate(360deg);\n            -ms-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n\n        &>div {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n\n            span {\n                position: absolute;\n                background: #676a6c;\n\n                &:nth-child(1) {\n                    top: 0;\n                    left: calc(50% - 1px);\n                    width: 2px;\n                    height: 100%;\n                }\n\n                &:nth-child(2) {\n                    top: calc(50% - 1px);\n                    left: 0;\n                    width: 100%;\n                    height: 2px;\n                }\n            }\n        }\n    }\n\n    &__child {\n        margin-top: 20px;\n\n        &data {\n            .table-responsive {\n                overflow-x: auto;\n                margin-bottom: 10px;\n\n                table {\n                    min-width: 297px;\n                    border: 1px solid #e7eaec;\n\n                    th,\n                    td {\n                        border: 1px solid #e7eaec;\n                        min-width: 120px;\n                    }\n                }\n\n                &+* {\n                    margin-top: 20px;\n                }\n            }\n\n            &--clarify {\n                h4 {\n                    color: $clarify-color;\n                }\n            }\n\n            &--ideate {\n                h4 {\n                    color: $ideate-color;\n                }\n            }\n\n            &--develop {\n                h4 {\n                    color: $develop-color;\n                }\n            }\n\n            &--implement {\n                h4 {\n                    color: $implement-color;\n                }\n            }\n\n            h4 {\n                font-size: 16px;\n                font-weight: 500;\n                margin: 0 0 2px;\n                @include headingfont();\n\n                &+h5 {\n                    mask-type: 10px;\n                }\n            }\n\n            p {\n                margin-bottom: 5px;\n                line-height: 1.3;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            &+div {\n                margin-top: 17px;\n            }\n        }\n    }\n\n    &__links {\n        padding: 0;\n        margin: 0;\n\n        li {\n            list-style: none;\n            width: 100%;\n\n            a {\n                position: relative;\n                color: $ideate-color;\n                @include transition-slow();\n                // &::before {\n\n                // }\n                &:hover {\n                    opacity: 0.75;\n                }\n            }\n\n            &+li {\n                margin-top: 4px;\n\n            }\n        }\n    }\n}\n\n\n\n.popaccordian {\n    &__row {\n        &head {\n            position: relative;\n            cursor: pointer;\n            border: 1px solid $ideate-color;\n            padding: 9px;\n            border-radius: 3px;\n            @include fflex();\n\n            &arrow {\n                position: absolute;\n                top: 0;\n                left: 0;\n            }\n\n            h5 {\n                margin: 0;\n                position: relative;\n                color: $ideate-color;\n                padding-left: 10px;\n                @include headingfont();\n\n                i {\n                    @include transition-slow();\n                }\n            }\n        }\n\n        &body {\n            border: 1px solid $ideate-color;\n            border-top: 0;\n            display: none;\n            border-radius: 0 0 3px 3px;\n\n            &inner {\n                padding: 10px;\n\n                &>*:last-child {\n                    margin-bottom: 0;\n                }\n\n                h5 {\n                    margin: 0 0 10px;\n                    position: relative;\n                    color: $ideate-color;\n                    @include headingfont();\n                }\n\n                ul {\n                    margin: 0;\n                    padding: 0;\n\n                    li {\n                        list-style: none;\n                        font-size: 14px;\n                        line-height: 1.3;\n                        position: relative;\n                        padding-left: 10px;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 7px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n\n                        &+li {\n                            margin-top: 5px;\n                        }\n                    }\n                }\n            }\n        }\n\n        &video {\n            margin-top: 20px;\n            padding-bottom: 15px;\n\n            &inner {\n                position: relative;\n                // padding-bottom: 56.25%;\n\n                iframe {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 100% !important;\n                    height: 100% !important;\n                }\n            }\n        }\n\n        &+div {\n            margin-top: 15px;\n        }\n\n        .popaccordian__rowhead {\n            align-items: center;\n            justify-content: space-between;\n        }\n\n        &--active {\n            .popaccordian__rowhead {\n                border-radius: 3px 3px 0 0;\n\n                i {\n                    @include transRotate (90deg);\n                }\n            }\n        }\n\n        &:first-child {\n            .popaccordian__rowbody {\n                display: block;\n            }\n        }\n\n    }\n\n    &__gen {\n        .slctrs {\n            border-bottom: 1.5px solid #F1F1F2;\n        }\n\n        select {\n            width: 100%;\n            border: 1px solid $cn-border-color;\n            padding: 6px;\n            height: 45px;\n            border-radius: 4px;\n        }\n\n        label {\n            display: block;\n        }\n\n        button {\n            background-color: $ideate-color;\n            border-color: $ideate-color;\n        }\n\n        &__aidata {\n            min-height: 400px;\n            position: relative;\n            display: none;\n\n            &--hyt {\n                min-height: auto;\n            }\n        }\n\n        &__addbtn {\n\n            button {\n                background-color: transparent;\n                border: 0;\n\n                &:active {\n                    box-shadow: none;\n                }\n            }\n        }\n    }\n\n}\n\n\n.prevnext {\n    padding: 20px 0;\n\n    &__inner {\n        @include fflex();\n        @include fflex-aic();\n        padding: 0;\n        margin: 0;\n    }\n\n    li {\n        list-style: none;\n\n        &.prevnext__next {\n            margin-left: auto;\n        }\n\n        &.prevnext__prev a {\n            &:hover>i {\n                left: -5px;\n            }\n        }\n\n        &.prevnext__next a {\n            background-color: $ideate-color;\n            color: #fff;\n            opacity: 1;\n            padding: 6px 12px;\n            border-radius: 3px;\n\n            &:hover>i {\n                left: 3px;\n            }\n        }\n\n        a {\n            @include headingfont();\n            font-size: 14px;\n            color: #676a6c;\n            opacity: 0.47;\n            padding: 6px 0;\n            display: inline-block;\n            @include transition-slow();\n\n            i {\n                position: relative;\n                font-size: 1.1em;\n                left: 0;\n                @include transition-slow();\n            }\n        }\n    }\n}\n\n.playbtn {\n    position: absolute;\n    right: 9px;\n    bottom: 7px;\n    color: #06a6ce;\n}\n\n.Del-data-btn {\n    padding: 40px 0;\n\n    .btn {\n        margin-left: 15px;\n        background-color: #fff;\n        border-color: #f5f5f5;\n        color: #ff485c;\n    }\n\n    .cancelbtn {\n        color: #676a6c;\n        text-align: center;\n        font-size: 15px;\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.5;\n        padding: 6px;\n    }\n}\n\n\n.editmode {\n    margin-bottom: 30px;\n\n    &--btinp {\n        margin-bottom: 0px;\n    }\n\n    &--sc {\n\n        h3 {\n            color: #676A6C !important;\n        }\n    }\n\n    &__list {\n\n        &row {\n            display: grid;\n            grid-template-columns: repeat(2, 1fr);\n            grid-gap: 15px;\n\n            &--nogap {\n                grid-gap: 0;\n            }\n\n            @media #{$mq-sm} {\n                grid-template-columns: 1fr;\n            }\n\n            &--equalblocks {\n                display: flex;\n                flex-wrap: wrap;\n\n                &>.editmode__listcol {\n                    flex: 1;\n\n                    @media #{$mq-sm} {\n                        flex: none;\n                        width: 100%;\n                    }\n                }\n\n            }\n\n            &--fullblocks {\n                grid-template-columns: 1fr;\n            }\n\n            &--grid {\n                &1 {\n                    grid-template-columns: 1fr;\n                }\n\n                &3 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 3;\n                    }\n                }\n\n                &4 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 4;\n                    }\n                }\n\n                &5 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 5;\n                    }\n                }\n\n                &6 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 6;\n                    }\n                }\n\n                &7 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 7;\n                    }\n                }\n            }\n        }\n\n        &cell {\n            padding: 10px 15px;\n            background-color: #EBEBEB;\n            border: 1px solid $cn-border-color;\n            border-radius: 6px;\n            height: 100%;\n\n            &--startbtn {\n                border: 1px solid $ideate-color;\n                // color: $ideate-color;\n                font-weight: 600;\n                font-family: 'Open Sans';\n                font-size: 16px;\n                cursor: pointer;\n                line-height: 1;\n                color: inherit !important;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 13px;\n            }\n\n            h3 {\n                color: $ideate-color;\n                margin-bottom: 5px;\n\n                a,\n                i {\n                    color: inherit;\n                }\n            }\n\n            &--ls {\n                li {\n                    list-style-type: disc;\n                    color: #676a6c;\n                }\n            }\n\n            &--sc {\n                p {\n                    font-weight: normal !important;\n                }\n\n                h3 {\n                    button {\n                        font-family: 'Open Sans';\n                        font-size: 16px;\n                        color: #676a6c;\n                        font-weight: 600;\n                        cursor: pointer;\n                    }\n                }\n            }\n\n            p {\n                font-size: 15px;\n                font-weight: 600;\n\n                @media #{$mq-sm} {\n                    font-size: 13px;\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n\n}\n\n.trackInfo {\n    padding: 2px 16px;\n    background-color: #6d6e71;\n    color: #fff;\n    margin-left: 40px;\n    border-radius: 5px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    font-size: 10px;\n\n    &--inputclr {\n        color: $ideate-color;\n        font-size: 11px;\n        background: transparent;\n        margin-left: 8px;\n        padding-left: 0;\n        margin-bottom: 2px;\n        display: inline-block;\n    }\n}\n\n.loader-container {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    top: 0;\n    bottom: 0;\n    background: rgba(236, 236, 236, .9);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: none;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    z-index: 9999999999;\n    height: 100vh;\n    margin: 0 auto;\n}\n\n.row {\n    &--editmodebg {\n        background-color: #fff;\n        padding: 0 35px;\n    }\n\n    &--wbg {\n        background-color: #fff;\n    }\n}\n\n.loader-spin {\n    background-color: hsla(0, 0%, 92.5%, .9);\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.loader__inner {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n    animation: blink 2s linear infinite;\n    opacity: 0;\n}\n\n#Path_130 {\n    animation: blink 2s linear infinite;\n    animation-delay: .5s;\n    opacity: 0;\n}\n\n#Path_132 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1s;\n    opacity: 0;\n}\n\n#Path_131 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1.5s;\n    opacity: 0;\n}\n\n@keyframes blink {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n\n}","@import './../cn-shared';\n\n::ng-deep#page-wrapper {\n    padding-bottom: 60px;\n}\n\n::ng-deep#wrapper {\n    overflow-x: initial;\n}\n\n::ng-deep.implement-is {\n    .to-do {\n        padding: 0px;\n        border: 1px solid $implement-color;\n        margin-bottom: 15px;\n\n        p {\n            display: initial;\n        }\n    }\n\n    .to-do .col-sm-6 {\n        padding: 0px;\n        float: left;\n    }\n\n    .to-do .col-sm-2 {\n        padding: 0px;\n        border-left: 1px dotted $color-neutral-mid;\n        float: left;\n    }\n\n    .to-do .to-do-term {\n        background-color: $implement-color;\n        min-height: 30px;\n    }\n\n    .next-input-tabs {\n        width: 90%;\n        display: inline-block;\n        margin-right: 20px;\n        margin-bottom: 10px;\n\n        input {\n            height: 35px;\n            padding: 10px 15px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n\n            &:focus {\n                border-color: $clarify-color;\n            }\n        }\n    }\n\n    .drag-content:hover {\n        cursor: move;\n    }\n\n    .implement-color {\n        color: $implement-color;\n    }\n\n    ::ng-deep #toast-container {\n        margin-top: 40px;\n    }\n\n    .input-tabs {\n        min-height: 21px;\n    }\n\n    .card-default h3 {\n        cursor: pointer;\n    }\n\n    .implement-section .to-do-term {\n        padding-left: 10px;\n        padding-right: 10px;\n        color: #fff;\n    }\n\n    .implement-section .ng-star-inserted label {\n        min-width: 30px;\n    }\n\n    .implement-section .ng-star-inserted input {\n        width: 100%;\n        margin-bottom: 0.5em;\n        margin-top: 0;\n    }\n\n    .implement-section .to-do .col-sm-2 input {\n        width: 100%;\n    }\n\n    .implement-section .col-sm-12.to-do>div:last-child.col-sm-3 .report-input {\n        width: calc(100% - 56px);\n        display: inline-block;\n    }\n\n    .implement-section .col-sm-12.to-do>div:last-child.col-sm-3 input {\n        width: 100%;\n        margin-bottom: 0.5em;\n    }\n\n    .implement-section .col-sm-12.to-do>div:last-child.col-sm-3 .fa {\n        display: inline-block;\n        width: auto;\n        margin-left: 8px;\n        border: none;\n    }\n\n    .implement-inner {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    .implement-inner .col-sm-5,\n    .implement-inner .col-sm-3 {\n        padding: 0;\n    }\n\n    .implement-inner .col-sm-3 {\n        border-left: 1px dotted $color-neutral-mid;\n    }\n\n    .implement-table {\n        border: 1px solid $color-neutral-mid;\n        margin-bottom: 15px;\n        width: 100%;\n        border-collapse: collapse;\n        text-align: left;\n    }\n\n    .ngx-datepicker-calendar-container {\n        z-index: 999;\n    }\n\n    .implement-table .heading-section {\n        display: block;\n        background-color: $integrator-color;\n        min-height: 30px;\n        padding: 0 10px;\n        color: $body-content-color;\n    }\n\n    .implement-table .heading-section--editbg {\n        background-color: #F5F5F5;\n        color: #676A6C;\n    }\n\n    .implement-table td,\n    .implement-table th {\n        padding: 0 !important;\n    }\n\n    .implement-table thead tr th,\n    .implement-table tbody tr td {\n        width: 15%;\n        padding: 0 !important;\n    }\n\n    .implement-table tbody tr td {\n        vertical-align: top;\n    }\n\n    .implement-table thead tr th:first-child,\n    .implement-table tbody tr td:first-child {\n        width: 40% !important;\n    }\n\n    .implement-table thead tr th:last-child,\n    .implement-table tbody tr td:last-child {\n        width: 30% !important;\n    }\n\n    .implement-table thead th:not(:last-child),\n    .implement-table tbody td:not(:last-child) {\n        border-right: 1px dotted $color-neutral-mid;\n    }\n\n    .implement-table tbody tr td input {\n        width: 100%;\n    }\n\n    .implement-table tbody tr td:first-child input {\n        width: calc(100% - 35px);\n    }\n\n    .implement-table tbody tr td:last-child input {\n        width: calc(100% - 59px);\n        margin-right: 10px;\n    }\n\n    .implement-table th:not(:first-child) {\n        text-align: left;\n    }\n\n    .implement-table th h4 {\n        color: #656565;\n    }\n\n    app-implement-challenge-action-plan,\n    app-implement-challenge-next24 {\n        display: block;\n        margin-top: 30px;\n    }\n\n    .card-default {\n        .card-body {\n            padding-top: 0;\n            padding-bottom: 0;\n        }\n\n        .list-columns {\n            padding-top: 10px !important;\n            padding-bottom: 10px !important;\n        }\n\n        .input-form {\n            label {\n                min-width: 20px !important;\n                margin-top: 10px;\n            }\n        }\n    }\n\n    .card-show .input-form {\n        padding-top: 15px;\n        padding-bottom: 10px;\n    }\n\n    ::ng-deep .card-default .alert {\n        margin-bottom: 0 !important;\n    }\n\n    .card-default .table.implement-table .list-columns {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n    }\n\n    .card-default .table.implement-table th h4,\n    .card-default .table.implement-table td p,\n    .card-default .table.implement-table td span {\n        margin-bottom: 0 !important;\n        padding: 12px !important;\n    }\n\n    .implement-table__head td {\n        background: $integrator-color;\n    }\n\n    .implement-table__head--editbg td {\n        background: #F5F5F5;\n        color: #676A6C;\n    }\n\n    .tooltipicon {\n        position: relative;\n        display: inline-block;\n        font-size: 18px;\n    }\n\n    .tooltipicon .tooltiptext {\n        visibility: hidden;\n        width: 250px;\n        background-color: #fff;\n        color: $implement-color;\n        text-align: center;\n        border-radius: 6px;\n        padding: 10px;\n        box-shadow: 0 0 18px rgba(0, 0, 0, .1);\n        font-family: 'Open Sans', sans-serif;\n        font-size: 15px;\n        line-height: 1.2em;\n        /* Position the tooltip */\n        position: absolute;\n        top: 15px;\n        right: 10px;\n        z-index: 1;\n\n        @media screen and (max-width: 1199px) {\n            left: auto;\n            right: 10px;\n        }\n    }\n\n    .tooltipicon:hover .tooltiptext {\n        visibility: visible;\n    }\n\n    .btn-develop {\n        background-color: #66bd4a;\n        color: #fff;\n        padding: 0.375rem 1rem;\n        border-radius: 3px;\n    }\n\n    table.implement-table td>div,\n    table.implement-table td>form {\n        padding: 10px !important;\n    }\n\n    .report-grid {\n        input {\n            display: inline-block;\n        }\n    }\n\n    .btn-bottom .btn-warning {\n        margin-left: 10px;\n    }\n\n    .generate-pdf {\n        cursor: pointer;\n        position: absolute;\n        top: 10px;\n        right: 10px;\n\n        @media screen and (max-width: 851px) {\n            position: relative;\n            top: 0;\n            right: 0;\n            margin-bottom: 20px;\n        }\n    }\n\n    .summary-pdf {\n        cursor: pointer;\n        position: absolute;\n        top: 10px;\n        right: 170px;\n\n        @media screen and (max-width: 851px) {\n            position: relative;\n            top: 0;\n            right: -7px;\n            margin-bottom: 20px;\n        }\n    }\n\n\n    .mainnav {\n        @include fflex();\n        @include fflex-jcc();\n        margin: 30px 0 40px;\n\n        @media #{$mq-sm} {\n            margin: 10px 0 30px;\n        }\n\n        &.mainnav--bottom {\n            margin: 30px 0 40px;\n\n            ul {\n                li {\n                    a {\n                        padding: 12px 30px;\n                        font-family: 'Open Sans', sans-serif;\n                        font-weight: 700;\n                        font-size: 16px;\n\n                        @media only screen and (max-width: 991px) {\n                            padding: 10px 20px;\n                            font-size: 14px;\n                        }\n\n                        @media only screen and (max-width: 767px) {\n                            padding: 9px;\n                            font-size: 11px;\n                        }\n                    }\n\n                    &.active {\n                        a {\n                            background-color: #bbb !important;\n                            border-top: 1px solid #bbb !important;\n                            border-right: 1px solid #bbb !important;\n                            border-bottom: 1px solid #bbb !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        &--editmode {\n            margin: 0 0 15px;\n\n            .mainnav__list {\n                flex: 1;\n                border-radius: 5px;\n\n                @media #{$mq-sm} {\n                    flex: none;\n                    width: 100%;\n                }\n\n                li {\n                    width: 100%;\n                    flex: 1;\n\n                    a {\n                        width: 100%;\n                        padding: 5px 2px;\n                        text-align: center;\n                    }\n                }\n            }\n        }\n\n        &__editmodeicon {\n            margin-left: 5px;\n\n            @media #{$mq-sm} {\n                margin: 10px 0 0 auto;\n            }\n\n            ul {\n                display: flex;\n                flex-wrap: wrap;\n                margin: 0;\n                padding: 0;\n                height: 100%;\n\n                li {\n                    list-style: none;\n                    transition: none;\n                    width: 37px;\n                    height: 100%;\n                    border-radius: 5px;\n                    background-color: #fff;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    cursor: pointer;\n                    border: 1px solid $cn-border-color;\n\n\n                    &.active {\n                        background-color: #676a6c;\n                    }\n\n                    &:not(:last-child) {\n                        margin-right: 5px;\n\n                        @media #{$mq-md} {\n                            margin-right: 0;\n                        }\n                    }\n\n                    @media #{$mq-md} {\n                        width: 35px;\n                        height: 31px;\n                        display: none;\n                    }\n\n                    &.mainnav__editmodepin {\n                        display: flex;\n\n                        svg {\n                            .st0 {\n                                fill: #FFFFFF;\n                            }\n\n                            .st1 {\n                                fill: #cfdbe2;\n                            }\n                        }\n\n                        &--pinactive {\n                            svg {\n                                .st0 {\n                                    fill: #6d6e71;\n                                }\n\n                                .st1 {\n                                    fill: #FFFFFF;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n    }\n\n    .stick-challenge {\n        position: relative;\n\n        .card__implementtable {\n            min-height: auto;\n            overflow-y: auto;\n            overflow-x: hidden;\n            z-index: 9;\n            position: relative;\n\n            .card-body__subtitle {\n                position: sticky;\n                top: 0;\n                z-index: 99;\n                background-color: #fff;\n            }\n        }\n\n    }\n\n    .info {\n        color: #fff;\n        border: 1px solid $implement-color;\n        margin-bottom: 18px;\n        padding: 20px 40px;\n        border-radius: 6px;\n\n        @media #{$mq-md} {\n            padding: 12px 20px;\n        }\n\n        &.infotitle {\n            background-color: $implement-color;\n\n            h3 {\n                color: #fff\n            }\n        }\n\n        h1 {\n            font-size: 36px;\n            font-weight: 500;\n            margin: 0;\n            @include headingfont();\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n\n            @media #{$mq-md} {\n                font-size: 28px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 24px;\n            }\n\n            .info__maintitle {\n                margin-right: auto;\n\n            }\n\n            small {\n                color: #fff;\n                font-size: 80%;\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 5px;\n                }\n            }\n        }\n\n        .card__toprow {\n            @include fflex();\n            @include fflex-aic();\n            margin: 0 -15px;\n\n            &--tne {\n\n                .card__topcol {\n\n                    &:first-child {\n                        width: 72% !important;\n\n                        @media #{$mq-sm} {\n                            flex: 1;\n                            width: auto !important;\n                        }\n                    }\n                }\n            }\n\n            .card__topcol {\n                padding: 0 15px;\n                width: calc(100% / 3);\n\n                &:nth-child(1) {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        flex: 1;\n                        margin-right: auto;\n                    }\n                }\n\n                &--tab {\n                    width: 44%;\n\n                    @media #{$mq-sm} {\n                        width: 120px;\n                    }\n                }\n\n                &--tt {\n                    width: 28%;\n                    margin-left: auto;\n                    text-align: right;\n\n                    @media #{$mq-sm} {\n                        width: auto;\n                    }\n\n                    svg {\n                        max-width: 16px;\n                        cursor: pointer;\n                    }\n\n                    .card__pinicon {\n                        position: absolute;\n                        right: -17px;\n                        top: -15px;\n                        width: 20px;\n\n                        @media #{$mq-md} {\n                            right: 2px;\n                            top: 1px;\n                        }\n                    }\n                }\n\n                &.card__topcol--title {\n                    @include fflex();\n                    @include fflex-aic();\n\n                    &>div:first-child {\n                        margin-right: 15px;\n                    }\n                }\n\n                &.card__topcol--tab {\n                    @include fflex();\n                    @include fflex-jcc();\n\n                    ul {\n                        @include fflex();\n                        margin: 0;\n                        padding: 0;\n                        border-radius: 3px;\n                        line-height: 1;\n\n                        li {\n                            &:first-child {\n                                button {\n                                    svg {\n                                        right: calc(100% + 1px)\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            left: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:last-child {\n                                button {\n                                    svg {\n                                        left: calc(100% + 1px);\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            right: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:not(:first-child) {\n                                margin-left: -1px;\n                            }\n\n                            &:only-child {\n                                button {\n                                    border-radius: 3px;\n                                }\n                            }\n\n                            &.card__topactive {\n                                button {\n                                    color: $implement-color;\n                                    border: 1px solid $implement-color;\n\n                                    span.card__topcount {\n                                        color: $implement-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &.card__topcomplete {\n                                button {\n                                    opacity: 0.2;\n                                    border: 1px solid $implement-color;\n                                    color: $implement-color;\n\n                                    span.card__topcount {\n                                        color: $implement-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            button {\n                                position: relative;\n                                color: $develop-color;\n                                font-size: 17px;\n                                padding: 6px 16px;\n                                @include headingfont();\n                                display: inline-block;\n                                height: 100%;\n                                border: 0;\n                                background-color: transparent;\n                                @include transition-slow();\n                                -webkit-appearance: none;\n                                -moz-appearance: none;\n                                appearance: none;\n\n                                svg {\n                                    position: absolute;\n                                    top: -1px;\n                                    height: calc(100% + 2px);\n\n                                    .st0 {\n                                        fill: $implement-color;\n                                    }\n                                }\n\n                                @media #{$mq-md} {\n                                    padding: 4px 6px;\n                                    font-size: 13px;\n                                }\n\n                                &:focus {\n                                    outline: none;\n                                    box-shadow: none;\n                                }\n\n                                &>.card__topdesktext {\n                                    @media only screen and (max-width: 1180px) {\n                                        display: none;\n                                    }\n                                }\n\n                                &>.card__topmobiletext {\n                                    display: none;\n\n                                    @media only screen and (max-width: 1180px) {\n                                        display: inline-block;\n                                    }\n                                }\n\n                                &>span.card__topcount {\n                                    width: 16px;\n                                    height: 16px;\n                                    line-height: 16px;\n                                    display: inline-block;\n                                    text-align: center;\n                                    font-size: 0.5em;\n                                    background-color: $implement-color;\n                                    color: #fff;\n                                    margin-left: 4px;\n                                    border-radius: 50%;\n                                    vertical-align: bottom;\n                                    position: relative;\n                                    top: -1px;\n\n                                    @media only screen and (max-width: 630px) {\n                                        position: absolute;\n                                        top: auto;\n                                        bottom: -2px;\n                                        right: 0;\n                                        margin: 0;\n                                    }\n                                }\n\n                                &:hover {\n                                    color: $implement-color;\n                                    opacity: 1;\n                                }\n\n                                &:hover>span.card__topcount {\n                                    color: $implement-color;\n                                    background-color: #efefef;\n                                    opacity: 1;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            .card__h3button {\n                border: 1px solid $implement-color;\n                background-color: transparent;\n                padding: 4px 26px;\n                border-radius: 3px;\n                @include headingfont();\n                color: $implement-color;\n                font-size: 22px;\n                line-height: 1.2;\n                @include transition-slow();\n                cursor: pointer;\n\n                &:hover {\n                    background-color: $implement-color;\n                    color: #fff;\n                }\n\n                &:focus {\n                    outline: none;\n                }\n            }\n\n            .tooltipicon {\n                cursor: pointer;\n                position: relative;\n                font-size: 18px;\n                display: inline-block;\n\n                i {\n                    color: $implement-color;\n                }\n\n                &:hover>i>.tooltiptext {\n                    visibility: visible;\n                }\n\n                .tooltiptext {\n                    visibility: hidden;\n                    width: 250px;\n                    background-color: #fff;\n                    color: $implement-color;\n                    text-align: center;\n                    border-radius: 6px;\n                    padding: 10px;\n                    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                    font-size: 13px;\n                    font-family: 'Open Sans', sans-serif;\n                    line-height: 1.5;\n                    position: absolute;\n                    top: 15px;\n                    right: 10px;\n                    z-index: 1;\n                }\n            }\n        }\n\n        h3 {\n            font-size: 20px;\n            margin: 0;\n            cursor: pointer;\n            color: $implement-color;\n            @include headingfont();\n            @include fflex();\n            @include fflex-aic();\n\n            @media #{$mq-md} {\n                font-size: 16px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 15px;\n                word-break: break-word;\n            }\n\n            &>*:not(:last-child) {\n                margin-right: 5px;\n            }\n\n            .card__bwnh3pencil {\n\n                a {\n                    color: $implement-color;\n                }\n            }\n\n            .card__bwnh3button {\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 10px;\n                }\n\n                button {\n                    font-size: 18px !important;\n                    padding-right: 15px !important;\n                    padding-left: 15px !important;\n\n                    @media #{$mq-sm} {\n                        font-size: 16px !important;\n                    }\n                }\n            }\n\n            i {\n                cursor: pointer;\n                font-size: 0.9em;\n\n                &+div {\n                    padding-left: 7px;\n\n                    span {\n                        display: block;\n                        font-size: 0.7em;\n                    }\n                }\n\n                &+span {\n                    padding-left: 7px;\n                }\n            }\n\n            a {\n                margin-left: 10px;\n                color: $implement-color;\n            }\n\n            &.d-flex {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n\n                div:first-child {\n                    padding-right: 10px;\n                }\n\n                div:nth-child(2) {\n                    span {\n                        display: block;\n                    }\n                }\n            }\n        }\n\n        .tooltipicon {\n            position: relative;\n            display: inline-block;\n\n            &:hover>i>.tooltiptext {\n                visibility: visible;\n            }\n\n            .tooltiptext {\n                visibility: hidden;\n                width: 250px;\n                background-color: #fff;\n                color: $implement-color;\n                text-align: center;\n                border-radius: 6px;\n                padding: 10px;\n                box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                font-size: 15px;\n                line-height: 1.2em;\n                position: absolute;\n                top: 15px;\n                right: 10px;\n                z-index: 1;\n            }\n        }\n    }\n\n    .topheading {\n        color: #fff;\n        background-color: $implement-color;\n        border-color: $implement-color;\n        margin-bottom: 18px;\n        padding: 24px;\n        border-radius: 6px;\n\n        h1 {\n            font-size: 36px;\n            font-weight: 500;\n            margin: 0;\n\n            small {\n                color: #fff;\n                font-size: 80%;\n            }\n        }\n    }\n\n    .card-default {\n        &.card-default--summary {\n            box-shadow: none;\n\n            .info {\n                border-top: 0;\n                border-right: 0;\n                border-left: 0;\n                padding-right: 20px;\n                padding-left: 20px;\n            }\n\n            .card-body {\n                border-right: 0;\n                border-bottom: 0;\n                border-left: 0;\n                border-radius: 0;\n\n                &__inner {\n                    padding: 15px 20px;\n                }\n            }\n\n            &+div {\n                margin-top: 20px;\n            }\n        }\n\n        &+div {\n            margin-top: 30px;\n        }\n\n        .info {\n            margin: 0;\n\n            &.card__headactive {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n\n                &--cc {\n                    background-color: $implement-color;\n\n                    .card__topcol {\n                        h3 {\n                            color: #fff;\n                        }\n\n                        ul {\n                            li {\n\n                                button {\n                                    border-color: #fff;\n                                    background-color: #fff;\n\n                                    span {\n                                        color: $implement-color;\n                                        background-color: #fff;\n                                    }\n\n                                    .st0 {\n                                        fill: #fff !important;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    i {\n                        color: #fff;\n                    }\n                }\n\n                .card__topcol--tt {\n                    svg {\n                        max-width: 16px;\n                        width: 100%;\n                    }\n\n                    .tooltipicon {\n                        i {\n                            color: #ff485c;\n                        }\n                    }\n                }\n\n                &.challenge__sol {\n                    display: flex;\n                    flex-wrap: wrap;\n                    justify-content: space-between;\n                    position: relative;\n\n                    .card__topcol--tt {\n                        span {\n                            position: absolute;\n                            right: 8px;\n                            top: 6px;\n                        }\n                    }\n                }\n            }\n        }\n\n        border-radius: 6px;\n        border-top-width: 3px;\n        border: 0;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n\n        .card-body__inner {\n            padding: 15px 40px;\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n\n        }\n\n        .card-body {\n            display: none;\n            border: 1px solid $cn-border-color;\n            border-top: 0;\n            border-radius: 0 0 6px 6px;\n            overflow: hidden;\n\n            &--ov {\n                overflow: visible;\n            }\n\n            &.card-show {\n                display: block;\n\n                &__wbg {\n                    background-color: #fff;\n                }\n\n            }\n\n            &__finalstate {\n                p {\n                    font-size: 15px;\n                    font-weight: 600;\n\n                    @media #{$mq-sm} {\n                        font-size: 13px;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &--2 {\n                    @include fflex();\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n\n                        p {\n                            position: relative;\n                            padding-left: 10px;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 8px;\n                                left: 0;\n                                width: 5px;\n                                height: 5px;\n                                border-radius: 50%;\n                                background-color: #444;\n                            }\n                        }\n                    }\n                }\n            }\n\n            &__subtitle {\n                margin-bottom: 16px;\n                padding-left: 0;\n\n                &--pl0 {\n                    padding-left: 0;\n                }\n\n                *:last-child {\n                    margin-bottom: 0;\n                }\n\n                p {\n                    color: #969798;\n                    font-size: 15px;\n\n                    i {\n                        padding-left: 5px;\n                    }\n                }\n            }\n\n            &__pdfdropdown {\n                padding: 0;\n                margin: 0;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                &>li {\n                    list-style: none;\n                    position: relative;\n\n                    &+li {\n                        margin-left: 15px;\n                    }\n\n                    &>a {\n                        font-size: 16px;\n                        color: #676a6a;\n                        font-weight: 700;\n                        background-color: #fff;\n                        border: 1px solid #ededed;\n                        border-radius: 6px;\n                        overflow: hidden;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        -ms-flex-wrap: wrap;\n                        flex-wrap: wrap;\n                        -webkit-transition: all ease 0.3s;\n                        -o-transition: all ease 0.3s;\n                        transition: all ease 0.3s;\n\n                        @media #{$mq-sm} {\n                            font-size: 13px;\n                        }\n\n                        .page-heading__icon {\n                            padding: 11px 14px;\n                            border-right: 1px solid #ededed;\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            align-items: center;\n                        }\n\n                        .page-heading__text {\n                            padding: 11px 14px;\n                        }\n\n                        &:hover {\n                            border: 1px solid $cn-border-color;\n                        }\n                    }\n\n                    &:hover>ul {\n                        display: block;\n                    }\n\n                    ul {\n                        margin: 0;\n                        padding: 0;\n                        display: none;\n                        position: absolute;\n                        top: calc(100%);\n                        right: 0;\n                        width: 144px;\n                        border: 1px solid #dcdcdc;\n                        border-radius: 3px;\n                        background-color: #fff;\n                        z-index: 99;\n\n                        li {\n                            list-style: none;\n\n                            &+li {\n                                border-top: 1px solid #dcdcdc;\n                            }\n\n                            a {\n                                color: #696969;\n                                text-align: center;\n                                padding: 8px 20px;\n                                font-size: 13px;\n                                display: block;\n                                -webkit-transition: all ease 0.3s;\n                                -o-transition: all ease 0.3s;\n                                transition: all ease 0.3s;\n\n                                &:hover {\n                                    background-color: #f9f9f9;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .c-radio {\n            label {\n                padding-left: 0;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 2px;\n                    margin-right: 6px;\n                    opacity: 0.6;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                margin: 0;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 50%;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        position: absolute;\n                        color: $implement-color;\n                        opacity: 0;\n                        font-size: 11px;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $implement-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .checkbox {\n            margin-top: 0;\n\n            label {\n                min-height: 20px;\n                padding-left: 0;\n                margin-bottom: 0;\n                font-weight: 400;\n                cursor: pointer;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 1px;\n                    margin-right: 6px;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        font-size: 12px;\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: #5D9CEC;\n                        background-color: #5D9CEC;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .card-body__button {\n            background-color: #f5f5f5;\n            border-top: 1px solid #e3e3e3;\n            padding: 12px 40px;\n\n            .card-button {\n                margin: 0;\n                @include fflex();\n                @include fflex-aic();\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    text-align: center;\n                    @include transition-slow();\n\n                    &+.btn {\n                        margin-left: 15px;\n                    }\n\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n                }\n\n                .float-right {\n                    margin-left: auto;\n                }\n\n                .btn-implement {\n                    background-color: $implement-color;\n                    border-color: $implement-color;\n                    color: #fff;\n\n                    &:hover {\n                        background-color: $implement-color;\n                        border-color: $implement-color;\n                    }\n                }\n\n                .btn-danger {\n                    background-color: #fff;\n                    border-color: #fff;\n                    color: #ef6272;\n\n                    &:hover {\n                        background-color: #ED2D2D;\n                        border-color: #EC2121;\n                    }\n                }\n\n                .btn-warning {\n                    em {\n                        margin: 0;\n                    }\n                }\n\n                .btn-deleteall {\n                    border: 0;\n                    background-color: transparent;\n                    position: relative;\n                    overflow: hidden;\n                    box-shadow: none;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n\n                    span {\n                        position: absolute;\n                        left: 110%;\n                        @include transition-slow();\n                    }\n\n                    &:hover {\n                        background-color: #fff;\n                        color: #ed5562;\n                        padding-right: 16px;\n                        padding-left: 16px;\n\n                        &>span {\n                            position: relative;\n                            left: 0;\n                        }\n\n                        em {\n                            margin-right: 6px;\n                        }\n                    }\n\n                    em {\n                        font-size: 1em;\n                        margin-right: 0;\n                        @include transition-slow();\n                    }\n                }\n            }\n        }\n\n        .card-body--ebtn {\n            margin-top: 15px;\n            padding: 15px 40px;\n            border-top: 1px solid $cn-border-color;\n\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n\n            .card-body--ebtnrow {\n                margin: 0 -8px;\n                @include fflex();\n                @include fflex-aic();\n\n                &>div {\n                    padding: 0 8px;\n\n                    @media #{$mq-sm} {\n                        width: 100%;\n                        text-align: center;\n\n                        &+div {\n                            margin-top: 10px;\n                        }\n                    }\n\n                    &.card-body--col {\n                        &--last {\n                            margin-left: auto;\n                        }\n                    }\n                }\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    padding: 7px 16px;\n                    text-align: center;\n                    transition: all ease 0.3s;\n                    font-weight: 900;\n\n                    @media #{$mq-md} {\n                        font-size: 12px;\n                    }\n\n                    i,\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n\n                    &--save {\n                        background-color: $develop-color;\n                        color: #fff;\n                    }\n\n                    &--clarify {\n                        background-color: $clarify-color;\n                        color: #fff;\n                    }\n\n                    &--implement {\n                        background-color: $implement-color;\n                        color: #fff;\n                        border-color: $implement-color;\n                        font-weight: 900;\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                    }\n\n                    &--cancel {\n                        padding: 0;\n                        background-color: transparent;\n                        margin-left: 0;\n                        border: 0;\n                        font-family: $font-stack;\n                        font-size: 14px;\n                        font-weight: 700;\n                        color: $body-content-color;\n\n                        &:hover {\n                            color: #000;\n                        }\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                    }\n\n                    &--converge {\n                        padding: 0 8px;\n                    }\n\n                    &--deleteall {\n                        border: 0;\n                        background-color: transparent;\n                        position: relative;\n                        overflow: hidden;\n                        box-shadow: none;\n                        padding-right: 0;\n                        padding-left: 0;\n                        @include transition-slow();\n\n                        i {\n                            font-size: 14px;\n                            color: $body-content-color;\n                        }\n\n                        span {\n                            position: absolute;\n                            left: 110%;\n                            @include transition-slow();\n                        }\n\n                        &:hover {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px !important;\n                            }\n                        }\n\n                        em {\n                            font-size: 1em;\n                            margin-right: 0;\n                            @include transition-slow();\n                        }\n                    }\n                }\n            }\n        }\n\n\n        .note-3 {\n            padding: 15px 15px 10px;\n            border: 2px solid $clarify-color;\n            margin-bottom: 15px;\n\n            label {\n                color: $clarify-color;\n            }\n        }\n\n        .footer-line {\n            color: $clarify-color;\n        }\n\n        p {\n            font-size: 15px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        .card-body__edit {\n            position: relative;\n            overflow: hidden;\n\n            &--ov {\n                overflow: visible;\n            }\n\n            .breakthrough-input-tabs,\n            .datadump-input-tabs {\n                width: 100%;\n                margin-right: 0;\n                position: relative;\n\n                input,\n                select {\n                    height: 45px;\n                    padding: 5px 15px;\n                    border: 1px solid $color-neutral-mid !important;\n                    border-radius: 4px;\n                    font-size: 15px;\n\n                    &:focus {\n                        outline: none !important;\n                    }\n                }\n            }\n\n            .card-body__editrow {\n                margin: 0 -15px;\n                @include fflex();\n\n                &>div {\n                    padding: 0 15px;\n                    width: 100%;\n                    margin-bottom: 15px;\n\n                    &.card-body__editcol--mb0 {\n                        margin-bottom: 0;\n                    }\n\n                    &.card-body__editcol--2 {\n                        width: calc(100% / 2);\n                    }\n\n                    &>div {\n                        position: relative;\n                    }\n                }\n\n                select {\n                    -webkit-appearance: none;\n                    -moz-appearance: none;\n                    appearance: none;\n                    background-image: url($assets+'/images/select.png');\n                    background-size: 10px;\n                    background-position: right 10px center;\n                    background-repeat: no-repeat;\n                }\n\n                textarea {\n                    width: 100%;\n                    border: 1px solid $color-neutral-mid;\n                    resize: none;\n                    border-radius: 3px;\n                    padding: 10px 15px;\n                    font-size: 15px;\n                }\n\n                .breakthrough-input-tabs,\n                .breakthrough-input-tabs {\n                    @include fflex();\n\n                    &>.card-body__editlabel {\n                        width: 35px;\n                        padding-right: 15px;\n                        @include fflex();\n                        @include fflex-aic();\n                    }\n\n                    &>.card-body__editnumber {\n                        width: 40px;\n                        text-align: center;\n                        @include fflex();\n                        @include fflex-aic();\n                        @include fflex-jcc;\n                        border-right: 0;\n                        border-radius: 4px 0 0 4px;\n\n                        &+.card-body__editinput {\n                            width: calc(100% - 41px);\n                        }\n\n                        label {\n                            margin-bottom: 0;\n                            font-weight: 900;\n                        }\n                    }\n\n                    &>.card-body__editselect {\n                        width: 315px;\n                        padding-right: 15px;\n                    }\n\n                    &>.card-body__editinput {\n                        width: calc(100% - 351px);\n\n                        input.add-line {\n                            // width: 100%;\n                            padding-right: 70px;\n                        }\n\n                        &.card-body__editinput--np {\n                            input {\n                                padding-right: 15px;\n                            }\n                        }\n                    }\n\n                    &>.card-body__editinput:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n\n            &+.card-body__addnew {\n\n                button {\n                    font-size: 14px;\n                    font-weight: bold;\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n\n                    &:hover {\n                        background-color: $implement-color;\n                        border: 1px solid $implement-color;\n                        color: #fff;\n                        padding-right: 12px;\n                        padding-left: 12px;\n                    }\n                }\n            }\n        }\n\n        .breakthrough-input-tabs {\n            width: 90%;\n            display: inline-block;\n            margin-right: 20px;\n\n            input {\n                height: 35px;\n                padding: 10px 15px;\n                border: 1px solid $implement-color;\n                border-radius: 4px;\n                margin-bottom: 0;\n            }\n        }\n\n        .input-tabs {\n            &+i {\n                position: relative;\n                top: -1px;\n            }\n\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            @include fflex-aic();\n            width: calc(100%);\n            padding: 0 0 0 0;\n            margin: 0;\n\n\n            &.card__body--cs {\n                position: relative;\n                border-bottom: 1px solid #e4e4e4;\n\n                &::before,\n                &::after {\n                    content: \"\";\n                    position: absolute;\n                    bottom: -1px;\n                    right: calc(100%);\n                    width: 40px;\n                    height: 1px;\n                    background-color: #e4e4e4;\n                }\n\n                &::after {\n                    right: auto;\n                    left: calc(100%);\n                }\n            }\n\n            .select_faded {\n                opacity: 0.2;\n                padding-left: 32px;\n            }\n\n            input,\n            select {\n                height: 45px;\n                padding: 5px 15px;\n                border: 1px solid #e3e3e3;\n                border-radius: 4px;\n                margin: 7px 0px;\n            }\n\n            label {\n                width: 20px;\n                margin: 0;\n            }\n\n            select {\n                width: 9%;\n            }\n\n            input {\n                width: 90%;\n                margin-left: 15px;\n            }\n        }\n\n        .input-group-text {\n            cursor: pointer;\n            padding: 3px 16px;\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 1.528571429;\n            color: #495057;\n            text-align: center;\n            white-space: nowrap;\n            background-color: #E9ECEF;\n            border: 1px solid #DDE6E9;\n            border-radius: 0.25rem;\n            position: absolute;\n            top: calc(50%);\n            right: 5px;\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n            @include transition-slow();\n\n            &:hover {\n                background-color: $implement-color;\n                border-color: $implement-color;\n                color: #fff;\n            }\n\n            i {\n                font-size: 12px;\n            }\n        }\n\n        .list-columns {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n            counter-reset: section;\n\n            &.list-columns--2 {\n                &>div {\n                    width: 100%;\n                }\n            }\n\n            .brainstorm-tabs {\n                position: relative;\n                padding-left: 23px;\n\n                &::before {\n                    counter-increment: section;\n                    content: counter(section) \".\";\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                }\n            }\n        }\n    }\n\n    .idea-shop-list {\n        padding: 20px;\n        margin-left: 17px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        li {\n            width: calc(100% / 2);\n            margin-bottom: 10px;\n        }\n    }\n\n    .brainstorm__col {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        margin-bottom: 17px;\n\n        .brainstorm-main {\n            width: calc(100% - 68px);\n            display: inline-block;\n            margin-right: 20px;\n\n            .brainstorm-group {\n                width: 100%;\n                position: relative;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                .input-group-prepend {\n                    margin-right: -1px;\n                    width: 45px;\n\n                    .input-group-text {\n                        background: transparent;\n                        border-color: $implement-color;\n                        height: 35px;\n                        padding: 0;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        align-items: center;\n                        -webkit-box-pack: center;\n                        -ms-flex-pack: center;\n                        justify-content: center;\n                    }\n                }\n\n                input {\n                    width: calc(100% - 45px);\n                    height: 35px;\n                    border: 1px solid $ideate-color;\n                    border-radius: 0 0.25rem 0.25rem 0;\n                }\n            }\n        }\n    }\n\n    .point-evaluation {\n        padding: 0px;\n        border: 1.5px solid #66bd4a;\n        margin-bottom: 20px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        &>div {\n            padding: 10px;\n        }\n\n        .pluses {\n            border-right: 1.5px solid #66bd4a;\n            border-bottom: 1.5px solid #66bd4a;\n\n            h4::before {\n                content: \"P\";\n            }\n        }\n\n        .opportunities {\n            border-bottom: 1.5px solid #66bd4a;\n\n            h4::before {\n                content: \"O\";\n            }\n        }\n\n        .issues {\n            border-right: 1.5px solid #66bd4a;\n\n            h4::before {\n                content: \"I\";\n            }\n        }\n\n        .new-thinking {\n            h4::before {\n                content: \"Nt\";\n            }\n        }\n\n        h4 {\n            position: relative;\n            padding-left: 50px;\n            color: #66bd4a;\n            font-size: 16px;\n            margin: 0 0 10px;\n\n            &::before {\n                content: \"\";\n                background: #66bd4a;\n                color: #fff;\n                font-size: 20px;\n                height: 35px;\n                width: 35px;\n                position: absolute;\n                border-radius: 50%;\n                top: 0;\n                left: 0;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-pack: center;\n                -ms-flex-pack: center;\n                justify-content: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n            }\n\n            small {\n                display: block;\n                margin-top: 4px;\n                color: inherit;\n                line-height: 1.3;\n                font-size: 82%;\n            }\n        }\n\n        p {\n            color: #66bd4a;\n        }\n\n        span.fill-bottom {\n            width: 100%;\n        }\n\n        .icons-right {\n            i {\n                font-size: 21px;\n                color: #66bd4a;\n                cursor: pointer;\n\n                &:not(:last-child) {\n                    margin-right: 10px;\n                }\n            }\n        }\n\n        .fill-input {\n            width: calc(100% - 35px);\n            display: inline-block;\n            margin-right: 15px;\n\n            label {\n                display: inline-block;\n                min-width: 20px;\n                color: #66bd4a;\n            }\n\n            input {\n                display: inline-block;\n                width: calc(100% - 20px);\n                height: 34px;\n                border-radius: 3px;\n                margin: 1px 0;\n            }\n        }\n\n        .input-tabs {\n            .input-tabs__row {\n                width: calc(100% - 35px);\n                display: inline-block;\n                margin-right: 15px;\n                position: relative;\n                vertical-align: middle;\n\n                .pr-0 {\n                    padding-right: 0;\n                }\n\n                &>i {\n                    position: absolute;\n                    top: 50%;\n                    right: -26px;\n                    -webkit-transform: translateY(-50%);\n                    -ms-transform: translateY(-50%);\n                    transform: translateY(-50%);\n                }\n            }\n\n            label {\n                display: inline-block;\n                min-width: 20px;\n                color: #66bd4a;\n            }\n\n            input,\n            select {\n                height: 34px;\n                border-radius: 3px;\n                margin: 1px 0;\n            }\n\n            select {\n                display: inline-block;\n                width: calc(100% - 20px);\n            }\n        }\n    }\n\n    .develop-footer-note {\n        color: #66bd4a;\n    }\n\n    .d-flex.count-div {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n\n        label {\n            width: 35px;\n        }\n    }\n\n    .implement-section .input-tabs {\n        display: block !important;\n    }\n\n    .card-bottom-button {\n        .button {\n            font-size: 13px;\n            color: #fff;\n            padding: 8px 10px;\n            border-radius: 3px;\n            -webkit-transition: all ease 0.3s;\n            -o-transition: all ease 0.3s;\n            transition: all ease 0.3s;\n\n            &:hover {\n                opacity: .8;\n            }\n\n            i {\n                font-size: 0.8em;\n            }\n\n            &.btn-clarify {\n                background-color: $clarify-color;\n            }\n\n            &.btn-ideate {\n                background-color: $ideate-color;\n            }\n\n            &.btn-implement {\n                background-color: $implement-color;\n            }\n        }\n    }\n\n    .cancelTool.tooltipicon {\n        position: relative;\n        display: inline-block;\n        cursor: pointer;\n\n        .tooltiptext {\n            width: 150px;\n            color: #676a6c;\n            text-align: center;\n            font-size: 13px;\n            font-family: 'Open Sans', sans-serif;\n            line-height: 1.5;\n            padding: 6px;\n            top: -25px;\n            left: 10px;\n        }\n\n        &:hover {\n            .tooltiptext {\n                visibility: visible;\n            }\n        }\n    }\n\n    .card_solution {\n        b {\n            font-size: 15px;\n        }\n\n        .solution-list {\n            margin-bottom: 0;\n            width: 100%;\n            margin-top: 10px;\n\n            span {\n                display: block;\n            }\n\n            &__selection1 {\n                margin-top: 10px;\n            }\n\n            &__selection2 {\n                margin-left: 20px;\n            }\n        }\n    }\n}\n\n::ng-deep.cdk-overlay-container {\n    position: absolute !important;\n    top: 288px !important;\n}\n\n.tooltippopup {\n    max-width: 360px;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    position: fixed;\n    top: 0;\n    right: -400px;\n    padding: 45px 24px 24px;\n    text-align: left;\n    z-index: 9999;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n    @include transition-slow();\n    overflow-y: auto;\n\n    &--active {\n        right: 0;\n    }\n\n    &__btn {\n        @include fflex();\n        padding: 0;\n        margin: 0 0 10px;\n\n        li {\n            list-style: none;\n            text-align: center;\n            cursor: pointer;\n            width: calc(100% / 3);\n\n            button {\n                width: 100%;\n                color: $implement-color;\n                font-size: 12px;\n                padding: 6px 16px;\n                @include headingfont();\n                display: inline-block;\n                height: 100%;\n                border: 0;\n                border: 1px solid $implement-color;\n                background-color: transparent;\n                transition: all ease 0.3s;\n                @include appearance-none();\n\n                &:focus {\n                    outline: none;\n                }\n\n                &.tooltippopup__btncompleted {\n                    opacity: 0.2;\n\n                    &:hover {\n                        opacity: 1;\n                    }\n                }\n\n                &.tooltippopup__btnactive {\n                    opacity: 1;\n                }\n\n                &:hover {\n                    position: relative;\n                    z-index: 9;\n                }\n            }\n\n            &+li {\n                margin-left: -1px;\n            }\n\n            &:first-child {\n                button {\n                    border-radius: 3px 0 0 3px\n                }\n            }\n\n            &:last-child {\n                button {\n                    border-radius: 0 3px 3px 0;\n                }\n            }\n        }\n    }\n\n    h4 {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 16px;\n        line-height: 1.2;\n    }\n\n    p {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 14px;\n        line-height: 1.4;\n    }\n\n    &__close {\n        position: absolute;\n        top: 10px;\n        right: 25px;\n        width: 18px;\n        height: 18px;\n        cursor: pointer;\n        @include transition-slow();\n\n        &:hover {\n            -webkit-transform: rotate(360deg);\n            -ms-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n\n        &>div {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n\n            span {\n                position: absolute;\n                background: #676a6c;\n\n                &:nth-child(1) {\n                    top: 0;\n                    left: calc(50% - 1px);\n                    width: 2px;\n                    height: 100%;\n                }\n\n                &:nth-child(2) {\n                    top: calc(50% - 1px);\n                    left: 0;\n                    width: 100%;\n                    height: 2px;\n                }\n            }\n        }\n    }\n\n    &__child {\n        margin-top: 20px;\n\n        &data {\n            .table-responsive {\n                overflow-x: auto;\n                margin-bottom: 10px;\n\n                table {\n                    min-width: 297px;\n                    border: 1px solid #e7eaec;\n\n                    th,\n                    td {\n                        border: 1px solid #e7eaec;\n                        min-width: 120px;\n                    }\n                }\n\n                &+* {\n                    margin-top: 20px;\n                }\n            }\n\n            &--clarify {\n                h4 {\n                    color: $clarify-color;\n                }\n            }\n\n            &--ideate {\n                h4 {\n                    color: $ideate-color;\n                }\n            }\n\n            &--develop {\n                h4 {\n                    color: $develop-color;\n                }\n            }\n\n            &--implement {\n                h4 {\n                    color: $implement-color;\n                }\n            }\n\n            h4 {\n                font-size: 16px;\n                font-weight: 500;\n                margin: 0 0 2px;\n                @include headingfont();\n\n                &+h5 {\n                    mask-type: 10px;\n                }\n            }\n\n            p {\n                margin-bottom: 5px;\n                line-height: 1.3;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            &+div {\n                margin-top: 17px;\n            }\n        }\n    }\n\n    &__links {\n        padding: 0;\n        margin: 0;\n\n        li {\n            list-style: none;\n            width: 100%;\n\n            a {\n                position: relative;\n                color: $implement-color;\n                @include transition-slow();\n\n                &::before {}\n\n                &:hover {\n                    opacity: 0.75;\n                }\n            }\n\n            &+li {\n                margin-top: 4px;\n\n            }\n        }\n    }\n}\n\n\n\n.popaccordian {\n    &__row {\n        &head {\n            position: relative;\n            cursor: pointer;\n            border: 1px solid $implement-color;\n            padding: 9px;\n            border-radius: 3px;\n            @include fflex();\n\n            &arrow {\n                position: absolute;\n                top: 0;\n                left: 0;\n            }\n\n            h5 {\n                margin: 0;\n                position: relative;\n                color: $implement-color;\n                padding-left: 10px;\n                @include headingfont();\n\n                i {\n                    @include transition-slow();\n                }\n            }\n        }\n\n        &body {\n            border: 1px solid $implement-color;\n            border-top: 0;\n            display: none;\n            border-radius: 0 0 3px 3px;\n\n            &inner {\n                padding: 10px;\n\n                &>*:last-child {\n                    margin-bottom: 0;\n                }\n\n                h5 {\n                    margin: 0 0 10px;\n                    position: relative;\n                    color: $implement-color;\n                    @include headingfont();\n                }\n\n                ul {\n                    margin: 0;\n                    padding: 0;\n\n                    li {\n                        list-style: none;\n                        font-size: 14px;\n                        line-height: 1.3;\n                        position: relative;\n                        padding-left: 10px;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 7px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n\n                        &+li {\n                            margin-top: 5px;\n                        }\n                    }\n                }\n            }\n\n        }\n\n        &+div {\n            margin-top: 15px;\n        }\n\n        &--active {\n            .popaccordian__rowhead {\n                border-radius: 3px 3px 0 0;\n\n                i {\n                    @include transRotate (90deg);\n                }\n            }\n        }\n\n        &:first-child {\n            .popaccordian__rowbody {\n                display: block;\n            }\n        }\n\n    }\n\n}\n\n\n.prevnext {\n    padding: 10px 0;\n\n    &__inner {\n        @include fflex();\n        @include fflex-aic();\n        padding: 0;\n        margin: 0;\n    }\n\n    li {\n        list-style: none;\n\n        &.prevnext__next {\n            margin-left: auto;\n        }\n\n        &.prevnext__action {\n            margin-left: auto;\n\n            a {\n                @include headingfont();\n                font-size: 14px;\n                color: #676a6c;\n                cursor: pointer;\n                opacity: 0.6;\n                @include transition-slow();\n\n                &:hover {\n                    opacity: 1;\n                }\n            }\n        }\n\n        &.prevnext__prev a {\n            &:hover>i {\n                left: -5px;\n            }\n        }\n\n        &.prevnext__next a {\n            background-color: $implement-color;\n            color: #fff;\n            opacity: 1;\n            padding: 6px 12px;\n            border-radius: 3px;\n\n            &:hover>i {\n                left: 3px;\n            }\n        }\n\n        a {\n            @include headingfont();\n            font-size: 14px;\n            color: #676a6c;\n            opacity: 0.47;\n            padding: 6px 0;\n            display: inline-block;\n            @include transition-slow();\n\n            i {\n                position: relative;\n                font-size: 1.1em;\n                left: 0;\n                @include transition-slow();\n            }\n        }\n    }\n}\n\n\n::ng-deep.card__implementtable {\n    overflow-y: auto;\n\n    table {\n\n        @media #{$mq-sm} {\n            width: 700px;\n            max-width: none;\n        }\n    }\n\n    .card-body__addnew {\n        button {\n            font-size: 14px;\n            font-weight: bold;\n            background-color: transparent;\n            border: 1px solid transparent;\n            padding-right: 0;\n            padding-left: 0;\n            margin: 6px 50px;\n            color: $body-content-color;\n            @include transition-slow();\n\n            &:hover {\n                background-color: $implement-color;\n                border: 1px solid $implement-color;\n                color: #fff;\n                padding-right: 12px;\n                padding-left: 12px;\n            }\n        }\n    }\n}\n\n\n.playbtn {\n    position: absolute;\n    right: 9px;\n    bottom: 7px;\n    color: #06a6ce;\n}\n\n.Del-data-btn {\n    padding: 40px 0;\n\n    .btn {\n        margin-left: 15px;\n        // border-color: #007bff;\n        background-color: #fff;\n        border-color: #f5f5f5;\n        color: #ff485c;\n    }\n\n    .cancelbtn {\n        color: #676a6c;\n        text-align: center;\n        font-size: 15px;\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.5;\n        padding: 6px;\n    }\n}\n\n\n\n.editmode {\n    margin-bottom: 30px;\n\n    &--not {\n        margin-bottom: 0;\n    }\n\n\n    &__list {\n\n        &row {\n            display: grid;\n            grid-template-columns: repeat(2, 1fr);\n            grid-gap: 15px;\n\n            @media #{$mq-sm} {\n                grid-template-columns: 1fr;\n            }\n\n            &--equalblocks {\n                display: flex;\n                flex-wrap: wrap;\n\n                &>.editmode__listcol {\n                    flex: 1;\n\n                    @media #{$mq-sm} {\n                        flex: none;\n                        width: 100%;\n                    }\n                }\n\n            }\n\n            &--fullblocks {\n                grid-template-columns: 1fr;\n            }\n\n            &--grid {\n                &1 {\n                    grid-template-columns: 1fr;\n                }\n\n                &3 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 3;\n                    }\n                }\n\n                &4 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 4;\n                    }\n                }\n\n                &5 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 5;\n                    }\n                }\n\n                &6 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 6;\n                    }\n                }\n\n                &7 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 7;\n                    }\n                }\n            }\n        }\n\n        &cell {\n            padding: 10px 15px;\n            background-color: #EBEBEB;\n            border: 1px solid $cn-border-color;\n            border-radius: 6px;\n            height: 100%;\n\n\n            @media #{$mq-sm} {\n                font-size: 13px;\n            }\n\n            h3 {\n                color: #676A6C;\n                margin-bottom: 5px;\n\n                a,\n                i {\n                    color: inherit;\n                }\n            }\n\n            p {\n                font-size: 15px;\n                font-weight: 600;\n\n                @media #{$mq-sm} {\n                    font-size: 13px;\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n\n}\n\n.trackInfo {\n    padding: 2px 16px;\n    background-color: #6d6e71;\n    color: #fff;\n    margin-left: 40px;\n    border-radius: 5px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    font-size: 10px;\n}\n\n\n.row {\n    &--editmodebg {\n        background-color: #fff;\n        padding: 40px 35px;\n    }\n\n    &--wbg {\n        background-color: #fff;\n    }\n}\n\n.loader-container {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    top: 0;\n    bottom: 0;\n    background: rgba(236, 236, 236, .9);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: none;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    z-index: 9999999999;\n    height: 100vh;\n    margin: 0 auto;\n}\n\n.row--editmodebg {\n    background-color: #fff;\n    padding: 40px 35px;\n}\n\n.trackInfo {\n    padding: 2px 16px;\n    background-color: #6d6e71;\n    color: #fff;\n    margin-left: 40px;\n    border-radius: 5px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    font-size: 10px;\n\n    &--inputclr {\n        color: $implement-color;\n        font-size: 11px;\n        background: transparent;\n        margin-left: 8px;\n        padding-left: 0;\n    }\n}\n\n.loader-spin {\n    background-color: hsla(0, 0%, 92.5%, .9);\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.loader__inner {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n    animation: blink 2s linear infinite;\n    opacity: 0;\n}\n\n#Path_130 {\n    animation: blink 2s linear infinite;\n    animation-delay: .5s;\n    opacity: 0;\n}\n\n#Path_132 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1s;\n    opacity: 0;\n}\n\n#Path_131 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1.5s;\n    opacity: 0;\n}\n\n@keyframes blink {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n\n}\n\n::ng-deep .datepicker-container {\n\n    input {\n        padding: 8px 10px;\n        font-size: 14px;\n        width: 200px;\n        outline: 0;\n        border: 1px solid #dfe3e9;\n    }\n}\n\n.card-body__minus {\n\n    &--hide {\n        display: none;\n    }\n}\n\n.pdf-modal {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
